// @ts-nocheck fff

/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {buildMarketplaceTitle} from '../../utils/marketplaceTitle';
import ImgsViewer from 'react-images-viewer'
import {toCdnUrl, watermarkPreviewSrc} from '../../utils/cdnUrl'
import './index.scss'
import '../../components/OnboardingWizard.scss'
import {GroupWidget} from './GroupWidget'
import {GroupTable} from './GroupTable'
import {MobileCampaignSwitcher} from './MobileCampaignSwitcher'
import {DebouncedTextarea} from './DebouncedTextarea'
import {WaLinkStripModal} from './WaLinkStripModal'
import {useAuth} from '../../../app/modules/auth'
import {Link, useLocation, useMatch, useNavigate} from 'react-router-dom'
import { ReactMediaLibrary } from "react-media-library";
import {useIntl} from 'react-intl'
import {useDropzone} from 'react-dropzone';
import styled_c from 'styled-components';
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Dropdown1, CreateCampaignModal} from '../../../_metronic/partials'
import SharePreviewLinkButton from '../../components/SharePreviewLinkButton'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {VnRevertModal} from '../virtual-number/VnRevertByDate'
import clsx from 'clsx'
import {getUserByToken, login} from '../../modules/auth/core/_requests'
import {isNewAccount as isNewCustomerAccount} from '../../utils/accountAge'
import PostVariationsModal from '../../components/PostVariationsModal'
import PostVariationsSettingsPanel from '../../components/PostVariationsSettingsPanel'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { getCategories, getCategoryAttributes } from '../marketplace/core/_requests'
import { getAdminToken } from '../../modules/admin/auth/_requests'
import { transferSingleCampaign } from '../../modules/admin/accounts/core/_requests'
import { IsraelCitySelector } from '../marketplace/IsraelCitySelector'
import { BulkMarketplaceModal } from '../marketplace/BulkMarketplaceModal'
import {Modal as BsModal} from 'bootstrap'
import QRCode from 'react-qr-code'
import WhatsappLinkModal, {findWaLinks, prefixAboveLink, localiseWaPhone} from './WhatsappLinkModal'
import type {FoundWaLink} from './WhatsappLinkModal'

import {
  TablesWidget1,
  TablesWidget2,
  TablesWidget3,
  TablesWidget4,
  TablesWidget5,
  TablesWidget6,
  TablesWidget7,
  TablesWidget8,
  TablesWidget9,
  TablesWidget10,
  TablesWidget11,
  TablesWidget12,
  TablesWidget13,
} from '../../../_metronic/partials/widgets'

import { PieChart } from '@mui/x-charts/PieChart';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';


const newCampaignSchema = Yup.object().shape({
  name: Yup.string()
    // .email('Wrong email format')
    .min(2, 'Minimum 2 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('שם הקמפיין הוא שדה חובה'),
})
const emailFormValidationSchema = Yup.object().shape({
  newUsername: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Username is required'),
  confirmPassword: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})



const API_URL = process.env.REACT_APP_API_URL
const CancelToken = axios.CancelToken;

// Front-end host the phone photo-upload QR codes point at (mobile companion at /m/:code).
const MOBILE_UPLOAD_BASE = 'https://console.fbzipper.com/m'

// Hebrew translations for marketplace categories
const categoryTranslations: {[key: string]: string} = {
  // Main categories
  'Home & Garden': 'בית וגינה',
  'Entertainment': 'בידור',
  'Clothing & Accessories': 'ביגוד ואביזרים',
  'Family': 'משפחה',
  'Electronics': 'אלקטרוניקה',
  'Hobbies': 'תחביבים',
  'Classifieds': 'מודעות',
  'Vehicles': 'רכבים',
  'Rentals': 'השכרות',
  'Home sales': 'מכירת נכסים',
  // Home & Garden subcategories
  'Tools': 'כלי עבודה',
  'Furniture': 'ריהוט',
  'Household': 'מוצרי בית',
  'Garden': 'גינה',
  'Appliances': 'מכשירי חשמל',
  // Entertainment subcategories
  'Video Games': 'משחקי וידאו',
  'Books, Movies & Music': 'ספרים, סרטים ומוזיקה',
  // Clothing & Accessories subcategories
  'Bags & Luggage': 'תיקים ומזוודות',
  "Women's clothing & shoes": 'ביגוד ונעלי נשים',
  "Men's clothing & shoes": 'ביגוד ונעלי גברים',
  'Jewelry & Accessories': 'תכשיטים ואביזרים',
  // Family subcategories
  'Health & beauty': 'בריאות ויופי',
  'Pet Supplies': 'ציוד לחיות מחמד',
  'Baby & kids': 'תינוקות וילדים',
  'Toys & Games': 'צעצועים ומשחקים',
  // Electronics subcategories
  'Electronics & computers': 'אלקטרוניקה ומחשבים',
  'Mobile phones': 'טלפונים סלולריים',
  // Hobbies subcategories
  'Bicycles': 'אופניים',
  'Arts & Crafts': 'אומנות ויצירה',
  'Sports & Outdoors': 'ספורט ופעילות חוץ',
  'Auto parts': 'חלקי רכב',
  'Musical Instruments': 'כלי נגינה',
  'Antiques & Collectibles': 'עתיקות ואספנות',
  // Classifieds subcategories
  'Garage Sale': 'מכירת חיסול',
  'Miscellaneous': 'שונות',
};

// Helper function to translate category name
const translateCategory = (name: string): string => {
  return categoryTranslations[name] || name;
};

// True when the text says something beyond contact lines — phones, links and
// labels like "📞 לחיוג:" removed, at least `min` letters remain.
const hasRealListingText = (text: any, min = 15): boolean => {
  const rest = String(text || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/https?:\/\/\S+|www\.\S+/gi, ' ')
    .replace(/\+?\d[\d\s\-().]{6,}\d/g, ' ')
    .replace(/(לחיוג|להתקשר|טלפון|טל|נייד|לוואטסאפ|וואטסאפ|ווטסאפ|whatsapp|phone|tel|call)\s*[:：]?/gi, ' ');
  return ((rest.match(/\p{L}/gu) || []).length) >= min;
};

// City coordinates for marketplace location
const cityCoordinates: {[key: string]: {lat: number, lng: number}} = {
  // מרכז
  'תל אביב': { lat: 32.0853, lng: 34.7818 },
  'רמת גן': { lat: 32.0680, lng: 34.8248 },
  'גבעתיים': { lat: 32.0717, lng: 34.8124 },
  'בני ברק': { lat: 32.0873, lng: 34.8338 },
  'חולון': { lat: 32.0117, lng: 34.7748 },
  'בת ים': { lat: 32.0171, lng: 34.7514 },
  'ראשון לציון': { lat: 31.9730, lng: 34.7925 },
  'פתח תקווה': { lat: 32.0841, lng: 34.8878 },
  'הרצליה': { lat: 32.1663, lng: 34.8463 },
  'רעננה': { lat: 32.1836, lng: 34.8706 },
  'כפר סבא': { lat: 32.1780, lng: 34.9065 },
  'הוד השרון': { lat: 32.1500, lng: 34.8917 },
  'רמת השרון': { lat: 32.1461, lng: 34.8394 },
  'נתניה': { lat: 32.3286, lng: 34.8569 },
  'לוד': { lat: 31.9514, lng: 34.8955 },
  'רמלה': { lat: 31.9275, lng: 34.8625 },
  'מודיעין': { lat: 31.8980, lng: 35.0101 },
  'רחובות': { lat: 31.8928, lng: 34.8113 },
  'נס ציונה': { lat: 31.9314, lng: 34.7983 },
  'יבנה': { lat: 31.8767, lng: 34.7394 },
  // ירושלים והסביבה
  'ירושלים': { lat: 31.7683, lng: 35.2137 },
  'בית שמש': { lat: 31.7467, lng: 34.9886 },
  'מעלה אדומים': { lat: 31.7780, lng: 35.3093 },
  // צפון
  'חיפה': { lat: 32.7940, lng: 34.9896 },
  'קריית אתא': { lat: 32.8078, lng: 35.1022 },
  'קריית ביאליק': { lat: 32.8333, lng: 35.0833 },
  'קריית מוצקין': { lat: 32.8397, lng: 35.0822 },
  'קריית ים': { lat: 32.8500, lng: 35.0667 },
  'עכו': { lat: 32.9333, lng: 35.0833 },
  'נהריה': { lat: 33.0039, lng: 35.0983 },
  'כרמיאל': { lat: 32.9136, lng: 35.3006 },
  'צפת': { lat: 32.9646, lng: 35.4960 },
  'טבריה': { lat: 32.7922, lng: 35.5312 },
  'עפולה': { lat: 32.6100, lng: 35.2919 },
  'נצרת': { lat: 32.6996, lng: 35.3035 },
  'נצרת עילית': { lat: 32.7019, lng: 35.3228 },
  // דרום
  'באר שבע': { lat: 31.2518, lng: 34.7913 },
  'אשדוד': { lat: 31.8040, lng: 34.6550 },
  'אשקלון': { lat: 31.6658, lng: 34.5664 },
  'קריית גת': { lat: 31.6061, lng: 34.7717 },
  'אילת': { lat: 29.5577, lng: 34.9519 },
  'דימונה': { lat: 31.0697, lng: 35.0331 },
  'אופקים': { lat: 31.3167, lng: 34.6167 },
  'שדרות': { lat: 31.5250, lng: 34.5967 },
  // השרון
  'חדרה': { lat: 32.4340, lng: 34.9196 },
  'זכרון יעקב': { lat: 32.5714, lng: 34.9528 },
  'אור עקיבא': { lat: 32.5050, lng: 34.9200 },
  'קיסריה': { lat: 32.5000, lng: 34.9000 },
};

// Helper to check if user is admin
const checkIsAdmin = async () => {
  try {
    const adminToken = getAdminToken();
    const headers: Record<string, string> = {};
    if (adminToken) {
      headers['Authorization'] = `Bearer ${adminToken}`;
    }
    const response = await axios.get(`${API_URL}/admin/check-auth`, {
      headers,
      withCredentials: true
    });
    return response.data.loggedIn === true;
  } catch {
    return false;
  }
};

// Helper to convert media URLs to proper CDN format
// Converts: ams3.digitaloceanspaces.com/zipper/... or ams3.cdn.digitaloceanspaces.com/zipper/...
// To: https://zipper.ams3.cdn.digitaloceanspaces.com/...
const convertToCdnUrl = toCdnUrl;


  const getColor = (props) => {
    if (props.isDragAccept) {
        return '#00e676';
    }
    if (props.isDragReject) {
        return '#ff1744';
    }
    if (props.isFocused) {
        return '#2196f3';
    }
    return '#eeeeee';
  }

  const Container = styled_c.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
  `;


  // Facebook supported file types
  const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/tiff', 'image/heic', 'image/heif'];
  const SUPPORTED_VIDEO_TYPES = ['video/mp4', 'video/mov', 'video/quicktime', 'video/avi', 'video/x-msvideo', 'video/wmv', 'video/x-ms-wmv', 'video/webm', 'video/mkv', 'video/x-matroska', 'video/3gpp', 'video/mpeg'];
  const SUPPORTED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.tif', '.heic', '.heif'];
  const SUPPORTED_VIDEO_EXTENSIONS = ['.mp4', '.mov', '.avi', '.wmv', '.webm', '.mkv', '.3gp', '.mpeg', '.mpg'];
  const MAX_VIDEO_SIZE_MB = 1024; // Facebook allows up to 1GB for videos

  function isFileSupported(file: File): { supported: boolean; reason?: string } {
    const ext = '.' + file.name.split('.').pop()?.toLowerCase();
    const isImage = file.type.startsWith('image/') || SUPPORTED_IMAGE_EXTENSIONS.includes(ext);
    const isVideo = file.type.startsWith('video/') || SUPPORTED_VIDEO_EXTENSIONS.includes(ext);

    if (!isImage && !isVideo) {
      return { supported: false, reason: `הקובץ "${file.name}" אינו נתמך. ניתן להעלות תמונות (JPG, PNG, GIF, BMP, WebP) או סרטונים (MP4, MOV, AVI, WMV, WebM)` };
    }

    if (isVideo && file.size > MAX_VIDEO_SIZE_MB * 1024 * 1024) {
      return { supported: false, reason: `הסרטון "${file.name}" גדול מדי (${(file.size / (1024 * 1024)).toFixed(0)}MB). הגודל המקסימלי הוא ${MAX_VIDEO_SIZE_MB}MB` };
    }

    return { supported: true };
  }

  // Compress image for Facebook (target under 4MB, max 2048px on longest side)
  async function compressImage(file: File): Promise<File> {
    // Skip compression for videos
    if (file.type.startsWith('video/') || SUPPORTED_VIDEO_EXTENSIONS.includes('.' + file.name.split('.').pop()?.toLowerCase())) {
      return file;
    }

    // Skip if under 10MB
    if (file.size < 10 * 1024 * 1024) {
      return file;
    }

    return new Promise((resolve) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      img.onload = () => {
        let { width, height } = img;
        const maxSize = 2048;

        // Scale down if larger than maxSize
        if (width > maxSize || height > maxSize) {
          if (width > height) {
            height = (height / width) * maxSize;
            width = maxSize;
          } else {
            width = (width / height) * maxSize;
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);

        // More aggressive compression to keep files Facebook-friendly
        let quality = 0.8;
        if (file.size > 3 * 1024 * 1024) quality = 0.65;
        if (file.size > 5 * 1024 * 1024) quality = 0.55;
        if (file.size > 10 * 1024 * 1024) quality = 0.45;

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              console.log(`Compressed ${file.name}: ${(file.size / 1024).toFixed(0)}KB -> ${(compressedFile.size / 1024).toFixed(0)}KB`);
              resolve(compressedFile);
            } else {
              resolve(file);
            }
          },
          'image/jpeg',
          quality
        );
      };

      img.onerror = () => resolve(file);
      img.src = URL.createObjectURL(file);
    });
  }

  function StyledDropzone(props) {
    const intl = useIntl()
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [uploadError, setUploadError] = useState<string | null>(null);

    const {
      getRootProps,
      getInputProps,
      isFocused,
      isDragAccept,
      isDragReject
    } = useDropzone({
      onDrop: async (acceptedFiles) => {
        setUploadError(null);

        // Validate files before uploading
        const unsupported: string[] = [];
        const validFiles: File[] = [];
        for (const file of acceptedFiles) {
          const check = isFileSupported(file);
          if (!check.supported) {
            unsupported.push(check.reason!);
          } else {
            validFiles.push(file);
          }
        }

        if (unsupported.length > 0) {
          setUploadError(unsupported.join('\n'));
          if (validFiles.length === 0) return;
        }

        setUploading(true);
        setUploadProgress({ current: 0, total: validFiles.length });

        for (let i = 0; i < validFiles.length; i++) {
          const file = validFiles[i];
          setUploadProgress({ current: i + 1, total: validFiles.length });
          try {
            // Compress image if needed
            const processedFile = await compressImage(file);

            let fd = new FormData();
            fd.append('file', processedFile);

            var res = await axios.post(`${API_URL}/upload-file`, fd, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

            // Hand the URL to the parent as a functional update instead of
            // pushing onto props.post.media. That array is captured when the drop
            // starts, and anything that replaces editingPost while the upload is
            // in flight — the phone-upload poll, an edit to the text — swaps in a
            // NEW media array, so the push would land on an orphaned one and the
            // file would be silently lost. Photos finish in about a second and
            // usually win the race; a 15MB video takes long enough that it
            // reliably loses it.
            props.onUploaded(res.data.location);
          } catch (err) {
            console.error('Error uploading file:', err);
            setUploadError(`שגיאה בהעלאת הקובץ "${file.name}"`);
          }
        }

        setUploading(false);
        setUploadProgress({ current: 0, total: 0 });
      },
      disabled: uploading,
    });

    return (
      <div>
        <Container {...getRootProps({isFocused, isDragAccept, isDragReject})} style={uploading ? {opacity: 0.6, pointerEvents: 'none'} : {}}>
          <input {...getInputProps()} />
          {uploading ? (
            <div style={{textAlign: 'center', padding: '8px 0'}}>
              <div className="fb-upload-spinner" />
              <p style={{margin: '8px 0 0', fontSize: '13px', color: '#65676b'}}>
                מעלה {uploadProgress.current} מתוך {uploadProgress.total}...
              </p>
            </div>
          ) : (
            <p style={{textAlign: 'center'}}><span style={{fontSize: '24px', display: 'block', marginBottom: '4px'}}>📷</span>{intl.formatMessage({id: 'GENERAL.DRAG_FILES'})}</p>
          )}
        </Container>
        {uploadError && (
          <div style={{
            marginTop: '8px',
            padding: '8px 12px',
            background: '#fee2e2',
            border: '1px solid #fca5a5',
            borderRadius: '8px',
            fontSize: '12px',
            color: '#dc2626',
            whiteSpace: 'pre-line',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px',
          }}>
            <span style={{flexShrink: 0}}>⚠️</span>
            <span style={{flex: 1}}>{uploadError}</span>
            <button onClick={() => setUploadError(null)} style={{background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontWeight: 'bold', fontSize: '14px', flexShrink: 0, padding: 0}}>×</button>
          </div>
        )}
      </div>
    );
  }



const initialValues = { name: '' };

// Customer-service WhatsApp, same number the post-register wizard and the tutorial use.
// 0722210190 → international (drop the leading 0, prepend 972).
const SUPPORT_WA = '972722210190';

// Marketplace listing type used when nothing better is known — when the AI didn't
// classify the post, or the listing is being set up before any content exists.
// The customer base is overwhelmingly real-estate, so a property listing is the far more
// likely guess than a generic item, and it's the one whose extra fields (rooms, size,
// property type) prompt for the details a property ad needs.
const MP_DEFAULT_LISTING_TYPE = 'home_sale';



// Why the user's own number isn't in their post. Shown under every field that carries the
// contact block — body, auto-reply, marketplace auto-reply — because each one is a place
// someone looks for their own phone number and doesn't find it.
const VN_EXPLAINER = 'ℹ️ כל הפוסטים מתפרסמים עם מספר וירטואלי שמעביר אליכם את השיחות וההודעות, כדי שנוכל למדוד את הלידים. לאחר ההרשמה וביצוע התשלום נוכל להסיר את המספר הווירטואלי ולהחזיר את המספר שלכם, אם תרצו.';

// Shown as the textarea's native placeholder when the body is empty on a virtual-number
// post. A real placeholder, not seeded text — nothing to delete, and nothing that can
// reach Facebook if the user doesn't notice it.
const POST_BODY_PLACEHOLDER = '✍️ כתבו כאן את תוכן המודעה…';

// The contact block is pinned to the bottom of the post body and rendered outside the
// textarea, so it can't be typed over — but it IS part of post_content and saves with
// it. These two keep the stored value ("body\n\nblock") and the edited value ("body")
// in sync. Splitting on the exact block means a body that happens to contain the same
// lines mid-text is left alone: only a block at the very end is treated as the pinned one.
const splitVnBody = (content: string, block: string): string => {
  const c = String(content || '');
  if (!block) return c;
  const suffix = `\n\n${block}`;
  if (c.endsWith(suffix)) return c.slice(0, -suffix.length);
  if (c === block) return '';
  return c;
};
// Israeli phone numbers written straight into a post: mobile (05X), landline (02/03/04/
// 08/09), 07X, and the +972 / 972 forms, with or without separators.
// Two deliberate details:
//  - the separator class excludes newlines, so a licence number on one line followed by
//    a phone on the next isn't stitched into one false match;
//  - the digit lookarounds stop a longer run of digits (a price, an ID) from having a
//    10-digit window inside it treated as a phone.
// Counts DIGITS rather than assuming a grouping. Fixed groups (\d{3} then \d{4}) only
// caught the common shapes and silently allowed anything grouped differently —
// 054-1234-567 sailed straight through. This matches an 05X/0X/+972 prefix followed by
// 8-9 more digits however the user chose to break them up.
// Separators are space, dot and hyphen only — no newline, so a licence number on one
// line and an unrelated figure on the next can't be stitched into a false match. The
// trailing lookbehind stops the match ending on a separator, and the digit lookarounds
// keep a longer run (a price, an ID) from matching a window inside it.
// Lengths are per PREFIX, not a blanket 8-9 digits. A blanket range matched a mobile
// number the user was still typing — 052123456 has 9 digits and passed as though it were
// a landline, so mid-typing the number was stripped and the final digit then landed in
// an empty field. Israeli numbering: 05X/07X are 10 digits, 0[2,3,4,8,9] are 9. A partial
// mobile now matches neither branch and is left alone until it's actually complete.
// Separators (space, dot, hyphen — never newline) may appear between any two digits.
const RAW_PHONE_RE = /(?<!\d)(?:\+?972[-. ]?|0[-. ]?)(?:[57][-. ]?\d(?:[-. ]?\d){7}|[23489](?:[-. ]?\d){7})(?!\d)/;

// First phone in `text` that ISN'T the account's own virtual number. The VN's DID is
// supposed to be there — it's the whole point — so it has to be exempt, including when
// it's written in +972 form.
const normalisePhone = (s: string) => String(s || '').replace(/\D/g, '').replace(/^972/, '0');
const findForeignPhone = (text: string, allowedDid: string): string | null => {
  const allowed = normalisePhone(allowedDid);
  const re = new RegExp(RAW_PHONE_RE.source, 'g');
  let m: RegExpExecArray | null;
  while ((m = re.exec(String(text || ''))) !== null) {
    if (!allowed || normalisePhone(m[0]) !== allowed) return m[0];
  }
  return null;
};

// Strip every phone number that isn't the account's own virtual number. Used as the text
// is typed/pasted, so a number is taken out the instant it's complete rather than sitting
// there until the user is stopped at the next step.
// Only the digits go: a line reading "📞 לפרטים: 052…" keeps its label, because guessing
// which surrounding words belonged to the number would delete the user's real copy.
// Left behind is tidied conservatively — doubled spaces collapsed, trailing spaces
// trimmed — and line structure is preserved.
const stripForeignPhones = (text: string, allowedDid: string): {text: string; removed: string | null} => {
  const allowed = normalisePhone(allowedDid);
  let removed: string | null = null;
  const stripped = String(text || '').replace(new RegExp(RAW_PHONE_RE.source, 'g'), (m) => {
    if (allowed && normalisePhone(m) === allowed) return m;
    if (!removed) removed = m;
    return '';
  });
  if (!removed) return {text: String(text || ''), removed: null};
  const tidied = stripped
    .split('\n')
    .map((line) => line.replace(/[ \t]{2,}/g, ' ').replace(/[ \t]+$/, ''))
    .join('\n');
  return {text: tidied, removed};
};

const joinVnBody = (body: string, block: string): string => {
  if (!block) return body;
  // Nothing written yet → just the block, so the post never opens with blank lines.
  if (!body.trim()) return block;
  // Otherwise keep the body byte-for-byte as typed. Trimming here would swallow a
  // newline the moment the user pressed Enter at the end of their text, because the
  // value round-trips through split/join on every keystroke.
  return `${body}\n\n${block}`;
};

// True when the post already routes contact through the virtual number: it holds the
// DID (if we know it) AND a tracked short link (katzr / l.fbzipper). Mirrors the
// /save-post require-virtual-number check.
const hasVirtualContact = (text: string, ddi: string): boolean => {
  const c = text || '';
  const hasLink = /katzr\.net\/|l\.fbzipper\.com\//i.test(c);
  const didDigits = String(ddi || '').replace(/\D/g, '');
  const hasDid = didDigits ? c.replace(/\D/g, '').includes(didDigits) : true;
  return hasLink && hasDid;
};

// The campaign SIGNATURE carries the virtual number when it holds the {number}+{wa_link}
// tokens (they expand to the VN contact at post time) — or already the literal contact.
const signatureCarriesVn = (sig: string, ddi: string): boolean => {
  const s = sig || '';
  const hasTokens = /\{number\}/.test(s) && /\{wa_link\}/.test(s);
  return hasTokens || hasVirtualContact(s, ddi);
};

const GroupsWrapper: FC = () => {
  const {auth, currentUser, logout, getBot, setCurrentBot, currentBot, setBot, saveBot, googleLogin, getQRCode, setCurrentUser} = useAuth()
  // "💬 קישור וואטסאפ" generator in the post editor — admin switch (/admin/settings), off by default.
  const [postWaLinkEnabled, setPostWaLinkEnabled] = useState(false)
  // New posts' "🛒 publish to Marketplace too": real-estate / cars accounts, or customers the
  // admin turned it on for (Account.marketplace_checkbox_enabled). Posts that already have
  // marketplace data keep the section regardless.
  const marketplaceCheckboxShown =
    ['real_estate', 'cars'].includes(String(currentUser?.library_occupation || '')) ||
    !!currentUser?.marketplace_checkbox_enabled
  // "תדירות פרסום" (post strength) in the post editor — admin switch, off by default.
  const [postStrengthEnabled, setPostStrengthEnabled] = useState(false)
  useEffect(() => {
    axios
      .get(`${API_URL}/api/account-settings`)
      .then((r) => {
        setPostWaLinkEnabled(r.data?.post_wa_link_enabled === true)
        setPostStrengthEnabled(r.data?.post_strength_enabled === true)
      })
      .catch(() => {})
  }, [])
  const intl = useIntl()
  const [showCreateCampaignModal, setShowCreateCampaignModal] = useState<boolean>(false)
  const [newCampaignProfiles, setNewCampaignProfiles] = useState<string[]>([])

  const [showEmailForm, setShowEmailForm] = useState<boolean>(true)
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)

  const [loading1, setLoading1] = useState(false)
  const [currentProfile, setCurrentProfile] = useState({});
  const [updatedFacebookProfile, setUpdatedFacebookProfile] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [limitedProfileIds, setLimitedProfileIds] = useState<Set<string>>(new Set());
  const [deletedCampaigns, setDeletedCampaigns] = useState<any[]>([]);
  const [showRestoreMode, setShowRestoreMode] = useState(false);
  const [restoringCampaign, setRestoringCampaign] = useState<string | null>(null);
  const [hiddenProfiles, setHiddenProfiles] = useState<any[]>([]); // soft-deleted profiles (restore mode)
  const [restoringProfile, setRestoringProfile] = useState<string | null>(null);
  const [deletingProfile, setDeletingProfile] = useState<string | null>(null);
  const [marketplaceEnabled] = useState(true);
  const [showBulkMarketplace, setShowBulkMarketplace] = useState(false);
  const [explanationDismissed, setExplanationDismissed] = useState(() => {
    return localStorage.getItem('campaignExplanationDismissed') === 'true';
  });
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'warning' | 'error' } | null>(null);
  const [adminNotes, setAdminNotes] = useState<any[]>([]);
  const [paymentNotes, setPaymentNotes] = useState<any[]>([]);
  const [adminNoteText, setAdminNoteText] = useState('');
  const [showAdminNoteInput, setShowAdminNoteInput] = useState(false);

  // Admin: move campaign to another account
  const [moveAccounts, setMoveAccounts] = useState<any[]>([]);
  const [moveSearch, setMoveSearch] = useState('');
  const [moveTarget, setMoveTarget] = useState<any>(null);
  const [moveProfileIds, setMoveProfileIds] = useState<string[]>([]);
  const [movingCampaign, setMovingCampaign] = useState(false);
  const [moveDropdownOpen, setMoveDropdownOpen] = useState(false);
  const moveDropdownRef = useRef<HTMLDivElement>(null);

  // Auto-dismiss toast after 4 seconds
  useEffect(() => {
    if (!toast) return
    const timer = setTimeout(() => setToast(null), 4000)
    return () => clearTimeout(timer)
  }, [toast])

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const adminToken = getAdminToken();
        const headers: Record<string, string> = {};
        if (adminToken) {
          headers['Authorization'] = `Bearer ${adminToken}`;
        }
        const response = await axios.get(`${API_URL}/admin/check-auth`, {
          headers,
          withCredentials: true
        })
        setIsAdmin(response.data.loggedIn === true)
      } catch {
        // Fallback: check if current user email is admin
        const adminEmails = ['aryeh@dcodeit.biz', 'admin@fbzipper.com'];
        if (currentUser?.email && adminEmails.includes(currentUser.email)) {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      }
    }
    checkAdmin()
  }, [currentUser?.email]);


  // Fetch admin notes for current account
  useEffect(() => {
    if (!isAdmin || !currentUser?._id) return;
    const fetchNotes = async () => {
      try {
        const adminToken = localStorage.getItem('admin_auth_token');
        if (!adminToken) return;
        const res = await axios.get(`${API_URL}/admin/account-notes/${currentUser._id}`, {
          headers: { Authorization: `Bearer ${adminToken}` }, withCredentials: true
        });
        setAdminNotes(res.data.admin_notes || []);
        setPaymentNotes(res.data.payment_notes || []);
      } catch { /* silently fail */ }
    };
    fetchNotes();
  }, [isAdmin, currentUser?._id]);

  // Admin: load accounts list for the "move campaign" target picker
  useEffect(() => {
    if (!isAdmin) return;
    const token = getAdminToken();
    if (!token) return;
    axios.get(`${API_URL}/admin/search-accounts`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true
    }).then(res => {
      setMoveAccounts(res.data?.accounts || []);
    }).catch(() => {});
  }, [isAdmin]);

  // Close move-target dropdown on click outside
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (moveDropdownRef.current && !moveDropdownRef.current.contains(e.target as Node)) {
        setMoveDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Admin: perform the campaign move
  const handleMoveCampaign = async () => {
    if (!selectedCampaign?._id || !currentUser?._id || !moveTarget?._id) return;
    setMovingCampaign(true);
    try {
      const {data} = await transferSingleCampaign(
        currentUser._id,
        selectedCampaign._id,
        moveTarget._id,
        moveProfileIds
      );
      setToast({
        message: `הקמפיין "${data.campaign}" הועבר (${data.movedProfileCount} פרופילים, ${data.movedSlotCount} סלוטים)`,
        type: 'success'
      });
      // Close the modal
      const modalEl = document.getElementById('kt_modal_move_campaign');
      if (modalEl) BsModal.getOrCreateInstance(modalEl).hide();
      setMoveTarget(null);
      setMoveSearch('');
      // Refresh current user so the campaign disappears from the source account UI
      const {data: user} = await getUserByToken(auth.api_token);
      setCurrentUser(user);
    } catch (e: any) {
      setToast({
        message: e?.response?.data?.error || 'שגיאה בהעברת הקמפיין',
        type: 'error'
      });
    } finally {
      setMovingCampaign(false);
    }
  };

  // Fetch schedule profile stats for admin dashboard
  const [scheduleProfileStats, setScheduleProfileStats] = useState<any[]>([]);
  const [editingPostsPerDay, setEditingPostsPerDay] = useState<{profileId: string; value: string} | null>(null);
  const [savedPostsPerDay, setSavedPostsPerDay] = useState<string | null>(null);
  useEffect(() => {
    if (!isAdmin) return;
    const fetchStats = async () => {
      try {
        const authToken = localStorage.getItem('kt-auth-react-v');
        if (!authToken) return;
        const parsed = JSON.parse(authToken);
        if (!parsed?.api_token) return;
        const response = await axios.get(`${API_URL}/api/schedule/today`, {
          headers: { Authorization: `Bearer ${parsed.api_token}` }
        });
        if (response.data?.profile_stats) {
          setScheduleProfileStats(response.data.profile_stats);
        }
      } catch {
        // silently fail
      }
    };
    fetchStats();
  }, [isAdmin]);

  // Fetch limited profiles for admin red dot indicators
  useEffect(() => {
    if (!isAdmin) return;
    const fetchLimited = async () => {
      try {
        const adminToken = localStorage.getItem('admin_auth_token');
        const res = await axios.get(`${API_URL}/admin/limited-profiles`, {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
          withCredentials: true
        });
        if (Array.isArray(res.data)) {
          setLimitedProfileIds(new Set(res.data));
        }
      } catch {
        // silently fail
      }
    };
    fetchLimited();
  }, [isAdmin]);

  const handleProfilePostsPerDaySave = async (profileId: string, value: string) => {
    const num = parseInt(value, 10);
    if (isNaN(num) || num < 1 || num > 1000) {
      setEditingPostsPerDay(null);
      return;
    }
    try {
      const adminToken = getAdminToken();
      await axios.put(`${API_URL}/admin/meetings/profiles/${profileId}/posts-per-day`,
        { posts_per_day: num },
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );
      setSavedPostsPerDay(profileId);
      setTimeout(() => setSavedPostsPerDay(null), 1500);
      setScheduleProfileStats(prev => prev.map((p: any) =>
        p._id === profileId ? {...p, max_daily: num} : p
      ));
    } catch (e) {
      console.error('Failed to update posts_per_day:', e);
    }
    setEditingPostsPerDay(null);
  };

  const formik1 = useFormik<IUpdateEmail>({
    initialValues: {
    },
    validationSchema: emailFormValidationSchema,
    onSubmit: (values) => {
      setLoading1(true);


      values._id = currentProfile._id;
      return axios.post(`${API_URL}/api/set-single-profile`, values).then(async (data) => {
        setCurrentProfile(data.data)
        setLoading1(false)
        setShowEmailForm(false);

        var data = await axios.get(`${API_URL}/api/get-single-profile`);

        setCurrentProfile(data.data);
        setUpdatedFacebookProfile(true);
        setAllProfiles(data.data.all_users);


      }).catch(() => {
        setLoading1(false);
        alert('שגיאה. יש למלא את כל השדות החובה')
      })

    },
  })



  const formik = useFormik({
    initialValues,
    validationSchema: newCampaignSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      console.log(values);

      try {
        var new_campaign = await axios.post(`${API_URL}/create-campaign`, {
          api_token: auth?.api_token || '',
          new_campaign: values,
        });

        // Save selected profiles for the new campaign
        if (newCampaignProfiles.length > 0) {
          await axios.post(`${API_URL}/api/save-campaign-profiles`, {
            campaign_id: new_campaign.data._id,
            users: newCampaignProfiles
          });
        }

        const {data: user} = await getUserByToken(auth.api_token)
        setCurrentUser(user)

        navigate(`/campaigns/${new_campaign.data._id}?${params.toString()}`);

        // Wait for campaign stats to load before closing modal
        await new Promise<void>((resolve) => {
          const poll = () => {
            const statsEl = document.querySelector('[data-onboarding="campaign-stats-loaded"]');
            if (statsEl) {
              resolve();
            } else {
              setTimeout(poll, 200);
            }
          };
          poll();
        });

        // Close the modal after everything is loaded
        const dismissBtn = document.querySelector('#kt_modal_1 [data-bs-dismiss="modal"]') as HTMLElement;
        dismissBtn?.click();

        // Scroll to posts section after navigation
        setTimeout(() => {
          document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500);
      } catch (e) {
        console.log(e);
        alert(1234)
      }

    },
  })

  const location = useLocation();
  const navigate = useNavigate();

  // Auto-start tutorial on desktop for new users (no connected profile, onboarding not completed)
  useEffect(() => {
    if (window.innerWidth <= 768) return; // Mobile uses OnboardingWizard
    if (!currentUser) return;
    if (currentUser.onboarding?.completed) return;
    if (!isNewCustomerAccount(currentUser)) return; // existing customers: no first-run tutorial
    // Accounts from 2026-10-18 on get the OnboardingGuide (3 short steps) instead.
    if (currentUser.created_at && new Date(currentUser.created_at) >= new Date('2026-10-18T00:00:00+03:00')) return;
    // Right after registration the PostRegisterOnboarding wizard runs first; don't let the
    // tutorial preempt it with ?tut=full. The wizard hands off to the tutorial on finish.
    if (localStorage.getItem('onboarding_pending') === '1') return;
    if (localStorage.getItem('tutorial_skipped') === 'true') return; // User previously skipped
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('tut')) return; // Already in tutorial
    const profiles = currentUser.users || [];
    const hasConnectedParentProfile = profiles.some((p: any) => p.facebook_id && !p.parent_user);
    if (hasConnectedParentProfile) return;
    // Auto-start tutorial
    searchParams.set('tut', 'full');
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  }, [currentUser]);

  // Helper to calculate actual group count (manual groups + library groups - blacklisted)
  const getGroupCount = (camp: any) => {
    const blacklistedSet = new Set((camp.blacklisted_groups || []).map((id: any) => id?.toString?.() || id));
    const manualGroups = (camp.slot_selected_groups || []).map((id: any) => id?.toString?.() || id);
    const libraryGroups = (camp.library_groups || []).map((id: any) => id?.toString?.() || id);
    const allGroups = [...new Set([...manualGroups, ...libraryGroups])];
    return allGroups.filter((id: any) => !blacklistedSet.has(id))?.length ?? 0;
  };

  let [campaigns, setCampaigns] = useState(currentUser?.campaigns || []);
  const [campaignSearch, setCampaignSearch] = useState('');
  let [galleryItems, setGalleryItems] = useState([]);
  const [params, setParams] = useState(new URLSearchParams(location.search));

  // Check for restore mode and fetch deleted campaigns
  useEffect(() => {
    const restoreParam = new URLSearchParams(location.search).get('restore');
    const urlCampaignId = location.pathname.split('/campaigns/')[1]?.split('?')[0];

    // Check admin status directly from user email as fallback
    const adminEmails = ['aryeh@dcodeit.biz', 'admin@fbzipper.com'];
    const isUserAdmin = isAdmin || (currentUser?.email && adminEmails.includes(currentUser.email));

    console.log('Restore check:', { restoreParam, isAdmin, isUserAdmin, urlCampaignId, userEmail: currentUser?.email });

    if (restoreParam === '1' && isUserAdmin && urlCampaignId) {
      setShowRestoreMode(true);
      const fetchDeletedCampaigns = async () => {
        try {
          console.log('Fetching deleted campaigns for campaign:', urlCampaignId);
          // Get admin token from localStorage if available
          const adminToken = localStorage.getItem('admin_auth_token');
          const headers: Record<string, string> = {};
          if (adminToken) {
            headers['Authorization'] = `Bearer ${adminToken}`;
          }
          const response = await axios.post(`${API_URL}/deleted-campaigns`, {
            api_token: auth?.api_token,
            campaign_id: urlCampaignId
          }, { headers });
          console.log('Deleted campaigns response:', response.data);
          if (response.data.success) {
            setDeletedCampaigns(response.data.campaigns);
          }
        } catch (e) {
          console.error('Error fetching deleted campaigns:', e);
        }
      };
      fetchDeletedCampaigns();
      // Also fetch soft-deleted (hidden) profiles for restore.
      (async () => {
        try {
          const r = await axios.get(`${API_URL}/api/schedule/admin/hidden-profiles`, {headers: adminAuthHeader()});
          if (r.data?.success) setHiddenProfiles(r.data.profiles || []);
        } catch (e) { console.error('Error fetching hidden profiles:', e); }
      })();
    } else {
      setShowRestoreMode(false);
      setDeletedCampaigns([]);
      setHiddenProfiles([]);
    }
  }, [location.search, location.pathname, isAdmin, auth?.api_token, currentUser?.email]);

  // Check for add-profile URL parameter
  useEffect(() => {
    const addProfileParam = new URLSearchParams(location.search).get('add-profile');
    if (addProfileParam === '1') {
      setProfileCount(1);
      setAddProfileTab('new');
      setSelectedSubProfiles([]);
      setShowAddProfileModal(true);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
      // Load slots data when opening via URL
      (async () => {
        setLoadingSlots(true);
        try {
          const response = await axios.get(`${API_URL}/api/slots`);
          if (response.data.success) {
            setProfileSlots(response.data.profile_slots || []);
            setSubprofileSlots(response.data.subprofile_slots || []);
            setSlotsSummary(response.data.summary || null);
          }
        } catch (e) {
          console.error('Error loading slots:', e);
        } finally {
          setLoadingSlots(false);
        }
      })();
    }
  }, [location.search]);

  // Function to load slots data from API
  const loadSlots = async () => {
    setLoadingSlots(true);
    try {
      const response = await axios.get(`${API_URL}/api/slots`);
      if (response.data.success) {
        setProfileSlots(response.data.profile_slots || []);
        setSubprofileSlots(response.data.subprofile_slots || []);
        setSlotsSummary(response.data.summary || null);
      }
    } catch (e) {
      console.error('Error loading slots:', e);
    } finally {
      setLoadingSlots(false);
    }
  };

  // Helper to open add profile modal with URL
  const openAddProfileModal = () => {
    setProfileCount(1);
    setAddProfileTab('new');
    setSelectedSubProfiles([]);
    setCardcomUrl(null);
    setShowAddProfileModal(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    // Load slots data
    loadSlots();
    // Update URL without navigation
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('add-profile', '1');
    window.history.pushState({}, '', newUrl.toString());
  };

  // Helper to close add profile modal and clean URL
  const closeAddProfileModal = () => {
    setShowAddProfileModal(false);
    setCardcomUrl(null);
    // Restore body scroll
    document.body.style.overflow = '';
    // Remove add-profile param from URL
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('add-profile');
    window.history.pushState({}, '', newUrl.toString());
  };

  const restoreCampaign = async (campaignId: string) => {
    setRestoringCampaign(campaignId);
    try {
      // Get admin token from localStorage if available
      const adminToken = localStorage.getItem('admin_auth_token');
      const headers: Record<string, string> = {};
      if (adminToken) {
        headers['Authorization'] = `Bearer ${adminToken}`;
      }
      const response = await axios.post(`${API_URL}/restore-campaign`, {
        api_token: auth?.api_token,
        campaign_id: campaignId
      }, { headers });
      if (response.data.success) {
        // Remove from deleted list
        setDeletedCampaigns(prev => prev.filter(c => c._id !== campaignId));
        // Refresh user data to get updated campaigns
        const {data: user} = await getUserByToken(auth.api_token);
        setCurrentUser(user);
        setToast({ message: 'הקמפיין שוחזר בהצלחה', type: 'success' });
      }
    } catch (e: any) {
      console.error('Error restoring campaign:', e);
      setToast({ message: e.response?.data?.error || 'שגיאה בשחזור הקמפיין', type: 'error' });
    } finally {
      setRestoringCampaign(null);
    }
  };

  const restoreProfile = async (profileId: string) => {
    setRestoringProfile(profileId);
    try {
      const res = await axios.post(`${API_URL}/api/schedule/admin/profile/${profileId}/restore`, {}, {headers: adminAuthHeader()});
      if (res.data?.success) {
        setHiddenProfiles(prev => prev.filter(p => p._id !== profileId));
        await refreshProfilesList();
        setToast({ message: 'הפרופיל שוחזר בהצלחה', type: 'success' });
      } else setToast({ message: res.data?.error || 'שגיאה בשחזור הפרופיל', type: 'error' });
    } catch (e: any) {
      setToast({ message: e.response?.data?.error || 'שגיאה בשחזור הפרופיל', type: 'error' });
    } finally {
      setRestoringProfile(null);
    }
  };

  const permanentDeleteProfile = async (profile: any) => {
    const nm = profile?.name || 'הפרופיל';
    if (!window.confirm(`⚠️ מחיקה לצמיתות של "${nm}"\n\nפעולה זו בלתי הפיכה! הפרופיל, הפרופילים המשניים שלו, כל התזמונים, הפוסטים המתוזמנים והשיוך לקבוצות יימחקו לצמיתות ולא ניתן יהיה לשחזר אותם.\n\nהאם להמשיך?`)) return;
    setDeletingProfile(profile._id);
    try {
      const res = await axios.post(`${API_URL}/api/schedule/admin/profile/${profile._id}/permanent-delete`, {}, {headers: adminAuthHeader()});
      if (res.data?.success) {
        setHiddenProfiles(prev => prev.filter(p => p._id !== profile._id));
        setToast({ message: 'הפרופיל נמחק לצמיתות', type: 'success' });
      } else setToast({ message: res.data?.error || 'שגיאה במחיקת הפרופיל', type: 'error' });
    } catch (e: any) {
      setToast({ message: e.response?.data?.error || 'שגיאה במחיקת הפרופיל', type: 'error' });
    } finally {
      setDeletingProfile(null);
    }
  };

  let [currImg, setCurrImg] = useState(0);
  let [loggingInProfile, setLoggingInProfile] = useState(null);
  let [profileLoginSuccess, setProfileLoginSuccess] = useState(false);
  // QR login flow: status is 'starting' (asking fleet to launch the bot),
  // 'pending' (bot up, waiting for FB to hand it a login QR), 'ready'
  // (qrLoginUrl holds the FB device-login URL), or 'error'.
  const [qrLoginStatus, setQrLoginStatus] = useState<'starting' | 'pending' | 'ready' | 'error'>('starting');
  const [qrLoginUrl, setQrLoginUrl] = useState<string | null>(null);
  // How this profile connects, per the server (admin flag "התחברות פרופילים
  // בברקוד"). 'password' — the default while FB's QR login is broken — means
  // passwordLoginUrl holds the /c/:code page where the customer types their FB
  // email + password, and there is no code to wait for.
  const [loginMethod, setLoginMethod] = useState<'qr' | 'password'>('qr');
  const [passwordLoginUrl, setPasswordLoginUrl] = useState<string | null>(null);
  const isMobileDevice = typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // Send the login link to a phone's WhatsApp (defaults to the account phone).
  // Kept for back-compat; the in-UI sender is hidden — users now share the link
  // themselves from a device that has the FB app via the "connect another device" flow.
  const [whatsappPhone, setWhatsappPhone] = useState<string>('');
  const [sendingWhatsapp, setSendingWhatsapp] = useState(false);
  const [whatsappSent, setWhatsappSent] = useState(false);
  // Toggle: shows instructions for sending the QR-login link from another device.
  const [showOtherDeviceInstructions, setShowOtherDeviceInstructions] = useState(false);
  // One-shot "Copied!" indicator on the copy-link button.
  const [copiedQrLink, setCopiedQrLink] = useState(false);
  // Minting a connect-link spins up a browser session on a box, so it isn't instant —
  // disable the username/password button while it's in flight.
  const [connectLinkBusy, setConnectLinkBusy] = useState(false);
  // Inline-edit state for profile display name (first_name + last_name).
  // editingNameProfileId = the FacebookUser._id currently being renamed (null
  // when no field is active). editingNameValue is the in-flight text.
  const [editingNameProfileId, setEditingNameProfileId] = useState<string | null>(null);
  const [editingNameValue, setEditingNameValue] = useState<string>('');
  const [savingNameProfileId, setSavingNameProfileId] = useState<string | null>(null);
  const saveProfileDisplayName = async (profileId: string, raw: string) => {
    const trimmed = raw.trim();
    if (!trimmed) { setEditingNameProfileId(null); return; }
    // Split on first space — everything before goes to first_name, rest to
    // last_name. Matches how the card displays "{first_name} {last_name}".
    const spaceIdx = trimmed.indexOf(' ');
    const first_name = spaceIdx === -1 ? trimmed : trimmed.slice(0, spaceIdx);
    const last_name = spaceIdx === -1 ? '' : trimmed.slice(spaceIdx + 1);
    setSavingNameProfileId(profileId);
    try {
      const r = await axios.post(`${API_URL}/api/update-profile-settings`, { profile_id: profileId, first_name, last_name });
      if (r.data?.success) {
        setAllProfiles((prev: any[]) => prev.map(p =>
          p._id === profileId ? { ...p, first_name: r.data.first_name, last_name: r.data.last_name } : p
        ));
      }
    } catch (e) {
      console.error('Failed to update profile name', e);
    } finally {
      setSavingNameProfileId(null);
      setEditingNameProfileId(null);
    }
  };
  const initialFacebookIdRef = useRef<string | null>(null);
  const initialHealthCheckRef = useRef<string | null>(null);
  let [showAddProfileModal, setShowAddProfileModal] = useState(false);
  let [addingProfile, setAddingProfile] = useState(false);
  let [paymentInfo, setPaymentInfo] = useState<any>(null);
  let [profileCount, setProfileCount] = useState(1);
  let [addProfileTab, setAddProfileTab] = useState<'new' | 'subprofiles'>('new');
  let [selectedSubProfiles, setSelectedSubProfiles] = useState<string[]>([]);
  let [cardcomUrl, setCardcomUrl] = useState<string | null>(null);
  let [loadingCardcom, setLoadingCardcom] = useState(false);

  // Slot management state
  let [profileSlots, setProfileSlots] = useState<any[]>([]);
  let [subprofileSlots, setSubprofileSlots] = useState<any[]>([]);
  let [slotsSummary, setSlotsSummary] = useState<any>(null);
  let [loadingSlots, setLoadingSlots] = useState(false);
  let [addingSlot, setAddingSlot] = useState<string | null>(null);
  let [removingSlot, setRemovingSlot] = useState<string | null>(null);
  let [assigningSlot, setAssigningSlot] = useState<any>(null);
  const [slotVnOnly, setSlotVnOnly] = useState(false); // filter switch-profile list to profiles with a virtual number
  // Admin-only account status (חדש / לקוח עובד / לא רלוונטי) shown in the slot/switch-profile sheet.
  const [acctStatus, setAcctStatus] = useState<string>((currentUser as any)?.customer_info?.account_status || 'new_account');
  const [savingAcctStatus, setSavingAcctStatus] = useState(false);
  const saveAccountStatus = async (status: string) => {
    setAcctStatus(status);
    setSavingAcctStatus(true);
    try {
      const headers: any = {};
      const adminToken = localStorage.getItem('admin_auth_token');
      if (adminToken) headers['Authorization'] = `Bearer ${adminToken}`;
      await axios.post(`${API_URL}/admin/account-status/${currentUser?._id}`, { status }, { headers, withCredentials: true });
    } catch (e) {
      console.error('save account status failed', e);
    } finally {
      setSavingAcctStatus(false);
    }
  };
  let [creatingProfileInSlot, setCreatingProfileInSlot] = useState<any>(null);
  let [profileLoginUrl, setProfileLoginUrl] = useState<string | null>(null);
  let [creatingProfile, setCreatingProfile] = useState(false);
  let [newProfileUsername, setNewProfileUsername] = useState('');
  let [newProfilePassword, setNewProfilePassword] = useState('');
  let [showNewProfilePassword, setShowNewProfilePassword] = useState(false);
  let [showPaymentHistory, setShowPaymentHistory] = useState(false);
  let [planPayments, setPlanPayments] = useState<any[]>([]);
  let [loadingPayments, setLoadingPayments] = useState(false);
  let [showAddConfirmation, setShowAddConfirmation] = useState<'profile' | 'subprofile' | null>(null);
  let [confirmingAdd, setConfirmingAdd] = useState(false);
  let [addSlotCount, setAddSlotCount] = useState(1);

  // Add slot directly without confirmation (for demo users)
  const handleAddSlotDirect = async (slotType: 'profile' | 'subprofile') => {
    setAddingSlot(slotType);
    try {
      const response = await axios.post(`${API_URL}/api/slots/add`, {
        slot_type: slotType,
        count: 1
      });
      if (response.data.success) {
        const slotsRes = await axios.get(`${API_URL}/api/slots`);
        if (slotsRes.data.success) {
          setProfileSlots(slotsRes.data.profile_slots);
          setSubprofileSlots(slotsRes.data.subprofile_slots);
          setSlotsSummary(slotsRes.data.summary);
        }
        setToast({ message: `${slotType === 'profile' ? 'פרופיל' : 'דף'} נוסף בהצלחה!`, type: 'success' });
        setTimeout(() => setToast(null), 5000);
      } else {
        setToast({ message: response.data.error || 'שגיאה', type: 'error' });
        setTimeout(() => setToast(null), 5000);
      }
    } catch (e: any) {
      setToast({ message: e.response?.data?.error || 'שגיאה בהוספה', type: 'error' });
      setTimeout(() => setToast(null), 5000);
    }
    setAddingSlot(null);
  };

  // Poll for profile login while the connect popup is open (QR flow). Once
  // the phone scans the QR and the bot logs in, the bot updates the
  // profile's facebook_id / last_health_check, which this catches.
  useEffect(() => {
    if (!loggingInProfile || profileLoginSuccess) return

    const profileId = loggingInProfile._id

    const checkLogin = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/get-single-profile`, {
          params: { api_token: auth?.api_token }
        })

        const profileData = response.data?.bot || response.data
        const allUsers = profileData?.all_users || []

        // Find the specific profile and check if it's now actually connected
        // Only consider logged in if: facebook_id is new, OR health check updated since iframe opened
        const targetProfile = allUsers.find((u: any) => u._id === profileId)
        if (targetProfile && targetProfile.facebook_id) {
          const isNewFacebookId = targetProfile.facebook_id !== initialFacebookIdRef.current
          const healthCheckChanged = targetProfile.last_health_check && targetProfile.last_health_check !== initialHealthCheckRef.current
          if (isNewFacebookId || healthCheckChanged) {
            console.log('[Groups] Profile logged in!', targetProfile)
            setAllProfiles(allUsers)
            setProfileLoginSuccess(true)
          }
        }
      } catch (e) {
        console.error('Error checking profile login:', e)
      }
    }

    // First check after 10 seconds (not immediately — profile was just submitted)
    const interval = setInterval(checkLogin, 10000)
    return () => clearInterval(interval)
  }, [loggingInProfile, profileLoginSuccess, auth?.api_token])

  // When the connect popup opens: ask the API to ensure the profile's bot
  // is running on the fleet, then poll for the FB login QR URL it sniffs.
  // Everything goes through the API — the client never hits the fleet.
  useEffect(() => {
    if (!loggingInProfile) return
    const profileId = loggingInProfile._id
    let cancelled = false
    let pollTimer: any = null

    setQrLoginStatus('starting')
    setQrLoginUrl(null)
    setLoginMethod('qr')
    setPasswordLoginUrl(null)
    setShowOtherDeviceInstructions(false)
    setCopiedQrLink(false)
    // Default to the local Israeli format (05XXXXXXXX); backend converts it.
    const toLocalIl = (p?: string) => {
      if (!p) return ''
      let s = p.replace(/[^\d+]/g, '')
      if (s.startsWith('+972')) s = '0' + s.slice(4)
      else if (s.startsWith('972')) s = '0' + s.slice(3)
      return s
    }
    setWhatsappPhone(toLocalIl(currentUser?.phone))
    setWhatsappSent(false)

    let lastStartAt = 0

    const startBot = async () => {
      lastStartAt = Date.now()
      try {
        await axios.post(`${API_URL}/api/profile-login/start`, { _id: profileId })
      } catch (e) {
        console.error('[Groups] fleet start failed:', e)
        // Still poll — the bot might already be running from a prior attempt.
      }
    }

    const pollQr = async () => {
      if (cancelled) return
      try {
        const res = await axios.get(`${API_URL}/api/profile-login/qr/${profileId}`)
        if (cancelled) return
        // Password mode answers on the first call and never changes — show the
        // link and stop polling, there is no QR coming.
        if (res.data?.method === 'password' && res.data.url) {
          setPasswordLoginUrl(res.data.url)
          setLoginMethod('password')
          setQrLoginStatus('ready')
          return
        }
        if (res.data?.status === 'ready' && res.data.url) {
          setQrLoginUrl(res.data.url)
          setQrLoginStatus('ready')
        } else {
          setQrLoginStatus((s) => (s === 'ready' ? s : 'pending'))
          // Stuck waiting for the QR? Re-send the start request every 15s
          // until the code shows up.
          if (Date.now() - lastStartAt >= 15000) {
            await startBot()
          }
        }
      } catch (e) {
        // keep waiting — the bot may still be coming up
      }
      if (!cancelled) pollTimer = setTimeout(pollQr, 3000)
    }

    const startAndPoll = async () => {
      // Ask how this profile connects BEFORE waiting on the fleet. In password
      // mode the answer comes back immediately, so the customer gets the login
      // button at once instead of watching a skeleton while a bot spawns — the
      // spawn still happens, just in the background, to warm the embed.
      try {
        const res = await axios.get(`${API_URL}/api/profile-login/qr/${profileId}`)
        if (cancelled) return
        if (res.data?.method === 'password' && res.data.url) {
          setPasswordLoginUrl(res.data.url)
          setLoginMethod('password')
          setQrLoginStatus('ready')
          startBot()
          return
        }
      } catch (e) {
        // fall through to the QR flow — it re-checks on every poll
      }
      await startBot()
      if (!cancelled) {
        setQrLoginStatus((s) => (s === 'ready' ? s : 'pending'))
        pollQr()
      }
    }

    startAndPoll()
    return () => {
      cancelled = true
      if (pollTimer) clearTimeout(pollTimer)
    }
  }, [loggingInProfile])

  const sendLoginLinkToWhatsapp = async () => {
    if (!loggingInProfile || !whatsappPhone.trim()) return
    setSendingWhatsapp(true)
    setWhatsappSent(false)
    try {
      await axios.post(`${API_URL}/api/profile-login/send-whatsapp`, {
        _id: loggingInProfile._id,
        phone: whatsappPhone.trim(),
      })
      setWhatsappSent(true)
      setTimeout(() => setWhatsappSent(false), 4000)
    } catch (e: any) {
      setToast({ message: e.response?.data?.error === 'invalid phone number' ? 'מספר טלפון לא תקין' : 'שגיאה בשליחה לוואטסאפ', type: 'error' })
      setTimeout(() => setToast(null), 5000)
    } finally {
      setSendingWhatsapp(false)
    }
  }

  let unallocated = campaigns.reduce((count, camp) => {
    count -= camp.publish_percentage || 0;
    count = Math.max(count, 0);
    return count;
  }, 100);

  useEffect(() => {
      setParams(new URLSearchParams(location.search));
  }, [location.search]); // Dependency on location.search ensures this runs when query changes

  const [display, setDisplay] = useState(false);
  let fileLibraryList: any;
  let setFileLibraryList: any;
  let selectedCampaign: any;
  let setSelectedCampaign: any;
  let selectedPost: any;
  let setSelectedPost: any;

  [fileLibraryList, setFileLibraryList] = useState([]);
  [selectedCampaign, setSelectedCampaign] = useState({});
  const [groupsModalOpen, setGroupsModalOpen] = useState(false);

  // yad2 sync (client side) — for accounts whose campaigns were imported from a yad2 agent
  const [yad2Sync, setYad2Sync] = useState<{has_yad2?: boolean; linked?: boolean; enabled?: boolean; last_synced_at?: string; settings?: any} | null>(null);
  const [yad2Syncing, setYad2Syncing] = useState(false);
  const [yad2Modal, setYad2Modal] = useState(false);
  const [yad2Form, setYad2Form] = useState<any>({});
  const userAuthHeader = () => {
    try {
      const raw = localStorage.getItem('kt-auth-react-v');
      const t = raw ? JSON.parse(raw)?.api_token : null;
      return t ? {Authorization: `Bearer ${t}`} : {};
    } catch (_) { return {}; }
  };
  // ADMIN-ONLY: turn this account into a yad2 customer (pick agent → pull listings daily).
  const isAdminMode = (() => { try { return !!localStorage.getItem('admin_auth_token'); } catch (_) { return false; } })();
  // Affiliate viewing a customer they "logged in as" (handleLoginAs stamps this).
  const isAffiliateSession = (() => { try { return !!localStorage.getItem('affiliate_return'); } catch (_) { return false; } })();
  const adminAuthHeader = () => {
    const h: any = {...userAuthHeader()};
    try { const a = localStorage.getItem('admin_auth_token'); if (a) h['X-Admin-Token'] = a; } catch (_) {}
    return h;
  };
  // Admin (logged in as client): add a blank profile record (no QR) / soft-delete
  // a profile. Endpoints authorize via the X-Admin-Token in adminAuthHeader().
  const [adminProfileBusy, setAdminProfileBusy] = useState(false);
  const refreshProfilesList = async () => {
    try { const r = await axios.get(`${API_URL}/api/get-single-profile`); setAllProfiles(r.data.data.all_users); } catch (_) {}
  };
  const handleAdminAddProfile = async () => {
    setAdminProfileBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/schedule/admin/add-profile`, {}, {headers: adminAuthHeader()});
      if (res.data?.success) { setToast({message: 'פרופיל נוצר ✓ — לחיבור צרו ברקוד כשתרצו', type: 'success'}); await refreshProfilesList(); }
      else setToast({message: res.data?.error || 'יצירת הפרופיל נכשלה', type: 'error'});
    } catch (e: any) { setToast({message: 'יצירת הפרופיל נכשלה: ' + (e?.response?.data?.error || e?.message), type: 'error'}); }
    finally { setAdminProfileBusy(false); }
  };
  const handleAdminDeleteProfile = async (profile: any) => {
    const nm = `${profile.first_name || profile.facebook_username || profile.facebook_id || 'פרופיל'} ${profile.last_name || ''}`.trim();
    if (!window.confirm(`למחוק את הפרופיל "${nm}"?\n\n⚠️ מחיקה רכה: הפרופיל יוסתר מהמערכת (ניתן לשחזר), כולל הפרופילים המשניים שלו. הפוסטים והתזמונים שלו יפסיקו לפעול.`)) return;
    setAdminProfileBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/schedule/admin/profile/${profile._id}/soft-delete`, {}, {headers: adminAuthHeader()});
      if (res.data?.success) { setToast({message: 'הפרופיל נמחק (מחיקה רכה)', type: 'success'}); await refreshProfilesList(); }
      else setToast({message: res.data?.error || 'המחיקה נכשלה', type: 'error'});
    } catch (e: any) { setToast({message: 'המחיקה נכשלה: ' + (e?.response?.data?.error || e?.message), type: 'error'}); }
    finally { setAdminProfileBusy(false); }
  };
  const [yad2SetupModal, setYad2SetupModal] = useState(false);
  const [yad2AgentQuery, setYad2AgentQuery] = useState('');
  const [yad2AgentResults, setYad2AgentResults] = useState<any[]>([]);
  const [yad2AgentSearching, setYad2AgentSearching] = useState(false);
  const [yad2AgentPicked, setYad2AgentPicked] = useState<any>(null);
  const [yad2SetupContact, setYad2SetupContact] = useState('');
  const [yad2SetupBusy, setYad2SetupBusy] = useState(false);
  // Import scope: just this agent's phone, or every broker in their agency (the
  // office behind the /realestate/agency/<id>/ page). Agent-scoped is the default —
  // an office holds other brokers, so pulling it in is an explicit choice.
  const [yad2SetupScope, setYad2SetupScope] = useState<'agent' | 'agency'>('agent');
  const [yad2SetupAgency, setYad2SetupAgency] = useState<any>(null);
  const [yad2AgencyLoading, setYad2AgencyLoading] = useState(false);
  // Look up the picked agent's agency so the choice can show what each scope pulls.
  useEffect(() => {
    setYad2SetupAgency(null);
    setYad2SetupScope('agent');
    if (!yad2AgentPicked?.phone) return;
    let dead = false;
    setYad2AgencyLoading(true);
    axios.get(`${API_URL}/api/yad2-agency-lookup`, {params: {phone: yad2AgentPicked.phone}, headers: adminAuthHeader()})
      .then((r) => { if (!dead) setYad2SetupAgency(r.data?.agency || null); })
      .catch(() => { if (!dead) setYad2SetupAgency(null); })
      .finally(() => { if (!dead) setYad2AgencyLoading(false); });
    return () => { dead = true; };
  }, [yad2AgentPicked]);
  // Debounced agent autocomplete (public endpoint — no auth needed to search).
  useEffect(() => {
    if (yad2AgentPicked) return;
    const q = yad2AgentQuery.trim();
    if (q.length < 2) { setYad2AgentResults([]); return; }
    const tmr = setTimeout(async () => {
      setYad2AgentSearching(true);
      try {
        const r = await axios.get(`${API_URL}/public/yad2-agents/autocomplete`, {params: {q}});
        setYad2AgentResults(r.data?.results || []);
      } catch (_) { setYad2AgentResults([]); }
      setYad2AgentSearching(false);
    }, 300);
    return () => clearTimeout(tmr);
  }, [yad2AgentQuery, yad2AgentPicked]);
  const submitYad2Setup = async () => {
    if (!yad2AgentPicked) return;
    setYad2SetupBusy(true);
    try {
      const r = await axios.post(`${API_URL}/api/yad2-sync/setup`, {
        phone: yad2AgentPicked.phone,
        agent_name: yad2AgentPicked.name,
        agency_name: yad2AgentPicked.agency_name,
        license_number: yad2AgentPicked.license_number,
        contact_phone: yad2SetupContact.trim(),
        agency_id: yad2SetupScope === 'agency' ? yad2SetupAgency?.id : undefined,
      }, {headers: adminAuthHeader()});
      if (r.data?.success) {
        alert('הוגדר! משיכת הנכסים מיד2 התחילה ברקע — הקמפיינים יופיעו תוך כמה דקות.');
        setYad2SetupModal(false);
        setYad2Sync((s: any) => ({...(s || {}), linked: true, enabled: true, settings: {...(s?.settings || {}), agent_phone: yad2AgentPicked.phone, agent_name: yad2AgentPicked.name, agency_name: yad2AgentPicked.agency_name}}));
      } else {
        alert(r.data?.error || 'ההגדרה נכשלה');
      }
    } catch (e: any) {
      alert('ההגדרה נכשלה: ' + (e?.response?.data?.error || e?.message));
    }
    setYad2SetupBusy(false);
  };
  useEffect(() => {
    axios.get(`${API_URL}/api/yad2-sync/status`, {headers: userAuthHeader()})
      .then((r) => setYad2Sync(r.data))
      .catch(() => {});
  }, []);
  // Open the settings popup pre-filled with the saved settings.
  // Import scope in the settings modal (admin only) — same agent/agency choice as
  // the first-time setup, for accounts that are already linked.
  const [yad2SettingsAgency, setYad2SettingsAgency] = useState<any>(null);
  const [yad2SettingsAgencyLoading, setYad2SettingsAgencyLoading] = useState(false);
  const openYad2Modal = () => {
    const s = yad2Sync?.settings || {};
    setYad2SettingsAgency(null);
    if (isAdminMode && s.agent_phone) {
      setYad2SettingsAgencyLoading(true);
      axios.get(`${API_URL}/api/yad2-agency-lookup`, {params: {phone: s.agent_phone}, headers: adminAuthHeader()})
        .then((r) => setYad2SettingsAgency(r.data?.agency || null))
        .catch(() => setYad2SettingsAgency(null))
        .finally(() => setYad2SettingsAgencyLoading(false));
    }
    setYad2Form({
      agency_id: s.agency_id || 0,
      agent_phone: s.agent_phone || '',
      contact_phone: s.contact_phone || '',
      whatsapp_phone: s.whatsapp_phone || '',
      agent_name: s.agent_name || '',
      agency_name: s.agency_name || '',
      license_text: s.license_text || '',
      include_price: s.include_price !== false,
      use_ai: true, // AI is always on for yad2 posts
      enabled: yad2Sync?.enabled !== false,
      include_no_images: s.include_no_images !== false,
    });
    setYad2Modal(true);
  };
  // Save the settings, then run a sync with them.
  const saveAndSyncYad2 = async () => {
    setYad2Syncing(true);
    try {
      await axios.post(`${API_URL}/api/yad2-sync/settings`, yad2Form, {headers: adminAuthHeader()});
      const r = await axios.post(`${API_URL}/api/yad2-sync/run`, {enable_daily: false}, {headers: userAuthHeader()});
      if (r.data?.success) {
        alert(`סנכרון הושלם ✓\nעודכנו ${r.data.updated} פוסטים, נוספו ${r.data.added} חדשים, הוסרו ${r.data.removed || 0} שנמכרו/ירדו.${r.data.skippedEdited ? `\n${r.data.skippedEdited} פוסטים שערכת ידנית נשארו ללא שינוי.` : ''}\nההגדרות נשמרו.`);
        window.location.reload();
      } else {
        alert(r.data?.error || 'הסנכרון נכשל');
      }
    } catch (e: any) {
      alert('הסנכרון נכשל: ' + (e?.response?.data?.error || e?.message));
    }
    setYad2Syncing(false);
  };
  // One-click sync from the toolbar: pull the latest listings now, without signing the
  // customer up to the nightly auto-sync (currently disabled). Posts the customer
  // rewrote by hand are left alone. Safe to press as often as they like.
  const runYad2SyncNow = async () => {
    // Confirm first: a sync rewrites the content of posts that still track yad2 and
    // deletes posts whose listing is gone. Posts the customer edited by hand are left
    // alone, but this still isn't something a single stray tap should do.
    const ok = window.confirm(
      'לסנכרן עכשיו את הנכסים מיד2?\n\n' +
      '• נכסים חדשים ביד2 → ייווצרו כפוסטים חדשים\n' +
      '• נכסים קיימים → התוכן שלהם יתעדכן לפי יד2\n' +
      '• פוסטים שערכת ידנית → יישארו בדיוק כפי שכתבת\n' +
      '• נכסים שנמכרו/ירדו מיד2 → הפוסטים שלהם יוסרו\n\n' +
      'להמשיך?'
    );
    if (!ok) return;
    setYad2Syncing(true);
    try {
      const r = await axios.post(`${API_URL}/api/yad2-sync/run`, {enable_daily: false}, {headers: userAuthHeader()});
      if (r.data?.success) {
        alert(`סנכרון הושלם ✓\nעודכנו ${r.data.updated} פוסטים, נוספו ${r.data.added} חדשים, הוסרו ${r.data.removed || 0} שנמכרו/ירדו.${r.data.skippedEdited ? `\n${r.data.skippedEdited} פוסטים שערכת ידנית נשארו ללא שינוי.` : ''}`);
        window.location.reload();
      } else {
        alert(r.data?.error || 'הסנכרון נכשל');
      }
    } catch (e: any) {
      alert('הסנכרון נכשל: ' + (e?.response?.data?.error || e?.message));
    }
    setYad2Syncing(false);
  };

  // Save settings only (no sync).
  const saveYad2Settings = async () => {
    setYad2Syncing(true);
    try {
      await axios.post(`${API_URL}/api/yad2-sync/settings`, yad2Form, {headers: adminAuthHeader()});
      setYad2Sync((s) => ({...(s || {}), enabled: yad2Form.enabled !== false, settings: {...(s?.settings || {}), ...yad2Form}}));
      setYad2Modal(false);
    } catch (e: any) {
      alert('שמירה נכשלה: ' + (e?.response?.data?.error || e?.message));
    }
    setYad2Syncing(false);
  };
  var [campaignToDelete, setCampaignToDelete] = useState<any>(null);
  [selectedPost, setSelectedPost] = useState({});
  var [allProfiles, setAllProfiles] = useState([]);
  const [allCampaignProfiles, setAllCampaignProfiles] = useState<{ [key: string]: string[] }>({});
  const [savingProfiles, setSavingProfiles] = useState(false);
  const [profilesSaved, setProfilesSaved] = useState(false);
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [postMenuOpen, setPostMenuOpen] = useState<string | null>(null);
  // "⋯" menu on a campaign card (duplicate, …)
  const [campaignMenuOpen, setCampaignMenuOpen] = useState<string | null>(null);
  const [duplicatingCampaignId, setDuplicatingCampaignId] = useState<string | null>(null);
  // Copy a per-post WhatsApp test link (virtual number) to the clipboard.
  const [waLinkCopiedId, setWaLinkCopiedId] = useState<string | null>(null);
  const copyPostWaLink = async (post: any) => {
    try {
      const {data} = await axios.post(`${API_URL}/api/my-posts/wa-link`, {post_id: post._id});
      if (data?.ok && data.wa_link) {
        try { await navigator.clipboard.writeText(data.wa_link); } catch { window.prompt('העתיקו את הקישור:', data.wa_link); }
        setWaLinkCopiedId(post._id);
        setTimeout(() => setWaLinkCopiedId((prev) => (prev === post._id ? null : prev)), 2000);
      } else {
        alert(data?.error === 'not enabled' ? 'המספר הווירטואלי אינו מופעל' : 'לא ניתן ליצור קישור לפוסט זה (ודאו שהפוסט נשמר)');
      }
    } catch (e: any) {
      alert(e?.response?.data?.error || 'שגיאה ביצירת הקישור');
    }
  };
  // Phone photo-upload QR modal
  const [qrModal, setQrModal] = useState<{url: string; code: string; title: string} | null>(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [movingPost, setMovingPost] = useState<any>(null);
  const [duplicatingPostId, setDuplicatingPostId] = useState<string | null>(null);
  const [rebuildingPostId, setRebuildingPostId] = useState<string | null>(null);
  const [profileMenuOpen, setProfileMenuOpen] = useState<string | null>(null);

  // Track groups modal open/close to avoid mounting TablesWidget10 when hidden
  useEffect(() => {
    const modal = document.getElementById('kt_modal_8');
    if (!modal) return;
    const onShow = () => setGroupsModalOpen(true);
    const onHide = () => setGroupsModalOpen(false);
    modal.addEventListener('shown.bs.modal', onShow);
    modal.addEventListener('hidden.bs.modal', onHide);
    return () => {
      modal.removeEventListener('shown.bs.modal', onShow);
      modal.removeEventListener('hidden.bs.modal', onHide);
    };
  }, []);

  // Close post menu on outside click
  useEffect(() => {
    if (!postMenuOpen) return;
    const handler = () => setPostMenuOpen(null);
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [postMenuOpen]);

  // Close campaign menu on outside click
  useEffect(() => {
    if (!campaignMenuOpen) return;
    const handler = () => setCampaignMenuOpen(null);
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [campaignMenuOpen]);

  // Close profile menu on outside click
  useEffect(() => {
    if (!profileMenuOpen) return;
    const handler = () => setProfileMenuOpen(null);
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [profileMenuOpen]);

  // Edit campaign name state
  const [editingCampaignId, setEditingCampaignId] = useState<string | null>(null);
  const [editingCampaignName, setEditingCampaignName] = useState('');
  // 0 = no daily limit, which is the default. A campaign only has a cap if one is typed in.
  const [editingMaxPosts, setEditingMaxPosts] = useState<number>(0);
  const [editingFakePublished, setEditingFakePublished] = useState<number>(0);
  const [editingDefaultAutoReply, setEditingDefaultAutoReply] = useState('');
  const [editingDefaultMarketplaceAutoReply, setEditingDefaultMarketplaceAutoReply] = useState('');
  // The campaign's default signature, edited in the settings popup. Editable and
  // clearable (an empty string saves and removes the signature) — unless an admin
  // has locked it, which /update-campaign also enforces server-side.
  const [editingDefaultSignature, setEditingDefaultSignature] = useState('');
  const [editingDefaultSignatureLocked, setEditingDefaultSignatureLocked] = useState(false);
  const [savingCampaignName, setSavingCampaignName] = useState(false);

  // Track when posts section becomes visible to hide scroll indicator
  useEffect(() => {
    const checkPostsVisibility = () => {
      const postsSection = document.getElementById('posts-section');
      if (!postsSection) return;

      const rect = postsSection.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight;
      setShowScrollIndicator(!isVisible);
    };

    // Check on scroll
    window.addEventListener('scroll', checkPostsVisibility);

    // Initial check with delay to ensure DOM is ready
    setTimeout(checkPostsVisibility, 500);

    return () => window.removeEventListener('scroll', checkPostsVisibility);
  }, []);

  // Handler to post to marketplace
  const handlePostToMarketplace = (post: any) => {
    // Store post data in localStorage for the marketplace page to pick up
    const marketplaceData = {
      title: post.name || post.post_content?.substring(0, 100) || '',
      description: post.post_content || '',
      photos: post.media || [],
      source_post_id: post._id,
      source_campaign_id: selectedCampaign?._id
    }
    localStorage.setItem('marketplace_prefill_data', JSON.stringify(marketplaceData))
    // Navigate to marketplace with create param
    window.location.href = '/marketplace?create=true'
  }

  // Check for new-post URL parameter to open create post modal
  useEffect(() => {
    const newPostParam = new URLSearchParams(location.search).get('new-post');
    if (newPostParam === '1' && selectedCampaign?._id && !editingPost) {
      // Create a new post and open the edit modal
      const newPost = {
        _id: 'new_' + Date.now(),
        campaign: selectedCampaign._id,
        is_new: true,
        updated: true,
        media: [],
      };
      posts.unshift(newPost);
      setPosts([...posts]);
      setEditingPost(newPost);
    }
  }, [location.search, selectedCampaign?._id]);

  // Helper to open create post modal with URL
  const openCreatePostModal = () => {
    if (!selectedCampaign?._id) return;
    const newPost = {
      _id: 'new_' + Date.now(),
      campaign: selectedCampaign._id,
      is_new: true,
      updated: true,
      media: [],
    };
    posts.unshift(newPost);
    setPosts([...posts]);
    setEditingPost(newPost);
    // Update URL without navigation
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('new-post', '1');
    window.history.pushState({}, '', newUrl.toString());
  };

  // Helper to close create post modal and clean URL
  const closeCreatePostModal = () => {
    // Cancelling a new post: drop any draft virtual-number tracked link we minted.
    discardVnDraft();
    if (editingPost?.is_new && !editingPost.post_content) {
      // Remove empty new post
      const idx = posts.indexOf(editingPost);
      if (idx > -1) posts.splice(idx, 1);
      setPosts([...posts]);
    }
    setEditingPost(null);
    setMarketplaceDescriptionError(null);
    // Remove new-post param from URL
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('new-post');
    window.history.pushState({}, '', newUrl.toString());
  };

  // Reusable publish function (used by both normal footer and wizard)
  const scrollToPostField = (selector: string, errorMsg: string) => {
    const el = document.querySelector(selector) as HTMLElement;
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.style.transition = 'box-shadow 0.3s';
      el.style.boxShadow = '0 0 0 2px #dc3545';
      // Show error text
      let errEl = el.querySelector('.publish-validation-error') as HTMLElement;
      if (!errEl) {
        errEl = document.createElement('div');
        errEl.className = 'publish-validation-error';
        errEl.style.cssText = 'color:#dc3545;font-size:12px;font-weight:600;margin-top:4px';
        el.appendChild(errEl);
      }
      errEl.textContent = errorMsg;
      setTimeout(() => {
        el.style.boxShadow = '';
        errEl?.remove();
      }, 3000);
    }
  };

  const triggerPublish = async () => {
    if (!editingPost) return;

    // Real-estate agents must name every post (it's how they tell their listings apart).
    // The server enforces this for new posts too (/save-post 422 post_name_required).
    if (currentUser?.library_occupation === 'real_estate' && !String(editingPost.name || '').trim()) {
      scrollToPostField('[data-field="name"]', 'יש לתת שם לפוסט (למשל: דירת 4 חדרים ברחוב הרצל)');
      setToast({message: 'יש לתת שם לפוסט', type: 'error'});
      setTimeout(() => setToast(null), 4000);
      return;
    }


    // When the account runs on a virtual number, a raw Israeli phone number in the
    // body defeats the tracking — block the save and point the user at the field.
    // The server enforces this too (/save-post 422); this is the immediate,
    // modal-blocking feedback so the popup can't optimistically close.
    // Trigger ONLY on a real enabled virtual number (the account flag / resolved DID,
    // both recomputed from the DB on every /account fetch, so they can't go stale).
    // A campaign signature is NOT a signal: signatures exist on plenty of accounts
    // that never had a virtual number, and treating one as "VN active" locked those
    // users out of saving with a requirement they could never satisfy (no DID to
    // insert). Mirrors the server, which keys strictly off VirtualNumber.enabled.
    const vnActive = !!(
      currentUser?.has_enabled_virtual_number ||
      currentUser?.enabled_virtual_number_ddi
    );
    // Require the virtual contact (DID + tracked link) in the body OR the campaign
    // signature (appended at post time) — admins exempt. Brand-new posts are exempt
    // too (no _id yet to mint a per-post tracked link), same as the server.
    const vnDid = String(currentUser?.enabled_virtual_number_ddi || '');

    // Backstop for the per-keystroke guard: "✨ שפר עם AI", a restored version, or a
    // yad2 import can all put a phone number in without going through onChange.
    if (vnActive && !isAdmin) {
      const strayBody = findForeignPhone(editingPost.post_content || '', vnDid);
      const strayReply = findForeignPhone(editingPost.reply_text || '', vnDid);
      const strayMp = findForeignPhone(
        String(editingPost.marketplace?.auto_reply_message ?? (editingPost.reply_text || '')),
        vnDid
      );
      if (strayBody || strayReply || strayMp) {
        const where = strayBody ? 'content' : strayReply ? 'reply' : 'mp-location';
        const stray = strayBody || strayReply || strayMp;
        scrollToPostField(`[data-field="${where}"]`, `יש להסיר את מספר הטלפון (${stray}) — הפניות חייבות לעבור דרך המספר הווירטואלי.`);
        setToast({message: `לא ניתן לפרסם עם מספר טלפון (${stray}) — השתמשו במספר הווירטואלי`, type: 'error'});
        setTimeout(() => setToast(null), 4000);
        return;
      }
    }

    const vnSignature = String(selectedCampaign?.default_signature || '');
    const vnPostExists = !!(editingPost._id && !String(editingPost._id).startsWith('new_'));
    if (vnActive && vnPostExists && !isAdmin && !hasVirtualContact(editingPost.post_content || '', vnDid) && !signatureCarriesVn(vnSignature, vnDid)) {
      scrollToPostField('[data-field="content"]', 'יש להוסיף לפוסט את המספר הווירטואלי ואת קישור הוואטסאפ. לחצו על "הוסף מספר וירטואלי".');
      const el = document.querySelector('[data-field="content"]') as HTMLElement;
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setToast({ message: 'יש להוסיף את המספר הווירטואלי לפוסט (לחצו על "הוסף מספר וירטואלי")', type: 'error' });
      setTimeout(() => setToast(null), 4000);
      return;
    }

    // A post that already has a marketplace listing (created / converted / live on
    // FB) is only being edited & re-saved here — the listing already exists, so the
    // create-time marketplace requirements (image present, title, price, location…)
    // must NOT re-validate and block the save. Only validate posts not yet on
    // marketplace. Same "already listed" predicate used elsewhere (e.g. line ~8580).
    const alreadyOnMarketplace = !!(
      editingPost.converted_to_marketplace_listing_id ||
      editingPost.marketplace_listing_id ||
      editingPost.facebook_marketplace_listing_id
    );

    // Marketplace validations - collect all errors and show them all at once
    if (editingPost.marketplace?.enabled && !alreadyOnMarketplace) {
      const errors: {selector: string, msg: string, field: string}[] = [];

      const isVid = (m: string) => /\.(mp4|mov|avi|webm|mkv)(\?|$)/i.test(m);
      if (!editingPost.media || editingPost.media.length === 0) {
        errors.push({selector: '[data-field="media"]', msg: 'חובה להוסיף לפחות תמונה אחת למרקטפלייס', field: 'media'});
      } else if (!editingPost.media.some((m: string) => !isVid(m))) {
        // Only video(s) and no image — the marketplace listing skips videos, so it
        // needs at least one image. A video CAN be first; just not video-only.
        errors.push({selector: '[data-field="media"]', msg: 'יש להוסיף לפחות תמונה אחת למרקטפלייס (סרטון בלבד אינו נתמך)', field: 'media'});
      }
      // The circles show every profile selected until the user narrows it down, so
      // an untouched selection is a valid one — resolve it the same way the UI does
      // and persist it, instead of rejecting the save. Only a genuine absence of
      // connected profiles is an error here.
      if (!isTutorialMode) {
        const mpIds = mpSelectedIds(editingPost.marketplace);
        if (!mpIds.length) {
          errors.push({selector: '[data-field="mp-profile"]', msg: 'אין פרופיל מחובר לפרסום במרקטפלייס', field: 'profile'});
        } else {
          editingPost.marketplace = {
            ...editingPost.marketplace,
            profile_ids: mpIds,
            profile_id: mpIds[0],
          };
        }
      }
      if (!editingPost.marketplace?.price) {
        errors.push({selector: '[data-field="mp-price"]', msg: 'נא להזין מחיר', field: 'price'});
      }
      if (!editingPost.marketplace?.location) {
        errors.push({selector: '[data-field="mp-location"]', msg: 'נא לבחור מיקום', field: 'location'});
      }
      if ((editingPost.marketplace?.listing_type === 'home_sale' || editingPost.marketplace?.listing_type === 'home_rent') && !editingPost.marketplace?.property_type) {
        errors.push({selector: '[data-field="mp-property-type"]', msg: 'נא לבחור סוג נכס', field: 'property_type'});
      }
      if (marketplaceDescriptionError) {
        errors.push({selector: '[data-field="mp-description"]', msg: marketplaceDescriptionError, field: 'description'});
      }

      if (errors.length > 0) {
        console.log('[Marketplace] Missing fields:', errors.map(e => e.field));
        // Mark all invalid fields
        errors.forEach(e => scrollToPostField(e.selector, e.msg));
        // Scroll to the first one
        const firstEl = document.querySelector(errors[0].selector) as HTMLElement;
        if (firstEl) firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    const idx = posts.findIndex((p: any) => p._id === editingPost._id);
    if (idx > -1) {
      posts[idx] = {...editingPost};
    }
    setPosts([...posts]);
    await savePost(editingPost, selectedCampaign);
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('new-post');
    window.history.pushState({}, '', newUrl.toString());
    setEditingPost(null);
    setMarketplaceDescriptionError(null);
  };

  // Pre-select profiles when they load and new-campaign param is present
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('new-campaign') !== '1') return;
    const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
    if (activeProfiles.length > 0) {
      setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
    }
  }, [allProfiles]);

  // Open create campaign modal when new-campaign=1 is in URL (on mount only)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('new-campaign') !== '1') return;
    // Skip opening campaign modal if post modal is also requested (already past that step)
    if (urlParams.get('new-post') === '1') return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const modalEl = document.getElementById('kt_modal_1');
      if (modalEl) {
        clearInterval(interval);
        BsModal.getOrCreateInstance(modalEl).show();
      }
      if (attempts > 50) clearInterval(interval);
    }, 200);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Sync URL param when campaign modal opens/closes
  useEffect(() => {
    const modalEl = document.getElementById('kt_modal_1');
    if (!modalEl) return;

    const onShown = () => {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('new-campaign')) {
        url.searchParams.set('new-campaign', '1');
        window.history.replaceState({}, '', url.toString());
      }
    };
    const onHidden = () => {
      const url = new URL(window.location.href);
      if (url.searchParams.has('new-campaign')) {
        url.searchParams.delete('new-campaign');
        window.history.replaceState({}, '', url.toString());
      }
    };

    modalEl.addEventListener('shown.bs.modal', onShown);
    modalEl.addEventListener('hidden.bs.modal', onHidden);
    return () => {
      modalEl.removeEventListener('shown.bs.modal', onShown);
      modalEl.removeEventListener('hidden.bs.modal', onHidden);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        var data = await axios.get(`${API_URL}/api/get-single-profile`);

        setAllProfiles(data.data.all_users);
        if (typeof data.data.logged_in_threshold_hours === 'number') {
          setLoggedInThresholdHours(data.data.logged_in_threshold_hours);
        }
        if (typeof data.data.logged_in_threshold_enabled === 'boolean') {
          setLoggedInThresholdEnabled(data.data.logged_in_threshold_enabled);
        }

        // Track which profiles are connected on initial load
        const connectedOnLoad = new Set<string>();
        data.data.all_users?.forEach((profile: any) => {
          if (profile.last_health_check && new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000) {
            connectedOnLoad.add(profile._id);
          }
        });
        setInitialConnectedProfiles(connectedOnLoad);

      } catch (e) {
        console.log(e);
        alert('error')
      }

   })();
  }, []);

  // Fetch payment info for add profile modal
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${API_URL}/api/get-payment-info`);
        if (response.data.success) {
          setPaymentInfo(response.data);
        }
      } catch (e) {
        console.error('Error fetching payment info:', e);
      }
    })();
  }, []);

  // Track profiles that were syncing groups (to detect when sync completes)
  const [profilesSyncingGroups, setProfilesSyncingGroups] = useState<Set<string>>(new Set());
  const [hasTriggeredScheduling, setHasTriggeredScheduling] = useState(() => {
    // Check if we already triggered scheduling in this session
    return sessionStorage.getItem('hasTriggeredScheduling') === 'true';
  });

  // Poll for profile updates every 30 seconds if any connected profile has no groups
  useEffect(() => {
    const profilesWithNoGroups = allProfiles.filter((profile: any) => {
      const isConnected = profile.last_health_check && new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
      return isConnected && (!profile.group_count || profile.group_count === 0);
    });

    // Track which profiles are currently syncing
    if (profilesWithNoGroups.length > 0) {
      setProfilesSyncingGroups(new Set(profilesWithNoGroups.map((p: any) => p._id)));
    }

    if (profilesWithNoGroups.length === 0) return;

    const interval = setInterval(async () => {
      try {
        const data = await axios.get(`${API_URL}/api/get-single-profile`);
        setAllProfiles(data.data.all_users);

        // Check if any profile that was syncing now has groups
        const newProfilesWithGroups = data.data.all_users.filter((profile: any) => {
          const wasSync = profilesSyncingGroups.has(profile._id);
          const nowHasGroups = profile.group_count && profile.group_count > 0;
          return wasSync && nowHasGroups;
        });

        // If a profile finished syncing groups, run scheduling
        if (newProfilesWithGroups.length > 0 && !hasTriggeredScheduling) {
          console.log('[Scheduling] Profile(s) finished syncing groups, running scheduling...');
          setHasTriggeredScheduling(true);
          sessionStorage.setItem('hasTriggeredScheduling', 'true');

          try {
            await axios.post(`${API_URL}/api/schedule/reschedule-all-campaigns`, {
              api_token: auth?.api_token
            });
            console.log('[Scheduling] Scheduling completed successfully');
            setToast({ message: 'הקבוצות סונכרנו והפוסטים תוזמנו בהצלחה!', type: 'success' });
            setTimeout(() => setToast(null), 5000);
          } catch (scheduleError) {
            console.error('[Scheduling] Error running scheduling:', scheduleError);
          }
        }

        // Check if all profiles now have groups
        const stillHasProfileWithNoGroups = data.data.all_users.some((profile: any) => {
          const isConnected = profile.last_health_check && new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
          return isConnected && (!profile.group_count || profile.group_count === 0);
        });

        if (!stillHasProfileWithNoGroups) {
          clearInterval(interval);
          setProfilesSyncingGroups(new Set());
        }
      } catch (e) {
        console.log('Error polling profiles:', e);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [allProfiles, profilesSyncingGroups, hasTriggeredScheduling, auth?.api_token]);

  // State for sub-profile toggling
  const [togglingProfiles, setTogglingProfiles] = useState<Set<string>>(new Set());
  // State for toggling posting permission
  const [togglingPostingProfiles, setTogglingPostingProfiles] = useState<Set<string>>(new Set());

  // Track initial connected status - profiles that were connected on page load stay connected
  const [initialConnectedProfiles, setInitialConnectedProfiles] = useState<Set<string>>(new Set());
  // Every profile seen connected at any point during this page session. Kept in a ref
  // rather than state: it only ever needs to be read while rendering, and it must not
  // itself trigger a re-render. Cleared by a page reload — see the profile card.
  const sessionConnectedProfilesRef = useRef<Set<string>>(new Set());

  // Admin-configurable window (in hours) for showing a profile as "connected" to non-admin users.
  // Admins always see real-time status (5-minute health-check window).
  // When the toggle is off, non-admins also see the real-time 5-minute window.
  const [loggedInThresholdHours, setLoggedInThresholdHours] = useState<number>(24);
  const [loggedInThresholdEnabled, setLoggedInThresholdEnabled] = useState<boolean>(false);
  const isProfileDisplayedAsConnected = (profile: any): boolean => {
    if (!profile?.last_health_check) return false;
    const fresh = new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
    if (fresh) return true;
    // The bot reported a Facebook logout: the grace window below is only for
    // short bot outages (restarts), never for a session that actually dropped.
    if (profile.is_logged_in === false) return false;
    const useExtendedWindow = !isAdmin && loggedInThresholdEnabled;
    const ms = useExtendedWindow
      ? Math.max(0, loggedInThresholdHours) * 60 * 60 * 1000
      : 5 * 60 * 1000;
    return new Date(profile.last_health_check).getTime() > Date.now() - ms;
  };

  // State for fetching sub-profiles and server connectivity
  const [fetchingSubProfiles, setFetchingSubProfiles] = useState(false);
  const [serverConnected, setServerConnected] = useState<boolean | null>(null);
  const [fetchMessage, setFetchMessage] = useState('');

  // Check server connectivity
  useEffect(() => {
    const checkServerConnection = async () => {
      try {
        await axios.get(`${API_URL}/api/ping`);
        setServerConnected(true);
      } catch (e) {
        setServerConnected(false);
      }
    };

    checkServerConnection();
    const interval = setInterval(checkServerConnection, 30000);
    return () => clearInterval(interval);
  }, []);

  // Track which profiles are currently fetching sub-profiles
  const [fetchingProfiles, setFetchingProfiles] = useState<Set<string>>(new Set());

  // Profile settings modal
  const [settingsModalProfile, setSettingsModalProfile] = useState<any>(null);

  // Automation status (has new listeners)
  const [automationStatus, setAutomationStatus] = useState<{[key: string]: {checking: boolean, hasNewListeners: boolean | null}}>({});

  // Check automation status when modal opens
  useEffect(() => {
    if (settingsModalProfile && !automationStatus[settingsModalProfile._id]) {
      checkAutomationStatus(settingsModalProfile._id);
    }
  }, [settingsModalProfile]);

  const checkAutomationStatus = async (profileId: string) => {
    setAutomationStatus(prev => ({
      ...prev,
      [profileId]: { checking: true, hasNewListeners: null }
    }));

    try {
      const response = await axios.post(`${API_URL}/api/check-automation-status`, {
        profile_id: profileId
      });

      setAutomationStatus(prev => ({
        ...prev,
        [profileId]: {
          checking: false,
          hasNewListeners: response.data.has_new_listeners || false
        }
      }));
    } catch (e) {
      setAutomationStatus(prev => ({
        ...prev,
        [profileId]: { checking: false, hasNewListeners: false }
      }));
    }
  };

  // Track which profiles are currently fetching groups
  const [fetchingGroups, setFetchingGroups] = useState<Set<string>>(new Set());

  // Fetch groups from Facebook for a specific profile
  const fetchGroups = async (profileId: string) => {
    setFetchingGroups(prev => new Set(prev).add(profileId));
    setFetchMessage('טוען קבוצות מפייסבוק...');

    try {
      const response = await axios.post(`${API_URL}/api/scrape-groups-fleet`, {
        profile_id: profileId
      });

      if (response.data.success) {
        // Show initial message
        setFetchMessage(response.data.message || 'פקודה נשלחה, ממתין לתוצאות...');

        // Wait a bit for the automation to complete, then refresh
        await new Promise(resolve => setTimeout(resolve, 5000));

        // Refresh profiles to get updated group count
        const data = await axios.get(`${API_URL}/api/get-single-profile`);
        setAllProfiles(data.data.all_users);

        // Update the modal profile if it's still open
        if (settingsModalProfile?._id === profileId) {
          const updated = data.data.all_users.find((p: any) => p._id === profileId);
          if (updated) setSettingsModalProfile(updated);
        }

        setFetchMessage('קבוצות עודכנו בהצלחה!');
      } else {
        setFetchMessage(response.data.error || 'שגיאה בטעינת קבוצות');
      }
    } catch (e: any) {
      setFetchMessage(e.response?.data?.error || 'שגיאה בטעינת קבוצות');
    } finally {
      setFetchingGroups(prev => {
        const next = new Set(prev);
        next.delete(profileId);
        return next;
      });
      setTimeout(() => setFetchMessage(''), 5000);
    }
  };

  // Fetch sub-profiles from Facebook for a specific parent profile
  const fetchSubProfiles = async (profileId: string) => {
    setFetchingProfiles(prev => new Set(prev).add(profileId));
    setFetchMessage('טוען פרופילים משניים מפייסבוק...');

    try {
      const response = await axios.post(`${API_URL}/api/scrape-sub-profiles-fleet`, {
        profile_id: profileId
      });

      if (response.data.success) {
        setFetchMessage(response.data.message || 'פקודה נשלחה, ממתין לתוצאות...');

        // Wait a bit for the automation to complete, then refresh
        await new Promise(resolve => setTimeout(resolve, 5000));

        // Refresh profiles list
        const data = await axios.get(`${API_URL}/api/get-single-profile`);
        setAllProfiles(data.data.all_users);

        // Update the modal profile if it's still open
        if (settingsModalProfile?._id === profileId) {
          const updated = data.data.all_users.find((p: any) => p._id === profileId);
          if (updated) setSettingsModalProfile(updated);
        }

        const newSubProfiles = data.data.all_users.filter((p: any) => p.parent_profile === profileId);
        setFetchMessage(`נמצאו ${newSubProfiles.length} פרופילים משניים!`);
      } else {
        setFetchMessage(response.data.error || 'שגיאה בטעינת פרופילים משניים');
      }
    } catch (e: any) {
      setFetchMessage(e.response?.data?.error || 'שגיאה בטעינת פרופילים משניים');
    } finally {
      setFetchingProfiles(prev => {
        const next = new Set(prev);
        next.delete(profileId);
        return next;
      });
      // Clear message after 5 seconds
      setTimeout(() => setFetchMessage(''), 5000);
    }
  };

  // Which tutorial step is on screen. SpotlightTutorial publishes it on <body>, which
  // keeps this free of any coupling to the tutorial's own step numbering (that differs
  // between desktop and mobile).
  const [spotlightStep, setSpotlightStep] = useState<string | null>(
    typeof document !== 'undefined' ? document.body.getAttribute('data-spotlight-step') : null
  );
  useEffect(() => {
    const read = () => setSpotlightStep(document.body.getAttribute('data-spotlight-step'));
    read();
    const obs = new MutationObserver(read);
    obs.observe(document.body, {attributes: true, attributeFilter: ['data-spotlight-step']});
    return () => obs.disconnect();
  }, []);

  // On the tutorial's "your profiles" step, pull the user's Facebook PAGES in without
  // being asked — they shouldn't have to know that a page lives behind a "load sub
  // profiles" button. The scrape runs quietly in the background so the pages are simply
  // there on the profiles card.
  //
  // It used to then throw the "הוסף פרופילים" picker open on top of the step. That
  // buried the tutorial tooltip under a modal the user hadn't asked for, mid-tour —
  // picking pages is a decision for after the tour, not an interruption during it.
  const autoPagesDoneRef = useRef<Set<string>>(new Set());
  useEffect(() => {
    if (spotlightStep !== 'tour-profiles') return;
    const parents = (allProfiles || []).filter((p: any) =>
      !p.parent_profile && isProfileDisplayedAsConnected(p) && !p.sub_profiles_fetched_at && !autoPagesDoneRef.current.has(p._id)
    );
    if (!parents.length) return;
    parents.forEach((p: any) => autoPagesDoneRef.current.add(p._id));
    (async () => {
      for (const p of parents) {
        try { await fetchSubProfiles(p._id); } catch { /* the helper already surfaces its own message */ }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spotlightStep, allProfiles]);

  // Toggle sub-profile on/off
  const toggleSubProfile = async (subProfileId: string, enabled: boolean) => {
    setTogglingProfiles(prev => new Set(prev).add(subProfileId));

    try {
      const response = await axios.post(`${API_URL}/api/toggle-sub-profile`, {
        sub_profile_id: subProfileId,
        enabled: enabled
      });

      if (response.data.success) {
        // Update local state
        setAllProfiles(prevProfiles =>
          prevProfiles.map(p =>
            p._id === subProfileId
              ? { ...p, parent_profile_on: enabled }
              : p
          )
        );
      } else {
        alert(response.data.error || 'שגיאה בשינוי סטטוס פרופיל');
      }
    } catch (e: any) {
      console.error('Error toggling sub-profile:', e);
      alert(e.response?.data?.error || 'שגיאה בשינוי סטטוס פרופיל');
    } finally {
      setTogglingProfiles(prev => {
        const next = new Set(prev);
        next.delete(subProfileId);
        return next;
      });
    }
  };





  useEffect(() => {
    // TODO Get file list from database
    setFileLibraryList([
      {
        _id: 1,
        title: "Me and my dog",
        size: 294880,
        fileName: "img_3549.jpg",
        type: "image/jpeg",
        createdAt: new Date("2019-10-17T03:12:29.866Z"),
        thumbnailUrl:
          "https://image.shutterstock.com/image-photo/beautiful-water-drop-on-dandelion-260nw-789676552.jpg"
      },
      {
        _id: 2,
        title: "2019 Summer Vacation",
        size: 864483,
        fileName: "201702.jpg",
        type: "image/jpeg",
        createdAt: new Date("2019-10-17T03:12:45.018Z"),
        thumbnailUrl:
          "https://image.shutterstock.com/image-photo/beautiful-water-drop-on-dandelion-260nw-789676552.jpg"
      },
      {
        _id: 3,
        title: "Our new baby",
        size: 586458,
        fileName: "271092.jpg",
        type: "image/jpeg",
        createdAt: new Date("2019-10-17T03:19:33.498Z"),
        thumbnailUrl:
          "https://image.shutterstock.com/image-photo/beautiful-water-drop-on-dandelion-260nw-789676552.jpg"
      },
      {
        _id: 4,
        title: "My new car",
        size: 894665,
        fileName: "photo-107.jpg",
        type: "image/jpeg",
        createdAt: new Date("2019-10-17T03:28:39.723Z"),
        thumbnailUrl:
          "https://image.shutterstock.com/image-photo/beautiful-water-drop-on-dandelion-260nw-789676552.jpg"
      }
    ]);
  }, []);

  async function uploadCallback(
    fileBase64: any,
    fileMeta: any
  ): Promise<any> {
    // TODO Upload file to backend APIs
  }

  function selectCallback(item: any) {
    // Hide modal
    setDisplay(false);
    console.info(item);
  }

  async function deleteCallback(item: any) {
  }


  useEffect(() => {
    getBot();
  }, [currentUser, currentBot])

  let sourceToken: any;
  let setSourceToken: any;
  let posts: any;
  let setPosts: any;
  const [campaignID, setCampaignID] = useState('');
  // Reset the post search when switching campaigns
  useEffect(() => { setPostSearch(''); }, [campaignID]);
  const [loadingPosts, setLoadingPosts] = useState(false);
  const [allCampaignStats, setAllCampaignStats] = useState<{[key: string]: {totalPostsAllTime: number, scheduledToday: number, postedToday: number, totalToday: number, marketplaceListings: number}}>({});
  [posts, setPosts] = useState([]);
  [sourceToken, setSourceToken] = useState();
  // Post search — campaigns can have 100+ posts (yad2 imports name them by street/neighborhood)
  const [postSearch, setPostSearch] = useState('');
  const visiblePostsUnsorted = postSearch.trim()
    ? posts.filter((p: any) => {
        const q = postSearch.trim().toLowerCase();
        return [p.name, p.post_content].filter(Boolean).join(' ').toLowerCase().includes(q);
      })
    : posts;
  // Active assets first, paused (disabled) ones at the end. Stable sort keeps
  // the existing order within each group.
  const visiblePosts = [...visiblePostsUnsorted].sort(
    (a: any, b: any) => (a.disabled ? 1 : 0) - (b.disabled ? 1 : 0)
  );
  // Count of paused posts in the currently open campaign (for the header badge).
  const pausedPostCount = posts.filter((p: any) => p.disabled).length;
  const [editingPost, setEditingPost] = useState<any>(null);
  const [editingField, setEditingField] = useState<string | null>(null);

  // Profiles a marketplace listing can publish from: connected main profiles
  // (sub-profiles/pages can't hold a listing). Every one of them is selected by
  // default — a listing published from N profiles creates N listing rows.
  const mpEligibleProfiles = useMemo(
    () => (allProfiles as any[]).filter((p: any) => p.facebook_id && !p.parent_profile),
    [allProfiles]
  );
  const mpDefaultProfileIds = useMemo(
    () => mpEligibleProfiles.map((p: any) => String(p._id)),
    [mpEligibleProfiles]
  );
  // What the circles show as picked for a given post: the stored selection, or —
  // when it was never touched — all eligible profiles. The UI and the save-time
  // validation MUST read the selection through this, otherwise the screen shows
  // profiles selected while the stored value is empty and the save is rejected
  // with "choose a profile".
  const mpSelectedIds = (mp: any): string[] => {
    const stored: string[] = Array.isArray(mp?.profile_ids)
      ? mp.profile_ids
      : (mp?.profile_id ? [String(mp.profile_id)] : []);
    return stored.length ? stored.map(String) : mpDefaultProfileIds;
  };
  const [showVnRevert, setShowVnRevert] = useState(false); // admin bulk reverse-by-date modal
  const [showWaStrip, setShowWaStrip] = useState(false); // admin: strip WhatsApp links from this campaign's bodies

  // Live guard for the edit modal: a raw Israeli phone in the body while the
  // account/campaign uses a virtual number. When true we disable the save button
  // and show an inline error, so the user can't submit (the server /save-post 422
  // is the backstop). Recomputed each render → updates as the user types.
  // Strictly a real enabled virtual number — NOT the presence of a campaign
  // signature. See the same guard in triggerPublish for why.
  const editVnActive = !!(
    currentUser?.has_enabled_virtual_number ||
    currentUser?.enabled_virtual_number_ddi
  );
  const editVnDid = String(currentUser?.enabled_virtual_number_ddi || '');
  // When a virtual number is active, a client's post must route contact through it
  // (DID + tracked link). Rather than blocking a raw phone, we REQUIRE the virtual
  // contact to be present and offer a one-click insert. Admins are never locked.
  // Block save when VN is on and the number/link is in NEITHER the post body NOR the
  // campaign signature (the signature is appended at post time, so its tokens count).
  const editVnSignature = String(selectedCampaign?.default_signature || '');
  const isExistingEditPost = !!(editingPost && editingPost._id && !String(editingPost._id).startsWith('new_'));
  // The number+link is in NEITHER the post body NOR the campaign signature.
  const editVnContactMissing = !!(editingPost && editVnActive
    && !hasVirtualContact(editingPost.post_content || '', editVnDid)
    && !signatureCarriesVn(editVnSignature, editVnDid));
  // Hard-disable save (for everyone, admins included) — but only for SAVED posts. A brand-new
  // post has no id yet to mint a per-post tracked link, so it isn't blocked (matches backend);
  // instead we offer to insert the number+link, and the tracked link is minted on save.
  const editVnRequired = editVnContactMissing && isExistingEditPost;
  // The virtual contact that SHOULD appear in the post: the DID number + its wa.me link.
  const editVnWaLink = editVnDid ? `https://wa.me/972${String(editVnDid).replace(/\D/g, '').replace(/^0/, '')}` : '';
  const [insertingVn, setInsertingVn] = useState(false);
  // The ACTUAL tracked link (l.fbzipper.com / katzr.net) that will appear in the post.
  // Fetched per post; for a NEW post the /wa-link endpoint mints (saving a draft) behind
  // the scenes and returns the code/shortlink so we can show + copy it immediately.
  const [editVnTrackedLink, setEditVnTrackedLink] = useState('');
  // Whether the /wa-link round-trip above has SETTLED (not whether it succeeded). The
  // autofill below has to wait for this: it runs once per post and remembers that it
  // ran, so firing while the tracked link is still in flight bakes the raw wa.me
  // fallback into the post and the replies permanently — and a post carrying wa.me
  // instead of a katzr link fails hasVirtualContact(), so saving is then blocked.
  const [editVnLinkResolved, setEditVnLinkResolved] = useState(false);
  // Draft LeadLink ids for NEW (unsaved) posts, keyed by the editor's temp id. We mint
  // a tracked katzr link against a client-generated ObjectId so it shows while composing
  // WITHOUT saving the post; on save we re-point it to the real post, on cancel we delete
  // it (Option A — no orphan post, no orphan link).
  const vnDraftRef = useRef<{[k: string]: string}>({});
  const genObjectId = () => {
    const ts = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0');
    let rand = '';
    for (let i = 0; i < 16; i++) rand += Math.floor(Math.random() * 16).toString(16);
    return ts + rand;
  };
  useEffect(() => {
    setEditVnTrackedLink('');
    setEditVnLinkResolved(false);
    if (!editVnActive || !editingPost) return;
    const isSaved = !!(isExistingEditPost && editingPost._id);
    let draftId: string | null = null;
    if (!isSaved) {
      const key = String(editingPost._id || 'new');
      draftId = vnDraftRef.current[key] || (vnDraftRef.current[key] = genObjectId());
    }
    let cancelled = false;
    (async () => {
      try {
        const body = isSaved
          ? {post_id: editingPost._id}
          : {draft_post_id: draftId, campaign_id: selectedCampaign?._id};
        const {data} = await axios.post(`${API_URL}/api/my-posts/wa-link`, body, {headers: adminAuthHeader()});
        if (!cancelled && data?.ok && data.wa_link) setEditVnTrackedLink(String(data.wa_link));
      } catch {}
      // Settled either way — on failure the autofill goes ahead with the wa.me fallback
      // rather than leaving the post with no contact details at all.
      if (!cancelled) setEditVnLinkResolved(true);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingPost?._id, editVnActive]);
  // Delete the draft link for the current new post (cancel path).
  const discardVnDraft = () => {
    if (!editingPost || isExistingEditPost) return;
    const key = String(editingPost?._id || 'new');
    const draftId = vnDraftRef.current[key];
    if (!draftId) return;
    delete vnDraftRef.current[key];
    axios.post(`${API_URL}/api/my-posts/wa-link/discard`, {draft_post_id: draftId}, {headers: adminAuthHeader()}).catch(() => {});
  };
  const editVnDisplayLink = editVnTrackedLink || editVnWaLink;
  // The contact block as it should read to someone scrolling a feed: labelled, so it's
  // obvious one is a phone number to call and the other is a WhatsApp link to tap.
  // Same wording in the post body, the auto-reply and the marketplace reply — a lead
  // who sees both shouldn't be given two differently-worded ways to make contact.
  const buildVnContactBlock = (did: string, link: string) => [
    did ? `📞 לחיוג: ${did}` : '',
    link ? `💬 לוואטסאפ: ${link}` : '',
  ].filter(Boolean).join('\n');
  // While composing a NEW post, the contact block is locked: the DID and the tracked
  // link are what make a lead attributable, and a typo in either sends the lead nowhere
  // (or, for the link, breaks the save guard). Editing an EXISTING post is left alone —
  // that's the deliberate "fix the contact details" path, not accidental typing.
  const vnLockedBlock = (editVnActive && !isExistingEditPost)
    ? buildVnContactBlock(editVnDid, editVnDisplayLink)
    : '';
  // Only pin it once it's actually the tail of post_content — before the autofill has
  // run (or if the user's own text already carries the contact details some other way)
  // there's nothing to split off, and splitting on a block that isn't there would
  // silently blank the textarea.
  const vnPinnedBlock = (vnLockedBlock && String(editingPost?.post_content || '').endsWith(vnLockedBlock))
    ? vnLockedBlock
    : '';
  const vnBodyText = splitVnBody(editingPost?.post_content || '', vnPinnedBlock);
  // Same treatment for the auto-reply: the contact details are pinned below the editable
  // text rather than sitting inside it, so they can't be typed over there either.
  const vnPinnedReplyBlock = (vnLockedBlock && String(editingPost?.reply_text || '').endsWith(vnLockedBlock))
    ? vnLockedBlock
    : '';
  const vnReplyBodyText = splitVnBody(editingPost?.reply_text || '', vnPinnedReplyBlock);
  // And the marketplace auto-reply. Note the value it displays falls back to reply_text
  // when unset, so the pinned check has to look at the same resolved value the textarea
  // shows — otherwise the block would render unpinned there while the post's own reply
  // has it pinned.
  const vnMpReplyValue = editingPost?.marketplace?.auto_reply_message ?? (editingPost?.reply_text || '');
  const vnPinnedMpBlock = (vnLockedBlock && String(vnMpReplyValue).endsWith(vnLockedBlock)) ? vnLockedBlock : '';
  const vnMpBodyText = splitVnBody(String(vnMpReplyValue), vnPinnedMpBlock);
  const mpReplyPhoneError = editVnActive ? findForeignPhone(String(vnMpReplyValue), editVnDid) : null;
  // A phone number other than the account's own virtual number, if the user has typed
  // one. Deliberately NOT enforced per keystroke — the text goes in freely and the
  // problem is reported inline, because refusing keystrokes mid-number reads as a broken
  // keyboard. What it does block is moving on: the wizard's "next" stays disabled and
  // publishing is refused while one is present.
  // Only while a virtual number is active — for every other account a phone number in
  // the post IS the way to be contacted.
  // In the TUTORIAL, a phone number is taken straight back out as it's typed and the user
  // is told why. Outside it we only report and block progress (below): quietly rewriting
  // an experienced user's copy while they type is worse than telling them it's a problem,
  // but someone on their first post benefits from the correction happening for them.
  // (reads ?tut directly rather than the isTutorialMode const, which is declared further
  // down — this would be a TDZ error the day anything calls it during render.)
  const scrubPhones = (nextText: string): string => {
    if (!editVnActive || !new URLSearchParams(location.search).has('tut')) return nextText;
    const {text, removed} = stripForeignPhones(nextText, editVnDid);
    if (!removed) return nextText;
    setToast({
      message: `הסרנו את מספר הטלפון (${removed}) — הפניות עוברות דרך המספר הווירטואלי שלכם`,
      type: 'success',
    });
    setTimeout(() => setToast(null), 3500);
    return text;
  };

  const postPhoneError = editVnActive ? findForeignPhone(editingPost?.post_content || '', editVnDid) : null;
  const replyPhoneError = editVnActive ? findForeignPhone(editingPost?.reply_text || '', editVnDid) : null;
  // --- WhatsApp click-to-chat link builder -------------------------------
  // Builds/edits a wa.me link with a pre-filled opening message, in the post
  // body, the auto-reply or the marketplace auto-reply. Hidden entirely on
  // virtual-number accounts: there contact must route through the tracked link,
  // and a second raw number would also trip findForeignPhone (which has no URL
  // exemption — the digits inside wa.me/972… match RAW_PHONE_RE).
  type WaTarget = 'content' | 'reply' | 'mpReply';
  const [waLinkModal, setWaLinkModal] = useState<
    {target: WaTarget; initial: any; replace: {start: number; end: number} | null} | null
  >(null);

  const waFieldValue = (t: WaTarget): string => {
    if (t === 'content') return editingPost?.post_content || '';
    if (t === 'reply') return editingPost?.reply_text || '';
    return String(editingPost?.marketplace?.auto_reply_message ?? (editingPost?.reply_text || ''));
  };
  const waSetFieldValue = (t: WaTarget, next: string) => {
    if (t === 'content') editingPost.post_content = next;
    else if (t === 'reply') editingPost.reply_text = next;
    else editingPost.marketplace = {...(editingPost.marketplace || {}), auto_reply_message: next};
    editingPost.updated = true;
    setEditingPost({...editingPost});
  };

  // The links already in a field. Recomputed on render so the chip appears the
  // moment one is pasted in by hand, not only when the builder wrote it.
  const waLinksIn = (t: WaTarget) => (editVnActive ? [] : findWaLinks(waFieldValue(t)));

  // `link` given → edit that one. Otherwise edit the only link present, or start
  // a new one (including when there are several — the chips edit those directly).
  const openWaLinkModal = (target: WaTarget, link?: FoundWaLink) => {
    const text = waFieldValue(target);
    const found = link || (findWaLinks(text).length === 1 ? findWaLinks(text)[0] : null);
    if (!found) {
      setWaLinkModal({target, initial: null, replace: null});
      return;
    }
    const prefix = prefixAboveLink(text, found.index);
    // Swallow the label line along with the link, so editing the prefix doesn't
    // leave the old one stranded above the new block.
    const start = prefix ? text.lastIndexOf(prefix, found.index) : found.index;
    setWaLinkModal({
      target,
      // `code` set → the link in the post is one of our short ones; the builder
      // resolves it to the number/message and re-points that same code on save.
      initial: {phone: found.phone, message: found.message, prefix, editing: true, code: found.code},
      replace: {start: start < 0 ? found.index : start, end: found.index + found.match.length},
    });
  };

  const applyWaLink = (block: string) => {
    if (!waLinkModal || !block) return;
    const {target, replace} = waLinkModal;
    const text = waFieldValue(target);
    const next = replace
      ? text.slice(0, replace.start) + block + text.slice(replace.end)
      // New link goes at the END of the field — that's where a contact line
      // belongs, and it's the one position that never splits the user's copy.
      : (text.trim() ? `${text.replace(/\s+$/, '')}\n\n${block}` : block);
    waSetFieldValue(target, next);
    setWaLinkModal(null);
  };

  // Button + "there's already a link here" chips, rendered under a field.
  const waLinkControls = (target: WaTarget) => {
    if (editVnActive || !postWaLinkEnabled) return null;
    const links = waLinksIn(target);
    return (
      <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginTop: 8}}>
        <button
          type="button"
          onClick={() => openWaLinkModal(target)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            border: '1px solid #25d366', background: '#fff', color: '#128c46',
            borderRadius: 8, padding: '6px 11px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}
        >
          <span>💬</span>
          <span>{links.length === 1 ? 'ערוך את קישור הוואטסאפ' : 'קישור וואטסאפ'}</span>
        </button>
        {links.map((l, i) => (
          <button
            key={`${l.index}-${i}`}
            type="button"
            onClick={() => openWaLinkModal(target, l)}
            title="ערוך את הקישור הזה"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 5,
              border: '1px solid #d7f5e3', background: '#f0fdf4', color: '#128c46',
              borderRadius: 999, padding: '4px 10px', fontSize: 12, cursor: 'pointer',
            }}
          >
            <span>🔗</span>
            <span style={{direction: 'ltr', fontFamily: 'monospace'}}>{localiseWaPhone(l.phone)}</span>
            <span style={{color: '#8a8d91'}}>· ערוך</span>
          </button>
        ))}
      </div>
    );
  };

  const phoneErrorBox = (found: string, whereHe: string) => (
    <div style={{
      marginTop: 8, color: '#d32f2f', fontSize: 13, fontWeight: 600,
      display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
      background: '#ffebee', border: '1px solid #ffcdd2', borderRadius: 8, padding: '8px 10px',
    }}>
      <span>⛔</span>
      <span>
        לא ניתן להשתמש במספר טלפון {whereHe} (<span style={{fontFamily: 'monospace', direction: 'ltr', unicodeBidi: 'embed'}}>{found}</span>).
        {' '}הפניות חייבות לעבור דרך המספר הווירטואלי — הסירו אותו כדי להמשיך.
      </span>
    </div>
  );

  // A NEW post on a virtual-number account gets the contact block written in for the
  // user — in the body, in the auto-reply and in the marketplace auto-reply. Leaving
  // them to paste it by hand was the single biggest source of posts that go out with
  // no way to reach the advertiser (and of the save-blocking guard firing).
  // Runs once the tracked link resolves, only fills fields the user hasn't written in,
  // and never touches a saved post.
  const vnAutofilledRef = useRef<{[k: string]: boolean}>({});
  useEffect(() => {
    if (!editingPost || isExistingEditPost || !editVnActive) return;
    // Hold off until the tracked link has resolved, so all three fields get the katzr
    // link rather than a raw wa.me that can never be corrected (see editVnLinkResolved).
    if (!editVnLinkResolved) return;
    if (!editVnDid && !editVnDisplayLink) return;
    const key = String(editingPost._id || 'new');
    if (vnAutofilledRef.current[key]) return;
    const block = buildVnContactBlock(editVnDid, editVnDisplayLink);
    if (!block) return;
    vnAutofilledRef.current[key] = true;
    setEditingPost((prev: any) => {
      if (!prev) return prev;
      const next: any = {...prev, updated: true};
      if (!hasVirtualContact(prev.post_content || '', editVnDid)) {
        // Body stays empty so the textarea shows its placeholder; the block is pinned
        // below it and rendered outside the textarea.
        next.post_content = joinVnBody(prev.post_content || '', block);
      }
      if (!String(prev.reply_text || '').trim()) {
        next.reply_text = joinVnBody('שלום! תודה על ההתעניינות 🙏\nאשמח לעזור — ניתן ליצור קשר:', block);
      }
      if (!String(prev.marketplace?.auto_reply_message || '').trim()) {
        next.marketplace = {...(prev.marketplace || {}), auto_reply_message: joinVnBody('שלום! תודה על ההתעניינות 🙏\nאשמח לעזור — ניתן ליצור קשר:', block)};
      }
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingPost?._id, isExistingEditPost, editVnActive, editVnDid, editVnDisplayLink, editVnLinkResolved]);
  const copyToClipboard = async (val: string, label: string) => {
    if (!val) return;
    try { await navigator.clipboard.writeText(val); } catch { try { window.prompt('העתקה:', val); } catch {} }
    setToast({message: `${label} הועתק`, type: 'success'});
    setTimeout(() => setToast(null), 1500);
  };
  const insertVirtualNumber = async () => {
    if (!editingPost?._id || String(editingPost._id).startsWith('new_')) {
      // New post: append the DID number + the tracked katzr link we minted against the
      // draft id (falls back to the wa.me link only if the tracked link hasn't loaded yet).
      const add = buildVnContactBlock(editVnDid, editVnDisplayLink);
      if (!add) { setToast({message: 'לא הוגדר מספר וירטואלי', type: 'error'}); setTimeout(() => setToast(null), 3000); return; }
      setEditingPost((prev: any) => (prev ? {...prev, post_content: `${prev.post_content ? prev.post_content + '\n\n' : ''}${add}`, updated: true} : prev));
      setToast({message: 'נוספו המספר והקישור לפוסט', type: 'success'});
      setTimeout(() => setToast(null), 3000);
      return;
    }
    setInsertingVn(true);
    try {
      const res = await axios.post(`${API_URL}/api/my-posts/transform-one`, {post_id: editingPost._id}, {headers: adminAuthHeader()});
      if (res.data?.ok && typeof res.data.suggested_content === 'string') {
        const nc = res.data.suggested_content;
        setEditingPost((prev: any) => (prev ? {...prev, post_content: nc, updated: true} : prev));
        setToast({message: 'פרטי הקשר הוחלפו במספר הווירטואלי', type: 'success'});
      } else {
        setToast({message: 'לא הוחזר תוכן', type: 'error'});
      }
    } catch (e: any) {
      setToast({message: e?.response?.data?.error || 'שגיאה בהוספת המספר הווירטואלי', type: 'error'});
    } finally {
      setInsertingVn(false);
      setTimeout(() => setToast(null), 4000);
    }
  };
  // ADMIN-ONLY: post content version history (backed by /posts/:id/history).
  const [copiedPostId, setCopiedPostId] = useState(false); // "הועתק" tick on the admin post-id chip
  const [postHistory, setPostHistory] = useState<any>(null); // {current, versions} while the panel is open, else null
  const [postHistoryLoading, setPostHistoryLoading] = useState(false);
  // ADMIN-ONLY: post variations (per-post editor + per-account settings).
  const [variationsPostId, setVariationsPostId] = useState<string | null>(null);
  const [showVariationSettings, setShowVariationSettings] = useState(false);
  const [restoringVersionId, setRestoringVersionId] = useState<string | null>(null);

  // Wizard state for tutorial mode
  const [wizardStep, setWizardStep] = useState(0);
  const [wizardValidationError, setWizardValidationError] = useState<string | null>(null);
  const isTutorialMode = new URLSearchParams(location.search).has('tut');
  // Onboarding tutorial "select a campaign" step: no campaign chosen yet → show a clear
  // "click to select" cue on each card.
  const inCampaignSelectStep = (() => {
    const sp = new URLSearchParams(location.search);
    return sp.get('tut') === 'onboarded' && (sp.get('step') === null || sp.get('step') === '0');
  })();
  // Picking a campaign navigates to /campaigns/:id but keeps ?tut=onboarded and step 0
  // (the tutorial waits for "המשך"), so inCampaignSelectStep stays true afterwards. All
  // the "pick one!" motion has to be switched off on this instead, or it keeps nagging
  // for something the user has already done.
  const campaignChosen = /^\/campaigns\/[A-Za-z0-9]/.test(location.pathname);
  // Demo hover: during that step, cycle a highlight across the campaign cards ("this one,
  // or that one, or that one…") so it's obvious any of them can be selected.
  const [demoHoverIdx, setDemoHoverIdx] = useState(0);
  useEffect(() => {
    if (!inCampaignSelectStep || campaignChosen) return;
    const count = currentUser?.campaigns?.length || 0;
    if (count < 2) return;
    setDemoHoverIdx(0);
    const t = setInterval(() => setDemoHoverIdx((i) => (i + 1) % count), 1100);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inCampaignSelectStep, campaignChosen, currentUser?.campaigns?.length]);

  const WIZARD_FIELDS = [
    { key: 'name', dataField: 'name', title: 'שם הפוסט', description: 'תנו שם לפוסט שלכם כדי שתוכלו לזהות אותו בקלות ברשימה. זה לא מתפרסם בפייסבוק.', isRequired: (_post: any) => true, validate: (post: any) => !!post?.name?.trim(), exampleImage: null },
    { key: 'content', dataField: 'content', title: 'תוכן הפוסט', description: 'כתבו את תוכן הפוסט שלכם.\nזה הטקסט שיופיע מעל התמונות או הסרטונים.', descriptionAfterExample: 'ובלחיצה על "✨ שפר עם AI" המערכת משדרגת את הנוסח.', isRequired: (_post: any) => false, validate: (post: any) => !!splitVnBody(post?.post_content || '', vnLockedBlock).trim() && !(editVnActive && findForeignPhone(post?.post_content || '', editVnDid)), exampleImage: '/media/example-post.jpeg' },
    { key: 'media', dataField: 'media', title: 'תמונות / סרטונים', description: 'הוסיפו תמונות או סרטונים לפוסט.\nולבחור את סדר התמונות, כש-תמונה מספר 1 היא הראשית, וניתן לסדר בעזרת החצים.', isRequired: (post: any) => !splitVnBody(post?.post_content || '', vnLockedBlock).trim(), validate: (post: any) => post?.media?.length > 0, exampleImage: '/media/example-media.jpeg' },
    { key: 'reply', dataField: 'reply', title: 'תגובה אוטומטית', description: 'הגדירו תגובה שתישלח אוטומטית לכל מי שמגיב לפוסט שלכם.', isRequired: (_post: any) => false, validate: (post: any) => !!splitVnBody(post?.reply_text || '', vnLockedBlock).trim() && !(editVnActive && findForeignPhone(post?.reply_text || '', editVnDid)), exampleImage: 'https://fbzipper.com/example-reply.jpeg' },
    { key: 'marketplace', dataField: 'marketplace', title: 'מרקטפלייס', description: 'בלחיצה על המרקטפלייס הפוסט מתפרסם אוטומטית גם במרקטפלייס.\nהמערכת ממלאת את כל השדות לפי הנכס, ודואגת לרענון ולהקפצה אוטומטית של המודעות.\n👈 חשוב לעבור על כל פרטי המרקטפלייס ולוודא שהכול נכון — סוג המודעה, המחיר, המיקום ושאר הפרטים.\nרק לוודא שלא התפספס שום פרט.', isRequired: (_post: any) => false, validate: (post: any) => !!post?.marketplace?.enabled && !(editVnActive && findForeignPhone(String(post?.marketplace?.auto_reply_message ?? (post?.reply_text || '')), editVnDid)), exampleImage: null },
  ];

  const isWizardDone = isTutorialMode && editingPost?.is_new && wizardStep >= WIZARD_FIELDS.length;

  // Same "stuck?" escape hatch the post-register wizard and the spotlight tutorial offer.
  // This tooltip needs its own: `body:has(.wizard-tooltip)` hides the spotlight tooltip
  // outright, so while the post wizard is open its help button is the only one on screen.
  const openWizardHelp = () => {
    const lines = [
      'שלום, אני צריך/ה עזרה ביצירת הפוסט 🙏',
      `שם משתמש: ${(currentUser as any)?.username || 'לקוח'}`,
      `שלב נוכחי: ${isWizardDone ? 'סיום ופרסום' : (WIZARD_FIELDS[wizardStep]?.title || '')}`,
    ];
    window.open(`https://wa.me/${SUPPORT_WA}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener');
  };
  const wizardHelpButton = (
    <button type="button" className="wizard-tooltip-help" onClick={openWizardHelp}>
      💬 צריכים עזרה? דברו איתנו
    </button>
  );

  // Keeps --spotlight-banner-h in step with the wizard banner's actual height on mobile.
  const wizardBannerRoRef = useRef<ResizeObserver | null>(null);
  useEffect(() => () => { wizardBannerRoRef.current?.disconnect(); }, []);

  // The wizard banner is position:fixed against the LAYOUT viewport. Once the keyboard is
  // up, the visual viewport is both shorter and offset, and scrolling the page slides a
  // top-fixed element out of view — so on the post steps, where the keyboard is always
  // open, the banner and its "הבא" button disappeared as soon as the user scrolled.
  // visualViewport.offsetTop is how far the visible area has been pushed; re-pinning to it
  // keeps the banner at the top of what's actually on screen.
  const wizardBannerElRef = useRef<HTMLDivElement | null>(null);
  const syncWizardBannerToViewport = useCallback(() => {
    const node = wizardBannerElRef.current;
    const vv = (window as any).visualViewport;
    if (!node || !vv) return;
    // Only while it's acting as the fixed top banner; on desktop it's positioned normally.
    if (!document.body.classList.contains('spotlight-banner-active') || window.innerWidth > 768) {
      node.style.transform = '';
      return;
    }
    node.style.transform = `translateY(${Math.max(0, Math.round(vv.offsetTop))}px)`;
  }, []);
  useEffect(() => {
    const vv = (window as any).visualViewport;
    if (!vv) return;
    // resize = keyboard opening/closing, scroll = panning while it's open.
    vv.addEventListener('resize', syncWizardBannerToViewport);
    vv.addEventListener('scroll', syncWizardBannerToViewport);
    window.addEventListener('scroll', syncWizardBannerToViewport, {passive: true});
    return () => {
      vv.removeEventListener('resize', syncWizardBannerToViewport);
      vv.removeEventListener('scroll', syncWizardBannerToViewport);
      window.removeEventListener('scroll', syncWizardBannerToViewport);
    };
  }, [syncWizardBannerToViewport]);

  // Flag the on-screen keyboard on <body> so the tutorial UI can shrink out of its way.
  // There's no keyboard event on the web: the signal is the VISUAL viewport becoming much
  // shorter than the layout viewport. The 0.75 threshold clears a browser's collapsing
  // address bar (~10-15%) without needing to know the keyboard's height.
  useEffect(() => {
    const vv = (window as any).visualViewport;
    if (!vv) return;
    const sync = () => {
      const open = vv.height < window.innerHeight * 0.75;
      document.body.classList.toggle('kb-open', open);
    };
    sync();
    vv.addEventListener('resize', sync);
    return () => {
      vv.removeEventListener('resize', sync);
      document.body.classList.remove('kb-open');
    };
  }, []);

  // True when the step the wizard is sitting on is the one holding a phone number, so
  // "next" being disabled has a visible reason next to it and "skip" is withheld.
  const phoneBlocksStep = (() => {
    const k = WIZARD_FIELDS[wizardStep]?.key;
    return !!((k === 'content' && postPhoneError) || (k === 'reply' && replyPhoneError) || (k === 'marketplace' && mpReplyPhoneError));
  })();

  const wizardFieldClass = (fieldKey: string) => {
    if (!isTutorialMode || !editingPost?.is_new) return '';
    if (wizardStep >= WIZARD_FIELDS.length) return ''; // wizard done, no highlighting
    return WIZARD_FIELDS[wizardStep]?.key === fieldKey ? 'wizard-active' : 'wizard-dimmed';
  };

  // Modal fields that are NOT wizard steps (e.g. strength, post-type — added after the
  // tutorial was built). Keep them greyed throughout the tutorial so only the current
  // step stands out, matching the other dimmed fields.
  const wizardExtraDimClass = () => {
    if (!isTutorialMode || !editingPost?.is_new) return '';
    if (wizardStep >= WIZARD_FIELDS.length) return ''; // wizard done, no dimming
    return 'wizard-dimmed';
  };

  // Marketplace section during the tutorial: highlighted when it's the active step, but
  // otherwise kept EDITABLE (dimmed look without pointer-events:none) so users can still
  // fix title/price/location if the auto-filled/demo data is wrong.
  const marketplaceWizardClass = () => {
    if (!isTutorialMode || !editingPost?.is_new) return '';
    if (wizardStep >= WIZARD_FIELDS.length) return '';
    return WIZARD_FIELDS[wizardStep]?.key === 'marketplace' ? 'wizard-active' : 'wizard-editable';
  };

  // Auto-focus and scroll to the current wizard field when step changes
  useEffect(() => {
    if (!isTutorialMode || !editingPost?.is_new) return;
    const dataField = WIZARD_FIELDS[wizardStep]?.dataField;
    if (!dataField) return;
    setTimeout(() => {
      const fieldEl = document.querySelector(`[data-field="${dataField}"]`);
      if (fieldEl) {
        fieldEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = fieldEl.querySelector('textarea, input') as HTMLElement;
        if (input) input.focus();
      }
    }, 100);
  }, [wizardStep, editingPost?._id]);

  // Reset wizard step when opening a new post in tutorial mode
  useEffect(() => {
    if (editingPost?.is_new && isTutorialMode) {
      setWizardStep(0);
      setWizardValidationError(null);
    }
  }, [editingPost?._id]);

  // Close Bootstrap modals when the custom post modal opens in tutorial mode
  // (Bootstrap focus trap prevents typing in the custom modal's inputs)
  useEffect(() => {
    if (!editingPost || !isTutorialMode) return;
    document.querySelectorAll('.modal.show').forEach((modalEl) => {
      const instance = BsModal.getInstance(modalEl as HTMLElement);
      if (instance) instance.hide();
    });
  }, [editingPost?._id, isTutorialMode]);

  // Sync post count to DOM for SpotlightTutorial to read
  useEffect(() => {
    if (isTutorialMode) {
      document.body.setAttribute('data-post-count', String(posts?.length || 0));
    }
  }, [posts?.length, isTutorialMode]);

  // AI Enhancement states
  const [aiEnhancing, setAiEnhancing] = useState(false);
  const [aiSuggestion, setAiSuggestion] = useState<{original: string, enhanced: string} | null>(null);
  const [showAiSuggestionModal, setShowAiSuggestionModal] = useState(false);

  // Function to enhance post content with AI
  const enhancePostWithAI = async () => {
    if (!editingPost?.post_content || aiEnhancing) return;

    setAiEnhancing(true);
    try {
      const response = await axios.post(`${API_URL}/api/enhance-post-content`, {
        content: editingPost.post_content,
        api_token: auth?.api_token
      });

      if (response.data.success && response.data.enhanced_content) {
        setAiSuggestion({
          original: editingPost.post_content,
          enhanced: response.data.enhanced_content
        });
        setShowAiSuggestionModal(true);
      } else {
        setToast({ message: response.data.error || 'שגיאה בשיפור התוכן', type: 'error' });
        setTimeout(() => setToast(null), 3000);
      }
    } catch (error: any) {
      console.error('AI enhancement error:', error);
      setToast({ message: 'שגיאה בשיפור התוכן עם AI', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setAiEnhancing(false);
    }
  };

  // Accept AI suggestion
  const acceptAiSuggestion = () => {
    if (aiSuggestion && editingPost) {
      editingPost.post_content = aiSuggestion.enhanced;
      editingPost.updated = true;
      setEditingPost({...editingPost});
      setShowAiSuggestionModal(false);
      setAiSuggestion(null);
      setToast({ message: 'התוכן עודכן בהצלחה!', type: 'success' });
      setTimeout(() => setToast(null), 3000);
    }
  };

  // Reject AI suggestion
  const rejectAiSuggestion = () => {
    setShowAiSuggestionModal(false);
    setAiSuggestion(null);
  };

  // AI Reply generation states
  const [aiGeneratingReply, setAiGeneratingReply] = useState(false);
  const [aiReplySuggestion, setAiReplySuggestion] = useState<string | null>(null);
  const [showAiReplyModal, setShowAiReplyModal] = useState(false);

  // Function to generate reply text with AI
  const generateReplyWithAI = async () => {
    if (aiGeneratingReply) return;

    setAiGeneratingReply(true);
    try {
      const loggedInProfile = (allProfiles as any[]).find((p: any) => p.facebook_id && !p.parent_profile);
      const posterName = loggedInProfile ? `${loggedInProfile.first_name || ''} ${loggedInProfile.last_name || ''}`.trim() : '';
      const response = await axios.post(`${API_URL}/api/generate-reply-text`, {
        post_content: editingPost?.post_content || '',
        poster_name: posterName,
        api_token: auth?.api_token
      });

      if (response.data.success && response.data.reply_text) {
        setAiReplySuggestion(response.data.reply_text);
        setShowAiReplyModal(true);
      } else {
        setToast({ message: response.data.error || 'שגיאה ביצירת תגובה', type: 'error' });
        setTimeout(() => setToast(null), 3000);
      }
    } catch (error: any) {
      console.error('AI reply generation error:', error);
      setToast({ message: 'שגיאה ביצירת תגובה עם AI', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setAiGeneratingReply(false);
    }
  };

  // Accept AI reply suggestion
  const acceptAiReplySuggestion = () => {
    if (aiReplySuggestion && editingPost) {
      editingPost.reply_text = aiReplySuggestion;
      editingPost.updated = true;
      setEditingPost({...editingPost});
      setShowAiReplyModal(false);
      setAiReplySuggestion(null);
      setToast({ message: 'התגובה נוצרה בהצלחה!', type: 'success' });
      setTimeout(() => setToast(null), 3000);
    }
  };

  // Reject AI reply suggestion
  const rejectAiReplySuggestion = () => {
    setShowAiReplyModal(false);
    setAiReplySuggestion(null);
  };

  const [marketplaceCategories, setMarketplaceCategories] = useState<any[]>([]);
  const [categoryAttributes, setCategoryAttributes] = useState<any[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [aiFillingMarketplace, setAiFillingMarketplace] = useState(false);
  const [marketplaceDescriptionError, setMarketplaceDescriptionError] = useState<string | null>(null);
  const [postToMarketplace, setPostToMarketplace] = useState<any>(null); // Post being added to marketplace

  // Validate marketplace description for no links and no phone numbers
  const validateMarketplaceDescription = (text: string): string | null => {
    if (!text) return null;

    // Check for URLs (http, https, www, common domains)
    const urlPatterns = [
      /https?:\/\//i,
      /www\./i,
      /\.[a-z]{2,}\/\S*/i, // domain.tld/path
      /[a-z0-9]+(\.com|\.co\.il|\.net|\.org|\.io|\.me|\.info|\.biz)/i,
    ];

    for (const pattern of urlPatterns) {
      if (pattern.test(text)) {
        return 'התיאור לא יכול להכיל קישורים';
      }
    }

    // Check for phone numbers (Israeli formats)
    const phonePatterns = [
      /05\d[\s-]?\d{3}[\s-]?\d{4}/,  // 05X-XXX-XXXX or 05X XXX XXXX or 05XXXXXXXX
      /\+972[\s-]?\d/,               // +972...
      /972[\s-]?5\d/,                // 972-5X...
    ];

    for (const pattern of phonePatterns) {
      if (pattern.test(text)) {
        return 'התיאור לא יכול להכיל מספרי טלפון';
      }
    }

    return null;
  };

  // City coordinates for marketplace location
  const CITY_COORDINATES: Record<string, { lat: number; lng: number }> = {
    'תל אביב': { lat: 32.0853, lng: 34.7818 },
    'ירושלים': { lat: 31.7683, lng: 35.2137 },
    'חיפה': { lat: 32.7940, lng: 34.9896 },
    'באר שבע': { lat: 31.2530, lng: 34.7915 },
    'ראשון לציון': { lat: 31.9730, lng: 34.7925 },
    'פתח תקווה': { lat: 32.0841, lng: 34.8878 },
    'אשדוד': { lat: 31.8040, lng: 34.6553 },
    'נתניה': { lat: 32.3215, lng: 34.8532 },
    'חולון': { lat: 32.0158, lng: 34.7794 },
    'בני ברק': { lat: 32.0834, lng: 34.8331 },
    'רמת גן': { lat: 32.0680, lng: 34.8241 },
    'אשקלון': { lat: 31.6688, lng: 34.5743 },
    'רחובות': { lat: 31.8928, lng: 34.8113 },
    'בת ים': { lat: 32.0231, lng: 34.7503 },
    'הרצליה': { lat: 32.1663, lng: 34.8463 },
    'כפר סבא': { lat: 32.1750, lng: 34.9066 },
    'רעננה': { lat: 32.1836, lng: 34.8706 },
    'מודיעין': { lat: 31.8977, lng: 35.0104 },
    'לוד': { lat: 31.9514, lng: 34.8883 },
    'רמלה': { lat: 31.9279, lng: 34.8664 },
  };

  // Helper function to sync marketplace fields with AI based on post content
  const syncMarketplaceWithAI = async (postContent: string, currentMarketplace: any = {}) => {
    // A post that is still only the signature ("📞 לחיוג: …") gives a listing
    // titled "📞 לחיוג:" with no description — wait for the real text.
    if (!postContent || !hasRealListingText(postContent)) return null;

    setAiFillingMarketplace(true);
    try {
      const response = await axios.post(`${API_URL}/api/marketplace/analyze-post`, {
        post_content: postContent
      });

      if (response.data) {
        const data = response.data;
        console.log('[Marketplace AI] Response:', data);

        // Map API listing types to frontend values
        let listingType = data.listing_type || currentMarketplace.listing_type || MP_DEFAULT_LISTING_TYPE;
        if (listingType === 'rental') listingType = 'home_rent';

        // Detect city from post content
        const detectCity = () => {
          const neighborhoodToCity: Record<string, string> = {
            'יעקב אבינו': 'באר שבע', 'נווה זאב': 'באר שבע', 'רמות': 'באר שבע',
            'פלורנטין': 'תל אביב', 'נווה צדק': 'תל אביב', 'יפו': 'תל אביב', 'רמת אביב': 'תל אביב',
            'הדר': 'חיפה', 'כרמל': 'חיפה',
            'תלפיות': 'ירושלים', 'בית הכרם': 'ירושלים', 'קטמון': 'ירושלים',
          };
          for (const [neighborhood, city] of Object.entries(neighborhoodToCity)) {
            if (postContent.includes(neighborhood)) return city;
          }
          for (const city of Object.keys(CITY_COORDINATES)) {
            if (postContent.includes(city)) return city;
          }
          return '';
        };
        const detectedCity = detectCity();

        // Generate marketplace-appropriate title
        const generateTitle = () => {
          const bedrooms = data.bedrooms || 0;
          switch (listingType) {
            case 'home_rent': return bedrooms > 0 ? `דירת ${bedrooms} חדרים להשכרה` : 'דירה להשכרה';
            case 'home_sale': return bedrooms > 0 ? `דירת ${bedrooms} חדרים למכירה` : 'דירה למכירה';
            case 'vehicle': return data.vehicle_year ? `רכב שנת ${data.vehicle_year} למכירה` : 'רכב למכירה';
            default: return data.title || 'פריט למכירה';
          }
        };

        return {
          ...currentMarketplace,
          enabled: true,
          listing_type: listingType,
          title: data.title || generateTitle(),
          description: data.description || '',
          // Empty, not "0": typing a price in front of a pre-filled 0 made
          // 3,650,000 into 36,500,000.
          price: (data.price || data.suggested_price) ? String(data.price || data.suggested_price) : '',
          category: data.suggested_category_id || currentMarketplace.category || '',
          condition: data.item_condition || data.suggested_condition || 'used_good',
          // "חדרים" = Israeli room count (incl. living room). The server derives
          // Facebook's bedrooms = rooms - 1, so bedrooms is not set here.
          rooms: (data.rooms || '').toString(),
          bedrooms: '',
          bathrooms: (data.bathrooms || 1).toString(), // Facebook rejects 0 baths
          square_meters: (data.square_meters || '').toString(),
          property_type: data.property_type || '',
          vehicle_year: (data.vehicle_year || '').toString(),
          vehicle_mileage: (data.vehicle_mileage || '').toString(),
          location: data.city || detectedCity || data.location || '',
          latitude: data.latitude || (detectedCity ? CITY_COORDINATES[detectedCity]?.lat : 0) || 0,
          longitude: data.longitude || (detectedCity ? CITY_COORDINATES[detectedCity]?.lng : 0) || 0,
          _suggestedCategory: data.suggested_category_id
        };
      }
      return null;
    } catch (err) {
      console.error('Error analyzing post for marketplace:', err);
      return null;
    } finally {
      setAiFillingMarketplace(false);
    }
  };

  // alert(JSON.stringify(id))


  const match = useMatch("campaigns/:id");

  useEffect(() => {
    if (match) {
      const { id } = match.params;
      setCampaignID(id || '');


      setSelectedCampaign(currentUser?.campaigns.find((c) => c._id == id));
      

      // ... business logic using tenentId
    } else {
      // During the onboarding tutorial's "select a campaign" step, DON'T auto-select the
      // first campaign — the user must consciously pick one.
      const sp = new URLSearchParams(location.search);
      const inCampaignSelectStep = sp.get('tut') === 'onboarded' && (sp.get('step') === null || sp.get('step') === '0');
      if (!inCampaignSelectStep && currentUser?.campaigns?.length > 0) {
        return navigate(`/campaigns/${currentUser?.campaigns[0]._id}?${sp.toString()}`)
      }
    }
  }, [match, currentUser]);

  // Fetch campaign slot data to get selected profiles for all campaigns
  useEffect(() => {
    if (currentUser?.campaigns?.length) {
      currentUser.campaigns.forEach((camp: any) => {
        if (!allCampaignProfiles[camp._id]) {
          axios.get(`${API_URL}/api/get-campaign-slot/${camp._id}`)
            .then(response => {
              if (response.data.success) {
                const userIds = (response.data.users || []).map((u: any) => u._id || u);
                // When no profiles are selected in DB, treat as all profiles selected
                if (userIds.length === 0) {
                  const allIds = allProfiles
                    .filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on))
                    .map((p: any) => p._id);
                  setAllCampaignProfiles(prev => ({ ...prev, [camp._id]: allIds }));
                } else {
                  setAllCampaignProfiles(prev => ({ ...prev, [camp._id]: userIds }));
                }
              }
            })
            .catch(e => console.error('Error fetching campaign slot:', e));
        }
      });
    }
  }, [currentUser?.campaigns, allProfiles]);

  // Save campaign profiles
  const saveCampaignProfiles = async () => {
    if (!campaignID) return;
    setSavingProfiles(true);
    try {
      await axios.post(`${API_URL}/api/save-campaign-profiles`, {
        campaign_id: campaignID,
        users: allCampaignProfiles[campaignID] || []
      });
      setProfilesSaved(true);
      setTimeout(() => setProfilesSaved(false), 2000);
    } catch (e) {
      console.error('Error saving campaign profiles:', e);
      alert('שגיאה בשמירת הפרופילים');
    } finally {
      setSavingProfiles(false);
    }
  };

  // Fetch marketplace categories when edit modal opens with marketplace enabled
  useEffect(() => {
    if (editingPost && marketplaceEnabled && marketplaceCategories.length === 0) {
      setLoadingCategories(true);
      getCategories()
        .then(res => {
          setMarketplaceCategories(res.categories || []);
        })
        .catch(err => {
          console.error('Failed to load categories:', err);
        })
        .finally(() => {
          setLoadingCategories(false);
        });
    }
  }, [editingPost, marketplaceEnabled]);

  // Load marketplace listing data when editing a post with a linked listing
  useEffect(() => {
    const listingId = editingPost?.converted_to_marketplace_listing_id || editingPost?.marketplace_listing_id;
    if (editingPost && listingId) {
      // Fetch the marketplace listing data (always fetch to get latest auto_reply_message)
      axios.get(`${API_URL}/api/marketplace/listings/${listingId}`)
        .then(res => {
          if (res.data.success && res.data.listing) {
            const listing = res.data.listing;
            // Populate editingPost.marketplace with the listing data
            editingPost.marketplace = {
              ...(editingPost.marketplace || {}),
              enabled: true,
              listing_type: listing.listing_type || MP_DEFAULT_LISTING_TYPE,
              profile_id: listing.profile_ids?.[0] || '',
              profile_ids: listing.profile_ids || [],
              title: listing.title || '',
              description: listing.description || '',
              price: listing.price?.toString() || '',
              category: listing.category_id || '',
              condition: listing.item_attributes?.condition || 'used_good',
              location: listing.address || '',
              latitude: listing.latitude,
              longitude: listing.longitude,
              brand: listing.item_attributes?.brand || '',
              color: listing.item_attributes?.color || '',
              item_attributes: listing.item_attributes || {},
              // Vehicle fields
              vehicle_make: listing.vehicle_data?.make || '',
              vehicle_model: listing.vehicle_data?.model || '',
              vehicle_year: listing.vehicle_data?.year?.toString() || '',
              vehicle_mileage: listing.vehicle_data?.mileage?.toString() || '',
              // Home fields
              // Converted records carry rooms; legacy ones kept the room count in bedrooms.
              rooms: (listing.home_data?.rooms ?? listing.home_data?.bedrooms)?.toString() || '',
              bedrooms: listing.home_data?.rooms != null ? (listing.home_data?.bedrooms?.toString() || '') : '',
              bathrooms: listing.home_data?.bathrooms?.toString() || '',
              square_meters: listing.home_data?.square_meters?.toString() || '',
              property_type: listing.home_data?.property_type || '',
              auto_reply_message: listing.auto_reply_message || ''
            };
            setEditingPost({...editingPost});

            // Load category attributes if it's an item listing with a category
            if (listing.listing_type === 'item' && listing.category_id) {
              handleCategoryChange(listing.category_id);
            }
          }
        })
        .catch(err => {
          console.error('Failed to load marketplace listing:', err);
        });

      // Also fetch auto_reply from synced listing if it has a facebook listing ID
      if (editingPost.facebook_marketplace_listing_id) {
        axios.get(`${API_URL}/api/marketplace/synced-listings`, {
          params: { facebook_listing_id: editingPost.facebook_marketplace_listing_id }
        })
          .then(res => {
            const synced = res.data?.listings?.[0];
            if (synced?.auto_reply_message && editingPost.marketplace) {
              editingPost.marketplace.auto_reply_message = synced.auto_reply_message;
              setEditingPost({...editingPost});
            }
          })
          .catch(() => {});
      }
    }
  }, [editingPost?.converted_to_marketplace_listing_id, editingPost?.marketplace_listing_id]);

  // Fetch category attributes when category changes
  const handleCategoryChange = async (categoryId: string) => {
    if (!editingPost) return;

    editingPost.marketplace = {
      ...editingPost.marketplace,
      category: categoryId
    };
    editingPost.updated = true;
    setEditingPost({...editingPost});

    // Clear previous attributes
    setCategoryAttributes([]);

    if (categoryId) {
      setLoadingAttributes(true);
      try {
        const res = await getCategoryAttributes(categoryId);
        setCategoryAttributes(res.attributes || []);
      } catch (err) {
        console.error('Failed to load category attributes:', err);
      } finally {
        setLoadingAttributes(false);
      }
    }
  };

  useEffect(() => {
    const source = CancelToken.source();

    try {
      sourceToken.cancel('Operation canceled by the user.');
    } catch (e) {

    }

    setSourceToken(sourceToken);

    (async () => {
      try {
        setLoadingPosts(true);
        setPosts([]);
        var posts = await axios.post(`${API_URL}/posts`, {
          api_token: auth?.api_token || '',
          campaign_id: campaignID,
        }, {
          cancelToken: source.token
        });

        posts.data.map((post) => {
          post.media = (post.media_url || '').split(',').filter((a) => a).map((a) => convertToCdnUrl(a));
        })
        

        setPosts(posts.data);
      } catch (e) {

      }
      setLoadingPosts(false);
    })()

  }, [campaignID]);

  // ---- Phone photo-upload (QR) --------------------------------------------
  // Re-fetch the current campaign's posts so photos added from a phone appear.
  const refreshPostsMedia = async () => {
    if (!campaignID) return;
    try {
      const resp = await axios.post(`${API_URL}/posts`, {
        api_token: auth?.api_token || '',
        campaign_id: campaignID,
      });
      resp.data.map((post: any) => {
        post.media = (post.media_url || '').split(',').filter((a: string) => a).map((a: string) => convertToCdnUrl(a));
      });
      setPosts(resp.data);
    } catch (e) { /* transient — next poll retries */ }
  };

  // Mint/reuse the account upload session and open the QR for a post or campaign.
  const openPhoneUpload = async (target: { postId?: string; campaignId?: string; title: string }) => {
    setPostMenuOpen(null);
    setQrLoading(true);
    setQrModal({ url: '', code: '', title: target.title });
    try {
      const resp = await axios.post(`${API_URL}/post-upload-session`, {}, { headers: { Authorization: `Bearer ${auth?.api_token}` } });
      const code = resp.data.code;
      const token = resp.data.token;
      let url = `${MOBILE_UPLOAD_BASE}/${code}`;
      if (target.postId) url += `/post/${target.postId}`;
      else if (target.campaignId) url += `/campaign/${target.campaignId}`;
      // Carry an api_token so the phone is logged in automatically — no login screen.
      if (token) url += `?t=${encodeURIComponent(token)}`;
      setQrModal({ url, code, title: target.title });
    } catch (e) {
      setQrModal(null);
      alert('שגיאה ביצירת קוד QR');
    } finally {
      setQrLoading(false);
    }
  };

  // Phone upload from inside the post editor. A saved post can deep-link to itself; a
  // post that hasn't been saved has no id to link to, so we mint a client-side draft id
  // and the phone uploads into the session's staging bucket instead. Nothing is written
  // to the DB for the post itself, so abandoning the composer leaves no orphan post.
  // Keyed by the editor's temp post id, NOT a single ref: composing two new posts in one
  // page session must not share a bucket, or the second post would pull in the first
  // one's photos.
  const editorDraftIdRef = useRef<{[k: string]: string}>({});
  const [editorDraftId, setEditorDraftId] = useState('');
  const openEditorPhoneUpload = async () => {
    const savedId = editingPost?._id && !String(editingPost._id).startsWith('new_') ? String(editingPost._id) : '';
    if (savedId) {
      setEditorDraftId('');
      await openPhoneUpload({postId: savedId, title: editingPost?.name || 'הפוסט'});
      return;
    }
    const key = String(editingPost?._id || 'new');
    const draftId = editorDraftIdRef.current[key] || (editorDraftIdRef.current[key] = genObjectId());
    setEditorDraftId(draftId);
    setQrLoading(true);
    setQrModal({url: '', code: '', title: editingPost?.name || 'פוסט חדש'});
    try {
      const resp = await axios.post(`${API_URL}/post-upload-session`, {}, {headers: {Authorization: `Bearer ${auth?.api_token}`}});
      const code = resp.data.code;
      let url = `${MOBILE_UPLOAD_BASE}/${code}/draft/${draftId}`;
      if (resp.data.token) url += `?t=${encodeURIComponent(resp.data.token)}`;
      setQrModal({url, code, title: editingPost?.name || 'פוסט חדש'});
    } catch (e) {
      setQrModal(null);
      setEditorDraftId('');
      alert('שגיאה ביצירת קוד QR');
    } finally {
      setQrLoading(false);
    }
  };

  // Pull staged photos into the open editor as the phone sends them. Only URLs not
  // already in the post are appended, so this stays correct if the user also drags
  // files in on the desktop while the QR is open.
  useEffect(() => {
    if (!qrModal?.code || !editorDraftId) return;
    let stop = false;
    const tick = async () => {
      try {
        const resp = await axios.get(
          `${API_URL}/post-upload-session/${qrModal.code}/draft/${editorDraftId}`,
          {headers: {Authorization: `Bearer ${auth?.api_token}`}}
        );
        if (resp.data?.expired) return;
        const staged: string[] = resp.data?.images || [];
        if (!staged.length) return;
        setEditingPost((prev: any) => {
          if (!prev) return prev;
          const have = new Set<string>((prev.media || []).map(String));
          const fresh = staged.filter((u) => !have.has(String(u)));
          if (!fresh.length) return prev;
          return {...prev, media: [...(prev.media || []), ...fresh], updated: true};
        });
      } catch (e) { /* ignore transient */ }
    };
    const id = setInterval(() => { if (!stop) tick(); }, 2500);
    tick();
    return () => { stop = true; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrModal?.code, editorDraftId]);

  // While the QR modal is open, poll the session and refresh media on changes.
  useEffect(() => {
    if (!qrModal?.code) return;
    let lastUpdated: string | null = null;
    let stop = false;
    const tick = async () => {
      try {
        const resp = await axios.get(`${API_URL}/post-upload-session/${qrModal.code}`, { headers: { Authorization: `Bearer ${auth?.api_token}` } });
        if (resp.data?.expired) return;
        const u = resp.data?.updated_at || null;
        if (lastUpdated !== null && u !== lastUpdated) await refreshPostsMedia();
        lastUpdated = u;
      } catch (e) { /* ignore transient */ }
    };
    const id = setInterval(() => { if (!stop) tick(); }, 2500);
    return () => { stop = true; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrModal?.code]);

  // Fetch stats for all campaigns
  useEffect(() => {
    if (!currentUser?.campaigns?.length) {
      setAllCampaignStats({});
      return;
    }

    (async () => {
      try {
        const response = await axios.get(`${API_URL}/all-campaign-stats`);
        if (response.data.success) {
          setAllCampaignStats(response.data.stats);
        }
      } catch (e) {
        console.error('Error fetching campaign stats:', e);
        setAllCampaignStats({});
      }
    })();
  }, [currentUser?.campaigns]);

  // Auto-schedule if user has 0 posts scheduled for today
  useEffect(() => {
    // Skip if already triggered scheduling or if stats haven't loaded
    if (hasTriggeredScheduling) return;
    if (Object.keys(allCampaignStats).length === 0) return;
    if (!currentUser?.campaigns?.length) return;

    // Calculate total posts scheduled for today across all campaigns
    const totalTodayPosts = Object.values(allCampaignStats).reduce((sum: number, stats: any) => {
      return sum + (stats.totalToday || 0);
    }, 0);

    // If user has campaigns but 0 posts for today, trigger scheduling
    if (totalTodayPosts === 0) {
      console.log('[Scheduling] User has 0 posts scheduled for today, running scheduling...');
      setHasTriggeredScheduling(true);
      sessionStorage.setItem('hasTriggeredScheduling', 'true');

      (async () => {
        try {
          await axios.post(`${API_URL}/api/schedule/reschedule-all-campaigns`, {
            api_token: auth?.api_token
          });
          console.log('[Scheduling] Scheduling completed successfully');
          setToast({ message: 'הפוסטים תוזמנו בהצלחה!', type: 'success' });
          setTimeout(() => setToast(null), 5000);

          // Refresh stats after scheduling
          const response = await axios.get(`${API_URL}/all-campaign-stats`);
          if (response.data.success) {
            setAllCampaignStats(response.data.stats);
          }
        } catch (scheduleError) {
          console.error('[Scheduling] Error running scheduling:', scheduleError);
        }
      })();
    }
  }, [allCampaignStats, currentUser?.campaigns, hasTriggeredScheduling, auth?.api_token]);

  let deleteCampaign = async (campaign) => {
    try {
      var new_campaign = await axios.post(`${API_URL}/delete-campaign`, {
        api_token: auth?.api_token || '',
        campaign: campaign,
      });

      const {data: user} = await getUserByToken(auth.api_token)
      setCurrentUser(user)

      return navigate(`/campaigns`);
    } catch (e) {
      console.log(e);
      alert(1234)
    }
  }
  // Clone a campaign with all its posts and its schedule config (profiles /
  // groups / times). The server creates the copy paused, so it starts posting
  // only after the user turns it on.
  let duplicateCampaign = async (campaign) => {
    if (duplicatingCampaignId) return;
    setDuplicatingCampaignId(campaign._id);
    try {
      const {data} = await axios.post(`${API_URL}/duplicate-campaign`, {
        api_token: auth?.api_token || '',
        campaign_id: campaign._id,
      });

      if (!data?.success) throw new Error('duplicate failed');

      const {data: user} = await getUserByToken(auth.api_token)
      setCurrentUser(user)

      setToast({
        message: `הקמפיין שוכפל (${data.posts_copied} פוסטים). העותק מושהה - הפעל אותו כשהוא מוכן`,
        type: 'success',
      });
      setTimeout(() => setToast(null), 5000);

      navigate(`/campaigns/${data.campaign._id}?${params.toString()}`);
    } catch (e) {
      console.error('Error duplicating campaign:', e);
      setToast({ message: 'שגיאה בשכפול הקמפיין', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setDuplicatingCampaignId(null);
      setCampaignMenuOpen(null);
    }
  }
  let deleteAllAccountCampaigns = async (campaign) => {
    try {
      const accountId = campaign.account?._id || campaign.account;
      if (!accountId) {
        alert('Account ID not found');
        return;
      }

      await axios.delete(`${API_URL}/admin/accounts/${accountId}/campaigns`, {
        withCredentials: true
      });

      const {data: user} = await getUserByToken(auth.api_token)
      setCurrentUser(user)

      setToast({ message: 'כל הקמפיינים נמחקו בהצלחה', type: 'success' });
      setTimeout(() => setToast(null), 3000);

      return navigate(`/campaigns`);
    } catch (e) {
      console.log(e);
      setToast({ message: 'שגיאה במחיקת הקמפיינים', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    }
  }
  let requestCampaignApproval = async (campaign) => {
    try {

      campaign.loading = true;
      setSelectedCampaign(JSON.parse(JSON.stringify(campaign)));

      var new_campaign = await axios.post(`${API_URL}/request-approve-campaign`, {
        api_token: auth?.api_token || '',
        campaign: campaign,
      });

      const {data: user} = await getUserByToken(auth.api_token)
      setCurrentUser(user)

      campaign.request_for_approval = new Date();

      setSelectedCampaign(JSON.parse(JSON.stringify(campaign)));
    } catch (e) {
      console.log(e);
      alert(1234)
    }
  }
  let enableCampaign = async (campaign, enabled) => {
    try {
      // When trying to turn ON, check for missing configuration
      if (enabled) {
        const campFromUser = currentUser?.campaigns?.find((c: any) => c._id === campaign._id);
        const groupCount = campFromUser ? (campFromUser._groupCount ?? getGroupCount(campFromUser)) : getGroupCount(campaign);
        const postCount = campFromUser?.post_count || campaign.post_count || 0;
        const campProfiles = allCampaignProfiles[campaign._id] || [];
        const hasNoGroups = groupCount === 0;
        const hasNoPosts = postCount === 0;
        const hasNoProfiles = campProfiles.length === 0;
        if (hasNoGroups || hasNoPosts || hasNoProfiles) {
          // Navigate to campaign and scroll to warning
          const isActive = location.pathname === `/campaigns/${campaign._id}`;
          if (!isActive) {
            navigate(`/campaigns/${campaign._id}?${params.toString()}`);
          }
          setTimeout(() => {
            const warningClass = hasNoGroups ? '.no-groups-warning' : hasNoProfiles ? '.no-profiles-warning' : '.no-posts-warning';
            const warningEl = document.querySelector(warningClass);
            if (warningEl) {
              warningEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
              warningEl.classList.add('flash-warning');
              setTimeout(() => warningEl.classList.remove('flash-warning'), 2000);
            }
          }, isActive ? 0 : 300);
          return;
        }
      }

      // When turning OFF (enabled=false means currently paused, so !enabled means turning off)
      if (!enabled) {
        const confirmed = window.confirm('השהיית הקמפיין תעצור את פרסום הפוסטים. להמשיך?');
        if (!confirmed) return;
      }

      campaign.loading = true;
      setSelectedCampaign(JSON.parse(JSON.stringify(campaign)));

      var new_campaign = await axios.post(`${API_URL}/enable-campaign`, {
        api_token: auth?.api_token || '',
        campaign: campaign,
        enabled: enabled,
      });

      const {data: user} = await getUserByToken(auth.api_token)
      setCurrentUser(user)

      campaign.enabled = enabled;

      setSelectedCampaign(JSON.parse(JSON.stringify(campaign)));

      // Show success toast
      if (enabled) {
        setToast({ message: `הקמפיין "${campaign.name}" הופעל בהצלחה`, type: 'success' });
      } else {
        setToast({ message: `הקמפיין "${campaign.name}" הושהה`, type: 'warning' });
      }
      setTimeout(() => setToast(null), 3000);
    } catch (e) {
      console.log(e);
      setToast({ message: 'שגיאה בעדכון הקמפיין', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    }
  }

  const updateCampaignName = async (campaignId: string, newName: string) => {
    if (!newName.trim()) {
      setToast({ message: 'שם הקמפיין לא יכול להיות ריק', type: 'error' });
      setTimeout(() => setToast(null), 3000);
      return;
    }

    setSavingCampaignName(true);
    try {
      const response = await axios.post(`${API_URL}/update-campaign`, {
        api_token: auth?.api_token || '',
        campaign_id: campaignId,
        name: newName.trim(),
        max_daily_posts: editingMaxPosts,
        default_auto_reply: editingDefaultAutoReply,
        default_marketplace_auto_reply: editingDefaultMarketplaceAutoReply,
        // Sent even when empty — clearing the box removes the signature. The server
        // ignores this field for a non-admin when the signature is locked.
        default_signature: editingDefaultSignature,
      });

      // Save fake published count via admin endpoint if admin
      const adminToken = getAdminToken();
      if (adminToken && editingFakePublished >= 0) {
        try {
          await axios.put(`${API_URL}/admin/accounts/campaign/${campaignId}/fake-published`, {
            fake_published_count: editingFakePublished
          }, {
            headers: { Authorization: `Bearer ${adminToken}` },
            withCredentials: true
          });
        } catch (e) {
          console.error('Error updating fake published count:', e);
        }
      }

      if (response.data.success) {
        // Refresh user data to get updated campaign list
        const {data: user} = await getUserByToken(auth.api_token);
        setCurrentUser(user);

        setToast({ message: 'שם הקמפיין עודכן בהצלחה', type: 'success' });
        setTimeout(() => setToast(null), 3000);
      }
    } catch (e) {
      console.error('Error updating campaign name:', e);
      setToast({ message: 'שגיאה בעדכון שם הקמפיין', type: 'error' });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setSavingCampaignName(false);
      setEditingCampaignId(null);
      setEditingCampaignName('');
      setEditingMaxPosts(300);
      setEditingFakePublished(0);
      setEditingDefaultAutoReply('');
      setEditingDefaultMarketplaceAutoReply('');
      setEditingDefaultSignature('');
      setEditingDefaultSignatureLocked(false);
    }
  };

  const [showMarketplaceDeleteDialog, setShowMarketplaceDeleteDialog] = useState<{post: any, campaign: any} | null>(null);
  const [deletingMarketplace, setDeletingMarketplace] = useState(false);

  let deletePost = async (post, campaign, alsoDeleteMarketplace = false) => {
    try {
      // Check if post has a marketplace listing and we haven't asked yet
      const hasMarketplace = post.converted_to_marketplace_listing_id || post.marketplace_listing_id;
      if (hasMarketplace && !alsoDeleteMarketplace && !showMarketplaceDeleteDialog) {
        // Show the marketplace delete dialog instead of deleting immediately
        setShowMarketplaceDeleteDialog({post, campaign});
        return;
      }

      // Delete marketplace listing if requested
      if (alsoDeleteMarketplace && hasMarketplace) {
        setDeletingMarketplace(true);
        try {
          const listingId = post.converted_to_marketplace_listing_id || post.marketplace_listing_id;
          await axios.delete(`${API_URL}/api/marketplace/my-listings/${listingId}`, {
            headers: { Authorization: `Bearer ${auth?.api_token}` }
          });
        } catch (e) {
          console.error('Error deleting marketplace listing:', e);
        }
        setDeletingMarketplace(false);
      }

      var new_campaign = await axios.post(`${API_URL}/delete-post`, {
        api_token: auth?.api_token || '',
        post: post,
        campaign: campaign,
      });
      posts.splice(posts.indexOf(post), 1)
      setPosts([...posts]);
      if (currentUser?.campaigns) {
        const newPostCount = posts.length - 1;
        const updatedCampaigns = currentUser.campaigns.map((c: any) =>
          c._id === campaign._id ? { ...c, post_count: newPostCount } : c
        );
        setCurrentUser({ ...currentUser, campaigns: updatedCampaigns });
      }
      setShowMarketplaceDeleteDialog(null);
    } catch (e) {
      console.log(e);
    }
  }
  let deletePosts = async (campaign) => {
    try {
      var posts_to_delete = posts.filter((a) => a.selected);

      var new_campaign = await axios.post(`${API_URL}/delete-posts`, {
        api_token: auth?.api_token || '',
        ids: posts_to_delete.map((a) => a._id),
        campaign: campaign,
      });

      for (var i = 0; i < posts_to_delete.length; i++) {
        posts.splice(posts.indexOf(posts_to_delete[i]), 1)
      }
      setPosts([...posts]);
      // Update post count in currentUser.campaigns
      if (currentUser?.campaigns) {
        const newPostCount = posts.length - posts_to_delete.length;
        const updatedCampaigns = currentUser.campaigns.map((c: any) =>
          c._id === campaign._id ? { ...c, post_count: newPostCount } : c
        );
        setCurrentUser({ ...currentUser, campaigns: updatedCampaigns });
      }

    } catch (e) {
      console.log(e);
      alert(1234)
    }
  }
  let deplicatePosts = async (post, campaign) => {
    try {
      var new_campaign = await axios.post(`${API_URL}/deplicate-posts`, {
        api_token: auth?.api_token || '',
        ids: posts.filter((a) => a.selected).map((a) => a._id),
        campaigns: campaigns.filter((a) => a.selected).map((a) => a._id),
      });
      // posts.splice(posts.indexOf(post), 1)
      setPosts([...posts]);
    } catch (e) {
      console.log(e);
      alert(1234)
    }
  }

  // ADMIN-ONLY: load a post's content version history.
  const openPostHistory = async () => {
    if (!editingPost?._id || String(editingPost._id).startsWith('new_')) return;
    setPostHistoryLoading(true);
    setPostHistory({ current: null, versions: [] });
    try {
      const res = await axios.get(`${API_URL}/posts/${editingPost._id}/history`);
      setPostHistory(res.data);
    } catch (e) {
      setToast({ message: 'טעינת היסטוריית הפוסט נכשלה', type: 'error' });
      setPostHistory(null);
    } finally {
      setPostHistoryLoading(false);
    }
  };

  // Human-readable label for where a snapshot came from.
  const historySourceLabel = (source: string) => {
    switch (source) {
      case 'edit': case 'edit-pre': return 'עריכה';
      case 'mobile-edit': case 'mobile-edit-pre': return 'עריכה מהנייד';
      case 'cron': return 'גיבוי אוטומטי';
      case 'yad2-sync-pre': return 'לפני סנכרון yad2';
      case 'restore': case 'restore-pre': return 'שחזור';
      default: return source || 'שינוי';
    }
  };

  // ADMIN-ONLY: restore a prior version (server snapshots current first).
  const restorePostVersion = async (versionId: string) => {
    if (!editingPost?._id || !versionId) return;
    if (!window.confirm('לשחזר את הגרסה הזו? התוכן הנוכחי יישמר בהיסטוריה, כך שאפשר יהיה לחזור אליו.')) return;
    setRestoringVersionId(versionId);
    try {
      const res = await axios.post(`${API_URL}/posts/${editingPost._id}/restore/${versionId}`);
      const name = res.data.name || '';
      const post_content = res.data.post_content || '';
      setEditingPost((prev: any) => prev ? { ...prev, name, post_content, updated: false } : prev);
      setPosts((prev: any) => (prev as any[]).map((p: any) => p._id === editingPost._id ? { ...p, name, post_content } : p) as any);
      setToast({ message: 'הגרסה שוחזרה בהצלחה', type: 'success' });
      setPostHistory(null);
    } catch (e) {
      setToast({ message: 'שחזור הגרסה נכשל', type: 'error' });
    } finally {
      setRestoringVersionId(null);
    }
  };

  let savePost = async (post, campaign) => {
    post.loading = true;
    setPosts([...posts]);

    // The title field is gone from the UI, so fill it in before saving — Facebook still
    // requires one. Only when absent: an AI-generated or previously-saved title is a
    // better headline than anything derived from the fields, so it isn't overwritten.
    // Title/description filled while the post was only the signature: refill
    // them from the text the post has now.
    if (post.marketplace?.enabled && hasRealListingText(post.post_content)
        && (!hasRealListingText(post.marketplace.description) || !hasRealListingText(post.marketplace.title, 3))) {
      const fresh = await syncMarketplaceWithAI(post.post_content, post.marketplace);
      if (fresh) {
        if (!hasRealListingText(post.marketplace.description)) post.marketplace.description = fresh.description;
        if (!hasRealListingText(post.marketplace.title, 3)) post.marketplace.title = fresh.title;
      }
    }
    if (post.marketplace?.enabled && !String(post.marketplace.title || '').trim()) {
      post.marketplace.title = buildMarketplaceTitle(post.marketplace, post);
    }

    // Log marketplace data for debugging
    if (post.marketplace?.enabled) {
      console.log('[Marketplace] Saving post with marketplace data:', {
        enabled: post.marketplace.enabled,
        profile_id: post.marketplace.profile_id,
        listing_type: post.marketplace.listing_type,
        title: post.marketplace.title,
        price: post.marketplace.price,
        category: post.marketplace.category,
        location: post.marketplace.location
      });
    }

    try {
      var _post = await axios.post(`${API_URL}/save-post`, {
        api_token: auth?.api_token || '',
        post: post,
        campaign: campaign,
      });

      post.updated = false;
      // A WhatsApp link in the post → the server switched the "💬 קישור וואטסאפ" builder on
      // for this account (lib/postWaLink.js); show it now, without a reload.
      if (/(?:wa\.me\/\d{7,15}|api\.whatsapp\.com\/send\/?\?phone=\d{7,15}|fbzipper[^\s/]*\/w\/[A-Za-z2-9]{6,20})/i.test(post.post_content || '')) setPostWaLinkEnabled(true);
      // Mirror the hands-off stamp the server sets when the text was rewritten by
      // hand, so the "yad2 sync won't touch this one" note shows without a reload.
      if (_post.data?.content_edited_at) post.content_edited_at = _post.data.content_edited_at;
      const wasNewPost = post.is_new || post._id?.startsWith('new_');
      const vnDraftKey = String(post._id);
      if (wasNewPost) {
        post._id = _post.data._id;
        post.is_new = false;

        // Re-point any draft virtual-number tracked link onto the now-saved post.
        const vnDraftId = vnDraftRef.current[vnDraftKey];
        if (vnDraftId) {
          delete vnDraftRef.current[vnDraftKey];
          axios.post(`${API_URL}/api/my-posts/wa-link/associate`, {draft_post_id: vnDraftId, post_id: _post.data._id}, {headers: adminAuthHeader()}).catch(() => {});
        }

        // Update post count in currentUser.campaigns for new posts
        if (currentUser?.campaigns && campaign?._id) {
          const updatedCampaigns = currentUser.campaigns.map((c: any) =>
            c._id === campaign._id ? { ...c, post_count: (c.post_count || 0) + 1 } : c
          );
          setCurrentUser({ ...currentUser, campaigns: updatedCampaigns });
        }

        // Run scheduling after creating a new post (non-blocking)
        axios.post(`${API_URL}/api/schedule/reschedule-all-campaigns`, {
          api_token: auth?.api_token
        }).catch(e => console.error('Error running scheduling:', e));

        // Show success toast for new post
        const marketplaceMessage = post.marketplace?.enabled
          ? ' + המודעה נשלחה למרקטפלייס'
          : '';
        setToast({
          message: `הפוסט הועלה בהצלחה ויפורסם אוטומטית בכל הקבוצות שנבחרו בקמפיין${marketplaceMessage}`,
          type: 'success'
        });

        // Refresh posts list to show the new post with updated data
        try {
          const postsResponse = await axios.post(`${API_URL}/posts`, {
            api_token: auth?.api_token || '',
            campaign_id: campaignID,
          });
          postsResponse.data.map((p: any) => {
            p.media = (p.media_url || '').split(',').filter((a: string) => a).map((a: string) => convertToCdnUrl(a));
          });
          setPosts(postsResponse.data);
          return; // Exit early since we already set posts
        } catch (refreshError) {
          console.error('Error refreshing posts:', refreshError);
        }
      }

    } catch (e: any) {
      console.log(e);
      const msg = e?.response?.data?.message || e?.response?.data?.error;
      setToast({ message: msg || 'שמירת הפוסט נכשלה, נסה שוב', type: 'error' });
      post.loading = false;
      setPosts([...posts]);
      return;
    }
    post.updated = false;
    post.loading = false;
    setPosts([...posts]);
  }




  return (
    <>

    <ReactMediaLibrary
      isOpen={display}
      multiple={true}
      multiSelect={true}
      onClose={() => setDisplay(false)}
      fileUploadCallback={() => {}}
      filesSelectCallback={() => {}}
      fileLibraryList={fileLibraryList}
    />

    <div className='card mb-4 mb-xl-6' style={{direction: 'rtl'}}>
      <div className='card-body pt-6 pb-6'>
        {/* Profile Section Header */}
        <div className="profiles-header">
          <h2>פרופילים</h2>
          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
            {/* Server connectivity indicator */}
            <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
              <span
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: serverConnected === null ? '#ffc107' : serverConnected ? '#4caf50' : '#f44336',
                  display: 'inline-block'
                }}
              ></span>
              <span style={{fontSize: '12px', color: '#666'}}>
                {serverConnected === null ? 'בודק...' : serverConnected ? 'מחובר' : 'לא מחובר'}
              </span>
            </div>


            {isAdmin && (
              <button
                onClick={handleAdminAddProfile}
                disabled={adminProfileBusy}
                title="אדמין: יצירת רשומת פרופיל חדשה (ללא ברקוד — הלקוח יחבר בהמשך)"
                style={{display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', border: '1px solid #5b6ef5', background: '#eef0ff', color: '#5b6ef5', fontSize: '12px', fontWeight: 600, cursor: adminProfileBusy ? 'wait' : 'pointer'}}
              >
                {adminProfileBusy ? <span className="spinner-border spinner-border-sm" style={{width: 12, height: 12}}></span> : <i className="bi bi-plus-lg"></i>}
                הוסף פרופיל (אדמין)
              </button>
            )}

          </div>
        </div>

        {/* Admin important note */}
        {isAdmin && (
          <div style={{marginBottom: '12px'}}>
            {/* Payments comments (ClientLog payment_note) — read-only here, so the
                admin sees notes written on the /admin/payments page. */}
            {paymentNotes.length > 0 && (
              <div style={{
                background: '#eef4ff', border: '1px solid #b6d0ff', borderRadius: '8px',
                padding: '8px 12px', marginBottom: '6px', direction: 'rtl', fontSize: '12px',
              }}>
                <div style={{fontWeight: 700, color: '#2b70fa', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <span>💳</span><span>הערות מהתשלומים</span>
                </div>
                {paymentNotes.map((n: any, i: number) => (
                  <div key={n._id || i} style={{display: 'flex', gap: '8px', alignItems: 'flex-start', padding: '2px 0'}}>
                    <span style={{flex: 1, whiteSpace: 'pre-wrap', color: '#334'}}>{n.description}</span>
                    <span style={{color: '#999', fontSize: '10px', whiteSpace: 'nowrap'}}>
                      {n.created_at ? new Date(n.created_at).toLocaleDateString('he-IL') : ''}
                    </span>
                  </div>
                ))}
              </div>
            )}
            {/* Show last note */}
            {adminNotes.length > 0 && (
              <div style={{
                background: '#fff8e1', border: '1px solid #ffc107', borderRadius: '8px',
                padding: '8px 12px', marginBottom: '6px', direction: 'rtl', fontSize: '13px',
                display: 'flex', alignItems: 'center', gap: '8px'
              }}>
                <span style={{fontWeight: 700}}>📌</span>
                <span style={{flex: 1}}>{adminNotes[adminNotes.length - 1].text}</span>
                <span style={{color: '#999', fontSize: '10px', whiteSpace: 'nowrap'}}>
                  {new Date(adminNotes[adminNotes.length - 1].created_at).toLocaleDateString('he-IL')}
                </span>
              </div>
            )}
            {showAdminNoteInput ? (
              <div style={{display: 'flex', gap: '6px', direction: 'rtl'}}>
                <input
                  type="text"
                  placeholder="הערה חשובה..."
                  value={adminNoteText}
                  onChange={(e) => setAdminNoteText(e.target.value)}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter' && adminNoteText.trim()) {
                      try {
                        const adminToken = localStorage.getItem('admin_auth_token');
                        const res = await axios.post(`${API_URL}/admin/account-notes/${currentUser?._id}`, { text: adminNoteText.trim() }, {
                          headers: { Authorization: `Bearer ${adminToken}` }, withCredentials: true
                        });
                        setAdminNotes(res.data.admin_notes || []);
                        setAdminNoteText('');
                        setShowAdminNoteInput(false);
                      } catch { alert('שגיאה בשמירת הערה') }
                    }
                  }}
                  style={{flex: 1, padding: '6px 10px', borderRadius: '6px', border: '1px solid #ffc107', fontSize: '12px', outline: 'none'}}
                  autoFocus
                />
                <button
                  onClick={async () => {
                    if (!adminNoteText.trim()) return;
                    try {
                      const adminToken = localStorage.getItem('admin_auth_token');
                      const res = await axios.post(`${API_URL}/admin/account-notes/${currentUser?._id}`, { text: adminNoteText.trim() }, {
                        headers: { Authorization: `Bearer ${adminToken}` }, withCredentials: true
                      });
                      setAdminNotes(res.data.admin_notes || []);
                      setAdminNoteText('');
                      setShowAdminNoteInput(false);
                    } catch { alert('שגיאה בשמירת הערה') }
                  }}
                  style={{padding: '6px 12px', borderRadius: '6px', border: 'none', background: '#ffc107', color: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer'}}
                >שמור</button>
                <button
                  onClick={() => { setShowAdminNoteInput(false); setAdminNoteText('') }}
                  style={{padding: '6px 8px', borderRadius: '6px', border: '1px solid #ddd', background: '#fff', fontSize: '12px', cursor: 'pointer'}}
                >×</button>
              </div>
            ) : (
              <span
                onClick={() => setShowAdminNoteInput(true)}
                style={{cursor: 'pointer', fontSize: '11px', color: '#1877f2'}}
              >+ הערה חשובה</span>
            )}
          </div>
        )}

        {/* Fetch message */}
        {fetchMessage && (
          <div style={{
            padding: '10px 16px',
            marginBottom: '16px',
            borderRadius: '8px',
            background: fetchMessage.includes('שגיאה') || fetchMessage.includes('לא') ? '#ffebee' : '#e8f5e9',
            color: fetchMessage.includes('שגיאה') || fetchMessage.includes('לא') ? '#c62828' : '#2e7d32',
            fontSize: '14px'
          }}>
            {fetchMessage}
          </div>
        )}

        {/* Profile Cards */}
        <div className="profile-cards-container" data-onboarding="connect-profile">
          {allProfiles?.filter(p => !p.parent_profile).map((parentProfile) => {
            // Connected is STICKY for the life of the page. The check compares a
            // last_health_check frozen at page load against a live Date.now(), so the
            // window slides off it on its own and a perfectly healthy profile flips to
            // "offline" after a few minutes on an open tab — nothing refetches profiles
            // in the steady state. Once we've seen a profile connected we keep saying so
            // until the page is reloaded, which is when fresh data arrives anyway.
            const isCurrentlyConnected = isProfileDisplayedAsConnected(parentProfile);
            if (isCurrentlyConnected) sessionConnectedProfilesRef.current.add(parentProfile._id);
            const isParentConnected = isCurrentlyConnected
              || sessionConnectedProfilesRef.current.has(parentProfile._id)
              || (isAdmin && initialConnectedProfiles.has(parentProfile._id));
            const parentNeedsAttention = !isParentConnected;
            const subProfiles = allProfiles.filter(p => p.parent_profile === parentProfile._id);

            return (
              <div
                key={parentProfile._id}
                className={`profile-card ${isParentConnected ? 'connected' : ''} ${parentNeedsAttention ? 'needs-attention' : ''} ${subProfiles.length > 0 ? 'has-sub-profiles' : ''}`}
              >
                <div className="profile-card-main">
                  <div className="profile-card-avatar">
                    <img
                      src={parentProfile.facebook_id
                        ? `https://graph.facebook.com/${parentProfile.facebook_id}/picture?type=large&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`
                        : `https://graph.facebook.com/100052652058470/picture?type=large&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`
                      }
                      alt={parentProfile.first_name}
                    />
                    <span className={`profile-status-indicator ${isParentConnected ? 'connected' : 'disconnected'}`}></span>
                    {isAdmin && limitedProfileIds.has(parentProfile._id) && (
                      <span style={{
                        width: '10px', height: '10px', borderRadius: '50%',
                        background: '#f44336', position: 'absolute', top: 0, right: 0,
                        border: '2px solid white'
                      }} title="פרופיל מוגבל" />
                    )}
                  </div>

                  <div className="profile-card-info">
                    {editingNameProfileId === parentProfile._id ? (
                      <input
                        autoFocus
                        className="profile-name"
                        value={editingNameValue}
                        disabled={savingNameProfileId === parentProfile._id}
                        onChange={(e) => setEditingNameValue(e.target.value)}
                        onBlur={() => saveProfileDisplayName(parentProfile._id, editingNameValue)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') saveProfileDisplayName(parentProfile._id, editingNameValue);
                          else if (e.key === 'Escape') setEditingNameProfileId(null);
                        }}
                        style={{ border: '1px solid #4caf50', borderRadius: '4px', padding: '2px 6px', fontSize: 'inherit', fontWeight: 'inherit', width: '100%', maxWidth: '220px' }}
                      />
                    ) : (
                      <div
                        className="profile-name"
                        title="לחץ לעריכת שם תצוגה"
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingNameProfileId(parentProfile._id);
                          setEditingNameValue(`${parentProfile.first_name || ''} ${parentProfile.last_name || ''}`.trim() || parentProfile.facebook_username || '');
                        }}
                      >
                        {parentProfile.first_name || parentProfile.facebook_username || parentProfile.facebook_id} {parentProfile.last_name || ''}
                        <i className="bi bi-pencil" style={{ fontSize: '11px', opacity: 0.45 }}></i>
                      </div>
                    )}
                    <div className={`profile-status ${isParentConnected ? 'connected' : 'disconnected'}`}>
                      {isParentConnected ? '● מחובר' : '○ לא מחובר'}
                    </div>
                    {isAdmin && isParentConnected && (!parentProfile.group_count || parentProfile.group_count === 0) && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#f59e0b', marginTop: '4px' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="syncing-spinner">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeDasharray="32" strokeLinecap="round"/>
                        </svg>
                        מסנכרן קבוצות (יסתיים תוך מספר דקות)
                      </div>
                    )}
                  </div>

                  <div className="profile-card-action" style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {(isAdmin || isAffiliateSession) && (
                      <button
                        title="תצוגה מקדימה של הפרופיל"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(
                            `http://144.91.72.128:8080/preview/${parentProfile._id}/`,
                            `profile_preview_${parentProfile._id}`,
                            'width=1100,height=820,resizable=yes,scrollbars=yes'
                          );
                        }}
                        style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', padding: '4px 8px', borderRadius: '50%', color: '#5b6ef5', lineHeight: 1 }}
                      >
                        <i className="bi bi-display"></i>
                      </button>
                    )}
                    {isAdmin && (
                      <button
                        title="אדמין: מחיקה רכה של הפרופיל"
                        disabled={adminProfileBusy}
                        onClick={(e) => { e.stopPropagation(); handleAdminDeleteProfile(parentProfile); }}
                        style={{ background: 'none', border: 'none', fontSize: '17px', cursor: 'pointer', padding: '4px 8px', borderRadius: '50%', color: '#e53935', lineHeight: 1 }}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    )}
                    {parentNeedsAttention ? (
                      <button
                        className="btn-connect"
                        data-onboarding="connect-btn"
                        onClick={() => {
                          if (parentProfile.facebook_username?.indexOf('autoGEN') === -1) {
                            formik1.setValues({
                              newUsername: parentProfile.facebook_username || '',
                              confirmPassword: parentProfile.facebook_password,
                            });
                          }
                          setUpdatedFacebookProfile(false);
                          initialFacebookIdRef.current = parentProfile.facebook_id || null;
                          initialHealthCheckRef.current = parentProfile.last_health_check || null;
                          setLoggingInProfile(parentProfile);
                          setCurrentProfile(parentProfile);
                        }}
                      >
                        התחבר
                      </button>
                    ) : (
                      <>
                        {parentProfile.block_publish && (
                          <span style={{ fontSize: '11px', color: '#e53935', fontWeight: 500 }}>פרסום כבוי</span>
                        )}
                        <button
                          style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            padding: '4px 8px',
                            borderRadius: '50%',
                            color: '#65676b',
                            lineHeight: 1,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setProfileMenuOpen(profileMenuOpen === parentProfile._id ? null : parentProfile._id);
                          }}
                          title="אפשרויות"
                        >
                          ⋮
                        </button>
                        {profileMenuOpen === parentProfile._id && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              background: '#fff',
                              borderRadius: '8px',
                              boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                              zIndex: 1000,
                              minWidth: '180px',
                              overflow: 'hidden',
                              border: '1px solid #e0e0e0',
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {/* Toggle posting */}
                            <button
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                width: '100%',
                                padding: '10px 16px',
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                color: parentProfile.block_publish ? '#4caf50' : '#e53935',
                                textAlign: 'right',
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                              onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                              disabled={togglingPostingProfiles.has(parentProfile._id)}
                              onClick={async () => {
                                const allowPosting = !!parentProfile.block_publish;
                                setTogglingPostingProfiles(prev => new Set(prev).add(parentProfile._id));
                                try {
                                  const response = await axios.post(`${API_URL}/api/toggle-profile-posting`, {
                                    api_token: auth?.api_token || '',
                                    profile_id: parentProfile._id,
                                    allow_posting: allowPosting
                                  });
                                  if (response.data.success) {
                                    setAllProfiles(prev => prev.map(p =>
                                      p._id === parentProfile._id ? { ...p, block_publish: response.data.block_publish } : p
                                    ));
                                  }
                                } catch (error) {
                                  console.error('Error toggling posting:', error);
                                } finally {
                                  setTogglingPostingProfiles(prev => {
                                    const next = new Set(prev);
                                    next.delete(parentProfile._id);
                                    return next;
                                  });
                                  setProfileMenuOpen(null);
                                }
                              }}
                            >
                              {togglingPostingProfiles.has(parentProfile._id)
                                ? '⏳ מעדכן...'
                                : parentProfile.block_publish
                                  ? '▶ הפעל פרסום'
                                  : '⏸ כבה פרסום'
                              }
                            </button>
                            {/* Settings - Admin Only */}
                            {isAdmin && (
                            <button
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                width: '100%',
                                padding: '10px 16px',
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                color: '#333',
                                textAlign: 'right',
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                              onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                              onClick={() => {
                                setSettingsModalProfile(parentProfile);
                                setProfileMenuOpen(null);
                              }}
                            >
                              ⚙ הגדרות פרופיל <span className="badge badge-light-danger" style={{ fontSize: '9px', marginRight: '4px' }}>אדמין</span>
                            </button>
                            )}
                            {/* Password-free link to this profile's live fleet preview, for
                                sending to the customer. Scoped to this one profile — see
                                GET /profile-preview-link/:id. Admin-only: a client must not
                                be able to mint these. */}
                            {isAdmin && (
                            <button
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                width: '100%',
                                padding: '10px 16px',
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                color: '#333',
                                textAlign: 'right',
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                              onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                              onClick={async () => {
                                setProfileMenuOpen(null);
                                try {
                                  const adminToken = getAdminToken();
                                  const r = await axios.get(
                                    `${API_URL}/profile-preview-link/${parentProfile._id}?days=30`,
                                    {headers: adminToken ? {'x-admin-token': adminToken} : {}}
                                  );
                                  if (!r.data?.success) throw new Error(r.data?.message || 'failed');
                                  // Clipboard needs a secure context; prompt() is the
                                  // fallback so the link is never just lost.
                                  try {
                                    await navigator.clipboard.writeText(r.data.url);
                                    setToast({message: 'הקישור הועתק — תקף 30 יום, פותח רק את הפרופיל הזה', type: 'success'});
                                    setTimeout(() => setToast(null), 4000);
                                  } catch (e) {
                                    window.prompt('קישור ללקוח (תקף 30 יום):', r.data.url);
                                  }
                                } catch (e: any) {
                                  setToast({message: 'יצירת הקישור נכשלה: ' + (e?.response?.data?.message || e.message), type: 'error'});
                                  setTimeout(() => setToast(null), 4000);
                                }
                              }}
                            >
                              🔗 קישור ללקוח <span className="badge badge-light-danger" style={{ fontSize: '9px', marginRight: '4px' }}>אדמין</span>
                            </button>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* Active Sub Profiles */}
                {subProfiles.filter(sp => sp.parent_profile_on).length > 0 && (
                  <div className="sub-profiles-section" style={{
                    borderTop: '1px solid #e0e0e0',
                    padding: '12px 16px',
                    background: 'rgba(76, 175, 80, 0.03)'
                  }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                      פרופילים משניים פעילים ({subProfiles.filter(sp => sp.parent_profile_on).length})
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {subProfiles.filter(sp => sp.parent_profile_on).map(subProfile => (
                        <div
                          key={subProfile._id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '4px 10px',
                            borderRadius: '16px',
                            background: '#e8f5e9',
                            border: '1px solid #c8e6c9',
                            fontSize: '12px',
                            position: 'relative'
                          }}
                        >
                          {isAdmin && limitedProfileIds.has(subProfile._id) && (
                            <span style={{
                              width: '8px', height: '8px', borderRadius: '50%',
                              background: '#f44336', position: 'absolute', top: '-2px', right: '-2px',
                              border: '1.5px solid white'
                            }} title="פרופיל מוגבל" />
                          )}
                          <img
                            src={`https://graph.facebook.com/${subProfile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                            alt=""
                            style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              border: '1px solid #4caf50'
                            }}
                          />
                          <span style={{ color: '#2e7d32', fontWeight: 500 }}>
                            {subProfile.first_name}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Inactive Sub Profiles Placeholder - show when has sub-profiles but none are active */}
                {subProfiles.length > 0 && subProfiles.filter(sp => sp.parent_profile_on).length === 0 && (
                  <div className="sub-profiles-section" style={{
                    borderTop: '1px solid #e0e0e0',
                    padding: '12px 16px',
                    background: 'rgba(158, 158, 158, 0.03)'
                  }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                      פרופילים משניים ({subProfiles.length} לא פעילים)
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      <div
                        onClick={() => {
                          setAddProfileTab('subprofiles');
                          setSelectedSubProfiles([]);
                          setShowAddProfileModal(true);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          padding: '4px 10px',
                          borderRadius: '16px',
                          background: '#f5f5f5',
                          border: '2px dashed #ccc',
                          fontSize: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        className="add-sub-profile-placeholder"
                      >
                        <div style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          border: '1px dashed #999',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                          fontSize: '14px'
                        }}>
                          +
                        </div>
                        <span style={{ color: '#666', fontWeight: 500 }}>
                          הפעל פרופיל משני
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          {/* Add Profile Card - Dummy placeholder */}
          <div
            className="profile-card add-profile-card"
            onClick={() => openAddProfileModal()}
          >
            <div className="profile-card-main" style={{ justifyContent: 'center', padding: '20px', flexDirection: 'column' }}>
              <div className="add-profile-icon" style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                border: '2px dotted #ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#999',
                fontSize: '24px',
                marginBottom: '8px'
              }}>
                +
              </div>
              <div className="add-profile-text" style={{ color: '#666', fontSize: '13px' }}>הוסף פרופילים</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Schedule Profile Stats - Admin Only */}
    {isAdmin && scheduleProfileStats.length > 0 && (
      <div className="card mb-4 mb-xl-6" style={{ direction: 'rtl' }}>
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bold fs-3 mb-1">סטטיסטיקות לפי פרופיל <span className="badge badge-light-danger ms-2" style={{ fontSize: '0.7rem' }}>אדמין</span></span>
            <span className="text-muted mt-1 fw-semibold fs-7">פוסטים מתוזמנים להיום</span>
          </h3>
        </div>
        <div className="card-body pt-0">
          <div className="d-flex flex-wrap gap-3">
            {scheduleProfileStats.map((profile: any) => (
              <div
                key={profile._id}
                className="border border-gray-300 rounded p-3"
                style={{ minWidth: '200px' }}
              >
                <div className="d-flex align-items-center mb-2">
                  <div className="position-relative me-2">
                    <img
                      src={profile.facebook_id
                        ? `https://graph.facebook.com/${profile.facebook_id}/picture?type=normal&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`
                        : profile.profile_picture_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(profile.name)}&background=random&color=fff&size=32`}
                      alt={profile.name}
                      className="rounded-circle"
                      style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                      onError={(e: any) => {
                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(profile.name)}&background=random&color=fff&size=32`
                      }}
                    />
                    <span
                      className={`position-absolute rounded-circle border border-2 border-white ${profile.is_online ? 'bg-success' : 'bg-danger'}`}
                      style={{ width: '10px', height: '10px', bottom: '0', right: '0' }}
                    />
                  </div>
                  <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                    <div className="d-flex align-items-center gap-1">
                      <span className="fw-bold text-gray-800 text-truncate" style={{ maxWidth: '130px' }}>
                        {profile.name}
                      </span>
                      <span className={`badge badge-sm ${profile.is_parent ? 'badge-light-primary' : 'badge-light-info'}`} style={{ fontSize: '9px', padding: '2px 4px' }}>
                        {profile.is_parent ? 'ראשי' : 'משני'}
                      </span>
                      <button
                        className="btn btn-icon btn-sm btn-light-secondary"
                        style={{ width: '18px', height: '18px', minWidth: '18px', padding: 0 }}
                        title={profile._id}
                        onClick={(e: any) => {
                          e.stopPropagation()
                          navigator.clipboard.writeText(profile._id)
                          const btn = e.currentTarget
                          btn.innerHTML = '<i class="bi bi-check fs-9 text-success"></i>'
                          setTimeout(() => { btn.innerHTML = '<i class="bi bi-clipboard fs-9"></i>' }, 1500)
                        }}
                      >
                        <i className="bi bi-clipboard fs-9"></i>
                      </button>
                    </div>
                    {isAdmin && profile.is_parent && String(profile.facebook_id || '').startsWith('615') && (
                      <span className="text-danger fs-9 fw-bold" title="מזהה פייסבוק שמתחיל ב-615 מציין פרופיל שנפתח לאחרונה — פחות משנה">
                        <i className="bi bi-exclamation-triangle-fill me-1"></i>פרופיל חדש — פחות משנה
                      </span>
                    )}
                    {!profile.is_parent && profile.parent_name && (
                      <span className="text-muted fs-9 text-truncate" style={{ maxWidth: '150px' }}>
                        ← {profile.parent_name}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-muted fs-7">פוסטים היום:</span>
                  <span className="fw-bold">
                    {profile.slots_total} / {editingPostsPerDay?.profileId === profile._id ? (
                      <input
                        type="number"
                        autoFocus
                        value={editingPostsPerDay.value}
                        onChange={(e) => setEditingPostsPerDay({profileId: profile._id, value: e.target.value})}
                        onBlur={() => handleProfilePostsPerDaySave(profile._id, editingPostsPerDay.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') handleProfilePostsPerDaySave(profile._id, editingPostsPerDay!.value)
                          if (e.key === 'Escape') setEditingPostsPerDay(null)
                        }}
                        min={1}
                        max={1000}
                        style={{width: '55px', padding: '0 4px', border: '1px solid #3699ff', borderRadius: '4px', fontSize: '13px', fontWeight: 600, textAlign: 'center'}}
                        onClick={(e: any) => e.stopPropagation()}
                      />
                    ) : (
                      <span
                        onClick={(e: any) => {
                          e.stopPropagation()
                          setEditingPostsPerDay({profileId: profile._id, value: String(profile.max_daily)})
                        }}
                        style={{
                          cursor: 'pointer',
                          borderBottom: '1px dashed #b5b5c3',
                          color: savedPostsPerDay === profile._id ? '#1bc5bd' : undefined,
                          transition: 'color 0.3s ease',
                        }}
                        title="לחץ לעריכה"
                      >
                        {profile.max_daily}
                      </span>
                    )}
                  </span>
                </div>
                <div className="progress h-6px mb-2" style={{ backgroundColor: '#e4e6ef' }}>
                  <div
                    className={`progress-bar ${profile.usage_percent >= 90 ? 'bg-danger' : profile.usage_percent >= 70 ? 'bg-warning' : 'bg-success'}`}
                    style={{ width: `${Math.min(profile.usage_percent, 100)}%` }}
                  />
                </div>
                <div className="d-flex gap-2 fs-8">
                  <span className="text-success">{profile.slots_posted} פורסמו</span>
                  <span className="text-warning">{profile.slots_pending} ממתינים</span>
                  {profile.slots_errors > 0 && (
                    <span className="text-danger">{profile.slots_errors} שגיאות</span>
                  )}
                </div>
                {profile.join_groups > 0 && (
                  <div className="fs-8 text-info mt-1">{profile.join_groups} הצטרפויות לקבוצות</div>
                )}
                <div className="mt-2 pt-2 border-top fs-8">
                  <div className="d-flex justify-content-between text-muted">
                    <span>קבוצות ({profile.groups_following}):</span>
                    <div className="d-flex align-items-center gap-1">
                      <span className={profile.last_get_groups ? '' : 'text-danger'}>
                        {profile.last_get_groups
                          ? new Date(profile.last_get_groups).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
                          : 'אף פעם'}
                      </span>
                      {profile.last_get_groups && (
                        <button
                          className="btn btn-icon btn-sm"
                          style={{ width: '16px', height: '16px', minWidth: '16px', padding: 0 }}
                          title="אפס כדי שהבוט יבדוק קבוצות מחדש"
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              await axios.post(`${API_URL}/reset-last-get-following`, {
                                api_token: auth?.api_token || '',
                                profile_id: profile._id,
                              });
                              profile.last_get_groups = null;
                              setAllProfiles([...allProfiles]);
                              setToast({ message: 'הבוט יבדוק קבוצות מחדש בהפעלה הבאה', type: 'success' });
                            } catch (error) {
                              console.error('Error resetting last_get_following:', error);
                              setToast({ message: 'שגיאה באיפוס', type: 'error' });
                            }
                          }}
                        >
                          <i className="bi bi-arrow-clockwise fs-9 text-primary"></i>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between text-muted">
                    <span>התראות:</span>
                    <span className={profile.last_get_notifications ? '' : 'text-danger'}>
                      {profile.last_get_notifications
                        ? new Date(profile.last_get_notifications).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
                        : 'אף פעם'}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between text-muted">
                    <span>מרקטפלייס:</span>
                    <span className={profile.last_get_marketplace ? '' : 'text-danger'}>
                      {profile.last_get_marketplace
                        ? new Date(profile.last_get_marketplace).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
                        : 'אף פעם'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}

{/* Bottom Sheet Modal for Facebook Login */}
{loggingInProfile && (
  <>
    <div
      className={`bottom-sheet-overlay show`}
      style={{zIndex: 10002}}
    />
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      borderRadius: '20px',
      padding: '32px',
      width: '90%',
      maxWidth: '480px',
      maxHeight: '90vh',
      overflow: 'hidden',
      zIndex: 10003,
      boxShadow: '0 12px 48px rgba(0,0,0,0.3)',
      direction: 'rtl',
      textAlign: 'center'
    }} data-onboarding="connect-wizard">
      <button
        type="button"
        aria-label="סגור"
        onClick={() => { setLoggingInProfile(null); setProfileLoginSuccess(false); }}
        style={{
          position: 'absolute',
          top: 12,
          left: 12,
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: 'none',
          background: '#f0f2f5',
          color: '#65676b',
          fontSize: 20,
          lineHeight: '32px',
          cursor: 'pointer',
          padding: 0,
          zIndex: 5,
          boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        }}
      >
        ×
      </button>
      {/* Inner scroll wrapper — keeps the close button pinned to the card corner while the content scrolls */}
      <div style={{maxHeight: 'calc(90vh - 64px)', overflowY: 'auto'}}>
      {/* ===== QR login (replaces username/password + login iframe) ===== */}
      {profileLoginSuccess ? (
        <div className="wizard-step profile-step">
          <div style={{padding: '24px 8px', textAlign: 'center'}}>
            <div style={{fontSize: '44px', marginBottom: '8px'}}>&#x2705;</div>
            <h3 style={{margin: 0}}>התחברת בהצלחה!</h3>
            <p style={{margin: '6px 0 0', color: '#555'}}>הפרופיל חובר בהצלחה למערכת.</p>
          </div>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => { setLoggingInProfile(null); setProfileLoginSuccess(false); }}
            style={{width: '100%', marginTop: '12px'}}
          >
            סיום
          </button>
        </div>
      ) : (
        <div className="wizard-step profile-step">
          <div className="congrats-banner">
            <div className="congrats-icon">🎉</div>
            <h3>חבר את הפרופיל שלך!</h3>
            <p>
              {loginMethod === 'password'
                ? 'התחבר עם המייל והסיסמה של הפייסבוק — בדיוק כמו התחברות רגילה.'
                : isMobileDevice
                ? 'התחבר דרך אפליקציית הפייסבוק בטלפון שבו אתה מחובר לחשבון.'
                : 'סרוק את הקוד עם מצלמת הטלפון שבו אתה מחובר לפייסבוק.'}
            </p>
          </div>
          <div className="facebook-login-card">
            <div className="fb-logo">
              <svg viewBox="0 0 36 36" fill="url(#loginFbGrad)" height="40" width="40">
                <defs>
                  <linearGradient id="loginFbGrad" x1="50%" x2="50%" y1="97.078%" y2="0%">
                    <stop offset="0%" stopColor="#0062E0"/>
                    <stop offset="100%" stopColor="#19AFFF"/>
                  </linearGradient>
                </defs>
                <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z"/>
                <path fill="#fff" d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"/>
              </svg>
            </div>
            <h2 className="fb-title">התחבר לפייסבוק</h2>

            {loginMethod === 'password' ? (
              /* Username/password connect. The link opens the live mobile browser
                 on the bot's side (/c/:code), where the customer signs in exactly
                 as they would on facebook.com — 2FA and checkpoints included —
                 and the session stays on the profile. */
              <div style={{display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8}}>
                <a
                  href={passwordLoginUrl || '#'}
                  target="_blank"
                  rel="noreferrer"
                  className="wizard-btn primary"
                  style={{display: 'block', width: '100%', textDecoration: 'none', textAlign: 'center', opacity: passwordLoginUrl ? 1 : 0.6, pointerEvents: passwordLoginUrl ? 'auto' : 'none'}}
                >
                  <i className="bi bi-key-fill me-2"></i>
                  התחבר עם שם משתמש וסיסמה
                </a>
                <p style={{margin: 0, fontSize: 13, color: '#65676b', lineHeight: 1.6, textAlign: 'center'}}>
                  ייפתח מסך התחברות של פייסבוק. הזינו את המייל והסיסמה, ואם תתבקשו — אשרו גם את האימות הדו־שלבי.
                </p>

                {/* Same link, for finishing on the phone instead — some people
                    would rather type a Facebook password on their own device. */}
                <div style={{paddingTop: 12, borderTop: '1px solid #e4e6eb', textAlign: 'right'}}>
                  {!showOtherDeviceInstructions ? (
                    <button
                      type="button"
                      onClick={() => setShowOtherDeviceInstructions(true)}
                      style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', padding: '10px 16px', background: '#f0f2f5', color: '#1c1e21', border: '1px solid #e4e6eb', borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: 'pointer'}}
                    >
                      <i className="bi bi-phone"></i>
                      התחבר ממכשיר אחר
                    </button>
                  ) : (
                    <div style={{background: '#f7f8fa', border: '1px solid #e4e6eb', borderRadius: 12, padding: 14}}>
                      <div style={{fontSize: 13, fontWeight: 600, color: '#1c1e21', marginBottom: 8, lineHeight: 1.6}}>
                        שלחו לעצמכם את הקישור לטלפון והשלימו שם את ההתחברות:
                      </div>
                      <div style={{display: 'flex', gap: 8, alignItems: 'stretch'}}>
                        <div style={{flex: 1, padding: '10px 12px', background: '#fff', border: '1px solid #e4e6eb', borderRadius: 8, fontSize: 12, direction: 'ltr', textAlign: 'left', wordBreak: 'break-all', maxHeight: 80, overflowY: 'auto', lineHeight: 1.4, color: '#1c1e21'}}>
                          {passwordLoginUrl}
                        </div>
                        <button
                          type="button"
                          onClick={async () => {
                            try {
                              await navigator.clipboard.writeText(passwordLoginUrl || '')
                              setCopiedQrLink(true)
                              setTimeout(() => setCopiedQrLink(false), 2000)
                            } catch {}
                          }}
                          style={{display: 'flex', alignItems: 'center', gap: 6, padding: '0 14px', background: '#1877f2', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap'}}
                        >
                          <i className={copiedQrLink ? 'bi bi-check2' : 'bi bi-clipboard'}></i>
                          {copiedQrLink ? 'הועתק' : 'העתק'}
                        </button>
                      </div>
                      <a
                        href={`https://wa.me/?text=${encodeURIComponent(passwordLoginUrl || '')}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 10, padding: '10px 16px', background: '#25D366', color: '#fff', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none'}}
                      >
                        <i className="bi bi-whatsapp"></i>
                        שלח את הקישור בוואטסאפ
                      </a>
                      <button
                        type="button"
                        onClick={() => setShowOtherDeviceInstructions(false)}
                        style={{display: 'block', margin: '8px auto 0', background: 'transparent', border: 'none', color: '#65676b', fontSize: 12, cursor: 'pointer', textDecoration: 'underline'}}
                      >
                        חזרה
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : qrLoginStatus === 'ready' && qrLoginUrl ? (
              <>
              {isMobileDevice ? (
                <a
                  href={qrLoginUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="wizard-btn primary"
                  style={{display: 'block', width: '100%', marginTop: '8px', textDecoration: 'none'}}
                >
                  התחבר עם אפליקציית פייסבוק
                </a>
              ) : (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginTop: '8px'}}>
                  <div style={{background: '#fff', padding: '16px', borderRadius: '16px', border: '1px solid #e4e6eb', boxShadow: '0 2px 12px rgba(0,0,0,0.08)'}}>
                    <div style={{position: 'relative', width: 208, height: 208}}>
                      {/* level="H" (~30% error correction) keeps the code scannable with the centered logo badge occluding the middle */}
                      <QRCode value={qrLoginUrl} size={208} level="H" fgColor="#1c1e21" bgColor="#ffffff" style={{display: 'block'}} />
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        background: 'linear-gradient(135deg, #2b70fa 0%, #19AFFF 100%)',
                        boxShadow: '0 0 0 5px #fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <i className="bi bi-lightning-charge-fill" style={{color: '#fff', fontSize: 26}}></i>
                      </div>
                    </div>
                  </div>
                  <p style={{margin: 0, fontSize: '13px', color: '#65676b', maxWidth: '300px', lineHeight: 1.6}}>
                    סרקו את הקוד עם <b>מצלמת הטלפון</b> שבו אתם מחוברים לפייסבוק.
                  </p>
                </div>
              )}
              {/* "Connect to another device" — replaces the old in-app WhatsApp sender.
                  We surface the QR-login link so the user can share it themselves
                  (e.g. via WhatsApp) to a device that already has the FB app installed. */}
              <div style={{marginTop: 16, paddingTop: 16, borderTop: '1px solid #e4e6eb', textAlign: 'right'}}>
                {!showOtherDeviceInstructions ? (
                  <button
                    type="button"
                    onClick={() => setShowOtherDeviceInstructions(true)}
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', padding: '10px 16px', background: '#f0f2f5', color: '#1c1e21', border: '1px solid #e4e6eb', borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: 'pointer'}}
                  >
                    <i className="bi bi-phone"></i>
                    התחבר ממכשיר אחר
                  </button>
                ) : (
                  <div style={{background: '#f7f8fa', border: '1px solid #e4e6eb', borderRadius: 12, padding: 14}}>
                    <div style={{fontSize: 13, fontWeight: 600, color: '#1c1e21', marginBottom: 8, lineHeight: 1.6}}>
                      פתחו את הוואטסאפ במכשיר שבו מותקנת אפליקציית פייסבוק, ושלחו אליו את הקישור הבא:
                    </div>
                    <div style={{display: 'flex', gap: 8, alignItems: 'stretch'}}>
                      <div style={{flex: 1, padding: '10px 12px', background: '#fff', border: '1px solid #e4e6eb', borderRadius: 8, fontSize: 12, direction: 'ltr', textAlign: 'left', wordBreak: 'break-all', maxHeight: 80, overflowY: 'auto', lineHeight: 1.4, color: '#1c1e21'}}>
                        {qrLoginUrl}
                      </div>
                      <button
                        type="button"
                        onClick={async () => {
                          try {
                            await navigator.clipboard.writeText(qrLoginUrl || '')
                            setCopiedQrLink(true)
                            setTimeout(() => setCopiedQrLink(false), 2000)
                          } catch {}
                        }}
                        style={{display: 'flex', alignItems: 'center', gap: 6, padding: '0 14px', background: '#1877f2', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap'}}
                      >
                        <i className={copiedQrLink ? 'bi bi-check2' : 'bi bi-clipboard'}></i>
                        {copiedQrLink ? 'הועתק' : 'העתק'}
                      </button>
                    </div>
                    <a
                      href={`https://wa.me/?text=${encodeURIComponent(qrLoginUrl || '')}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 10, padding: '10px 16px', background: '#25D366', color: '#fff', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none'}}
                    >
                      <i className="bi bi-whatsapp"></i>
                      פתח וואטסאפ ובחר נמען
                    </a>
                    <button
                      type="button"
                      onClick={() => setShowOtherDeviceInstructions(false)}
                      style={{display: 'block', margin: '8px auto 0', background: 'transparent', border: 'none', color: '#65676b', fontSize: 12, cursor: 'pointer', textDecoration: 'underline'}}
                    >
                      חזרה
                    </button>
                  </div>
                )}
              </div>
              </>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px', padding: '8px'}}>
                {/* QR-shaped skeleton that occupies the real QR's footprint and pulses
                    with a shimmer until qrLoginUrl arrives. Mirrors the live QR layout
                    (208px outer, 48px centered logo badge) so there's no layout shift. */}
                <div style={{background: '#fff', padding: '16px', borderRadius: '16px', border: '1px solid #e4e6eb', boxShadow: '0 2px 12px rgba(0,0,0,0.08)'}}>
                  <div style={{position: 'relative', width: 208, height: 208}}>
                    <div
                      aria-label="טוען קוד התחברות"
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 8,
                        background: 'linear-gradient(90deg, #eef0f3 0%, #f7f8fa 50%, #eef0f3 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'qrShimmer 1.4s ease-in-out infinite',
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: 'linear-gradient(135deg, #2b70fa 0%, #19AFFF 100%)',
                      boxShadow: '0 0 0 5px #fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <i className="bi bi-lightning-charge-fill" style={{color: '#fff', fontSize: 26}}></i>
                    </div>
                  </div>
                </div>
                <style>{`
                  @keyframes qrShimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                  }
                `}</style>
                <span style={{fontSize: '14px', color: '#65676b'}}>
                  {qrLoginStatus === 'starting' ? 'מפעילים את הפרופיל...' : 'ממתינים לקוד התחברות...'}
                </span>
              </div>
            )}

            {/* Manual username+password fallback: opens the live mobile-browser
                embed and logs this profile in directly (same persistent bot
                session). Deliberately OUTSIDE the qr-ready branch above — it
                used to live inside it, so the one case where people most need
                it (the QR never renders, so there is nothing to scan) was
                exactly the case where the button wasn't there. Shown to every
                user, not just admins, for the same reason. Hidden in password
                mode — there it IS the flow above, not a fallback. */}
            {loginMethod !== 'password' && loggingInProfile?._id && (
              <div style={{marginTop: 14, paddingTop: 14, borderTop: '1px solid #e4e6eb', textAlign: 'center'}}>
                <button
                  type="button"
                  disabled={connectLinkBusy}
                  onClick={async () => {
                    setConnectLinkBusy(true)
                    try {
                      const r = await axios.post(`${API_URL}/api/profiles/${loggingInProfile._id}/connect-link`, { api_token: auth?.api_token || '' })
                      const url = r.data?.url
                      if (url) window.open(url, '_blank')
                      else alert('שגיאה ביצירת קישור התחברות')
                    } catch (e) { alert('שגיאה ביצירת קישור התחברות') }
                    finally { setConnectLinkBusy(false) }
                  }}
                  style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', padding: '11px 16px', background: '#1877f2', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: connectLinkBusy ? 'default' : 'pointer', opacity: connectLinkBusy ? 0.65 : 1}}
                >
                  <i className="bi bi-key-fill"></i>
                  {connectLinkBusy ? 'מכינים את החיבור…' : 'התחבר עם שם משתמש וסיסמה'}
                </button>
                <div style={{fontSize: 11.5, color: '#8a8d91', marginTop: 6}}>
                  {qrLoginStatus === 'ready' && qrLoginUrl
                    ? 'לא מצליח לסרוק את הקוד? התחבר ידנית עם פרטי הפרופיל'
                    : 'הקוד לא נטען? אפשר להתחבר ידנית עם פרטי הפרופיל'}
                </div>
              </div>
            )}

            <button
              type="button"
              className="forgot-password-btn"
              onClick={() => setLoggingInProfile(null)}
            >
              ביטול
            </button>
            {(getAdminToken() || isAffiliateSession) && <div style={{marginTop: '8px'}}><a href={`http://144.91.72.128:8080/preview/${loggingInProfile._id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary">פתח בחלון חדש</a><SharePreviewLinkButton profileId={loggingInProfile._id} className="ms-3" /></div>}
          </div>
        </div>
      )}

      {/* ===== Legacy login flow (username/password + iframe) — disabled, kept for reference =====
      {updatedFacebookProfile ? (
        <div className="wizard-step profile-iframe-step">
          {profileLoginSuccess && (
            <div style={{padding: '12px 20px', textAlign: 'center', marginBottom: '12px', background: '#d4edda', borderRadius: '12px'}}>
              <div style={{fontSize: '32px', marginBottom: '4px'}}>&#x2705;</div>
              <h3 style={{margin: 0}}>התחברת בהצלחה!</h3>
              <p style={{margin: '4px 0 0'}}>הפרופיל חובר בהצלחה למערכת.</p>
            </div>
          )}
          {!profileLoginSuccess && <h2>התחברות לפייסבוק</h2>}
          {!profileLoginSuccess && <p>אנא התחבר לחשבון הפייסבוק שלך בחלון למטה.</p>}
          {(getAdminToken() || isAffiliateSession) && <div style={{marginBottom: '8px'}}><a href={`http://144.91.72.128:8080/preview/${loggingInProfile._id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary">פתח בחלון חדש</a><SharePreviewLinkButton profileId={loggingInProfile._id} className="ms-3" /></div>}
          <div className="iphone-mockup">
            <div className="iphone-notch"></div>
            <div className="iphone-screen">
              <iframe
                src={`https://profilelogin.fbzipper.com/?id=${loggingInProfile._id}`}
                title="Facebook Login"
              />
            </div>
            <div className="iphone-home-bar"></div>
          </div>
          {!profileLoginSuccess && (
            <div className="waiting-indicator">
              <div className="spinner"></div>
              <span>ממתין לאישור התחברות...</span>
            </div>
          )}
          <button
            type="button"
            className={profileLoginSuccess ? "btn btn-success" : "btn btn-secondary"}
            onClick={() => {
              setLoggingInProfile(null);
              setProfileLoginSuccess(false);
            }}
            style={{width: '100%', marginTop: '12px'}}
          >
            סגור
          </button>
        </div>
      ) : (
        <div className="wizard-step profile-step">
          <div className="congrats-banner">
            <div className="congrats-icon">🎉</div>
            <h3>חבר את הפרופיל שלך!</h3>
            <p>הזן את פרטי ההתחברות לפייסבוק כדי לחבר את הפרופיל שלך למערכת.</p>
          </div>
          <div className="facebook-login-card">
            <div className="fb-logo">
              <svg viewBox="0 0 36 36" fill="url(#loginFbGrad)" height="40" width="40">
                <defs>
                  <linearGradient id="loginFbGrad" x1="50%" x2="50%" y1="97.078%" y2="0%">
                    <stop offset="0%" stopColor="#0062E0"/>
                    <stop offset="100%" stopColor="#19AFFF"/>
                  </linearGradient>
                </defs>
                <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z"/>
                <path fill="#fff" d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"/>
              </svg>
            </div>
            <h2 className="fb-title">התחבר לפייסבוק</h2>
            <form onSubmit={formik1.handleSubmit} autoComplete="off">
              <div className="fb-form">
                <input
                  type="text"
                  placeholder="אימייל או מספר טלפון"
                  className="fb-input"
                  autoComplete="off"
                  data-lpignore="true"
                  data-form-type="other"
                  {...formik1.getFieldProps('newUsername')}
                />
                <div className="password-input-wrapper">
                  <input
                    type="password"
                    placeholder="סיסמה"
                    className="fb-input"
                    autoComplete="new-password"
                    data-lpignore="true"
                    data-form-type="other"
                    {...formik1.getFieldProps('confirmPassword')}
                  />
                </div>
              </div>
              <button
                type="submit"
                className="wizard-btn primary"
                style={{width: '100%', marginTop: '12px'}}
                disabled={loading1}
              >
                {loading1 ? 'מתחבר...' : 'התחבר'}
              </button>
            </form>
            <button
              type="button"
              className="forgot-password-btn"
              onClick={() => setLoggingInProfile(null)}
            >
              ביטול
            </button>
            {(getAdminToken() || isAffiliateSession) && <div style={{marginTop: '8px'}}><a href={`http://144.91.72.128:8080/preview/${loggingInProfile._id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary">פתח בחלון חדש</a><SharePreviewLinkButton profileId={loggingInProfile._id} className="ms-3" /></div>}
          </div>
        </div>
      )}
      ===== end legacy login flow ===== */}
      </div>
    </div>
  </>
)}

{/* Add Profile / Slot Management Modal */}
{showAddProfileModal && (
  <>
    <div
      className={`bottom-sheet-overlay show`}
    />
    <div className={`bottom-sheet show`} style={{direction: 'rtl', width: '95%', maxWidth: assigningSlot ? '1000px' : '550px', maxHeight: '90vh', display: 'flex', flexDirection: 'column'}}>
      <div className="bottom-sheet-handle" />

      <div className="bottom-sheet-header">
        <h3>{showPaymentHistory ? 'היסטוריית תשלומים' : 'הוסף פרופילים'}</h3>
        <button className="close-btn" onClick={() => !addingProfile && !addingSlot && closeAddProfileModal()}>×</button>
      </div>

      {showPaymentHistory ? (
        /* Payment History View */
        <div className="bottom-sheet-body" style={{padding: '20px'}}>
          <button
            onClick={() => setShowPaymentHistory(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#1877f2',
              fontSize: '14px',
              cursor: 'pointer',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            ← חזרה
          </button>

          {loadingPayments ? (
            <div style={{textAlign: 'center', padding: '40px'}}>
              <div className="spinner-border" style={{color: '#1877f2'}}></div>
            </div>
          ) : planPayments.length === 0 ? (
            <div style={{textAlign: 'center', color: '#666', padding: '40px'}}>
              אין תשלומים עדיין
            </div>
          ) : (
            <div>
              {planPayments.map((payment: any) => (
                <div
                  key={payment._id}
                  style={{
                    background: '#fff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '10px',
                    padding: '14px',
                    marginBottom: '10px'
                  }}
                >
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '6px'}}>
                    <span style={{fontWeight: '600', fontSize: '14px'}}>
                      {payment.description || (payment.payment_type === 'prorated' ? 'חיוב יחסי' : payment.payment_type === 'recurring' ? 'חיוב חודשי' : payment.payment_type)}
                    </span>
                    <span style={{fontWeight: '700', color: payment.payment_type === 'refund' ? '#e53935' : '#1877f2'}}>
                      {payment.payment_type === 'refund' ? '-' : ''}₪{payment.amount}
                    </span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', color: '#888', fontSize: '12px'}}>
                    <span>{new Date(payment.created_at).toLocaleDateString('he-IL')}</span>
                    <span style={{
                      color: payment.status === 'completed' ? '#4caf50' : payment.status === 'failed' ? '#e53935' : '#ff9800'
                    }}>
                      {payment.status === 'completed' && '✓ הושלם'}
                      {payment.status === 'pending' && 'ממתין'}
                      {payment.status === 'failed' && 'נכשל'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : assigningSlot ? (
        /* Profile Assignment View */
        <div className="bottom-sheet-body" style={{padding: '20px'}}>
          <button
            onClick={() => setAssigningSlot(null)}
            style={{
              background: 'none',
              border: 'none',
              color: '#1877f2',
              fontSize: '14px',
              cursor: 'pointer',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            ← חזרה
          </button>

          <h4 style={{fontSize: '16px', fontWeight: '600', marginBottom: '16px', textAlign: 'center'}}>
            {assigningSlot.assigned_profile ? 'החלף דף' : 'בחר דף לשיוך'}
          </h4>

          {/* Admin-only: set the account's customer status */}
          {isAdmin && (
            <div style={{marginBottom: '16px', padding: '12px', background: '#f8f9fb', border: '1px solid #eef0f4', borderRadius: '10px'}}>
              <label style={{display: 'block', fontSize: '12px', fontWeight: 600, color: '#65676b', marginBottom: '8px'}}>סטטוס לקוח (אדמין)</label>
              <div style={{display: 'flex', gap: '8px'}}>
                {[
                  {key: 'new_account', label: 'חדש'},
                  {key: 'working', label: 'לקוח עובד'},
                  {key: 'not_relevant', label: 'לא רלוונטי'},
                ].map(opt => (
                  <button
                    key={opt.key}
                    type="button"
                    onClick={() => saveAccountStatus(opt.key)}
                    disabled={savingAcctStatus}
                    style={{
                      flex: 1, padding: '8px 10px', borderRadius: '8px', fontSize: '13px', fontWeight: 600,
                      cursor: savingAcctStatus ? 'wait' : 'pointer',
                      border: acctStatus === opt.key ? '2px solid #1877f2' : '1px solid #ddd',
                      background: acctStatus === opt.key ? '#e7f3ff' : '#fff',
                      color: acctStatus === opt.key ? '#1877f2' : '#444',
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Option to unassign */}
          {assigningSlot.assigned_profile && (
            <button
              onClick={async () => {
                try {
                  await axios.post(`${API_URL}/api/slots/unassign`, { slot_id: assigningSlot._id });
                  const slotsRes = await axios.get(`${API_URL}/api/slots`);
                  if (slotsRes.data.success) {
                    setProfileSlots(slotsRes.data.profile_slots);
                    setSubprofileSlots(slotsRes.data.subprofile_slots);
                    setSlotsSummary(slotsRes.data.summary);
                  }
                  const profilesRes = await axios.get(`${API_URL}/api/get-single-profile`);
                  setAllProfiles(profilesRes.data.all_users);
                  setAssigningSlot(null);
                } catch (e) {
                  console.error(e);
                }
              }}
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '12px',
                background: '#fff3e0',
                border: '1px solid #ff9800',
                borderRadius: '10px',
                color: '#e65100',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              הסר דף (השאר ריק)
            </button>
          )}

          {/* Filter: only profiles that have a virtual number (own or inherited) */}
          <label style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', fontSize: '13px', cursor: 'pointer'}}>
            <input type="checkbox" checked={slotVnOnly} onChange={e => setSlotVnOnly(e.target.checked)} />
            <span>הצג רק פרופילים עם מספר וירטואלי 📞</span>
          </label>

          {/* Available profiles */}
          {(() => {
            const assignedIds = [...profileSlots, ...subprofileSlots]
              .filter(s => s.assigned_profile)
              .map(s => s.assigned_profile._id);
            const profileHasVn = (p: any): boolean => {
              if (p?.virtual_number_id) return true;
              if (p?.parent_profile) {
                const parent = allProfiles.find((x: any) => x._id === p.parent_profile);
                return !!parent?.virtual_number_id;
              }
              return false;
            };
            const availableProfiles = allProfiles.filter((p: any) => {
              const isSubProfile = p.parent_profile && p.parent_profile !== null;
              const matchesType = (assigningSlot.slot_type === 'profile' && !isSubProfile) || (assigningSlot.slot_type === 'subprofile' && isSubProfile);
              return matchesType && !assignedIds.includes(p._id) && (!slotVnOnly || profileHasVn(p));
            });

            if (availableProfiles.length === 0) {
              return (
                <div style={{textAlign: 'center', color: '#888', padding: '20px'}}>
                  {slotVnOnly ? 'אין פרופילים עם מספר וירטואלי' : 'אין פרופילים זמינים מסוג זה'}
                </div>
              );
            }

            return availableProfiles.map((profile: any) => (
              <div
                key={profile._id}
                onClick={async () => {
                  try {
                    const endpoint = assigningSlot.assigned_profile ? '/api/slots/switch' : '/api/slots/assign';
                    await axios.post(`${API_URL}${endpoint}`, {
                      slot_id: assigningSlot._id,
                      profile_id: profile._id
                    });
                    const slotsRes = await axios.get(`${API_URL}/api/slots`);
                    if (slotsRes.data.success) {
                      setProfileSlots(slotsRes.data.profile_slots);
                      setSubprofileSlots(slotsRes.data.subprofile_slots);
                      setSlotsSummary(slotsRes.data.summary);
                    }
                    const profilesRes = await axios.get(`${API_URL}/api/get-single-profile`);
                    setAllProfiles(profilesRes.data.all_users);
                    setAssigningSlot(null);
                  } catch (e: any) {
                    setToast({ message: e.response?.data?.error || 'שגיאה בשיוך', type: 'error' });
                  }
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px',
                  marginBottom: '8px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
              >
                <img
                  src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                  alt=""
                  style={{width: '40px', height: '40px', borderRadius: '50%', border: '2px solid #e0e0e0'}}
                />
                <div style={{flex: 1, textAlign: 'right'}}>
                  <div style={{fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-end'}}>
                    {profile.first_name} {profile.last_name}
                    {profileHasVn(profile) && (
                      <span
                        title="לפרופיל משויך מספר וירטואלי"
                        style={{fontSize: '10px', fontWeight: 600, color: '#1e7d34', background: '#e6f4ea', border: '1px solid #b7dfc4', borderRadius: '10px', padding: '1px 7px'}}
                      >
                        📞 וירטואלי
                      </span>
                    )}
                  </div>
                  <div style={{fontSize: '12px', color: '#888'}}>{profile.facebook_username || profile._id}</div>
                </div>
              </div>
            ));
          })()}
        </div>
      ) : (
        /* Main Slot Management View */
        <>
          <div className="bottom-sheet-body" style={{padding: '20px', flex: 1, overflow: 'auto'}}>
            {loadingSlots ? (
              <div style={{textAlign: 'center', padding: '40px'}}>
                <div className="spinner-border" style={{color: '#1877f2'}}></div>
              </div>
            ) : (
              <>
                {/* Check if user is in demo period */}
                {(() => {
                  const demoEnd = currentUser?.created_at ? new Date(new Date(currentUser.created_at).getTime() + 14 * 24 * 60 * 60 * 1000) : new Date(0);
                  const isDemo = currentUser?.account_type === 'demo_free' && new Date() < demoEnd;
                  return isDemo ? (
                    <div style={{
                      background: '#e8f5e9',
                      borderRadius: '10px',
                      padding: '12px 16px',
                      marginBottom: '16px',
                      fontSize: '13px',
                      color: '#2e7d32',
                      textAlign: 'center',
                      fontWeight: '500'
                    }}>
                      תקופת דמו חינם — הוסף פרופילים ודפים ללא תשלום
                    </div>
                  ) : null;
                })()}

                {/* Profiles Section */}
                {(() => {
                  const profilePricing = slotsSummary?.pricing?.profile || { beforeVat: 190, withVat: 224.20 };
                  const demoEnd = currentUser?.created_at ? new Date(new Date(currentUser.created_at).getTime() + 14 * 24 * 60 * 60 * 1000) : new Date(0);
                  const isDemo = currentUser?.account_type === 'demo_free' && new Date() < demoEnd;
                  return (
                    <div style={{marginBottom: '24px'}}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{fontSize: '15px', fontWeight: '600'}}>
                          פרופילים
                        </span>
                        <span style={{fontSize: '12px', color: '#888'}}>{profileSlots.length} פרופילים{!isDemo && ` • ₪${profilePricing.beforeVat}+מע"מ/חודש`}</span>
                      </div>

                      {profileSlots.map((slot: any) => (
                        <div
                          key={slot._id}
                          style={{
                            background: '#fff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '12px',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                          }}
                        >
                          {slot.assigned_profile ? (
                            <>
                              <img
                                src={`https://graph.facebook.com/${slot.assigned_profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                alt=""
                                style={{width: '40px', height: '40px', borderRadius: '50%', border: '2px solid #e0e0e0'}}
                              />
                              <div style={{flex: 1}}>
                                <div style={{fontWeight: '500'}}>{slot.assigned_profile.first_name} {slot.assigned_profile.last_name}</div>
                              </div>
                              <span style={{
                                background: '#e8f5e9',
                                color: '#4caf50',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                fontSize: '12px'
                              }}>
                                פעיל
                              </span>
                            </>
                          ) : (
                            <>
                              <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: '#fff3e0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#ff9800',
                                fontSize: '20px'
                              }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                  <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                              </div>
                              <div style={{flex: 1}}>
                                <div style={{fontWeight: '500', color: '#ff9800'}}>ממתין להתחברות</div>
                              </div>
                              <button
                                onClick={() => setCreatingProfileInSlot(slot)}
                                style={{
                                  background: '#1877f2',
                                  border: 'none',
                                  color: '#fff',
                                  padding: '6px 12px',
                                  borderRadius: '6px',
                                  fontSize: '12px',
                                  cursor: 'pointer'
                                }}
                              >
                                צור פרופיל
                              </button>
                              {!slot.is_free && (
                                <button
                                  onClick={async () => {
                                    setRemovingSlot(slot._id);
                                    try {
                                      await axios.post(`${API_URL}/api/slots/remove`, { slot_id: slot._id });
                                      const slotsRes = await axios.get(`${API_URL}/api/slots`);
                                      if (slotsRes.data.success) {
                                        setProfileSlots(slotsRes.data.profile_slots);
                                        setSubprofileSlots(slotsRes.data.subprofile_slots);
                                        setSlotsSummary(slotsRes.data.summary);
                                      }
                                    } catch (e: any) {
                                      setToast({ message: e.response?.data?.error || 'שגיאה בהסרה', type: 'error' });
                                    }
                                    setRemovingSlot(null);
                                  }}
                                  disabled={removingSlot === slot._id}
                                  style={{
                                    background: 'none',
                                    border: '1px solid #e53935',
                                    color: '#e53935',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    opacity: removingSlot === slot._id ? 0.5 : 1
                                  }}
                                >
                                  {removingSlot === slot._id ? '...' : 'הסר'}
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      ))}

                      <button
                        onClick={() => isDemo ? handleAddSlotDirect('profile') : setShowAddConfirmation('profile')}
                        style={{
                          width: '100%',
                          padding: '12px',
                          marginTop: '8px',
                          border: '2px dashed #1877f2',
                          background: 'none',
                          borderRadius: '10px',
                          color: '#1877f2',
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px'
                        }}
                      >
                        + הוסף פרופיל
                      </button>
                    </div>
                  );
                })()}

                {/* Pages Section */}
                {(() => {
                  const pagePricing = slotsSummary?.pricing?.subprofile || { beforeVat: 100, withVat: 118 };
                  const demoEnd = currentUser?.created_at ? new Date(new Date(currentUser.created_at).getTime() + 14 * 24 * 60 * 60 * 1000) : new Date(0);
                  const isDemo = currentUser?.account_type === 'demo_free' && new Date() < demoEnd;
                  return (
                    <div style={{marginBottom: '16px'}}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{fontSize: '15px', fontWeight: '600'}}>
                          דפים
                        </span>
                        <span style={{fontSize: '12px', color: '#888'}}>{subprofileSlots.length} דפים{!isDemo && ' • הראשון חינם'}</span>
                      </div>

                      {subprofileSlots.length === 0 ? (
                        <div style={{color: '#888', fontSize: '13px', textAlign: 'center', padding: '16px', background: '#f8f9fa', borderRadius: '10px'}}>
                          אין דפים עדיין
                        </div>
                      ) : (
                        subprofileSlots.map((slot: any) => (
                          <div
                            key={slot._id}
                            style={{
                              background: '#fff',
                              border: '1px solid #e0e0e0',
                              borderRadius: '10px',
                              padding: '12px',
                              marginBottom: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px'
                            }}
                          >
                            {slot.assigned_profile ? (
                              <>
                                <img
                                  src={`https://graph.facebook.com/${slot.assigned_profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                  alt=""
                                  style={{width: '40px', height: '40px', borderRadius: '50%', border: '2px solid #e0e0e0'}}
                                />
                                <div style={{flex: 1}}>
                                  <div style={{fontWeight: '500'}}>{slot.assigned_profile.first_name} {slot.assigned_profile.last_name}</div>
                                  <div style={{fontSize: '12px', color: '#888'}}>
                                    {slot.is_free ? 'חינם' : `₪${pagePricing.withVat}/חודש`}
                                  </div>
                                </div>
                                <button
                                  onClick={() => setAssigningSlot(slot)}
                                  style={{
                                    background: 'none',
                                    border: '1px solid #1877f2',
                                    color: '#1877f2',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  החלף
                                </button>
                              </>
                            ) : (
                              <>
                                <div style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '50%',
                                  background: '#e8f5e9',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#4caf50',
                                  fontSize: '20px'
                                }}>
                                  +
                                </div>
                                <div style={{flex: 1}}>
                                  <div style={{fontWeight: '500', color: '#4caf50'}}>ריק</div>
                                  <div style={{fontSize: '12px', color: '#888'}}>
                                    {slot.is_free ? 'חינם' : `₪${pagePricing.withVat}/חודש`}
                                  </div>
                                </div>
                                <button
                                  onClick={() => setAssigningSlot(slot)}
                                  style={{
                                    background: '#1877f2',
                                    border: 'none',
                                    color: '#fff',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  שייך
                                </button>
                                {!slot.is_free && (
                                  <button
                                    onClick={async () => {
                                      setRemovingSlot(slot._id);
                                      try {
                                        await axios.post(`${API_URL}/api/slots/remove`, { slot_id: slot._id });
                                        const slotsRes = await axios.get(`${API_URL}/api/slots`);
                                        if (slotsRes.data.success) {
                                          setProfileSlots(slotsRes.data.profile_slots);
                                          setSubprofileSlots(slotsRes.data.subprofile_slots);
                                          setSlotsSummary(slotsRes.data.summary);
                                        }
                                      } catch (e: any) {
                                        setToast({ message: e.response?.data?.error || 'שגיאה בהסרה', type: 'error' });
                                      }
                                      setRemovingSlot(null);
                                    }}
                                    disabled={removingSlot === slot._id}
                                    style={{
                                      background: 'none',
                                      border: '1px solid #e53935',
                                      color: '#e53935',
                                      padding: '6px 12px',
                                      borderRadius: '6px',
                                      fontSize: '12px',
                                      cursor: 'pointer',
                                      opacity: removingSlot === slot._id ? 0.5 : 1
                                    }}
                                  >
                                    {removingSlot === slot._id ? '...' : 'הסר'}
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        ))
                      )}

                      <button
                        onClick={() => isDemo ? handleAddSlotDirect('subprofile') : setShowAddConfirmation('subprofile')}
                        style={{
                          width: '100%',
                          padding: '12px',
                          marginTop: '8px',
                          border: '2px dashed #1877f2',
                          background: 'none',
                          borderRadius: '10px',
                          color: '#1877f2',
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px'
                        }}
                      >
                        + הוסף דף
                      </button>
                    </div>
                  );
                })()}

                {/* Payment Method - hide during demo */}
                {(() => {
                  const demoEnd = currentUser?.created_at ? new Date(new Date(currentUser.created_at).getTime() + 14 * 24 * 60 * 60 * 1000) : new Date(0);
                  const isDemo = currentUser?.account_type === 'demo_free' && new Date() < demoEnd;
                  if (isDemo) return null;
                  return <div style={{
                  background: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '10px',
                  padding: '14px',
                  marginTop: '16px'
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                    <span style={{fontWeight: '600', fontSize: '14px'}}>אמצעי תשלום</span>
                    {paymentInfo?.hasPaymentMethod && paymentInfo?.paymentMethod?.last4 && (
                      <button
                        onClick={async () => {
                          setLoadingCardcom(true);
                          try {
                            const response = await axios.get(`${API_URL}/api/generate-token`);
                            if (response.data.url) {
                              setCardcomUrl(response.data.url);
                            }
                          } catch (e) {
                            console.error('Error getting cardcom URL:', e);
                          } finally {
                            setLoadingCardcom(false);
                          }
                        }}
                        disabled={loadingCardcom}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#1877f2',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        {loadingCardcom ? '...' : 'שנה'}
                      </button>
                    )}
                  </div>
                  {paymentInfo?.hasPaymentMethod && paymentInfo?.paymentMethod?.last4 ? (
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <span style={{fontSize: '20px'}}>💳</span>
                      <span style={{color: '#666', fontSize: '13px'}}>
                        **** **** **** {paymentInfo.paymentMethod.last4}
                      </span>
                    </div>
                  ) : (
                    <button
                      onClick={async () => {
                        setLoadingCardcom(true);
                        try {
                          const response = await axios.get(`${API_URL}/api/generate-token`);
                          if (response.data.url) {
                            setCardcomUrl(response.data.url);
                          }
                        } catch (e) {
                          console.error('Error getting cardcom URL:', e);
                        } finally {
                          setLoadingCardcom(false);
                        }
                      }}
                      disabled={loadingCardcom}
                      style={{
                        width: '100%',
                        padding: '10px',
                        background: '#1877f2',
                        border: 'none',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer'
                      }}
                    >
                      {loadingCardcom ? '...' : 'הוסף אמצעי תשלום'}
                    </button>
                  )}
                </div>;
                })()}

              </>
            )}
          </div>

          <div className="bottom-sheet-footer" style={{
            position: 'sticky',
            bottom: 0,
            background: '#fff',
            borderTop: '1px solid #e0e0e0',
            padding: '16px 20px',
            flexShrink: 0
          }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => closeAddProfileModal()}
              style={{width: '100%'}}
            >
              סגור
            </button>
          </div>
        </>
      )}
    </div>
  </>
)}

{/* Create Profile in Slot Modal */}
{creatingProfileInSlot && (
  <>
    <div
      className="bottom-sheet-overlay show"
      style={{zIndex: 10002}}
    />
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      borderRadius: '20px',
      padding: '32px',
      width: '90%',
      maxWidth: '480px',
      maxHeight: '90vh',
      overflowY: 'auto',
      zIndex: 10003,
      boxShadow: '0 12px 48px rgba(0,0,0,0.3)',
      direction: 'rtl',
      textAlign: 'center'
    }}>
      {profileLoginUrl ? (
        /* Show login iframe in iPhone mockup */
        <div className="wizard-step profile-iframe-step">
          <h2>התחברות לפייסבוק</h2>
          <p>אנא התחבר לחשבון הפייסבוק שלך בחלון למטה.</p>
          {getAdminToken() && <div style={{marginBottom: '8px'}}><a href={profileLoginUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary">פתח בחלון חדש</a></div>}
          <div className="iphone-mockup">
            <div className="iphone-notch"></div>
            <div className="iphone-screen">
              <iframe
                src={profileLoginUrl}
                title="Facebook Login"
              />
            </div>
            <div className="iphone-home-bar"></div>
          </div>
          <div className="waiting-indicator">
            <div className="spinner"></div>
            <span>ממתין לאישור התחברות...</span>
          </div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setCreatingProfileInSlot(null);
              setProfileLoginUrl(null);
              setNewProfileUsername('');
              setNewProfilePassword('');
            }}
            style={{width: '100%', marginTop: '12px'}}
          >
            סגור
          </button>
        </div>
      ) : (
        /* Show credentials form */
        <div className="wizard-step profile-step">
          <div className="congrats-banner">
            <div className="congrats-icon">🎉</div>
            <h3>חבר את הפרופיל שלך!</h3>
            <p>הזן את פרטי ההתחברות לפייסבוק כדי לחבר את הפרופיל שלך למערכת.</p>
          </div>
          <div className="facebook-login-card">
            <div className="fb-logo">
              <svg viewBox="0 0 36 36" fill="url(#slotFbGrad)" height="40" width="40">
                <defs>
                  <linearGradient id="slotFbGrad" x1="50%" x2="50%" y1="97.078%" y2="0%">
                    <stop offset="0%" stopColor="#0062E0"/>
                    <stop offset="100%" stopColor="#19AFFF"/>
                  </linearGradient>
                </defs>
                <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z"/>
                <path fill="#fff" d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"/>
              </svg>
            </div>
            <h2 className="fb-title">התחבר לפייסבוק</h2>
            <div className="fb-form">
              <input
                type="text"
                value={newProfileUsername}
                onChange={(e) => setNewProfileUsername(e.target.value)}
                placeholder="אימייל או מספר טלפון"
                className="fb-input"
                autoComplete="off"
                data-lpignore="true"
                data-form-type="other"
              />
              <div className="password-input-wrapper">
                <input
                  type={showNewProfilePassword ? 'text' : 'password'}
                  value={newProfilePassword}
                  onChange={(e) => setNewProfilePassword(e.target.value)}
                  placeholder="סיסמה"
                  className="fb-input"
                  autoComplete="new-password"
                  data-lpignore="true"
                  data-form-type="other"
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowNewProfilePassword(!showNewProfilePassword)}
                >
                  {showNewProfilePassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <button
              type="button"
              className="wizard-btn primary"
              style={{width: '100%', marginTop: '12px'}}
              disabled={creatingProfile || !newProfileUsername || !newProfilePassword}
              onClick={async () => {
                if (creatingProfile) return;
                if (!newProfileUsername || !newProfilePassword) {
                  setToast({ message: 'נא להזין אימייל וסיסמה', type: 'error' });
                  setTimeout(() => setToast(null), 3000);
                  return;
                }
                setCreatingProfile(true);
                try {
                  const response = await axios.post(`${API_URL}/api/slots/create-profile`, {
                    slot_id: creatingProfileInSlot._id,
                    username: newProfileUsername,
                    password: newProfilePassword
                  });
                  if (response.data.success) {
                    setProfileLoginUrl(response.data.login_url);
                  } else {
                    setToast({ message: response.data.error || 'שגיאה ביצירת פרופיל', type: 'error' });
                    setTimeout(() => setToast(null), 5000);
                  }
                } catch (e: any) {
                  setToast({ message: e.response?.data?.error || 'שגיאה ביצירת פרופיל', type: 'error' });
                  setTimeout(() => setToast(null), 5000);
                }
                setCreatingProfile(false);
              }}
            >
              {creatingProfile ? 'מתחבר...' : 'התחבר'}
            </button>
            <button
              type="button"
              className="forgot-password-btn"
              onClick={() => {
                setCreatingProfileInSlot(null);
                setNewProfileUsername('');
                setNewProfilePassword('');
              }}
              disabled={creatingProfile}
            >
              ביטול
            </button>
          </div>
        </div>
      )}
    </div>
  </>
)}

{/* Add Profile/Page Confirmation Popup */}
{showAddConfirmation && (
  <>
    <div
      className="bottom-sheet-overlay show"
      style={{zIndex: 10002}}
    />
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      borderRadius: '16px',
      padding: '24px',
      width: '90%',
      maxWidth: '400px',
      zIndex: 10003,
      direction: 'rtl',
      boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
    }}>
      <h3 style={{margin: '0 0 20px 0', fontSize: '18px', fontWeight: '600'}}>
        הוספת {showAddConfirmation === 'profile' ? 'פרופילים' : 'דפים'}
      </h3>

      {/* Quantity Selector */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        marginBottom: '20px'
      }}>
        <button
          onClick={() => setAddSlotCount(Math.max(1, addSlotCount - 1))}
          disabled={addSlotCount <= 1}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: '1px solid #ddd',
            background: '#fff',
            fontSize: '20px',
            cursor: 'pointer',
            opacity: addSlotCount <= 1 ? 0.5 : 1
          }}
        >
          -
        </button>
        <span style={{fontSize: '24px', fontWeight: '600', minWidth: '40px', textAlign: 'center'}}>
          {addSlotCount}
        </span>
        <button
          onClick={() => setAddSlotCount(Math.min(10, addSlotCount + 1))}
          disabled={addSlotCount >= 10}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: '1px solid #ddd',
            background: '#fff',
            fontSize: '20px',
            cursor: 'pointer',
            opacity: addSlotCount >= 10 ? 0.5 : 1
          }}
        >
          +
        </button>
      </div>

      {(() => {
        const pricing = slotsSummary?.pricing?.[showAddConfirmation] ||
          (showAddConfirmation === 'profile' ? { beforeVat: 190, withVat: 224.20 } : { beforeVat: 100, withVat: 118 });
        const trialEnd = currentUser?.trial_period_end ? new Date(currentUser.trial_period_end) : new Date();
        const now = new Date();
        const daysLeft = Math.max(0, Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
        const proRatedBeforeVat = Math.round((daysLeft / 30) * pricing.beforeVat * addSlotCount);
        const proRatedVat = Math.round(proRatedBeforeVat * 0.18);
        const proRatedWithVat = proRatedBeforeVat + proRatedVat;
        const currentMonthly = currentUser?.monthly_payment_amount || 0;
        const monthlyAddBeforeVat = pricing.beforeVat * addSlotCount;
        const monthlyAddVat = Math.round(monthlyAddBeforeVat * 0.18);
        const monthlyAdd = monthlyAddBeforeVat + monthlyAddVat;
        const newMonthly = currentMonthly + monthlyAdd;

        return (
          <>
            <div style={{
              background: '#f8f9fa',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              {/* Monthly Price Breakdown */}
              <div style={{marginBottom: '12px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                  <span style={{color: '#666'}}>מחיר ליחידה (לפני מע"מ):</span>
                  <span>₪{pricing.beforeVat.toFixed(2)}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                  <span style={{color: '#666'}}>מע"מ (18%):</span>
                  <span>₪{(pricing.beforeVat * 0.18).toFixed(2)}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontWeight: '500'}}>מחיר חודשי ליחידה:</span>
                  <span style={{fontWeight: '600'}}>₪{pricing.withVat.toFixed(2)}</span>
                </div>
              </div>

              {addSlotCount > 1 && (
                <div style={{
                  borderTop: '1px dashed #ddd',
                  paddingTop: '12px',
                  marginTop: '12px',
                  marginBottom: '12px'
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                    <span style={{color: '#666'}}>סה"כ לפני מע"מ ({addSlotCount}):</span>
                    <span>₪{monthlyAddBeforeVat.toFixed(2)}</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                    <span style={{color: '#666'}}>מע"מ (18%):</span>
                    <span>₪{monthlyAddVat.toFixed(2)}</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <span style={{fontWeight: '500'}}>סה"כ תוספת חודשית:</span>
                    <span style={{fontWeight: '600'}}>₪{monthlyAdd.toFixed(2)}</span>
                  </div>
                </div>
              )}

              {/* Pro-rated charge */}
              <div style={{
                borderTop: '1px dashed #ddd',
                paddingTop: '12px',
                marginTop: '12px'
              }}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
                  <span style={{color: '#666'}}>ימים שנותרו בחודש:</span>
                  <span>{daysLeft} ימים</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                  <span style={{color: '#666'}}>חיוב יחסי (לפני מע"מ):</span>
                  <span>₪{proRatedBeforeVat.toFixed(2)}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                  <span style={{color: '#666'}}>מע"מ (18%):</span>
                  <span>₪{proRatedVat.toFixed(2)}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontWeight: '600'}}>חיוב עכשיו:</span>
                  <span style={{fontWeight: '600', color: '#1877f2'}}>₪{proRatedWithVat.toFixed(2)}</span>
                </div>
              </div>

              {/* Monthly totals */}
              <div style={{
                borderTop: '1px solid #ddd',
                paddingTop: '12px',
                marginTop: '12px'
              }}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                  <span style={{color: '#666'}}>תשלום חודשי נוכחי:</span>
                  <span>₪{currentMonthly.toFixed(2)}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontWeight: '600'}}>תשלום חודשי חדש:</span>
                  <span style={{fontWeight: '600', color: '#1877f2'}}>₪{newMonthly.toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div style={{display: 'flex', gap: '12px'}}>
              <button
                onClick={() => { setShowAddConfirmation(null); setAddSlotCount(1); }}
                disabled={confirmingAdd}
                style={{
                  flex: 1,
                  padding: '12px',
                  border: '1px solid #ddd',
                  background: '#fff',
                  borderRadius: '10px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  opacity: confirmingAdd ? 0.5 : 1
                }}
              >
                ביטול
              </button>
              <button
                onClick={async () => {
                  if (confirmingAdd) return; // Prevent double-click
                  setConfirmingAdd(true);
                  try {
                    const response = await axios.post(`${API_URL}/api/slots/add`, {
                      slot_type: showAddConfirmation,
                      count: addSlotCount
                    });
                    if (response.data.success) {
                      const slotsRes = await axios.get(`${API_URL}/api/slots`);
                      if (slotsRes.data.success) {
                        setProfileSlots(slotsRes.data.profile_slots);
                        setSubprofileSlots(slotsRes.data.subprofile_slots);
                        setSlotsSummary(slotsRes.data.summary);
                      }
                      // Refresh user data to get updated monthly_payment_amount
                      const {data: user} = await getUserByToken(auth.api_token);
                      setCurrentUser(user);
                      setShowAddConfirmation(null);
                      setAddSlotCount(1);
                      setToast({ message: `${addSlotCount} ${showAddConfirmation === 'profile' ? 'פרופילים' : 'דפים'} נוספו בהצלחה!`, type: 'success' });
                      setTimeout(() => setToast(null), 5000);
                    } else if (response.data.payment_url) {
                      window.location.href = response.data.payment_url;
                    } else if (response.data.needs_new_card) {
                      setShowAddConfirmation(null);
                      setAddSlotCount(1);
                      setToast({ message: 'נדרש להוסיף כרטיס אשראי', type: 'error' });
                      setTimeout(() => setToast(null), 5000);
                    } else {
                      setToast({ message: response.data.error || 'שגיאה', type: 'error' });
                      setTimeout(() => setToast(null), 5000);
                    }
                  } catch (e: any) {
                    setToast({ message: e.response?.data?.error || 'שגיאה בהוספה', type: 'error' });
                    setTimeout(() => setToast(null), 5000);
                  }
                  setConfirmingAdd(false);
                }}
                disabled={confirmingAdd}
                style={{
                  flex: 1,
                  padding: '12px',
                  border: 'none',
                  background: '#1877f2',
                  color: '#fff',
                  borderRadius: '10px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: confirmingAdd ? 0.7 : 1
                }}
              >
                {confirmingAdd ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  `אישור ותשלום ₪${proRatedWithVat.toFixed(2)}`
                )}
              </button>
            </div>
          </>
        );
      })()}
    </div>
  </>
)}

{/* Cardcom Payment Modal - Separate Secure Popup */}
{cardcomUrl && (
  <>
    <div
      className="bottom-sheet-overlay show"
      style={{zIndex: 10001}}
    />
    <div
      className="bottom-sheet show"
      style={{
        direction: 'rtl',
        maxWidth: '480px',
        zIndex: 10002,
        maxHeight: '90vh'
      }}
    >
      <div className="bottom-sheet-handle" />

      <div className="bottom-sheet-header" style={{borderBottom: '1px solid #e0e0e0'}}>
        <h3 style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          <span style={{color: '#4caf50'}}>🔒</span>
          תשלום מאובטח
        </h3>
        <button
          className="close-btn"
          onClick={async () => {
            setCardcomUrl(null);
            const paymentResponse = await axios.get(`${API_URL}/api/get-payment-info`);
            if (paymentResponse.data.success) {
              setPaymentInfo(paymentResponse.data);
            }
            const {data: user} = await getUserByToken(auth.api_token);
            setCurrentUser(user);
          }}
        >
          ×
        </button>
      </div>

      <div style={{padding: '16px'}}>
        {/* Security Badge */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          padding: '12px',
          background: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)',
          borderRadius: '10px',
          marginBottom: '16px',
          border: '1px solid #c8e6c9'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '12px',
            color: '#2e7d32',
            fontWeight: 500
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#2e7d32">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
            SSL מאובטח
          </div>
          <div style={{width: '1px', height: '20px', background: '#c8e6c9'}}></div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '12px',
            color: '#2e7d32',
            fontWeight: 500
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#2e7d32">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            PCI DSS
          </div>
          <div style={{width: '1px', height: '20px', background: '#c8e6c9'}}></div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '12px',
            color: '#2e7d32',
            fontWeight: 500
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#2e7d32">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
            Cardcom
          </div>
        </div>

        {/* Iframe Container */}
        <div style={{
          border: '1px solid #e0e0e0',
          borderRadius: '10px',
          overflow: 'hidden',
          background: '#fff'
        }}>
          <iframe
            src={cardcomUrl}
            style={{
              width: '100%',
              height: '450px',
              border: 'none'
            }}
            onLoad={() => {
              // Poll to check if payment was updated
              const checkPayment = setInterval(async () => {
                try {
                  const response = await axios.get(`${API_URL}/api/get-payment-info`);
                  const userResponse = await getUserByToken(auth.api_token);
                  if (response.data.success && response.data.hasPaymentMethod) {
                    if (!paymentInfo?.hasPaymentMethod ||
                        response.data.paymentMethod?.last4 !== paymentInfo?.paymentMethod?.last4 ||
                        userResponse.data?.card_last4 !== currentUser?.card_last4) {
                      setPaymentInfo(response.data);
                      setCurrentUser(userResponse.data);
                      setCardcomUrl(null);
                      setToast({ message: 'כרטיס האשראי עודכן בהצלחה!', type: 'success' });
                      clearInterval(checkPayment);
                    }
                  }
                } catch (e) {
                  // Ignore errors during polling
                }
              }, 3000);
              setTimeout(() => clearInterval(checkPayment), 120000);
            }}
          />
        </div>

        {/* Security Note */}
        <div style={{
          marginTop: '12px',
          padding: '10px',
          background: '#f5f5f5',
          borderRadius: '8px',
          fontSize: '11px',
          color: '#666',
          textAlign: 'center'
        }}>
          🔐 פרטי הכרטיס מועברים ישירות לחברת הסליקה ואינם נשמרים במערכת
        </div>
      </div>
    </div>
  </>
)}

    {/* Campaign Section - Mobile First Design */}
    <div className='card mb-4 mb-xl-6' style={{direction: 'rtl'}}>
      <div className='card-body pt-6 pb-6'>
        {/* Campaign Section Header */}
        <div className="campaigns-header">
          <h2>
            {intl.formatMessage({id: 'GENERAL.CAMPIAGNS'})}
            {selectedCampaign?.name && <span title={selectedCampaign.name} style={{fontWeight: 400, fontSize: '16px', color: '#666', marginRight: '8px'}}>/ {selectedCampaign.name}</span>}
            {isAdmin && selectedCampaign && (
              <button
                onClick={() => {
                  setSelectedCampaign(selectedCampaign);
                  const modalBtn = document.getElementById('delete-all-campaigns-modal-trigger') as HTMLElement;
                  modalBtn?.click();
                }}
                style={{
                  marginRight: '12px',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  background: '#dc3545',
                  border: 'none',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                title="Admin: מחק את כל הקמפיינים של החשבון"
              >
                🗑 מחק כל הקמפיינים <span className="badge badge-light-warning" style={{ fontSize: '9px' }}>אדמין</span>
              </button>
            )}
            {isAdmin && selectedCampaign?._id && (
              <button
                onClick={() => {
                  const campaignProfileIds = allCampaignProfiles[selectedCampaign._id] || [];
                  setMoveProfileIds(campaignProfileIds);
                  setMoveTarget(null);
                  setMoveSearch('');
                  const modalEl = document.getElementById('kt_modal_move_campaign');
                  if (modalEl) BsModal.getOrCreateInstance(modalEl).show();
                }}
                style={{
                  marginRight: '8px',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  border: 'none',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                title="Admin: העבר את הקמפיין והפרופילים לחשבון אחר"
              >
                ↔ העבר לחשבון אחר <span className="badge badge-light-warning" style={{ fontSize: '9px' }}>אדמין</span>
              </button>
            )}
            {isAdmin && (
              <button
                onClick={() => setShowVnRevert(true)}
                style={{
                  marginRight: '8px',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  background: 'linear-gradient(135deg, #43a047 0%, #1e88e5 100%)',
                  border: 'none',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                title="Admin: שחזור פוסטים לגרסה קודמת מההיסטוריה, בכמות לפי טווח תאריכים"
              >
                ↩️ שחזור פוסטים לפי תאריך <span className="badge badge-light-warning" style={{ fontSize: '9px' }}>אדמין</span>
              </button>
            )}
            {isAdmin && selectedCampaign?._id && (
              <button
                onClick={() => setShowWaStrip(true)}
                style={{
                  marginRight: '8px',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
                  border: 'none',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                title="Admin: הסר כל לינק וואטסאפ מתוכן הפוסטים של הקמפיין (נשמר בהיסטוריה, ניתן לשחזור)"
              >
                🧹 הסר לינקי וואטסאפ <span className="badge badge-light-warning" style={{ fontSize: '9px' }}>אדמין</span>
              </button>
            )}
            {isAdmin && currentUser?._id && (
              <button
                onClick={() => setShowVariationSettings(true)}
                style={{
                  marginRight: '8px',
                  padding: '4px 10px',
                  borderRadius: '4px',
                  background: 'linear-gradient(135deg, #7c3aed 0%, #2b70fa 100%)',
                  border: 'none',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                title="Admin: וריאציות לפוסטים של הלקוח — הפעלה, הגדרות ויצירה לכל הפוסטים"
              >
                🔀 וריאציות <span className="badge badge-light-warning" style={{ fontSize: '9px' }}>אדמין</span>
              </button>
            )}
            {variationsPostId && isAdmin && (
              <PostVariationsModal postId={variationsPostId} onClose={() => setVariationsPostId(null)} />
            )}
            {showVariationSettings && isAdmin && currentUser?._id && (
              <div onClick={() => setShowVariationSettings(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(560px, 96vw)', position: 'relative', fontSize: '13px', fontWeight: 400 }}>
                  <button onClick={() => setShowVariationSettings(false)} style={{ position: 'absolute', top: 6, left: 10, zIndex: 1, border: 'none', background: 'transparent', fontSize: '22px', cursor: 'pointer', color: '#888' }}>×</button>
                  <PostVariationsSettingsPanel accountId={String(currentUser._id)} />
                </div>
              </div>
            )}
          </h2>
          <button
            data-onboarding="create-campaign"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_1"
            className="new-campaign-btn"
            style={{
              padding: '6px 14px',
              borderRadius: '20px',
              background: 'transparent',
              border: '1.5px solid #1877f2',
              color: '#1877f2',
              fontSize: '13px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            onClick={() => {
              // Initialize with all active profiles selected
              const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
              setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#1877f2';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#1877f2';
            }}
          >
            + צור קמפיין חדש
          </button>
          {/* Search campaigns by name — same row as the header */}
          {(currentUser?.campaigns?.length || 0) > 1 && (
            <div style={{ position: 'relative', flex: '0 1 240px', minWidth: 160, marginInlineStart: 8 }}>
              <i className="bi bi-search" style={{ position: 'absolute', insetInlineStart: 12, top: '50%', transform: 'translateY(-50%)', color: '#a1a5b7', fontSize: 13 }}></i>
              <input
                type="text"
                value={campaignSearch}
                onChange={(e) => setCampaignSearch(e.target.value)}
                placeholder="חפש קמפיין…"
                style={{ width: '100%', padding: '7px 32px 7px 28px', border: '1.5px solid #e4e6ef', borderRadius: 20, fontSize: 13, outline: 'none', direction: 'rtl', background: '#fff' }}
              />
              {campaignSearch && (
                <button onClick={() => setCampaignSearch('')} title="נקה" style={{ position: 'absolute', insetInlineEnd: 8, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', color: '#a1a5b7', cursor: 'pointer', padding: 2 }}>
                  <i className="bi bi-x-circle-fill" style={{ fontSize: 13 }}></i>
                </button>
              )}
            </div>
          )}
          {/* yad2 sync — update prices + add new listings from the agent's yad2 */}
          {/* Primary action is the sync itself — an agent with a lot of listings presses
              this whenever they've added properties on yad2. Settings moved to the small
              gear beside it: they're set once, the sync is used constantly. */}
          {yad2Sync?.linked && (
            <>
              <button
                onClick={runYad2SyncNow}
                disabled={yad2Syncing}
                className="new-campaign-btn"
                title={yad2Sync?.last_synced_at
                  ? `סונכרן לאחרונה: ${new Date(yad2Sync.last_synced_at).toLocaleString('he-IL')}`
                  : 'משיכת הנכסים העדכניים מיד2 — אפשר ללחוץ בכל פעם שמוסיפים נכס'}
                style={{
                  padding: '6px 14px', borderRadius: '20px', background: 'transparent',
                  border: '1.5px solid #16a34a', color: '#16a34a', fontSize: '13px', fontWeight: 500,
                  cursor: yad2Syncing ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', marginInlineStart: 8,
                }}
              >
                <i className="bi bi-arrow-repeat" style={yad2Syncing ? {animation: 'spin 1s linear infinite'} : undefined} />
                {yad2Syncing ? 'מסנכרן…' : 'סנכרן נכסים מיד2'}
              </button>
              <button
                onClick={openYad2Modal}
                disabled={yad2Syncing}
                className="new-campaign-btn"
                title="הגדרות סנכרון יד2"
                aria-label="הגדרות סנכרון יד2"
                style={{
                  padding: '6px 10px', borderRadius: '20px', background: 'transparent',
                  border: '1.5px solid #16a34a', color: '#16a34a', fontSize: '13px',
                  cursor: yad2Syncing ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', marginInlineStart: 4,
                }}
              >
                <i className="bi bi-gear" />
              </button>
            </>
          )}
          {/* ADMIN ONLY: define this account as a yad2 customer when it isn't linked yet */}
          {isAdminMode && !yad2Sync?.linked && (
            <button
              onClick={() => { setYad2AgentPicked(null); setYad2AgentQuery(''); setYad2AgentResults([]); setYad2SetupContact(''); setYad2SetupModal(true); }}
              className="new-campaign-btn"
              title="הגדר חשבון זה כלקוח יד2 — משיכת כל מודעות הסוכן"
              style={{
                padding: '6px 14px', borderRadius: '20px', background: 'transparent',
                border: '1.5px solid #7239ea', color: '#7239ea', fontSize: '13px', fontWeight: 500,
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', marginInlineStart: 8,
              }}
            >
              <i className="bi bi-shield-lock" />
              הגדר לקוח יד2 (אדמין)
            </button>
          )}
        </div>

        {/* ADMIN ONLY: yad2 customer setup — pick agent, pull listings, enable daily sync */}
        {yad2SetupModal && (
          <div style={{position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => !yad2SetupBusy && setYad2SetupModal(false)}>
            <div style={{background: '#fff', borderRadius: 16, width: 520, maxWidth: '92vw', maxHeight: '88vh', overflowY: 'auto', direction: 'rtl', boxShadow: '0 20px 60px rgba(0,0,0,0.2)'}} onClick={(e) => e.stopPropagation()}>
              <div style={{padding: '16px 22px', borderBottom: '1px solid #e4e6ef', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h4 style={{margin: 0, fontSize: 17, fontWeight: 700}}><i className="bi bi-shield-lock" style={{marginInlineEnd: 8, color: '#7239ea'}} />הגדרת לקוח יד2 (אדמין)</h4>
                <button onClick={() => setYad2SetupModal(false)} style={{border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#a1a5b7'}}><i className="bi bi-x-lg" /></button>
              </div>
              <div style={{padding: 22}}>
                <div style={{fontSize: 12.5, color: '#7e8299', marginBottom: 14}}>בחרו את הסוכן מתוך מאגר יד2. המערכת תמשוך את כל מודעות הסוכן לחשבון זה.</div>
                {yad2AgentPicked ? (
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #16a34a', background: '#f8fdf9', borderRadius: 10, padding: '10px 12px', marginBottom: 14}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, minWidth: 0}}>
                      {yad2AgentPicked.avatar ? <img src={yad2AgentPicked.avatar} alt="" style={{width: 40, height: 40, borderRadius: '50%', objectFit: 'cover'}} /> : <div style={{width: 40, height: 40, borderRadius: '50%', background: '#eef', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><i className="bi bi-person" /></div>}
                      <div style={{minWidth: 0}}>
                        <div style={{fontWeight: 700}}>{yad2AgentPicked.name}</div>
                        <div style={{fontSize: 12, color: '#7e8299'}}>{yad2AgentPicked.agency_name ? yad2AgentPicked.agency_name + ' · ' : ''}{yad2AgentPicked.listings_count || 0} נכסים · <span dir="ltr">{yad2AgentPicked.phone}</span></div>
                      </div>
                    </div>
                    <button onClick={() => setYad2AgentPicked(null)} style={{border: 'none', background: '#f1f1f1', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 13}}>החלף</button>
                  </div>
                ) : (
                  <div style={{position: 'relative', marginBottom: 14}}>
                    <input value={yad2AgentQuery} onChange={(e) => setYad2AgentQuery(e.target.value)} placeholder="חיפוש סוכן: שם / סוכנות / טלפון וירטואלי…" style={{width: '100%', padding: '9px 12px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} />
                    {yad2AgentSearching && <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>מחפש…</div>}
                    {yad2AgentResults.length > 0 && (
                      <div style={{position: 'absolute', top: '100%', insetInlineStart: 0, insetInlineEnd: 0, background: '#fff', border: '1px solid #e4e6ef', borderRadius: 8, marginTop: 4, maxHeight: 280, overflowY: 'auto', zIndex: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)'}}>
                        {yad2AgentResults.map((a: any, i: number) => (
                          <div key={a.broker_id || a.phone || i} onClick={() => { setYad2AgentPicked(a); setYad2AgentResults([]); }} style={{display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', cursor: 'pointer', borderBottom: '1px solid #f4f4f4'}}>
                            {a.avatar ? <img src={a.avatar} alt="" style={{width: 34, height: 34, borderRadius: '50%', objectFit: 'cover', flexShrink: 0}} /> : <div style={{width: 34, height: 34, borderRadius: '50%', background: '#eef', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}><i className="bi bi-person" /></div>}
                            <div style={{flex: 1, minWidth: 0}}>
                              <div style={{fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{a.name}</div>
                              <div style={{fontSize: 11.5, color: '#a1a5b7', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{a.agency_name ? a.agency_name + ' · ' : ''}<span dir="ltr">{a.phone}</span></div>
                            </div>
                            <span style={{flexShrink: 0, fontSize: 11.5, color: '#16a34a', fontWeight: 600}}>{a.listings_count || 0} נכסים</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {!yad2AgentSearching && yad2AgentQuery.trim().length >= 2 && yad2AgentResults.length === 0 && (
                      <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>לא נמצאו סוכנים תואמים.</div>
                    )}
                  </div>
                )}
                {yad2AgentPicked && (yad2AgencyLoading || yad2SetupAgency) && (
                  <div style={{marginBottom: 14}}>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6}}>מה למשוך?</label>
                    {yad2AgencyLoading ? (
                      <div style={{fontSize: 12, color: '#a1a5b7'}}>בודק סוכנות…</div>
                    ) : (
                      <>
                        {([
                          {key: 'agent' as const, title: 'רק הסוכן', count: yad2SetupAgency.agent_count, sub: yad2AgentPicked.phone},
                          {key: 'agency' as const, title: 'כל הסוכנות', count: yad2SetupAgency.agency_count, sub: `${yad2SetupAgency.name || 'סוכנות'} · ${(yad2SetupAgency.brokers || []).length} סוכנים`},
                        ]).map((o) => (
                          <div
                            key={o.key}
                            onClick={() => setYad2SetupScope(o.key)}
                            style={{display: 'flex', alignItems: 'center', gap: 10, border: `1px solid ${yad2SetupScope === o.key ? '#7239ea' : '#e4e6ef'}`, background: yad2SetupScope === o.key ? '#faf7ff' : '#fff', borderRadius: 10, padding: '9px 12px', marginBottom: 6, cursor: 'pointer'}}
                          >
                            <input type="radio" checked={yad2SetupScope === o.key} onChange={() => setYad2SetupScope(o.key)} style={{flexShrink: 0}} />
                            <div style={{minWidth: 0, flex: 1}}>
                              <div style={{fontWeight: 600, fontSize: 13.5}}>{o.title}</div>
                              <div style={{fontSize: 11.5, color: '#a1a5b7', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}} dir={o.key === 'agent' ? 'ltr' : undefined}>{o.sub}</div>
                            </div>
                            <span style={{flexShrink: 0, fontSize: 12, fontWeight: 700, color: '#16a34a'}}>{o.count} נכסים</span>
                          </div>
                        ))}
                        {yad2SetupScope === 'agency' && (
                          <div style={{fontSize: 11.5, color: '#f1416c', background: '#fff5f8', border: '1px solid #ffd6e2', borderRadius: 8, padding: '7px 10px'}}>
                            כולל נכסים של סוכנים אחרים במשרד. בחרו רק אם הלקוח מפרסם עבור כל הסוכנות.
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
                <div style={{marginBottom: 14}}>
                  <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>טלפון ליצירת קשר בפוסטים (לא חובה)</label>
                  <input dir="ltr" value={yad2SetupContact} onChange={(e) => setYad2SetupContact(e.target.value)} placeholder="ברירת מחדל: טלפון החשבון" style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} />
                </div>
                <button onClick={submitYad2Setup} disabled={!yad2AgentPicked || yad2SetupBusy} style={{width: '100%', padding: '10px', borderRadius: 8, border: 'none', background: (!yad2AgentPicked || yad2SetupBusy) ? '#b9a6f0' : '#7239ea', color: '#fff', fontWeight: 700, fontSize: 14, cursor: (!yad2AgentPicked || yad2SetupBusy) ? 'not-allowed' : 'pointer'}}>
                  {yad2SetupBusy ? 'מגדיר…' : 'הגדר ומשוך נכסים'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* yad2 sync settings popup — editable, saved for future syncs */}
        {yad2Modal && (
          <div style={{position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => !yad2Syncing && setYad2Modal(false)}>
            <div style={{background: '#fff', borderRadius: 16, width: 520, maxWidth: '92vw', maxHeight: '88vh', overflowY: 'auto', direction: 'rtl', boxShadow: '0 20px 60px rgba(0,0,0,0.2)'}} onClick={(e) => e.stopPropagation()}>
              <div style={{padding: '16px 22px', borderBottom: '1px solid #e4e6ef', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h4 style={{margin: 0, fontSize: 17, fontWeight: 700}}><i className="bi bi-houses" style={{marginInlineEnd: 8, color: '#16a34a'}} />הגדרות סנכרון נכסים מיד2</h4>
                <button onClick={() => setYad2Modal(false)} style={{border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#a1a5b7'}}><i className="bi bi-x-lg" /></button>
              </div>
              <div style={{padding: 22}}>
                <div style={{fontSize: 12.5, color: '#7e8299', marginBottom: 14}}>ההגדרות נשמרות ומשמשות בכל סנכרון שתריצו.</div>
                {/* ADMIN ONLY: import scope — this agent's phone, or the whole agency */}
                {isAdminMode && (yad2SettingsAgencyLoading || yad2SettingsAgency || !!yad2Form.agency_id) && (
                  <div style={{marginBottom: 16, border: '1px dashed #7239ea', borderRadius: 10, padding: '10px 12px'}}>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6}}><i className="bi bi-shield-lock" style={{marginInlineEnd: 6, color: '#7239ea'}} />מה למשוך? (אדמין)</label>
                    {yad2SettingsAgencyLoading ? (
                      <div style={{fontSize: 12, color: '#a1a5b7'}}>בודק סוכנות…</div>
                    ) : (() => {
                      // Keep a stored agency id even if the lookup now resolves a different office.
                      const storedAgency = Number(yad2Sync?.settings?.agency_id) || 0;
                      const agencyId = storedAgency || yad2SettingsAgency?.id || 0;
                      const lookupMatches = !!yad2SettingsAgency && yad2SettingsAgency.id === agencyId;
                      const scope = Number(yad2Form.agency_id) ? 'agency' : 'agent';
                      const opts = [
                        {key: 'agent' as const, title: 'רק הסוכן', count: yad2SettingsAgency?.agent_count, sub: yad2Sync?.settings?.agent_phone || '', value: 0},
                        ...(agencyId ? [{key: 'agency' as const, title: 'כל הסוכנות', count: lookupMatches ? yad2SettingsAgency.agency_count : undefined, sub: lookupMatches ? `${yad2SettingsAgency.name || 'סוכנות'} · ${(yad2SettingsAgency.brokers || []).length} סוכנים` : `סוכנות #${agencyId}`, value: agencyId}] : []),
                      ];
                      return (
                        <>
                          {opts.map((o) => (
                            <div
                              key={o.key}
                              onClick={() => setYad2Form({...yad2Form, agency_id: o.value})}
                              style={{display: 'flex', alignItems: 'center', gap: 10, border: `1px solid ${scope === o.key ? '#7239ea' : '#e4e6ef'}`, background: scope === o.key ? '#faf7ff' : '#fff', borderRadius: 10, padding: '9px 12px', marginBottom: 6, cursor: 'pointer'}}
                            >
                              <input type="radio" checked={scope === o.key} onChange={() => setYad2Form({...yad2Form, agency_id: o.value})} style={{flexShrink: 0}} />
                              <div style={{minWidth: 0, flex: 1}}>
                                <div style={{fontWeight: 600, fontSize: 13.5}}>{o.title}</div>
                                <div style={{fontSize: 11.5, color: '#a1a5b7', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}} dir={o.key === 'agent' ? 'ltr' : undefined}>{o.sub}</div>
                              </div>
                              {o.count != null && <span style={{flexShrink: 0, fontSize: 12, fontWeight: 700, color: '#16a34a'}}>{o.count} נכסים</span>}
                            </div>
                          ))}
                          {scope === 'agency' && !storedAgency && (
                            <div style={{fontSize: 11.5, color: '#f1416c', background: '#fff5f8', border: '1px solid #ffd6e2', borderRadius: 8, padding: '7px 10px'}}>
                              כולל נכסים של סוכנים אחרים במשרד. בחרו רק אם הלקוח מפרסם עבור כל הסוכנות.
                            </div>
                          )}
                          {scope === 'agent' && !!storedAgency && (
                            <div style={{fontSize: 11.5, color: '#f1416c', background: '#fff5f8', border: '1px solid #ffd6e2', borderRadius: 8, padding: '7px 10px'}}>
                              חזרה לסוכן בלבד — בסנכרון הבא יימחקו הפוסטים של שאר הסוכנים במשרד.
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12}}>
                  {/* agent phone (yad2 source) is fixed at import — not user-editable here */}
                  <div>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>טלפון ליצירת קשר בפוסטים</label>
                    <input dir="ltr" value={yad2Form.contact_phone || ''} onChange={(e) => setYad2Form({...yad2Form, contact_phone: e.target.value})} style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} placeholder="05X-XXXXXXX" />
                    <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>הטלפון שמופיע בשורת "📞 לפרטים" בכל פוסט.</div>
                  </div>
                  <div>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>טלפון וואטסאפ (לא חובה)</label>
                    <input dir="ltr" value={yad2Form.whatsapp_phone || ''} onChange={(e) => setYad2Form({...yad2Form, whatsapp_phone: e.target.value})} style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} placeholder="05X-XXXXXXX" />
                    <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>אם יוזן — קישור הוואטסאפ בפוסט יפנה למספר זה. אם ריק — ישתמש בטלפון ליצירת קשר.</div>
                  </div>
                  <div>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>שם הסוכן</label>
                    <input value={yad2Form.agent_name || ''} onChange={(e) => setYad2Form({...yad2Form, agent_name: e.target.value})} style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} />
                  </div>
                  <div>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>שם הסוכנות (לא חובה)</label>
                    <input value={yad2Form.agency_name || ''} onChange={(e) => setYad2Form({...yad2Form, agency_name: e.target.value})} style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} />
                    <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>אם יוזן — שם הסוכנות יתווסף לכל פוסט (בפרטי יצירת הקשר).</div>
                  </div>
                  <div style={{gridColumn: '1 / -1'}}>
                    <label style={{fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5}}>רישיון תיווך (לא חובה)</label>
                    <input value={yad2Form.license_text || ''} onChange={(e) => setYad2Form({...yad2Form, license_text: e.target.value})} style={{width: '100%', padding: '8px 10px', border: '1px solid #e4e6ef', borderRadius: 8, fontSize: 14}} placeholder="למשל: רישיון תיווך: 12345" />
                    <div style={{fontSize: 11.5, color: '#a1a5b7', marginTop: 4}}>אם יוזן — מספר רישיון התיווך יתווסף לכל פוסט.</div>
                  </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 14, marginTop: 16}}>
                  <label style={{display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer', fontSize: 14}}>
                    <input type="checkbox" style={{marginTop: 3}} checked={yad2Form.include_no_images !== false} onChange={(e) => setYad2Form({...yad2Form, include_no_images: e.target.checked})} />
                    <span>
                      כלול מודעות ללא תמונות
                      <div style={{fontSize: 11.5, color: '#a1a5b7'}}>אם מסומן — מודעות ללא תמונות יפורסמו כפוסט טקסט. אם לא — הן לא יפורסמו.</div>
                    </span>
                  </label>
                  <label style={{display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer', fontSize: 14}}>
                    <input type="checkbox" style={{marginTop: 3}} checked={yad2Form.include_price !== false} onChange={(e) => setYad2Form({...yad2Form, include_price: e.target.checked})} />
                    <span>
                      כלול מחיר בפוסט
                      <div style={{fontSize: 11.5, color: '#a1a5b7'}}>אם מסומן — מחיר הנכס יופיע בפוסט. אם לא — הפוסט יפורסם ללא מחיר.</div>
                    </span>
                  </label>
                </div>

                {/* Sub-profiles / pages — toggling activates them AND assigns them to the yad2 campaigns */}
                {(() => {
                  const subs = (allProfiles || []).filter((p: any) => p.parent_profile);
                  if (!subs.length) return null;
                  const enabledCount = subs.filter((p: any) => p.parent_profile_on).length;
                  return (
                    <div style={{marginTop: 16, borderTop: '1px solid #e4e6ef', paddingTop: 14}}>
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8}}>
                        <div style={{fontSize: 13, fontWeight: 700}}>דפים עסקיים לפרסום <span style={{fontWeight: 400, color: '#50cd89'}}>(מומלץ על מנת לקבל פי 2 יותר חשיפה)</span></div>
                        <span style={{fontSize: 12.5, color: '#a1a5b7'}}>{enabledCount}/{subs.length} פעילים</span>
                      </div>
                      <div style={{fontSize: 11.5, color: '#a1a5b7', marginBottom: 8}}>הפעלת דף עסקי תגרום לפרסום הפוסטים בפייסבוק גם מהדף.</div>
                      <div style={{maxHeight: 280, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 8}}>
                        {subs.map((sp: any, idx: number) => (
                          <div key={sp._id} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', borderBottom: idx < subs.length - 1 ? '1px solid #f0f0f0' : 'none', background: sp.parent_profile_on ? 'rgba(76,175,80,0.05)' : 'transparent'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                              <img src={`https://graph.facebook.com/${sp.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`} alt="" style={{width: 36, height: 36, borderRadius: '50%', border: sp.parent_profile_on ? '2px solid #4caf50' : '2px solid #ccc'}} />
                              <div>
                                <div style={{fontWeight: 500, fontSize: 13, color: sp.parent_profile_on ? '#333' : '#999'}}>{sp.first_name} {sp.last_name}</div>
                                <div style={{fontSize: 11, color: '#999'}}>{sp.facebook_id}</div>
                              </div>
                            </div>
                            <div
                              style={{width: 44, height: 24, borderRadius: 12, background: sp.parent_profile_on ? '#4caf50' : '#ccc', cursor: togglingProfiles.has(sp._id) ? 'not-allowed' : 'pointer', position: 'relative', transition: 'background 0.2s', opacity: togglingProfiles.has(sp._id) ? 0.6 : 1, flexShrink: 0}}
                              onClick={async () => {
                                if (togglingProfiles.has(sp._id)) return;
                                const newValue = !sp.parent_profile_on;
                                setTogglingProfiles(prev => new Set(prev).add(sp._id));
                                try {
                                  const r = await axios.post(`${API_URL}/api/yad2-sync/toggle-profile`, {api_token: auth?.api_token || '', sub_profile_id: sp._id, enabled: newValue});
                                  if (r.data.success) {
                                    setAllProfiles(prev => prev.map(p => p._id === sp._id ? {...p, parent_profile_on: newValue} : p));
                                  }
                                } catch (e) {
                                  setToast({message: 'שגיאה בעדכון הפרופיל', type: 'error'});
                                } finally {
                                  setTogglingProfiles(prev => { const n = new Set(prev); n.delete(sp._id); return n; });
                                }
                              }}
                            >
                              <div style={{width: 20, height: 20, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.3)', position: 'absolute', top: 2, left: sp.parent_profile_on ? 22 : 2, transition: 'left 0.2s'}} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}
              </div>
              <div style={{padding: '14px 22px', borderTop: '1px solid #e4e6ef', display: 'flex', gap: 8, justifyContent: 'flex-end'}}>
                <button onClick={() => setYad2Modal(false)} disabled={yad2Syncing} style={{padding: '9px 16px', borderRadius: 8, border: '1px solid #e4e6ef', background: '#fff', color: '#5e6278', fontWeight: 600, cursor: 'pointer'}}>ביטול</button>
                <button onClick={saveYad2Settings} disabled={yad2Syncing} style={{padding: '9px 16px', borderRadius: 8, border: '1px solid #16a34a', background: '#fff', color: '#16a34a', fontWeight: 700, cursor: 'pointer'}}>שמור הגדרות</button>
                <button onClick={saveAndSyncYad2} disabled={yad2Syncing} style={{padding: '9px 18px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontWeight: 700, cursor: yad2Syncing ? 'wait' : 'pointer'}}>
                  {yad2Syncing ? 'מסנכרן…' : 'שמור וסנכרן עכשיו'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* yad2 sync, mobile. The desktop button is in .campaigns-header (display:none
            under 768px), and the mobile quick-actions row only exists once a campaign
            does — so an agent whose account has no campaigns yet, i.e. exactly the
            person who needs to press sync to create them, could not reach it at all.
            This row sits in the campaigns card, which always renders. */}
        {yad2Sync?.linked && (
          <div className="mobile-yad2-row">
            <button
              className="mobile-yad2-btn"
              onClick={runYad2SyncNow}
              disabled={yad2Syncing}
              title="משיכת הנכסים העדכניים מיד2"
            >
              <i className="bi bi-arrow-repeat" />
              {yad2Syncing ? 'מסנכרן…' : 'סנכרן נכסים מיד2'}
            </button>
          </div>
        )}
        {/* Campaign Explanation - only show for new accounts (< 3 days) and not dismissed */}
        {!explanationDismissed && currentUser?.created_at && (Date.now() - new Date(currentUser.created_at).getTime()) < 3 * 24 * 60 * 60 * 1000 && (
          <div className="campaign-explanation">
            <div className="explanation-icon">💡</div>
            <div className="explanation-text">
              קמפיין הוא המקום שבו מעלים פוסטים, והם מתפרסמים בקבוצות שבחרת.
              בחר קמפיין כדי להעלות או לערוך פוסטים, ולהוסיף או להסיר קבוצות.
            </div>
            <button
              className="explanation-dismiss"
              onClick={() => {
                setExplanationDismissed(true);
                localStorage.setItem('campaignExplanationDismissed', 'true');
              }}
            >
              ✕
            </button>
          </div>
        )}

        {/* Deleted Campaigns Section (Admin Restore Mode) */}
        {showRestoreMode && isAdmin && deletedCampaigns.length > 0 && (
          <div className="deleted-campaigns-section">
            <div className="deleted-campaigns-header">
              <h3>🗑️ קמפיינים שנמחקו ({deletedCampaigns.length})</h3>
              <span className="deleted-campaigns-hint">לחץ על "שחזר" כדי לשחזר קמפיין</span>
            </div>
            <div className="deleted-campaigns-list">
              {deletedCampaigns.map((camp: any) => (
                <div key={camp._id} className="deleted-campaign-card">
                  <div className="deleted-campaign-info">
                    <span className="deleted-campaign-name">{camp.name}</span>
                    <span className="deleted-campaign-date">
                      נמחק: {camp.deletedAt ? new Date(camp.deletedAt).toLocaleDateString('he-IL') : 'לא ידוע'}
                    </span>
                  </div>
                  <button
                    className="restore-campaign-btn"
                    onClick={() => restoreCampaign(camp._id)}
                    disabled={restoringCampaign === camp._id}
                  >
                    {restoringCampaign === camp._id ? 'משחזר...' : '♻️ שחזר'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {showRestoreMode && isAdmin && deletedCampaigns.length === 0 && (
          <div className="deleted-campaigns-section empty">
            <div className="deleted-campaigns-header">
              <h3>🗑️ אין קמפיינים שנמחקו</h3>
            </div>
          </div>
        )}

        {/* Deleted Profiles Section (Admin Restore Mode) */}
        {showRestoreMode && isAdmin && hiddenProfiles.length > 0 && (
          <div className="deleted-campaigns-section">
            <div className="deleted-campaigns-header">
              <h3>🗑️ פרופילים שנמחקו ({hiddenProfiles.length})</h3>
              <span className="deleted-campaigns-hint">לחץ על "שחזר" כדי לשחזר פרופיל, או "מחק לצמיתות" כדי להסירו לצמיתות</span>
            </div>
            <div className="deleted-campaigns-list">
              {hiddenProfiles.map((p: any) => (
                <div key={p._id} className="deleted-campaign-card">
                  <img
                    className="deleted-profile-avatar"
                    src={p.facebook_id
                      ? `https://graph.facebook.com/${p.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`
                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(p.name || '?')}&background=random&color=fff&size=44`}
                    onError={(e: any) => { e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(p.name || '?')}&background=random&color=fff&size=44`; }}
                    alt={p.name}
                  />
                  <div className="deleted-campaign-info">
                    <span className="deleted-campaign-name">{p.name}</span>
                    <span className="deleted-campaign-date">
                      נמחק: {p.deleted_at ? new Date(p.deleted_at).toLocaleDateString('he-IL') : 'לא ידוע'}
                    </span>
                  </div>
                  <div className="deleted-campaign-actions">
                    <button
                      className="restore-campaign-btn"
                      onClick={() => restoreProfile(p._id)}
                      disabled={restoringProfile === p._id || deletingProfile === p._id}
                    >
                      {restoringProfile === p._id ? 'משחזר...' : '♻️ שחזר'}
                    </button>
                    <button
                      className="permanent-delete-btn"
                      onClick={() => permanentDeleteProfile(p)}
                      disabled={restoringProfile === p._id || deletingProfile === p._id}
                      title="מחיקה לצמיתות — בלתי הפיך"
                    >
                      {deletingProfile === p._id ? 'מוחק...' : '🗑️ מחק לצמיתות'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Mobile Empty State - No Campaigns Yet (visible only on mobile) */}
        {(!currentUser?.campaigns || currentUser.campaigns.length === 0) && (
          <div className="mobile-empty-campaigns-state">
            <div className="mobile-empty-campaigns-icon">📢</div>
            <h3 className="mobile-empty-campaigns-title">אין קמפיינים עדיין</h3>
            <p className="mobile-empty-campaigns-text">צור את הקמפיין הראשון שלך והתחל לפרסם בקבוצות פייסבוק</p>
            <button
              className="mobile-empty-campaigns-btn"
              onClick={() => {
                const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
                setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
                const modalEl = document.getElementById('kt_modal_1');
                if (modalEl) {
                  BsModal.getOrCreateInstance(modalEl).show();
                }
              }}
            >
              ➕ צור קמפיין ראשון
            </button>
          </div>
        )}

        {/* Campaign Cards */}
        <div className="campaigns-cards-container">
          {/* Empty State - No Campaigns Yet (desktop only) */}
          {(!currentUser?.campaigns || currentUser.campaigns.length === 0) && (
            <div className="empty-campaigns-state">
              <div className="empty-campaigns-icon">📢</div>
              <h3 className="empty-campaigns-title">אין קמפיינים עדיין</h3>
              <p className="empty-campaigns-text">צור את הקמפיין הראשון שלך והתחל לפרסם בקבוצות פייסבוק</p>
              <button
                className="empty-campaigns-btn"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_1"
                onClick={() => {
                  const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
                  setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
                }}
              >
                ➕ צור קמפיין ראשון
              </button>
            </div>
          )}
          {/* Campaign Cards */}
          {(() => {
            const anyCampaignSelected = (currentUser?.campaigns || []).some((c: any) => location.pathname === `/campaigns/${c._id}`);
            const q = campaignSearch.trim().toLowerCase();
            const filteredCampaigns = (currentUser?.campaigns || []).filter((c: any) => !q || (c.name || '').toLowerCase().includes(q));
            if (q && filteredCampaigns.length === 0) {
              return <div style={{ textAlign: 'center', color: '#a1a5b7', fontSize: 13, padding: '20px 0' }}>לא נמצאו קמפיינים תואמים ל"{campaignSearch}"</div>;
            }
            return filteredCampaigns.map((camp: any, campIdx: number) => {
            const isActive = location.pathname === `/campaigns/${camp._id}`;
            // Tutorial demo: auto-cycle a "hover" across cards to show any of them is selectable.
            const isDemoHover = inCampaignSelectStep && !campaignChosen && !isActive && campIdx === demoHoverIdx;
            const isPaused = !camp.enabled;
            const groupCount = camp._groupCount ?? getGroupCount(camp);
            const hasNoGroups = groupCount === 0;
            const postCount = camp.post_count || 0;
            const hasNoPosts = postCount === 0;
            const hasOnlyOnePost = postCount === 1;
            const campStats = allCampaignStats[camp._id];
            const isNewAccount = currentUser?.created_at && (Date.now() - new Date(currentUser.created_at).getTime()) < 3 * 24 * 60 * 60 * 1000;
            const campProfiles = allCampaignProfiles[camp._id] || [];
            const hasNoProfiles = campProfiles.length === 0;
            // Only show hard warning (red) for no groups, no posts, or no profiles - one post is soft warning (yellow notice)
            const hasWarning = hasNoGroups || hasNoPosts || hasNoProfiles;

            return (
              <div
                key={camp._id}
                className={`campaign-card ${isActive ? 'active' : ''} ${isPaused || hasWarning ? 'paused' : ''} ${anyCampaignSelected && !isActive ? 'inactive' : ''} ${isDemoHover ? 'demo-hover' : ''}`}
                onClick={() => navigate(`/campaigns/${camp._id}?${params.toString()}`)}
              >
                {/* Row 1: Header + Actions (wraps on narrow cards so the name keeps its width) */}
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%', gap: '12px' }}>
                  {/* Onboarding "select a campaign" step: a radio circle (which one is chosen)
                      plus a flashing nudge arrow on unselected cards so it's clear they're clickable. */}
                  {inCampaignSelectStep && !isActive && !campaignChosen && (
                    <svg className='campaign-select-arrow' aria-hidden width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#2b70fa' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' style={{flexShrink: 0}}>
                      <line x1='19' y1='12' x2='5' y2='12' /><polyline points='12 19 5 12 12 5' />
                    </svg>
                  )}
                  {inCampaignSelectStep && (
                    <div aria-hidden style={{flexShrink: 0, width: 24, height: 24, borderRadius: '50%', border: `2px solid ${isActive ? '#2b70fa' : '#b7c0d0'}`, background: isActive ? '#2b70fa' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s ease'}}>
                      {isActive && (
                        <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'><polyline points='20 6 9 17 4 12' /></svg>
                      )}
                    </div>
                  )}
                  <div className="campaign-card-header" style={{ flex: 1, marginBottom: 0 }}>
                    <span className={`campaign-status-dot ${hasWarning ? 'no-groups' : isPaused ? 'paused' : 'active'}`}></span>
                    <div className="campaign-name">
                      קמפיין - {camp.name}
                      {camp.source === 'yad2_agent' && (
                        <span className="badge badge-light-success" style={{fontSize: '9px', marginInlineStart: 6, verticalAlign: 'middle'}} title="קמפיין שיובא מיד2">
                          <i className="bi bi-houses" style={{marginInlineEnd: 2}} />יד2
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="campaign-card-actions" onClick={(e) => e.stopPropagation()}>
                    <label className="campaign-toggle">
                      <input
                        type="checkbox"
                        checked={!isPaused && !hasWarning}
                        disabled={camp.loading}
                        onChange={() => {
                          if (hasWarning) {
                            // Navigate to this campaign if not active
                            if (!isActive) {
                              navigate(`/campaigns/${camp._id}?${params.toString()}`);
                            }
                            setTimeout(() => {
                              const warningClass = hasNoGroups ? '.no-groups-warning' : hasNoProfiles ? '.no-profiles-warning' : '.no-posts-warning';
                              const warningEl = document.querySelector(warningClass);
                              if (warningEl) {
                                warningEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                warningEl.classList.add('flash-warning');
                                setTimeout(() => warningEl.classList.remove('flash-warning'), 2000);
                              }
                            }, isActive ? 0 : 300);
                          } else {
                            enableCampaign(camp, isPaused);
                          }
                        }}
                      />
                      <span
                        className="campaign-toggle-slider"
                        data-tooltip={
                          hasWarning
                            ? (hasNoGroups ? 'יש לבחור קבוצות כדי להפעיל את הקמפיין' : hasNoProfiles ? 'יש לבחור פרופיל כדי להפעיל את הקמפיין' : 'יש להוסיף פוסטים כדי להפעיל את הקמפיין')
                            : isPaused
                              ? 'הקמפיין מושהה - לחץ להפעלה'
                              : 'הקמפיין פעיל - לחץ להשהיה'
                        }
                      ></span>
                    </label>
                    <button
                      className="camp-btn edit"
                      data-tooltip="ערוך שם קמפיין"
                      onClick={() => {
                        setEditingCampaignId(camp._id);
                        setEditingCampaignName(camp.name);
                        setEditingMaxPosts(camp.max_daily_posts > 0 ? camp.max_daily_posts : 0);
                        setEditingFakePublished(camp.fake_published_count || 0);
                        setEditingDefaultAutoReply(camp.default_auto_reply || '');
                        setEditingDefaultMarketplaceAutoReply(camp.default_marketplace_auto_reply || '');
                        setEditingDefaultSignature(camp.default_signature || '');
                        setEditingDefaultSignatureLocked(!!camp.default_signature_locked);
                      }}
                    >
                      ✏️
                    </button>
                    <button
                      className="camp-btn delete"
                      data-tooltip="מחק קמפיין"
                      onClick={() => {
                        setCampaignToDelete(camp);
                        const modalBtn = document.getElementById('delete-campaign-modal-trigger') as HTMLElement;
                        modalBtn?.click();
                      }}
                    >
                      🗑
                    </button>
                    {/* Campaign-level "⋯" menu */}
                    <div className="campaign-menu-wrap">
                      <button
                        className="camp-btn more"
                        data-tooltip="אפשרויות נוספות"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCampaignMenuOpen(campaignMenuOpen === camp._id ? null : camp._id);
                        }}
                      >
                        ⋯
                      </button>
                      {campaignMenuOpen === camp._id && (
                        <div className="campaign-menu" onClick={(e) => e.stopPropagation()}>
                          <button
                            className="campaign-menu-item"
                            disabled={duplicatingCampaignId === camp._id}
                            onClick={() => duplicateCampaign(camp)}
                          >
                            📋 {duplicatingCampaignId === camp._id ? 'משכפל...' : 'שכפל קמפיין'}
                            <span className="campaign-menu-hint">
                              {postCount} פוסטים - העותק ייווצר מושהה
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Row 2: Profiles, Stats, Warnings - full width */}
                <div className="campaign-card-info">
                  {/* Campaign Profiles - Desktop Only */}
                  <div
                    className="campaign-profiles-row desktop-only-profile-row"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px'
                    }}
                    >
                      <span style={{ fontSize: '13px', color: '#666', fontWeight: 500 }}>בחר את הפרופילים שיפרסמו בקמפיין זה</span>
                      {((allCampaignProfiles[camp._id] || []).length === 0) && (
                        <span style={{ fontSize: '12px', color: '#1877f2', fontWeight: 500 }}>כל הפרופילים ישמשו (ברירת מחדל)</span>
                      )}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).map((profile: any) => {
                          const campProfiles = allCampaignProfiles[camp._id] || [];
                          const noneSelected = campProfiles.length === 0;
                          const selected = noneSelected || campProfiles.includes(profile._id);
                          const ownConnected = isProfileDisplayedAsConnected(profile);
                          const parentProfile = profile.parent_profile ? allProfiles.find((p: any) => p._id === profile.parent_profile) : null;
                          const parentConnected = isProfileDisplayedAsConnected(parentProfile);
                          const isConnected = ownConnected || (profile.parent_profile && parentConnected);
                          return (
                            <div
                              key={profile._id}
                              onClick={(e) => {
                                e.stopPropagation();
                                let newSelection: string[];
                                if (noneSelected) {
                                  // Select this profile explicitly
                                  newSelection = [profile._id];
                                } else if (selected) {
                                  newSelection = campProfiles.filter(id => id !== profile._id);
                                } else {
                                  newSelection = [...campProfiles, profile._id];
                                }
                                // Don't allow deselecting all profiles
                                if (newSelection.length === 0) {
                                  setToast({ message: 'לא ניתן להסיר את כל הפרופילים מהקמפיין', type: 'error' });
                                  setTimeout(() => setToast(null), 3000);
                                  return;
                                }
                                setAllCampaignProfiles(prev => ({ ...prev, [camp._id]: newSelection }));
                                // Auto-save
                                axios.post(`${API_URL}/api/save-campaign-profiles`, {
                                  campaign_id: camp._id,
                                  users: newSelection
                                });
                              }}
                              className="profile-avatar-with-tooltip"
                              style={{
                                position: 'relative',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              <span className="profile-tooltip">{profile.first_name || profile.facebook_username || 'Unknown'}</span>
                              <img
                                src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=normal&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                alt={profile.first_name || profile.facebook_username || 'Unknown'}
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  borderRadius: '50%',
                                  objectFit: 'cover',
                                  border: selected ? (noneSelected ? '2px solid #90caf9' : '3px solid #1877f2') : '2px solid #e0e0e0',
                                  opacity: selected ? (noneSelected ? 0.85 : 1) : 0.5,
                                  filter: selected ? 'none' : 'grayscale(50%)'
                                }}
                              />
                              <span style={{
                                position: 'absolute',
                                bottom: '0',
                                right: '0',
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: isConnected ? '#22c55e' : '#ef4444',
                                border: '2px solid #fff'
                              }}></span>
                              {selected && !noneSelected && (
                                <span style={{
                                  position: 'absolute',
                                  top: '-4px',
                                  left: '-4px',
                                  width: '16px',
                                  height: '16px',
                                  borderRadius: '50%',
                                  backgroundColor: '#1877f2',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 12l5 5L20 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  <div className="campaign-stats" style={{ marginTop: '10px' }} {...(isActive && campStats ? {'data-onboarding': 'campaign-stats-loaded'} : {})}>
                    <span
                      className="clickable-stat"
                      {...(isActive ? {'data-onboarding': 'posts-button'} : {})}
                      onClick={(e) => {
                        e.stopPropagation();
                        const scrollAndHighlight = () => {
                          const postsSection = document.getElementById('posts-section');
                          if (postsSection) {
                            postsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            postsSection.classList.add('highlight-section');
                            setTimeout(() => postsSection.classList.remove('highlight-section'), 2000);
                          }
                        };
                        if (isActive) {
                          scrollAndHighlight();
                        } else {
                          navigate(`/campaigns/${camp._id}?${params.toString()}`);
                          setTimeout(scrollAndHighlight, 500);
                        }
                      }}
                      title="לחץ לצפייה בפוסטים"
                    >
                      📊 {camp.post_count || 0} פוסטים
                      {(() => {
                        // Prefer the live count for the open campaign (reflects
                        // toggles made this session); fall back to the server count.
                        const paused = isActive ? pausedPostCount : (camp.paused_post_count || 0);
                        return paused > 0 ? (
                          <span
                            style={{ display: 'block', fontSize: '11px', color: '#e65100', fontWeight: 600, marginTop: '2px' }}
                            title="פוסטים מושהים שלא יתוזמנו"
                          >
                            ⏸️ {paused} מושהים
                          </span>
                        ) : null;
                      })()}
                    </span>
                    <span
                      className="clickable-stat"
                      {...(isActive ? {'data-onboarding': 'groups-button'} : {})}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCampaign(camp);
                        if (isActive) {
                          document.getElementById('groups-modal-trigger')?.click();
                        } else {
                          navigate(`/campaigns/${camp._id}?${params.toString()}`);
                          setTimeout(() => {
                            document.getElementById('groups-modal-trigger')?.click();
                          }, 300);
                        }
                      }}
                      title="לחץ לבחירת קבוצות"
                    >
                      👥 {groupCount} קבוצות
                    </span>
                    <span
                      className="clickable-stat"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/stats');
                      }}
                      title="לחץ לצפייה בסטטיסטיקות"
                    >
                      📈 {campStats?.totalPostsAllTime?.toLocaleString() || 0} פורסמו
                    </span>
                    <span>📅 {campStats?.totalToday || 0} היום</span>
                    {campStats?.marketplaceListings > 0 && (
                      <span
                        className="clickable-stat"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate('/marketplace');
                        }}
                        title="לחץ לצפייה במרקטפלייס"
                      >
                        🏪 {campStats.marketplaceListings} מרקטפלייס
                      </span>
                    )}
                  </div>
                  {hasNoGroups && (
                    <div className="no-groups-warning" style={{
                      marginTop: '8px',
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                      borderRadius: '8px',
                      fontSize: '12px',
                      color: '#c62828',
                      lineHeight: '1.5',
                      border: '1px solid #ef9a9a'
                    }}>
                      <span style={{ marginLeft: '6px' }}>⚠️</span>
                      <strong>שים לב חובה לבחור קבוצות:</strong> לא נבחרו קבוצות לקמפיין זה.
                      <span
                        style={{
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginRight: '4px'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCampaign(camp);
                          if (isActive) {
                            document.getElementById('groups-modal-trigger')?.click();
                          } else {
                            navigate(`/campaigns/${camp._id}?${params.toString()}`);
                            setTimeout(() => {
                              document.getElementById('groups-modal-trigger')?.click();
                            }, 300);
                          }
                        }}
                      >
                        לחץ כאן לבחירת קבוצות
                      </span>
                    </div>
                  )}
                  {hasNoPosts && (
                    <div className="no-posts-warning" style={{
                      marginTop: '8px',
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                      borderRadius: '8px',
                      fontSize: '12px',
                      color: '#c62828',
                      lineHeight: '1.5',
                      border: '1px solid #ef9a9a'
                    }}>
                      <span style={{ marginLeft: '6px' }}>⚠️</span>
                      <strong>שים לב חובה להוסיף פוסטים:</strong> אין פוסטים בקמפיין זה.
                      <span
                        style={{
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginRight: '4px'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isActive) {
                            navigate(`/campaigns/${camp._id}?${params.toString()}`);
                          }
                          setTimeout(() => {
                            document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth' });
                          }, isActive ? 0 : 300);
                        }}
                      >
                        לחץ כאן להוספת פוסטים
                      </span>
                    </div>
                  )}
                  {hasNoProfiles && (
                    <div className="no-profiles-warning" style={{
                      marginTop: '8px',
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                      borderRadius: '8px',
                      fontSize: '12px',
                      color: '#c62828',
                      lineHeight: '1.5',
                      border: '1px solid #ef9a9a'
                    }}>
                      <span style={{ marginLeft: '6px' }}>⚠️</span>
                      <strong>שים לב חובה לבחור פרופיל:</strong> אין פרופילים בקמפיין זה.
                      <span
                        style={{
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginRight: '4px'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCampaign(camp);
                          if (!isActive) {
                            navigate(`/campaigns/${camp._id}?${params.toString()}`);
                          }
                          setTimeout(() => {
                            document.getElementById('profiles-modal-trigger')?.click();
                          }, isActive ? 0 : 300);
                        }}
                      >
                        לחץ כאן לבחירת פרופיל
                      </span>
                    </div>
                  )}
                  {hasOnlyOnePost && (
                    <div className="one-post-warning" style={{
                      marginTop: '8px',
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)',
                      borderRadius: '8px',
                      fontSize: '12px',
                      color: '#f57c00',
                      lineHeight: '1.5',
                      border: '1px solid #ffcc80'
                    }}>
                      <span style={{ marginLeft: '6px' }}>💡</span>
                      <strong>המלצה:</strong> יש לך רק פוסט אחד בקמפיין. מומלץ מאוד להוסיף עוד פוסטים לגיוון התוכן.
                      <span
                        style={{
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginRight: '4px'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isActive) {
                            navigate(`/campaigns/${camp._id}?${params.toString()}`);
                          }
                          setTimeout(() => {
                            document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth' });
                          }, isActive ? 0 : 300);
                        }}
                      >
                        לחץ כאן להוספת פוסטים
                      </span>
                    </div>
                  )}
                  {isNewAccount && (() => {
                    // Calculate joined groups count from all connected profiles
                    const campaignGroups = new Set((camp.slot_selected_groups || []).map((g: any) => g.toString()));
                    const totalCampaignGroups = campaignGroups.size;

                    // Get all groups joined by connected profiles
                    const joinedGroupsSet = new Set<string>();
                    allProfiles.forEach((profile: any) => {
                      const isConnected = isProfileDisplayedAsConnected(profile);
                      if (isConnected && profile.joined_groups) {
                        profile.joined_groups.forEach((groupId: string) => {
                          if (campaignGroups.has(groupId)) {
                            joinedGroupsSet.add(groupId);
                          }
                        });
                      }
                    });
                    const joinedCount = joinedGroupsSet.size;

                    return (
                      <div className="new-campaign-notice" style={{
                        marginTop: '8px',
                        padding: '8px 12px',
                        background: 'linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)',
                        borderRadius: '8px',
                        fontSize: '12px',
                        color: '#6d4c00',
                        lineHeight: '1.5',
                        border: '1px solid #ffe082'
                      }}>
                        <span style={{ marginLeft: '6px' }}>🌱</span>
                        <strong>קמפיין חדש:</strong> בימים הראשונים הפרופיל מצטרף לקבוצות ומספר הפוסטים גדל בהדרגה.
                        {totalCampaignGroups > 0 && (
                          <span style={{ fontWeight: 'bold', color: '#5d4200' }}>
                            {' '}(חבר ב-{joinedCount} קבוצות מתוך {totalCampaignGroups})
                          </span>
                        )}
                        <br />בינתיים, הפוסטים מתפרסמים בקבוצות שאתם כבר חברים בהן.
                      </div>
                    );
                  })()}
                </div>
              </div>
            );
          });
          })()}

        </div>

        {/* Modal for creating new campaign */}
        <div className="modal fade" tabIndex={-1} id="kt_modal_1" data-bs-backdrop="static" data-bs-keyboard="false">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <form
                        className='form w-100'
                        onSubmit={formik.handleSubmit}
                        noValidate
                      >

                        <div className="modal-header">
                          <h5 className="modal-title">יצירת קמפיין</h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>
                        <div className="modal-body">
                          {/* Campaign explanation - hidden during tutorial */}
                          {!new URLSearchParams(window.location.search).has('tut') && (
                          <div style={{ marginBottom: '20px', padding: '12px 16px', backgroundColor: '#f8f9fa', borderRadius: '8px', fontSize: '13px', color: '#555', lineHeight: '1.6' }}>
                            <p style={{ margin: '0 0 8px 0' }}>קמפיין זו תיקייה שמארגנת את הפוסטים שלכם לפי אזור או תחום.</p>
                            <p style={{ margin: '0 0 8px 0' }}>יש ליצור קמפיין נפרד לכל אזור או קטגוריה.</p>
                            <p style={{ margin: '0 0 12px 0', fontWeight: 500 }}>שם הקמפיין לא מוצג בפייסבוק – הוא מיועד רק לניהול וסדר פנימי.</p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                              <span style={{ fontSize: '12px', color: '#666' }}>דוגמאות:</span>
                              <span style={{ backgroundColor: '#e9ecef', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}>נדל"ן תל אביב</span>
                              <span style={{ backgroundColor: '#e9ecef', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}>רכבים מרכז</span>
                              <span style={{ backgroundColor: '#e9ecef', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}>שיווק דיגיטלי</span>
                            </div>
                          </div>
                          )}

                          <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label htmlFor="exampleInputEmail1" style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>שם הקמפיין</label>
                            <input
                              type="text"
                              {...formik.getFieldProps('name')}
                              className={clsx(
                                'form-control bg-transparent',
                                {'is-invalid': formik.touched.name && formik.errors.name},
                                {
                                  'is-valid': formik.touched.name && !formik.errors.name,
                                }
                              )}
                              placeholder="לדוגמא: נכסים תל אביב"
                            />

                            {(formik.touched.name || formik.submitCount > 0) && formik.errors.name && (
                              <div className='fv-plugins-message-container'>
                                <span role='alert' style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{formik.errors.name}</span>
                              </div>
                            )}
                          </div>

                          {/* Profile Selection — only show when connected profiles exist */}
                          {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).length > 0 && <div className="form-group">
                            <label style={{ marginBottom: '8px', display: 'block' }}>בחר פרופילים לקמפיין</label>
                            <p style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
                              בחר את הפרופילים שיפרסמו בקמפיין זה ({newCampaignProfiles.length} / {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).length} נבחרו)
                            </p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxHeight: '200px', overflowY: 'auto', padding: '4px' }}>
                              {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).map((profile: any) => {
                                const selected = newCampaignProfiles.includes(profile._id);
                                const newCampOwnConnected = isProfileDisplayedAsConnected(profile);
                                const newCampParentProfile = profile.parent_profile ? allProfiles.find((p: any) => p._id === profile.parent_profile) : null;
                                const newCampParentConnected = isProfileDisplayedAsConnected(newCampParentProfile);
                                const isConnected = newCampOwnConnected || (profile.parent_profile && newCampParentConnected);
                                return (
                                  <div
                                    key={profile._id}
                                    onClick={() => {
                                      const newSelection = selected
                                        ? newCampaignProfiles.filter(id => id !== profile._id)
                                        : [...newCampaignProfiles, profile._id];
                                      setNewCampaignProfiles(newSelection);
                                    }}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                      padding: '8px 12px',
                                      borderRadius: '8px',
                                      border: selected ? '2px solid #1877f2' : '1px solid #e0e0e0',
                                      backgroundColor: selected ? '#e7f3ff' : '#fff',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s'
                                    }}
                                  >
                                    <div style={{ position: 'relative' }}>
                                      <img
                                        src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                        alt=""
                                        style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
                                      />
                                      <span style={{
                                        position: 'absolute',
                                        bottom: '-2px',
                                        right: '-2px',
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        backgroundColor: isConnected ? '#22c55e' : '#ef4444',
                                        border: '2px solid #fff'
                                      }}></span>
                                    </div>
                                    <span style={{ fontWeight: selected ? 600 : 400, color: selected ? '#1877f2' : '#333', fontSize: '13px' }}>
                                      {profile.first_name || profile.facebook_username || 'Unknown'}
                                    </span>
                                    {selected && (
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M5 12l5 5L20 7" stroke="#1877f2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>}
                        </div>
                        <div className="modal-footer" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '12px' }}>
                          <p style={{ fontSize: '12px', color: '#888', margin: 0, textAlign: 'center' }}>
                            ניתן להוסיף קמפיינים נוספים בהמשך מתוך המערכת.
                          </p>
                          <button disabled={formik.isSubmitting || (allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).length > 0 && newCampaignProfiles.length === 0)} type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                            {formik.isSubmitting ? (
                              <span><span className="spinner-border spinner-border-sm me-2" role="status"></span>יוצר קמפיין...</span>
                            ) : 'צור קמפיין'}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* Hidden trigger for groups modal */}
                <button
                  type="button"
                  id="groups-modal-trigger"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_8"
                  style={{display: 'none'}}
                />
                <div className="modal fade" tabIndex={-1} id="kt_modal_8" data-bs-backdrop="static" data-bs-keyboard="false">
                  <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                      {selectedCampaign && groupsModalOpen && <TablesWidget10 campaign={selectedCampaign} allProfiles={allProfiles} currentUser={currentUser} isAdmin={isAdmin} onOccupationSave={(occupation) => {
                        // Update currentUser.library_occupation so it persists in session
                        if (currentUser) {
                          setCurrentUser({ ...currentUser, library_occupation: occupation });
                        }
                      }} ddddddddddd={(c) => {
                        setSelectedCampaign(c);
                        // Update currentUser.campaigns to reflect the new group count and library groups
                        if (currentUser?.campaigns) {
                          const updatedCampaigns = currentUser.campaigns.map((camp: any) =>
                            camp._id === c._id
                              ? {
                                  ...camp,
                                  slot_selected_groups: c.groups || [],
                                  library_groups: c.library_groups || [],
                                  blacklisted_groups: c.blacklisted_groups || [],
                                  _groupCount: c._groupCount
                                }
                              : camp
                          );
                          setCurrentUser({ ...currentUser, campaigns: updatedCampaigns });
                        }
                      }}/>}
                    </div>
                  </div>
                </div>

                {/* Hidden trigger for profiles modal */}
                <button
                  type="button"
                  id="profiles-modal-trigger"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_profiles"
                  style={{display: 'none'}}
                />
                <div className="modal fade" tabIndex={-1} id="kt_modal_profiles">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header" style={{borderBottom: '1px solid #e0e0e0'}}>
                        <h5 className="modal-title" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#1877f2" strokeWidth="2"/>
                            <circle cx="9" cy="7" r="4" stroke="#1877f2" strokeWidth="2"/>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#1877f2" strokeWidth="2"/>
                          </svg>
                          פרופילים לקמפיין: {selectedCampaign?.name}
                        </h5>
                        <div
                          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-2x"
                          />
                        </div>
                      </div>
                      <div className="modal-body" style={{maxHeight: '60vh', overflowY: 'auto'}}>
                        <p style={{fontSize: '13px', color: '#666', marginBottom: '16px'}}>
                          בחר את הפרופילים שיפרסמו בקמפיין זה
                        </p>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                          {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).map((profile: any) => {
                            const modalCampProfiles = allCampaignProfiles[selectedCampaign?._id] || [];
                            const selected = modalCampProfiles.includes(profile._id);
                            const modalOwnConnected = profile.last_health_check && new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                            const modalParentProfile = profile.parent_profile ? allProfiles.find((p: any) => p._id === profile.parent_profile) : null;
                            const modalParentConnected = modalParentProfile?.last_health_check && new Date(modalParentProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                            const isConnected = modalOwnConnected || (profile.parent_profile && modalParentConnected);
                            return (
                              <div
                                key={profile._id}
                                onClick={() => {
                                  const newSelection = selected
                                    ? modalCampProfiles.filter(id => id !== profile._id)
                                    : [...modalCampProfiles, profile._id];
                                  // Don't allow deselecting all profiles
                                  if (newSelection.length === 0) {
                                    setToast({ message: 'לא ניתן להסיר את כל הפרופילים מהקמפיין', type: 'error' });
                                    setTimeout(() => setToast(null), 3000);
                                    return;
                                  }
                                  setAllCampaignProfiles(prev => ({ ...prev, [selectedCampaign?._id]: newSelection }));
                                }}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  padding: '10px 14px',
                                  borderRadius: '10px',
                                  border: selected ? '2px solid #1877f2' : '1px solid #e0e0e0',
                                  backgroundColor: selected ? '#e7f3ff' : '#fff',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s'
                                }}
                              >
                                <div style={{position: 'relative'}}>
                                  <img
                                    src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=normal&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                    alt=""
                                    style={{width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover'}}
                                  />
                                  <span style={{
                                    position: 'absolute',
                                    bottom: '0',
                                    right: '0',
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: isConnected ? '#22c55e' : '#ef4444',
                                    border: '2px solid #fff'
                                  }}></span>
                                </div>
                                <span style={{fontWeight: selected ? 600 : 400, color: selected ? '#1877f2' : '#333'}}>
                                  {profile.first_name || profile.facebook_username || 'Unknown'}
                                </span>
                                {selected && (
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 12l5 5L20 7" stroke="#1877f2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="modal-footer" style={{borderTop: '1px solid #e0e0e0'}}>
                        <span style={{fontSize: '13px', color: '#666', marginLeft: 'auto'}}>
                          {(allCampaignProfiles[selectedCampaign?._id] || []).length} / {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).length} נבחרו
                        </span>
                        <button
                          onClick={saveCampaignProfiles}
                          disabled={savingProfiles}
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}
                        >
                          {savingProfiles ? 'שומר...' : 'שמור'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Hidden trigger for delete modal */}
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_2"
                  style={{ display: 'none' }}
                  id="delete-campaign-modal-trigger"
                />

                <div className="modal fade" tabIndex={-1} id="kt_modal_2">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header alert-dismissible bg-light-danger">
                          <h5 className="modal-title"></h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>

                        <div className="modal-body alert-dismissible bg-light-danger">

                        <div>
                          <div className="text-center">
                            <h5 className="fw-bolder fs-1 mb-5">{intl.formatMessage({id: 'GENERAL.DELETE_CAMPAIGN'})} <span style={{color: 'red'}}>{campaignToDelete?.name}</span></h5>

                            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

                            <div className="mb-9">
                              {intl.formatMessage({id: 'GENERAL.WANRING_DELETE_CAMPAIGN'})}.<br/>
                            </div>
                            <div className="d-flex flex-center flex-wrap">
                              <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">{intl.formatMessage({id: 'GENERAL.CANCEL'})}</button>
                              <button className="btn btn-danger m-2" data-bs-dismiss="modal" onClick={deleteCampaign.bind(this, campaignToDelete)}>{intl.formatMessage({id: 'GENERAL.OK_GOT_IT'})}</button>
                            </div>
                          </div>
                      </div>


                        </div>



                    </div>
                  </div>
                </div>

                {/* Admin: Move Campaign to Another Account Modal */}
                {isAdmin && (
                  <div className="modal fade" tabIndex={-1} id="kt_modal_move_campaign" data-bs-backdrop="static" data-bs-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">העבר קמפיין לחשבון אחר <span className="badge badge-light-warning" style={{ fontSize: '10px', marginRight: '6px' }}>אדמין</span></h5>
                          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                            <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-2x" />
                          </div>
                        </div>
                        <div className="modal-body" style={{ direction: 'rtl' }}>
                          <div style={{ marginBottom: '12px', fontSize: '13px', color: '#555' }}>
                            הקמפיין <strong>{selectedCampaign?.name}</strong> יועבר יחד עם כל הפוסטים שלו. בחר חשבון יעד ואת הפרופילים להעביר (סלוטי החיוב שלהם יועברו גם הם, והשיבוץ ינוקה).
                          </div>

                          {/* Target account picker */}
                          <div ref={moveDropdownRef} style={{ position: 'relative', marginBottom: '14px' }}>
                            <label style={{ fontSize: '12px', fontWeight: 600, marginBottom: '4px', display: 'block' }}>חשבון יעד</label>
                            <input
                              type="text"
                              placeholder="חפש לפי שם, אימייל או טלפון..."
                              value={moveSearch}
                              onChange={(e) => { setMoveSearch(e.target.value); setMoveDropdownOpen(true); }}
                              onFocus={() => setMoveDropdownOpen(true)}
                              disabled={movingCampaign}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                borderRadius: '8px',
                                border: `1px solid ${moveDropdownOpen ? '#f5576c' : '#d9d9d9'}`,
                                fontSize: '13px',
                                outline: 'none',
                                opacity: movingCampaign ? 0.6 : 1,
                              }}
                            />
                            {moveDropdownOpen && (
                              <div style={{
                                position: 'absolute',
                                top: '100%', left: 0, right: 0,
                                background: '#fff',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                marginTop: '4px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                zIndex: 1055,
                                maxHeight: '260px',
                                overflowY: 'auto',
                              }}>
                                {(() => {
                                  const q = moveSearch.toLowerCase().trim();
                                  if (!q) {
                                    return <div style={{ padding: '14px', textAlign: 'center', color: '#999', fontSize: '13px' }}>הקלד לחיפוש חשבון יעד...</div>;
                                  }
                                  const filtered = moveAccounts.filter((a: any) => {
                                    if (a._id === currentUser?._id) return false;
                                    return (a.first_name || '').toLowerCase().includes(q) ||
                                      (a.last_name || '').toLowerCase().includes(q) ||
                                      (a.email || '').toLowerCase().includes(q) ||
                                      (a.phone || '').toLowerCase().includes(q);
                                  }).slice(0, 30);
                                  if (filtered.length === 0) {
                                    return <div style={{ padding: '14px', textAlign: 'center', color: '#999', fontSize: '13px' }}>לא נמצאו חשבונות</div>;
                                  }
                                  return filtered.map((acc: any) => (
                                    <div
                                      key={acc._id}
                                      onClick={() => {
                                        setMoveTarget(acc);
                                        setMoveDropdownOpen(false);
                                        setMoveSearch(`${acc.first_name || ''} ${acc.last_name || ''}`.trim() || acc.email);
                                      }}
                                      style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
                                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                    >
                                      <div style={{ fontSize: '13px', fontWeight: 500 }}>{acc.first_name} {acc.last_name}</div>
                                      <div style={{ fontSize: '11px', color: '#888' }}>{acc.email}{acc.phone ? ` · ${acc.phone}` : ''}</div>
                                    </div>
                                  ));
                                })()}
                              </div>
                            )}
                          </div>

                          {moveTarget && (
                            <div style={{
                              padding: '8px 12px',
                              borderRadius: '8px',
                              background: 'rgba(245, 87, 108, 0.06)',
                              border: '1px solid rgba(245, 87, 108, 0.2)',
                              marginBottom: '14px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                              <div>
                                <div style={{ fontSize: '13px', fontWeight: 600 }}>{moveTarget.first_name} {moveTarget.last_name}</div>
                                <div style={{ fontSize: '11px', color: '#888' }}>{moveTarget.email}</div>
                              </div>
                              <button
                                onClick={() => { setMoveTarget(null); setMoveSearch(''); }}
                                className="btn btn-sm btn-light"
                                style={{ fontSize: '11px' }}
                              >נקה</button>
                            </div>
                          )}

                          {/* Profile checklist */}
                          <div>
                            <label style={{ fontSize: '12px', fontWeight: 600, marginBottom: '6px', display: 'block' }}>
                              פרופילים להעביר ({moveProfileIds.length})
                            </label>
                            {(allCampaignProfiles[selectedCampaign?._id] || []).length === 0 ? (
                              <div style={{ fontSize: '12px', color: '#888', padding: '8px 0' }}>
                                לא משויכים פרופילים לקמפיין זה.
                              </div>
                            ) : (
                              <div style={{ maxHeight: '220px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px' }}>
                                {(allCampaignProfiles[selectedCampaign?._id] || []).map((pid: string) => {
                                  const profile: any = allProfiles.find((p: any) => p._id === pid);
                                  if (!profile) return null;
                                  const checked = moveProfileIds.includes(pid);
                                  const name = `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || profile.facebook_username || pid;
                                  return (
                                    <label
                                      key={pid}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '8px 12px',
                                        borderBottom: '1px solid #f5f5f5',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => {
                                          setMoveProfileIds(prev =>
                                            prev.includes(pid) ? prev.filter(x => x !== pid) : [...prev, pid]
                                          );
                                        }}
                                      />
                                      <span style={{ fontSize: '13px' }}>{name}</span>
                                      {profile.facebook_username && (
                                        <span style={{ fontSize: '11px', color: '#888' }}>({profile.facebook_username})</span>
                                      )}
                                    </label>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button className="btn btn-light" data-bs-dismiss="modal" disabled={movingCampaign}>ביטול</button>
                          <button
                            className="btn btn-primary"
                            style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', border: 'none' }}
                            disabled={!moveTarget || movingCampaign}
                            onClick={handleMoveCampaign}
                          >
                            {movingCampaign ? 'מעביר...' : 'העבר קמפיין'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Admin: Delete All Account Campaigns Modal */}
                {isAdmin && (
                  <>
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#kt_modal_delete_all_campaigns"
                      style={{ display: 'none' }}
                      id="delete-all-campaigns-modal-trigger"
                    />
                    <div className="modal fade" tabIndex={-1} id="kt_modal_delete_all_campaigns">
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header alert-dismissible bg-light-danger">
                            <h5 className="modal-title"></h5>
                            <div
                              className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                              />
                            </div>
                          </div>
                          <div className="modal-body alert-dismissible bg-light-danger">
                            <div>
                              <div className="text-center">
                                <h5 className="fw-bolder fs-1 mb-5">מחיקת כל הקמפיינים של החשבון</h5>
                                <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>
                                <div className="mb-9">
                                  <strong>אזהרה:</strong> פעולה זו תמחק את כל הקמפיינים של החשבון הזה.<br/>
                                  פעולה זו היא בלתי הפיכה!
                                </div>
                                <div className="d-flex flex-center flex-wrap">
                                  <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">ביטול</button>
                                  <button className="btn btn-danger m-2" data-bs-dismiss="modal" onClick={deleteAllAccountCampaigns.bind(this, selectedCampaign)}>מחק הכל</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="modal fade" tabIndex={-1} id="kt_modal_3">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header alert-dismissible bg-light-danger">
                          <h5 className="modal-title"></h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>

                        <div className="modal-body alert-dismissible bg-light-danger">

                        <div>
                          <div className="text-center">
                            <h5 className="fw-bolder fs-1 mb-5">{intl.formatMessage({id: 'GENERAL.DELETE_POST'})} <span style={{color: 'red'}}>{selectedPost?.name}</span></h5>

                            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

                            <div className="mb-9">
                              {intl.formatMessage({id: 'GENERAL.WANRING_DELETE_POST'})}.<br/>
                            </div>
                            <div className="d-flex flex-center flex-wrap">
                              <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">{intl.formatMessage({id: 'GENERAL.CANCEL'})}</button>
                              <button className="btn btn-danger m-2" data-bs-dismiss="modal" onClick={() => deletePost(selectedPost, selectedCampaign)}>{intl.formatMessage({id: 'GENERAL.OK_GOT_IT'})}</button>
                            </div>
                          </div>
                      </div>


                        </div>



                    </div>
                  </div>
                </div>

                <div className="modal fade" tabIndex={-1} id="kt_modal_4">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header alert-dismissible bg-light-danger">
                          <h5 className="modal-title"></h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>

                        <div className="modal-body alert-dismissible bg-light-danger">

                        <div>
                          <div className="text-center">
                            <h5 className="fw-bolder fs-1 mb-5">{intl.formatMessage({id: 'GENERAL.DELETE_POSTS'})} <span style={{color: 'red'}}>({posts.filter((a) => a.selected).length})</span></h5>

                            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

                            <div className="mb-9">
                              {intl.formatMessage({id: 'GENERAL.WANRING_DELETE_POSTS'})}.<br/>
                            </div>
                            <div className="d-flex flex-center flex-wrap">
                              <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">{intl.formatMessage({id: 'GENERAL.CANCEL'})}</button>
                              <button className="btn btn-danger m-2" data-bs-dismiss="modal" onClick={deletePosts.bind(this, selectedCampaign)}>{intl.formatMessage({id: 'GENERAL.OK_GOT_IT'})}</button>
                            </div>
                          </div>
                      </div>


                        </div>



                    </div>
                  </div>
                </div>

                <div className="modal fade" tabIndex={-1} id="kt_modal_delete_campaign">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header alert-dismissible bg-light-danger">
                          <h5 className="modal-title"></h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>

                        <div className="modal-body alert-dismissible bg-light-danger">

                        <div>
                          <div className="text-center">
                            <h5 className="fw-bolder fs-1 mb-5">{intl.formatMessage({id: 'GENERAL.DELETE_CAMPAIGN'})} <span style={{color: 'red'}}>({posts.filter((a) => a.selected).length})</span></h5>

                            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

                            <div className="mb-9">
                              {intl.formatMessage({id: 'GENERAL.WANRING_DELETE_POSTS'})}.<br/>
                            </div>
                            <div className="d-flex flex-center flex-wrap">
                              <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">{intl.formatMessage({id: 'GENERAL.CANCEL'})}</button>
                              <button className="btn btn-danger m-2" data-bs-dismiss="modal" onClick={deletePosts.bind(this, selectedCampaign)}>{intl.formatMessage({id: 'GENERAL.OK_GOT_IT'})}</button>
                            </div>
                          </div>
                      </div>


                        </div>



                    </div>
                  </div>
                </div>

                <div className="modal fade" tabIndex={-1} id="kt_modal_5">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header alert-dismissible bg-light-primary">
                          <h5 className="modal-title"></h5>
                          <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr061.svg"
                              className="svg-icon svg-icon-2x"
                            />
                          </div>
                        </div>

                        <div className="modal-body alert-dismissible bg-light-primary">

                        <div>
                          <div className="text-center">
                            <h5 className="fw-bolder fs-1 mb-5">{intl.formatMessage({id: 'GENERAL.DEPLICATE_POSTS'})} <span style={{color: 'red'}}>({posts.filter((a) => a.selected).length})</span></h5>

                            <div className="separator separator-dashed border-danger opacity-25 mb-5"></div>

                            <div className="mb-9">
                              {intl.formatMessage({id: 'GENERAL.WANRING_DEPLICATE_POSTS'})}.<br/>
                            </div>
                            <div className="mb-9">




            {campaigns.map((camp:any) => (<div className='nav-item'>
                <label>
                  {camp.name}

                  <input className="form-check-input" type="checkbox" checked={camp.selected} onClick={(e) => {
                    camp.selected = !camp.selected;
                    setCampaigns([...campaigns]);
                  }}/>
                </label>

            </div>))}

                            </div>
                            <div className="d-flex flex-center flex-wrap">
                              <button className="btn btn-outline btn-outline-danger btn-active-danger m-2" data-bs-dismiss="modal">{intl.formatMessage({id: 'GENERAL.CANCEL'})}</button>
                              <button className="btn btn-primary m-2" data-bs-dismiss="modal" onClick={deplicatePosts.bind(this, selectedCampaign)}>{intl.formatMessage({id: 'GENERAL.DUPLICATE'})}</button>
                            </div>
                          </div>
                      </div>


                        </div>



                    </div>
                  </div>
                </div>



      </div>
    </div>

{selectedCampaign?.name && <>
    {/* Mobile Campaign Warnings - shown above mobile profile section */}
    {(
      getGroupCount(selectedCampaign) === 0 ||
      (selectedCampaign.post_count || 0) === 0 ||
      (selectedCampaign.post_count || 0) === 1
    ) && (
      <div className="mobile-campaign-warnings">
        {getGroupCount(selectedCampaign) === 0 && (
          <div
            className="mobile-campaign-warning"
            onClick={() => document.getElementById('groups-modal-trigger')?.click()}
          >
            <span className="warning-icon">⚠️</span>
            <div className="warning-content">
              <strong>חובה לבחור קבוצות</strong>
              <span>לחץ כאן לבחירת קבוצות</span>
            </div>
            <span className="warning-arrow">←</span>
          </div>
        )}
        {(selectedCampaign.post_count || 0) === 0 && (
          <div
            className="mobile-campaign-warning"
            onClick={() => document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
          >
            <span className="warning-icon">⚠️</span>
            <div className="warning-content">
              <strong>חובה להוסיף פוסטים</strong>
              <span>לחץ כאן להוספת פוסטים</span>
            </div>
            <span className="warning-arrow">←</span>
          </div>
        )}
        {(allCampaignProfiles[selectedCampaign?._id] || []).length === 0 && (
          <div
            className="mobile-campaign-warning"
            onClick={() => document.getElementById('profiles-modal-trigger')?.click()}
          >
            <span className="warning-icon">⚠️</span>
            <div className="warning-content">
              <strong>חובה לבחור פרופיל</strong>
              <span>לחץ כאן לבחירת פרופיל</span>
            </div>
            <span className="warning-arrow">←</span>
          </div>
        )}
        {(selectedCampaign.post_count || 0) === 1 && (
          <div
            className="mobile-campaign-warning recommendation"
            onClick={() => document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
          >
            <span className="warning-icon">💡</span>
            <div className="warning-content">
              <strong>מומלץ להוסיף עוד פוסטים</strong>
              <span>יש לך רק פוסט אחד, לחץ להוספה</span>
            </div>
            <span className="warning-arrow">←</span>
          </div>
        )}
      </div>
    )}

    {/* Campaign Profile Selection Box - Mobile Only */}
    <div className="card mb-5 mobile-only-profile-section" style={{direction: 'rtl'}}>
      <div className="card-body p-4">
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px'}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#1877f2" strokeWidth="2"/>
            <circle cx="9" cy="7" r="4" stroke="#1877f2" strokeWidth="2"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#1877f2" strokeWidth="2"/>
          </svg>
          <h4 style={{margin: 0, fontSize: '15px', fontWeight: 500, color: '#333'}}>בחר את הפרופילים שיפרסמו בקמפיין {selectedCampaign?.name}</h4>
        </div>
        {((allCampaignProfiles[selectedCampaign?._id] || []).length === 0) && (
          <div style={{ fontSize: '12px', color: '#1877f2', fontWeight: 500, marginBottom: '10px' }}>כל הפרופילים ישמשו (ברירת מחדל)</div>
        )}
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
          {allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on)).map((profile: any) => {
            const mobileCampProfiles = allCampaignProfiles[selectedCampaign?._id] || [];
            const mobileNoneSelected = mobileCampProfiles.length === 0;
            const selected = mobileNoneSelected || mobileCampProfiles.includes(profile._id);
            const ownConnected = profile.last_health_check && new Date(profile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
            const parentProfile = profile.parent_profile ? allProfiles.find((p: any) => p._id === profile.parent_profile) : null;
            const parentConnected = parentProfile?.last_health_check && new Date(parentProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
            const isConnected = ownConnected || (profile.parent_profile && parentConnected);
            return (
              <div
                key={profile._id}
                onClick={async () => {
                  let newSelection: string[];
                  if (mobileNoneSelected) {
                    // Select this profile explicitly
                    newSelection = [profile._id];
                  } else if (selected) {
                    newSelection = mobileCampProfiles.filter(id => id !== profile._id);
                  } else {
                    newSelection = [...mobileCampProfiles, profile._id];
                  }
                  // Don't allow deselecting all profiles
                  if (newSelection.length === 0) {
                    setToast({ message: 'לא ניתן להסיר את כל הפרופילים מהקמפיין', type: 'error' });
                    setTimeout(() => setToast(null), 3000);
                    return;
                  }
                  setAllCampaignProfiles(prev => ({ ...prev, [selectedCampaign?._id]: newSelection }));
                  // Auto-save profiles
                  try {
                    await axios.post(`${API_URL}/api/save-campaign-profiles`, {
                      api_token: auth?.api_token,
                      campaign_id: selectedCampaign?._id,
                      users: newSelection
                    });
                  } catch (e) {
                    console.error('Error auto-saving profiles:', e);
                  }
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px 14px',
                  borderRadius: '10px',
                  border: selected ? (mobileNoneSelected ? '1px solid #90caf9' : '2px solid #1877f2') : '1px solid #e0e0e0',
                  backgroundColor: selected ? (mobileNoneSelected ? '#f0f7ff' : '#e7f3ff') : '#fff',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                <div style={{position: 'relative'}}>
                  <img
                    src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=normal&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                    alt=""
                    style={{width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover'}}
                  />
                  <span style={{
                    position: 'absolute',
                    bottom: '0',
                    right: '0',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: isConnected ? '#22c55e' : '#ef4444',
                    border: '2px solid #fff'
                  }}></span>
                </div>
                <span style={{fontWeight: selected ? (mobileNoneSelected ? 500 : 600) : 400, color: selected ? '#1877f2' : '#333'}}>
                  {profile.first_name || profile.facebook_username || 'Unknown'}
                </span>
                {selected && !mobileNoneSelected && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12l5 5L20 7" stroke="#1877f2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>

    {/* Scroll Indicator - Fixed at bottom until posts section is visible */}
    {showScrollIndicator && (
      <div
        className="scroll-indicator"
        onClick={() => document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <div className="scroll-indicator-content">
          <span className="scroll-arrow">↓</span>
          <span className="scroll-text">גלול למטה לצפייה בפוסטים</span>
        </div>
      </div>
    )}

    <div id="posts-section" className="posts-section" style={{direction: 'rtl'}}>
      {/* Posts Header - only show when posts are selected */}
      {posts.filter((a) => a.selected).length > 0 && (
        <div className="posts-header">
          <div className="posts-toolbar">
            <button
              className="post-btn delete"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_4"
            >
              🗑 מחק ({posts.filter((a) => a.selected).length})
            </button>
            <button
              className="post-btn edit"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_5"
            >
              📋 שכפל ({posts.filter((a) => a.selected).length})
            </button>
          </div>
        </div>
      )}

      {/* Loading State */}
      {loadingPosts && (
        <div className="posts-loading">
          <div className="spinner"></div>
          <span>טוען פוסטים...</span>
        </div>
      )}

      {/* Facebook-Style Posts Feed */}
      {!loadingPosts && (
        <>
        {/* Mobile Quick Actions - Above Posts */}
        <div className="mobile-quick-actions">
          <button
            className="mobile-quick-action-btn primary"
            data-onboarding="create-campaign-mobile"
            onClick={() => {
              // Initialize with all active profiles selected
              const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
              setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
              const modalBtn = document.querySelector('[data-bs-target="#kt_modal_1"]') as HTMLElement;
              modalBtn?.click();
            }}
          >
            <span>➕</span>
            קמפיין חדש
          </button>
          {selectedCampaign && (
            <button
              className="mobile-quick-action-btn secondary"
              data-onboarding="groups-button-mobile"
              onClick={() => {
                document.getElementById('groups-modal-trigger')?.click();
              }}
            >
              <span>👥</span>
              {/* Prefer _groupCount: the groups modal writes the figure it displayed into
                  it on save, including the account's own library additions. getGroupCount
                  only knows the campaign's stored ids, so recomputing here replaced a
                  correct number with a smaller one the moment the modal closed. */}
              קבוצות ({selectedCampaign ? (selectedCampaign._groupCount ?? getGroupCount(selectedCampaign)) : 0})
            </button>
          )}
        </div>

        {/* Post search — for campaigns with many posts */}
        {posts.length > 0 && (
          <div style={{display: 'flex', alignItems: 'center', gap: 10, margin: '0 0 12px', flexWrap: 'wrap'}}>
            <div style={{position: 'relative', flex: '0 1 320px', minWidth: 220}}>
              <i className="bi bi-search" style={{position: 'absolute', insetInlineStart: 12, top: '50%', transform: 'translateY(-50%)', color: '#a1a5b7', fontSize: 13}}></i>
              <input
                type="text"
                value={postSearch}
                onChange={(e) => setPostSearch(e.target.value)}
                placeholder="חפש פוסט לפי שם / רחוב / שכונה / תוכן…"
                style={{width: '100%', padding: '8px 36px 8px 30px', border: '1px solid #e4e6ef', borderRadius: 10, fontSize: 13, outline: 'none', direction: 'rtl', background: '#fff'}}
              />
              {postSearch && (
                <button
                  onClick={() => setPostSearch('')}
                  title="נקה חיפוש"
                  style={{position: 'absolute', insetInlineEnd: 8, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', color: '#a1a5b7', cursor: 'pointer', padding: 2}}
                >
                  <i className="bi bi-x-circle-fill" style={{fontSize: 13}}></i>
                </button>
              )}
            </div>
            {postSearch && (
              <span style={{fontSize: 12.5, color: '#7e8299', fontWeight: 600}}>
                מציג {visiblePosts.length} מתוך {posts.length} פוסטים
              </span>
            )}
            {/* Scanning a QR with the phone you're already holding is pointless — hidden on
                mobile, where the normal file picker already offers the camera. */}
            {!isMobileDevice && (
            <button
              onClick={() => openPhoneUpload({ campaignId: campaignID, title: selectedCampaign?.name || 'קמפיין' })}
              title="העלאת תמונות מהטלפון לפוסטים בקמפיין (QR)"
              style={{marginInlineStart: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer'}}
            >
              <i className="bi bi-qr-code" /> 📱 העלאה מהטלפון
            </button>
            )}
          </div>
        )}

        <div className="posts-grid">
          {/* Empty State - No Posts Yet */}
          {posts.length === 0 && (
            <div className="empty-posts-state">
              <div className="empty-posts-icon">📝</div>
              <h3 className="empty-posts-title">אין פוסטים עדיין בקמפיין {selectedCampaign?.name}</h3>
              <p className="empty-posts-text">צור את הפוסט הראשון שלך וזה יפורסם אוטומטית בקבוצות שבחרת</p>
              <button
                className="empty-posts-btn"
                data-onboarding="add-post"
                onClick={openCreatePostModal}
              >
                ➕ צור פוסט ראשון
              </button>
            </div>
          )}

          {/* Add New Post Card - Facebook Style (only show when posts exist) */}
          {posts.length > 0 && (
            <button
              className="add-post-card"
              data-onboarding="add-post"
              onClick={openCreatePostModal}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ flexShrink: 0 }}>
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>לחץ כאן להוספת פוסט לקמפיין {selectedCampaign?.name || ''}</span>
            </button>
          )}

          {/* Bulk Marketplace Upload Button - next to add post */}
          {marketplaceEnabled && posts.filter((p: any) =>
            !p.is_new &&
            !p.converted_to_marketplace_listing_id &&
            !p.marketplace_listing_id &&
            !p.facebook_marketplace_listing_id &&
            (p.media_url || (p.media && p.media.length > 0))
          ).length >= 2 && (
            <button
              onClick={() => setShowBulkMarketplace(true)}
              className="add-post-card"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                borderColor: 'transparent',
              }}
            >
              <span>🛒</span>
              <span>פרסום מרובה במרקטפלייס ({posts.filter((p: any) =>
                !p.is_new &&
                !p.converted_to_marketplace_listing_id &&
                !p.marketplace_listing_id &&
                !p.facebook_marketplace_listing_id &&
                (p.media_url || (p.media && p.media.length > 0))
              ).length} פוסטים)</span>
            </button>
          )}

          {posts.length > 0 && visiblePosts.length === 0 && (
            <div style={{gridColumn: '1 / -1', textAlign: 'center', padding: 30, color: '#a1a5b7', fontSize: 13}}>
              <i className="bi bi-search" style={{fontSize: 24, display: 'block', marginBottom: 6}}></i>
              לא נמצאו פוסטים לחיפוש "{postSearch}"
            </div>
          )}

          {visiblePosts.map((post: any) => (
            <div
              key={post._id || Math.random()}
              className={`fb-post-card ${post.selected ? 'selected' : ''}`}
              style={post.disabled ? { opacity: 0.5, position: 'relative' } : undefined}
            >
              {/* Facebook Post Header */}
              <div className="fb-post-header">
                <div className="fb-post-author">
                  <img
                    className="fb-author-avatar"
                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%231877f2'/%3E%3Ccircle cx='50' cy='40' r='18' fill='%23fff'/%3E%3Cellipse cx='50' cy='85' rx='28' ry='22' fill='%23fff'/%3E%3C/svg%3E"
                    alt=""
                  />
                  <div className="fb-author-info">
                    <div className="fb-author-name">משתמש פייסבוק</div>
                  </div>
                </div>
                <div className="fb-post-actions" style={{ position: 'relative' }}>
                  {post.yad2_token && (
                    <a
                      href={`https://www.yad2.co.il/item/${post.yad2_token}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={post.yad2_delisted ? 'המודעה הוסרה/נמכרה ב-yad2 — הפוסט הושבת ולא יישלח. לחץ לבדיקה' : 'מקור: מודעת yad2 — לחץ לפתיחה'}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '4px',
                        background: post.yad2_delisted ? '#c62828' : '#ff6a00', color: '#fff', fontWeight: 800, fontSize: '11px',
                        lineHeight: 1, padding: '4px 7px', borderRadius: '6px', textDecoration: 'none',
                        marginInlineEnd: '6px',
                      }}
                    >
                      <i className={`bi ${post.yad2_delisted ? 'bi-x-circle' : 'bi-box-arrow-up-right'}`} /> {post.yad2_delisted ? 'הוסר מ-yad2' : 'yad2'}
                    </a>
                  )}
                  {/* Hand-edited: the yad2 sync leaves this post's text alone from here on. */}
                  {post.yad2_token && post.content_edited_at && (
                    <span
                      title={`נערך ידנית ב-${new Date(post.content_edited_at).toLocaleDateString('he-IL')} — סנכרון יד2 לא ידרוס את התוכן. כדי לחזור לגרסת יד2: "רענן נתונים מ-yad2" בתפריט הפוסט.`}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '4px',
                        background: '#dcfce7', color: '#15803d', fontWeight: 800, fontSize: '11px',
                        lineHeight: 1, padding: '4px 7px', borderRadius: '6px',
                        border: '1px solid #86efac', marginInlineEnd: '6px',
                      }}
                    >
                      <i className="bi bi-pencil-fill" /> נערך ידנית
                    </span>
                  )}
                  {editVnActive && (
                    <button
                      className="fb-edit-btn"
                      title="העתקת קישור וואטסאפ לבדיקה (מספר וירטואלי)"
                      onClick={(e) => { e.stopPropagation(); copyPostWaLink(post); }}
                      style={waLinkCopiedId === post._id ? { background: '#e8fff3', color: '#0e9384' } : undefined}
                    >
                      {waLinkCopiedId === post._id ? '✓ הועתק' : '📋 קישור וואטסאפ'}
                    </button>
                  )}
                  {isAdmin && post._id && !String(post._id).startsWith('new_') && (
                    <button
                      className="fb-edit-btn"
                      title="וריאציות לפוסט — נוסחים חלופיים שהבוט מפרסם באקראי (אדמין בלבד)"
                      onClick={(e) => { e.stopPropagation(); setVariationsPostId(String(post._id)); }}
                      style={{ color: '#7c3aed' }}
                    >
                      🔀 וריאציות
                    </button>
                  )}
                  <button
                    className="fb-edit-btn"
                    onClick={() => {
                      setEditingPost(post);
                    }}
                  >
                    ✏️ עריכה
                  </button>
                  <button
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '20px',
                      cursor: 'pointer',
                      padding: '4px 8px',
                      borderRadius: '50%',
                      color: '#65676b',
                      lineHeight: 1,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPostMenuOpen(postMenuOpen === post._id ? null : post._id);
                    }}
                    title="אפשרויות נוספות"
                  >
                    ⋯
                  </button>
                  {postMenuOpen === post._id && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        background: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                        zIndex: 1000,
                        minWidth: '180px',
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0',
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {/* Duplicate */}
                      {!post.is_new && post._id && (
                        <button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 16px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#333',
                            textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          disabled={duplicatingPostId === post._id}
                          onClick={async () => {
                            setDuplicatingPostId(post._id);
                            try {
                              const response = await axios.post(`${API_URL}/duplicate-post`, {
                                api_token: auth?.api_token || '',
                                post_id: post._id,
                              });
                              if (response.data.success) {
                                const newPost = response.data.post;
                                newPost.media = (newPost.media_url || '').split(',').filter((a: string) => a).map((a: string) => convertToCdnUrl(a));
                                setPosts(prev => [...prev, newPost]);
                                setToast({ message: 'הפוסט שוכפל בהצלחה', type: 'success' });
                              }
                            } catch (error) {
                              console.error('Error duplicating post:', error);
                              setToast({ message: 'שגיאה בשכפול הפוסט', type: 'error' });
                            } finally {
                              setDuplicatingPostId(null);
                              setPostMenuOpen(null);
                            }
                          }}
                        >
                          📋 {duplicatingPostId === post._id ? 'משכפל...' : 'שכפל פוסט'}
                        </button>
                      )}
                      {/* yad2: open the source listing to verify the data */}
                      {post.yad2_token && (
                        <a
                          href={`https://www.yad2.co.il/item/${post.yad2_token}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                            padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer',
                            fontSize: '14px', color: '#333', textAlign: 'right', textDecoration: 'none',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          onClick={() => setPostMenuOpen(null)}
                        >
                          🔗 פתח מודעת yad2
                        </a>
                      )}
                      {/* yad2: rebuild this post's data from the source listing */}
                      {post.yad2_token && !post.is_new && post._id && (
                        <button
                          style={{
                            display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                            padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer',
                            fontSize: '14px', color: '#333', textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          disabled={rebuildingPostId === post._id}
                          onClick={async () => {
                            setRebuildingPostId(post._id);
                            try {
                              const response = await axios.post(`${API_URL}/posts/rebuild-yad2`, {
                                api_token: auth?.api_token || '',
                                post_id: post._id,
                              });
                              if (response.data.delisted) {
                                post.disabled = true;
                                post.yad2_delisted = true;
                                setPosts([...posts]);
                                setToast({ message: 'המודעה הוסרה/נמכרה ב-yad2 — הפוסט הושבת', type: 'error' });
                              } else if (response.data.success) {
                                const u = response.data.post;
                                post.post_content = u.post_content;
                                post.name = u.name;
                                if (u.media_url !== undefined) {
                                  post.media_url = u.media_url;
                                  post.media = (u.media_url || '').split(',').filter((a: string) => a).map((a: string) => convertToCdnUrl(a));
                                }
                                if (u.type) post.type = u.type;
                                setPosts([...posts]);
                                setToast({ message: 'נתוני הפוסט עודכנו מ-yad2', type: 'success' });
                              }
                            } catch (error: any) {
                              setToast({ message: error?.response?.data?.error || 'שגיאה ברענון הפוסט', type: 'error' });
                            } finally {
                              setRebuildingPostId(null);
                              setPostMenuOpen(null);
                            }
                          }}
                        >
                          🔄 {rebuildingPostId === post._id ? 'מרענן...' : 'רענן נתונים מ-yad2'}
                        </button>
                      )}
                      {/* Disable/Enable toggle */}
                      {!post.is_new && post._id && (
                        <button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 16px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: post.disabled ? '#2e7d32' : '#e65100',
                            textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          onClick={async () => {
                            try {
                              const newDisabled = !post.disabled;
                              await axios.post(`${API_URL}/toggle-post-disabled`, {
                                api_token: auth?.api_token || '',
                                post_id: post._id,
                                disabled: newDisabled,
                              });
                              post.disabled = newDisabled;
                              setPosts([...posts]);
                              setToast({ message: newDisabled ? 'הפוסט הושבת ולא יתוזמן' : 'הפוסט הופעל מחדש', type: 'success' });
                            } catch (error) {
                              console.error('Error toggling post:', error);
                              setToast({ message: 'שגיאה בעדכון הפוסט', type: 'error' });
                            }
                            setPostMenuOpen(null);
                          }}
                        >
                          {post.disabled ? '▶️ הפעל פוסט' : '⏸️ השבת פוסט'}
                        </button>
                      )}
                      {/* Move to campaign */}
                      {!post.is_new && post._id && (
                        <button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 16px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#333',
                            textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f2f2')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          onClick={() => {
                            setMovingPost(post);
                            setPostMenuOpen(null);
                          }}
                        >
                          📦 העבר לקמפיין אחר
                        </button>
                      )}
                      {/* Delete */}
                      {post.is_new ? (
                        <button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 16px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#e53935',
                            textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#fff5f5')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          onClick={() => {
                            const idx = posts.indexOf(post);
                            if (idx > -1) {
                              posts.splice(idx, 1);
                              setPosts([...posts]);
                            }
                            setPostMenuOpen(null);
                          }}
                        >
                          🗑️ מחק
                        </button>
                      ) : post._id && (
                        <button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100%',
                            padding: '10px 16px',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#e53935',
                            textAlign: 'right',
                          }}
                          className="post-menu-item"
                          onMouseEnter={(e) => (e.currentTarget.style.background = '#fff5f5')}
                          onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                          onClick={() => {
                            // Open the confirm modal programmatically instead of via
                            // Bootstrap's data-bs-toggle data-api: on iOS Safari the
                            // data-api open didn't fire reliably (the tap also closes
                            // this menu), so iPhone users couldn't delete posts. This
                            // matches the getOrCreateInstance().show() pattern used
                            // elsewhere in this file.
                            setSelectedPost(post);
                            setPostMenuOpen(null);
                            const modalEl = document.getElementById('kt_modal_3');
                            if (modalEl) BsModal.getOrCreateInstance(modalEl).show();
                          }}
                        >
                          🗑️ מחק
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Disabled Badge */}
              {post.disabled && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '6px 14px',
                  background: '#fff3e0',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: '#e65100',
                  fontWeight: 500,
                  margin: '0 14px',
                }}>
                  ⏸️ פוסט מושבת - לא יתוזמן
                </div>
              )}

              {/* Post Name Badge */}
              {post.name && (
                <div className="fb-post-name-badge">
                  📌 {post.name}
                </div>
              )}

              {/* Post Strength Badge */}
              {(post.strength || 1) > 1 && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '6px 14px',
                  margin: '0 16px 4px',
                  background: '#fff3e0',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: '#e65100',
                  fontWeight: 500,
                }}>
                  {`פוסט עם עוצמה ${post.strength} יופיע פי ${post.strength} יותר בלוח הזמנים`}
                </div>
              )}

              {/* Marketplace Badge */}
              {(post.converted_to_marketplace_listing_id || post.marketplace_listing_id || post.facebook_marketplace_listing_id) && (
                <div
                  className="fb-marketplace-badge fb-marketplace-badge-clickable"
                  onClick={() => {
                    if (post.facebook_marketplace_url) {
                      window.open(post.facebook_marketplace_url, '_blank');
                    } else if (post.synced_listing_id) {
                      navigate(`/marketplace?listing=${post.synced_listing_id}&tab=info`)
                    } else {
                      navigate(`/marketplace?pending=${post.converted_to_marketplace_listing_id || post.marketplace_listing_id}`)
                    }
                  }}
                  title="לחץ לצפייה במודעה"
                >
                  🏪 מפורסם במרקטפלייס
                </div>
              )}

              {/* Post to Marketplace Button - show for posts without marketplace listing */}
              {marketplaceEnabled && !post.is_new && !post.converted_to_marketplace_listing_id && !post.marketplace_listing_id && !post.facebook_marketplace_listing_id && (
                <button
                  className="fb-post-to-marketplace-btn"
                  onClick={async () => {
                    // Initialize marketplace data for this post
                    const eligibleProfiles = allProfiles.filter((p: any) => p.facebook_id && !p.parent_profile);
                    const marketplaceData: any = {
                      enabled: true,
                      listing_type: MP_DEFAULT_LISTING_TYPE,
                      condition: 'used_good'
                    };
                    // Auto-select profile if only one
                    if (eligibleProfiles.length === 1) {
                      marketplaceData.profile_id = eligibleProfiles[0]._id;
                    }
                    post.marketplace = marketplaceData;
                    setPostToMarketplace({...post});
                    // Auto-fill with AI
                    if (post.post_content) {
                      const result = await syncMarketplaceWithAI(post.post_content, marketplaceData);
                      if (result) {
                        post.marketplace = result;
                        setPostToMarketplace({...post});
                        if (result._suggestedCategory) {
                          handleCategoryChange(result._suggestedCategory);
                        }
                      }
                    }
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '6px 12px',
                    margin: '8px 16px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 500,
                    cursor: 'pointer'
                  }}
                >
                  🛒 פרסם במרקטפלייס
                </button>
              )}

              {/* Post Content */}
              <div className={`fb-post-section fb-post-content-wrapper ${post.expanded ? 'expanded' : ''}`}>
                <div
                  className={`fb-post-content ${!post.expanded ? 'clamped' : ''}`}
                  ref={(el) => {
                    if (el && !post.expanded) {
                      post.isOverflowing = el.scrollHeight > el.clientHeight;
                    }
                  }}
                >
                  {post.post_content}
                </div>
                {!post.expanded && post.isOverflowing && (
                  <span
                    className="fb-see-more"
                    onClick={() => {
                      post.expanded = true;
                      setPosts([...posts]);
                    }}
                  >
                    ראה עוד
                  </span>
                )}
                <button
                  className="fb-section-edit-btn"
                  onClick={() => {
                    setEditingField('content');
                    setEditingPost(post);
                  }}
                >
                  ✏️ עריכה
                </button>
              </div>

              {/* Virtual-number signature — appended automatically to every post.
                  Shown locked here; it's managed on the virtual number page. */}
              {selectedCampaign?.default_signature?.trim() && (
                <div className="fb-post-section" style={{ padding: '0 14px 12px' }}>
                  <div
                    style={{
                      whiteSpace: 'pre-wrap',
                      fontSize: '14px',
                      lineHeight: 1.5,
                      color: '#1c1e21',
                      padding: '10px 12px',
                      background: '#f5f6f8',
                      border: '1px solid #e4e6ef',
                      borderRadius: '10px',
                    }}
                  >
                    {(() => {
                      const vnDdi = (currentUser?.enabled_virtual_number_ddi || '').replace(/\D/g, '');
                      // {wa_link} is a per-post katzr short link minted at publish
                      // (→ l.fbzipper.com → WhatsApp with the tracked prefill), so
                      // here we show its short-link format, not the exact URL.
                      return selectedCampaign.default_signature
                        .replace(/\{number\}/g, vnDdi || '{number}')
                        .replace(/\{wa_link\}/g, 'https://katzr.net/…');
                    })()}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '11px', color: '#8a8d91', marginTop: '5px' }}>
                    <span>🔒</span> חתימה קבועה — מתווספת אוטומטית לכל פוסט (לא ניתנת לעריכה)
                  </div>
                </div>
              )}

              {/* Post Media */}
              {post.media?.length > 0 && (
                <div className="fb-post-section fb-post-media-wrapper">
                  <div className={`fb-post-media ${post.media.length === 1 ? 'single-image' : 'multi-image'} ${post.media.length === 2 ? 'count-2' : ''}`}>
                    {post.media.slice(0, 3).map((media: string, index: number) => {
                      const cdnUrl = convertToCdnUrl(media);
                      const isVideo = /\.(mp4|mov|webm|avi|mkv)$/i.test(cdnUrl);
                      return (
                      <div key={index} className={`fb-media-item ${isVideo ? 'video-item' : ''}`}>
                        {isVideo ? (
                          <div className="video-container" onClick={() => {
                            const imgs = post.media.map((a: string) => convertToCdnUrl(a));
                            setGalleryItems(imgs);
                            setCurrImg(index);
                          }}>
                            <video src={cdnUrl} muted playsInline preload="metadata" />
                            <div className="video-play-button">
                              <svg viewBox="0 0 24 24" fill="white" width="48" height="48">
                                <path d="M8 5v14l11-7z"/>
                              </svg>
                            </div>
                          </div>
                        ) : (
                          <img
                            src={watermarkPreviewSrc(cdnUrl)}
                            alt=""
                            onClick={() => {
                              const imgs = post.media.map((a: string) => convertToCdnUrl(a));
                              setGalleryItems(imgs);
                              setCurrImg(index);
                            }}
                          />
                        )}
                        {index === 2 && post.media.length > 3 && (
                          <div className="fb-more-overlay">+{post.media.length - 3}</div>
                        )}
                      </div>
                    )})}
                  </div>
                  <button
                    className="fb-section-edit-btn"
                    onClick={() => {
                      setEditingField('media');
                      setEditingPost(post);
                    }}
                  >
                    ✏️ עריכה
                  </button>
                </div>
              )}

              {/* Scan-from-phone to upload media — desktop only (see above) */}
              {!isMobileDevice && !post.is_new && post._id && (
                <div style={{ padding: '0 14px 12px' }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openPhoneUpload({ postId: post._id, title: post.name || 'פוסט' });
                    }}
                    style={{
                      width: '100%',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                      padding: '10px 14px',
                      border: '1px dashed #b3a4e0',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, rgba(102,126,234,0.06) 0%, rgba(118,75,162,0.06) 100%)',
                      color: '#5b4bbd',
                      fontSize: '13.5px',
                      fontWeight: 700,
                      cursor: 'pointer',
                    }}
                  >
                    <i className="bi bi-qr-code" style={{ fontSize: '16px' }} />
                    📱 סרקו מהטלפון להעלאת תמונות
                  </button>
                </div>
              )}

              {/* Facebook-style action bar */}
              <div className="fb-action-bar">
                <button className="fb-action-btn">
                  <span className="fb-action-icon">👍</span>
                  לייק
                </button>
                <button className="fb-action-btn">
                  <span className="fb-action-icon">💬</span>
                  תגובה
                </button>
                <button className="fb-action-btn">
                  <span className="fb-action-icon">↗️</span>
                  שיתוף
                </button>
              </div>

              {/* Comment Preview - Shows Reply Text */}
              {(post.reply_text || (!post.reply_text && selectedCampaign?.default_auto_reply)) && (
                <div className="fb-post-section fb-comment-preview">
                  {/* Example user comment */}
                  <div className="fb-comment-item">
                    <div className="fb-comment-avatar user">
                      <svg viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                      </svg>
                    </div>
                    <div className="fb-comment-content">
                      <div className="fb-comment-author">לקוח מתעניין</div>
                      <div className="fb-comment-text">אשמח לפרטים 🙏</div>
                    </div>
                  </div>
                  {/* Auto-reply */}
                  <div className="fb-comment-item reply">
                    <div className="fb-comment-avatar bot">
                      <svg viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                      </svg>
                    </div>
                    <div className="fb-comment-content">
                      <div className="fb-comment-author">התגובה שלך</div>
                      <div className="fb-comment-text">{post.reply_text || selectedCampaign?.default_auto_reply}</div>
                    </div>
                  </div>
                  <div className="fb-comment-label">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    {post.reply_text ? 'תגובה אוטומטית לכל מי שמגיב על הפוסט' : 'תגובה אוטומטית מהגדרות הקמפיין'}
                  </div>
                  <button
                    className="fb-section-edit-btn"
                    onClick={() => {
                      setEditingField('reply');
                      setEditingPost(post);
                    }}
                  >
                    ✏️ עריכה
                  </button>
                </div>
              )}
            </div>
          ))}

          {/* Add New Post Card at End (only show when posts exist) */}
          {posts.length > 0 && (
            <div
              className="add-post-card add-post-card-bottom"
              onClick={openCreatePostModal}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>הוסף פוסט חדש לקמפיין {selectedCampaign?.name}</span>
            </div>
          )}
        </div>
        </>
      )}
    </div>

    {/* Phone photo-upload QR modal */}
    {qrModal && (
      <div
        onClick={() => setQrModal(null)}
        // Above the tutorial layers (spotlight overlay + tooltips sit at 10010-10016).
        // At the old 2000 this opened *underneath* them during the tutorial: the QR was
        // dimmed by the spotlight mask and every click landed on the overlay instead, so
        // the button looked dead exactly when a new user needs it most.
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10050 }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          dir="rtl"
          style={{ background: '#fff', borderRadius: 20, padding: 28, width: '100%', maxWidth: 380, textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.25)' }}
        >
          <h3 style={{ margin: '0 0 4px', color: '#1a1a2e' }}>סרקו להעלאת תמונות</h3>
          <div style={{ color: '#888', fontSize: 13, marginBottom: 20, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{qrModal.title}</div>

          <div style={{ display: 'flex', justifyContent: 'center', minHeight: 200, alignItems: 'center' }}>
            {qrLoading || !qrModal.url ? (
              <div style={{ color: '#aaa' }}>טוען…</div>
            ) : (
              <div style={{ background: '#fff', padding: 12, borderRadius: 12, border: '1px solid #eee' }}>
                <QRCode value={qrModal.url} size={200} />
              </div>
            )}
          </div>

          <p style={{ color: '#666', fontSize: 13, marginTop: 18 }}>
            פתחו את המצלמה בטלפון וסרקו את הקוד. התמונות שתעלו יתווספו לפוסט אוטומטית — והעמוד כאן יתעדכן.
          </p>

          {qrModal.url && (
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <input
                readOnly
                value={qrModal.url}
                onFocus={(e) => e.currentTarget.select()}
                style={{ flex: 1, padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12, color: '#555', direction: 'ltr' }}
              />
              <button
                onClick={() => { navigator.clipboard?.writeText(qrModal.url); }}
                style={{ padding: '8px 12px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
              >
                העתק
              </button>
            </div>
          )}

          <button
            onClick={() => setQrModal(null)}
            style={{ marginTop: 16, padding: '10px 24px', borderRadius: 10, border: '1px solid #ccc', background: 'transparent', color: '#1a1a2e', fontSize: 14, cursor: 'pointer' }}
          >
            סגור
          </button>
        </div>
      </div>
    )}

    {/* Admin: bulk reverse-by-date of the virtual-number contact replace */}
    {showVnRevert && isAdmin && <VnRevertModal onClose={() => setShowVnRevert(false)} />}

    {/* Admin: take the WhatsApp links out of this campaign's post bodies */}
    {showWaStrip && isAdmin && selectedCampaign?._id && (
      <WaLinkStripModal
        campaignId={String(selectedCampaign._id)}
        campaignName={selectedCampaign.name}
        onClose={() => setShowWaStrip(false)}
        onApplied={refreshPostsMedia}
      />
    )}

    {/* Edit Post Modal */}
    {editingPost && (
      <div className="fb-edit-modal-backdrop" onClick={(e) => e.stopPropagation()}>
        <div className="fb-edit-modal" style={{direction: 'rtl'}} onClick={(e) => e.stopPropagation()}>
          <div className="fb-modal-header">
            <button className="fb-modal-close" onClick={closeCreatePostModal}>×</button>
            <h3>{editingPost.is_new ? 'יצירת פוסט' : 'עריכת פוסט'}</h3>
            {isAdmin && !editingPost.is_new && !String(editingPost._id || '').startsWith('new_') && (
              <div
                style={{
                  position: 'absolute', top: '14px', insetInlineStart: '16px',
                  display: 'flex', alignItems: 'center', gap: '8px',
                }}
              >
                {/* The post's id, so a support conversation or a DB lookup can name
                    the exact document. Admin-only, and click to copy. */}
                <button
                  type="button"
                  onClick={() => {
                    const id = String(editingPost._id || '');
                    navigator.clipboard?.writeText(id);
                    setCopiedPostId(true);
                    window.setTimeout(() => setCopiedPostId(false), 1500);
                  }}
                  title="מזהה הפוסט (אדמין בלבד) — לחצו להעתקה"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    padding: '6px 10px', borderRadius: '8px', border: '1px solid #e2e8f0',
                    background: copiedPostId ? '#dcfce7' : '#f8fafc',
                    color: copiedPostId ? '#15803d' : '#475569',
                    fontWeight: 600, fontSize: '11.5px', cursor: 'pointer',
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    direction: 'ltr',
                  }}
                >
                  <i className={copiedPostId ? 'bi bi-check-lg' : 'bi bi-hash'} />
                  {copiedPostId ? 'הועתק' : String(editingPost._id || '')}
                </button>
                <button
                  type="button"
                  onClick={openPostHistory}
                  title="היסטוריית שינויים ושחזור (אדמין בלבד)"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    padding: '6px 12px', borderRadius: '8px', border: '1px solid #c7d2fe',
                    background: '#eef2ff', color: '#4338ca', fontWeight: 700, fontSize: '12.5px',
                    cursor: 'pointer',
                  }}
                >
                  <i className="bi bi-clock-history" /> היסטוריה
                </button>
                <button
                  type="button"
                  onClick={() => setVariationsPostId(String(editingPost._id))}
                  title="וריאציות לפוסט — נוסחים חלופיים שהבוט מפרסם באקראי (אדמין בלבד)"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    padding: '6px 12px', borderRadius: '8px', border: '1px solid #ddd6fe',
                    background: '#f5f3ff', color: '#7c3aed', fontWeight: 700, fontSize: '12.5px',
                    cursor: 'pointer',
                  }}
                >
                  <i className="bi bi-shuffle" /> וריאציות
                </button>
              </div>
            )}
          </div>
          {postHistory && (
            <div onClick={() => setPostHistory(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
              <div onClick={(e) => e.stopPropagation()} style={{ direction: 'rtl', background: '#fff', borderRadius: '14px', width: 'min(680px, 96vw)', maxHeight: '86vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #eee' }}>
                  <div style={{ fontWeight: 800, fontSize: '16px', color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="bi bi-clock-history" style={{ color: '#4338ca' }} /> היסטוריית גרסאות
                    <span style={{ fontSize: '11px', fontWeight: 700, color: '#4338ca', background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: '6px', padding: '2px 8px' }}>אדמין</span>
                  </div>
                  <button onClick={() => setPostHistory(null)} style={{ border: 'none', background: 'transparent', fontSize: '22px', cursor: 'pointer', color: '#888', lineHeight: 1 }}>×</button>
                </div>
                <div style={{ padding: '16px 20px', overflowY: 'auto' }}>
                  {postHistoryLoading ? (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>טוען…</div>
                  ) : (!postHistory.versions || postHistory.versions.length === 0) ? (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>אין עדיין גרסאות שמורות לפוסט זה.</div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {postHistory.versions.map((v: any) => (
                        <div key={v._id} style={{ border: '1px solid #e5e7eb', borderRadius: '10px', padding: '12px 14px', background: '#fafafa' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', marginBottom: '8px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                              <span style={{ fontSize: '11px', fontWeight: 700, color: '#374151', background: '#eef2ff', borderRadius: '6px', padding: '2px 8px' }}>{historySourceLabel(v.source)}</span>
                              <span style={{ fontSize: '12px', color: '#6b7280' }}>{new Date(v.created_at).toLocaleString('he-IL')}</span>
                            </div>
                            <button onClick={() => restorePostVersion(v._id)} disabled={restoringVersionId === v._id} style={{ flexShrink: 0, padding: '6px 14px', borderRadius: '8px', border: 'none', background: restoringVersionId === v._id ? '#9ca3af' : '#4338ca', color: '#fff', fontWeight: 700, fontSize: '12.5px', cursor: restoringVersionId === v._id ? 'wait' : 'pointer' }}>
                              {restoringVersionId === v._id ? 'משחזר…' : 'שחזר'}
                            </button>
                          </div>
                          {v.name ? <div style={{ fontWeight: 700, fontSize: '13px', color: '#1a1a2e', marginBottom: '4px' }}>{v.name}</div> : null}
                          <div style={{ fontSize: '13px', color: '#374151', whiteSpace: 'pre-wrap', maxHeight: '120px', overflowY: 'auto', lineHeight: 1.5 }}>{v.post_content || <span style={{ color: '#9ca3af' }}>(ללא תוכן)</span>}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="fb-modal-body" ref={(el) => {
            // Scroll to and highlight the field when modal opens
            if (el && editingField) {
              setTimeout(() => {
                const field = el.querySelector(`[data-field="${editingField}"]`);
                if (field) {
                  field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  field.classList.add('highlight');
                  const input = field.querySelector('textarea, input');
                  if (input) (input as HTMLElement).focus();
                  setTimeout(() => field.classList.remove('highlight'), 2000);
                }
                setEditingField(null);
              }, 100);
            }
          }}>
            {editingPost.yad2_token && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap',
                background: editingPost.content_edited_at ? '#f0fdf4' : '#eff6ff',
                border: `1px solid ${editingPost.content_edited_at ? '#86efac' : '#bfdbfe'}`,
                borderRadius: '10px', padding: '12px 14px', marginBottom: '16px',
              }}>
                <div style={{flex: '1 1 240px', minWidth: 0}}>
                  <div style={{fontWeight: 800, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px',
                    color: editingPost.content_edited_at ? '#15803d' : '#1d4ed8'}}>
                    <i className={`bi ${editingPost.content_edited_at ? 'bi-pencil-fill' : 'bi-arrow-repeat'}`} />
                    {editingPost.content_edited_at ? 'הפוסט הזה נערך ידנית — הסנכרון לא ידרוס אותו' : 'תוכן הפוסט מגיע מיד2'}
                  </div>
                  <div style={{fontSize: '12.5px', marginTop: '4px', lineHeight: 1.5,
                    color: editingPost.content_edited_at ? '#166534' : '#1e40af'}}>
                    {editingPost.content_edited_at
                      ? 'סנכרון נכסים מיד2 ימשיך להוסיף נכסים חדשים ולהסיר נכסים שנמכרו, אבל את התוכן של הפוסט הזה הוא ישאיר בדיוק כפי שכתבת. כדי לחזור לגרסה של יד2 — "רענן נתונים מ-yad2" בתפריט הפוסט.'
                      : 'כל עוד לא ערכת אותו, כל סנכרון מרענן את התוכן מיד2. ברגע שתערוך ותשמור — הגרסה שלך נשמרת, וסנכרונים הבאים לא יחליפו אותה.'}
                  </div>
                </div>
              </div>
            )}
            <div className={`fb-modal-field ${wizardFieldClass('name')}`} data-field="name">
              <label>
                שם הפוסט
                {currentUser?.library_occupation === 'real_estate'
                  ? ' *'
                  : !isTutorialMode && ' (לא חובה)'}
              </label>
              <input
                type="text"
                placeholder="תן שם לפוסט שלך..."
                value={editingPost.name || ''}
                onChange={(e) => {
                  editingPost.name = e.target.value;
                  editingPost.updated = true;
                  setEditingPost({...editingPost});
                }}
              />
            </div>

            <div className={`fb-modal-field ${wizardFieldClass('content')}`} data-field="content">
              <label>
                <span>תוכן הפוסט</span>
                <span className="fb-example-tooltip-wrapper">
                  <span className="fb-example-link">📷 ראה דוגמה</span>
                  <span className="fb-example-tooltip">
                    <img src="/media/example-post.jpeg" alt="דוגמה לפוסט" />
                  </span>
                </span>
              </label>
              <div className="fb-textarea-wrapper">
                <button
                  type="button"
                  className="fb-ai-enhance-btn"
                  onClick={enhancePostWithAI}
                  disabled={!editingPost.post_content || aiEnhancing}
                >
                  {aiEnhancing ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      משפר...
                    </>
                  ) : (
                    <>
                      ✨ שפר עם AI
                    </>
                  )}
                </button>
                <DebouncedTextarea
                  placeholder={vnPinnedBlock ? POST_BODY_PLACEHOLDER : `לדוגמה:
💫 חדש למכירה בבלעדיות 💫
⭐️ בשכונת קרית עבודה מרכז חולון
⭐️ דירה 3.5 חדרים גדולה כמו 4 חדרים
⭐️ מושכרת ב- 5,000 ש״ח
⭐️ מחיר מציאה לרציניים !!!!
📞 לתיאום פגישה בנכס - 052-455-1715`}
                  value={vnPinnedBlock ? vnBodyText : (editingPost.post_content || '')}
                  style={{
                    // Sit flush on the pinned block below so the two read as one field.
                    ...(vnPinnedBlock ? {borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 'none', marginBottom: 0} : {}),
                  }}
                  onCommit={(next) => {
                    // With a pinned block the textarea edits only the BODY; the block is
                    // re-joined on the way into post_content, so it always saves with the
                    // post and can never be typed over. (joinVnBody is a no-op when there
                    // is no pinned block.)
                    editingPost.post_content = joinVnBody(scrubPhones(next), vnPinnedBlock);
                    editingPost.updated = true;
                    setEditingPost({...editingPost});
                  }}
                />
                {vnPinnedBlock && (
                  <div
                    title="פרטי הקשר מתווספים אוטומטית לסוף הפוסט"
                    style={{
                      border: '1px solid #dfe1e6', borderTop: '1px dashed #dfe1e6',
                      borderBottomLeftRadius: 8, borderBottomRightRadius: 8,
                      background: '#fafbfc', padding: '10px 12px 12px',
                      font: 'inherit', fontSize: 14, lineHeight: 1.5, color: '#1c1e21',
                      whiteSpace: 'pre-wrap', wordBreak: 'break-word', cursor: 'not-allowed', userSelect: 'none',
                    }}
                  >
                    {vnPinnedBlock}
                    <div style={{marginTop: 8, fontSize: 11.5, color: '#8a8d91', display: 'flex', alignItems: 'center', gap: 5}}>
                      <span>🔒</span>
                      <span>פרטי הקשר נשמרים כחלק מהפוסט ואי אפשר לערוך אותם</span>
                    </div>
                  </div>
                )}
                {postPhoneError && phoneErrorBox(postPhoneError, 'בתוכן הפוסט')}
                {editVnContactMissing && (
                  <div style={{
                    marginTop: '8px', color: '#d32f2f', fontSize: '13px', fontWeight: 600,
                    display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap',
                    background: '#ffebee', border: '1px solid #ffcdd2', borderRadius: '8px', padding: '8px 10px',
                  }}>
                    <span>⛔</span>
                    <span>
                      {editVnRequired
                        ? 'יש להוסיף לפוסט את המספר הווירטואלי ואת קישור הוואטסאפ לפני השמירה.'
                        : 'יש להוסיף לפוסט את המספר הווירטואלי ואת קישור הוואטסאפ.'}
                    </span>
                    {(editVnDid || editVnDisplayLink) && (
                      <div style={{width: '100%', display: 'flex', flexDirection: 'column', gap: '4px', fontWeight: 500, color: '#7a1f1f'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '6px', direction: 'ltr', justifyContent: 'flex-end'}}>
                          <button type="button" title="העתק מספר" onClick={() => copyToClipboard(editVnDid, 'המספר')}
                            style={{border: '1px solid #e0aeae', background: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 12, padding: '1px 6px'}}>📋</button>
                          <span style={{fontFamily: 'monospace'}}>{editVnDid || '—'}</span>
                          <span>📞</span>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: '6px', direction: 'ltr', justifyContent: 'flex-end'}}>
                          <button type="button" title="העתק קישור" onClick={() => copyToClipboard(editVnDisplayLink, 'הקישור')}
                            style={{border: '1px solid #e0aeae', background: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 12, padding: '1px 6px'}}>📋</button>
                          <span style={{fontFamily: 'monospace', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{editVnDisplayLink || '—'}</span>
                          <span>🔗</span>
                        </div>
                      </div>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-primary py-1 px-3"
                      style={{fontSize: '12px'}}
                      onClick={insertVirtualNumber}
                      disabled={insertingVn}
                    >
                      {insertingVn ? 'מוסיף…' : '✨ הוסף מספר וירטואלי'}
                    </button>
                  </div>
                )}
              </div>
              {waLinkControls('content')}
              <div className="fb-post-content-actions">
                <span className="fb-field-hint">
                  {editVnActive
                    ? VN_EXPLAINER
                    : 'לא לשכוח להשאיר מספר טלפון, לינק לאתר או קישור לוואטסאפ בתוכן הפוסט כדי שיוכלו ליצור איתך קשר'}
                </span>
              </div>
            </div>

            {/* Post Strength Selector — hidden during the tutorial (not relevant for a first post),
                and for now everywhere unless the admin switch is on (/admin/settings). */}
            {!isTutorialMode && (postStrengthEnabled || currentUser?.uses_post_strength) && (
            <div className="fb-modal-field" data-field="strength" style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#65676b', marginBottom: '8px' }}>
                תדירות פרסום (כמה פעמים יופיע בלוח הזמנים בהשוואה לפוסטים אחרים)
              </label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {[1, 2, 3, 4, 5].map(val => (
                  <button
                    key={val}
                    type="button"
                    onClick={() => {
                      const updated = { ...editingPost, strength: val, updated: true };
                      setEditingPost(updated);
                    }}
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      border: (editingPost.strength || 1) === val ? '2px solid #1877f2' : '2px solid #ddd',
                      background: (editingPost.strength || 1) === val ? '#e3f2fd' : '#fff',
                      color: (editingPost.strength || 1) === val ? '#1877f2' : '#666',
                      fontWeight: 700,
                      fontSize: '14px',
                      cursor: 'pointer',
                    }}
                  >
                    {val}
                  </button>
                ))}
              </div>
              <small style={{ color: '#999', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                למשל: בחירת 3 תגרום לפוסט הזה להופיע פי 3 יותר בהשוואה לפוסטים אחרים
              </small>
            </div>
            )}

            {/* Post type: album (images, default) vs text-background (no images) */}
            <div className={`fb-modal-field ${wizardExtraDimClass()}`} data-field="post-type" style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#65676b', marginBottom: '8px' }}>
                סוג הפוסט
              </label>
              <div style={{ display: 'flex', gap: '8px' }}>
                {[
                  { key: 'album', label: '🖼️ אלבום (תמונות)' },
                  { key: 'text-background', label: '🎨 טקסט + רקע (ללא תמונות)' },
                ].map(opt => {
                  const isTextBg = editingPost.type === 'text-background';
                  const selected = opt.key === 'text-background' ? isTextBg : !isTextBg;
                  return (
                    <button
                      key={opt.key}
                      type="button"
                      onClick={() => {
                        const updated: any = { ...editingPost, type: opt.key, updated: true };
                        if (opt.key === 'text-background') updated.media = [];
                        setEditingPost(updated);
                      }}
                      style={{
                        flex: 1,
                        padding: '10px 12px',
                        borderRadius: '8px',
                        border: selected ? '2px solid #1877f2' : '2px solid #ddd',
                        background: selected ? '#e7f3ff' : '#fff',
                        color: selected ? '#1877f2' : '#666',
                        fontWeight: 600,
                        fontSize: '13px',
                        cursor: 'pointer',
                      }}
                    >
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {editingPost.type === 'text-background' ? (
              <div className="fb-modal-field" style={{ marginBottom: '12px' }}>
                <div style={{ padding: '14px', background: '#f0f2f5', borderRadius: '8px', fontSize: '13px', color: '#65676b', textAlign: 'center' }}>
                  🎨 טקסט + רקע — מתפרסם כסטטוס עם רקע, ללא תמונות.
                </div>
                {/* FB only renders the colored background for text up to 130 chars.
                    Above that it silently posts plain text — warn the user here. */}
                {(editingPost.post_content || '').length > 130 && (
                  <div style={{
                    marginTop: '8px', color: '#b26a00', fontSize: '13px', fontWeight: 600,
                    display: 'flex', alignItems: 'center', gap: '6px',
                    background: '#fff8e1', border: '1px solid #ffe0a3', borderRadius: '8px', padding: '8px 10px',
                  }}>
                    <span>⚠️</span>
                    <span>
                      הטקסט ארוך מדי לרקע צבעוני ({(editingPost.post_content || '').length}/130 תווים).
                      פייסבוק מפרסמת רקע רק עד 130 תווים — מעבר לכך הפוסט יתפרסם כטקסט רגיל ללא רקע.
                      קצר את הטקסט כדי לשמור על הרקע הצבעוני.
                    </span>
                  </div>
                )}
              </div>
            ) : (
            <div className={`fb-modal-media ${wizardFieldClass('media')}`} data-field="media">
              <label style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#65676b', marginBottom: '8px'}}>
                <span>תמונות / סרטונים ({editingPost.media?.length || 0})</span>
                <span className="fb-example-tooltip-wrapper">
                  <span className="fb-example-link">📷 ראה דוגמה</span>
                  <span className="fb-example-tooltip">
                    <img src="/media/example-media.jpeg" alt="דוגמה לתמונות" />
                  </span>
                </span>
              </label>
              {editingPost.media?.length > 0 && (
                <div className="fb-media-preview">
                  {editingPost.media.map((media: string, index: number) => {
                    const cdnUrl = convertToCdnUrl(media);
                    const isVideo = /\.(mp4|mov|webm|avi|mkv)$/i.test(cdnUrl);
                    return (
                    <div key={index} className={`fb-media-item ${isVideo ? 'video-item' : ''}`}>
                      {isVideo ? (
                        <div className="video-container">
                          {/* #t=0.1 makes the browser seek and paint a real frame;
                              preload="metadata" alone leaves many MP4s a black tile. */}
                          <video src={`${cdnUrl}#t=0.1`} muted playsInline preload="metadata" />
                          <div className="video-play-button small">
                            <svg viewBox="0 0 24 24" fill="white" width="32" height="32">
                              <path d="M8 5v14l11-7z"/>
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <img
                          src={cdnUrl}
                          alt=""
                        />
                      )}
                      <span className="fb-media-number">{index + 1}</span>
                      <button
                        className="fb-media-remove"
                        onClick={() => {
                          editingPost.media.splice(index, 1);
                          editingPost.updated = true;
                          setEditingPost({...editingPost});
                        }}
                      >×</button>
                      <div className="fb-media-order">
                        {editingPost.media.length > 1 && (
                          <button onClick={() => {
                            const media = editingPost.media;
                            if (index > 0) {
                              [media[index], media[index - 1]] = [media[index - 1], media[index]];
                            } else {
                              const item = media.splice(0, 1)[0];
                              media.push(item);
                            }
                            setEditingPost({...editingPost});
                          }}>→</button>
                        )}
                        {editingPost.media.length > 1 && (
                          <button onClick={() => {
                            const media = editingPost.media;
                            if (index < media.length - 1) {
                              [media[index], media[index + 1]] = [media[index + 1], media[index]];
                            } else {
                              const item = media.splice(index, 1)[0];
                              media.unshift(item);
                            }
                            setEditingPost({...editingPost});
                          }}>←</button>
                        )}
                      </div>
                    </div>
                  )})}
                </div>
              )}
              <StyledDropzone
                post={editingPost}
                onUploaded={(url: string) => setEditingPost((prev: any) =>
                  prev ? {...prev, media: [...(prev.media || []), url], updated: true} : prev
                )}
              />
              {/* Phone upload. A saved post deep-links straight to itself; a post still
                  being composed has no id, so it uses a draft staging bucket keyed by a
                  client-minted id and the photos are pulled in as they arrive. */}
              {!isMobileDevice && (
              <button
                type="button"
                onClick={() => openEditorPhoneUpload()}
                style={{
                  marginTop: 10, width: '100%', padding: '10px 14px', borderRadius: 8,
                  background: '#fff', color: '#2b70fa', border: '1px solid #2b70fa',
                  fontWeight: 600, fontSize: 13, cursor: 'pointer',
                }}
              >
                📱 העלאת תמונות מהטלפון (סריקת QR)
              </button>
              )}
            </div>
            )}

            <div className={`fb-modal-field ${wizardFieldClass('reply')}`} data-field="reply">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>תגובה אוטומטית</span>
                <span className="fb-example-tooltip-wrapper">
                  <span className="fb-example-link">📷 ראה דוגמה</span>
                  <span className="fb-example-tooltip">
                    <img src="https://fbzipper.com/example-reply.jpeg" alt="דוגמה לתגובה אוטומטית" />
                  </span>
                </span>
              </label>
              <span className="fb-form-hint" style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                אם תמלאו את שדה "תגובה אוטומטית", המערכת תתייג כל מי שהגיב לפוסט ותשלח לו את התגובה שהגדרתם – באופן אוטומטי.
              </span>
              {selectedCampaign?.default_auto_reply && !editingPost.reply_text && (
                <div style={{
                  padding: '8px 12px', marginBottom: '8px', borderRadius: '6px',
                  background: 'rgba(54, 153, 255, 0.08)', border: '1px solid rgba(54, 153, 255, 0.2)',
                  fontSize: '12px', color: '#3699ff', display: 'flex', alignItems: 'center', gap: '6px'
                }}>
                  <span>💬</span>
                  <span>משתמש בתגובה גלובלית מהגדרות הקמפיין: "<strong>{selectedCampaign.default_auto_reply.substring(0, 60)}{selectedCampaign.default_auto_reply.length > 60 ? '...' : ''}</strong>"</span>
                </div>
              )}
              <div className="fb-textarea-wrapper">
                <button
                  type="button"
                  className="fb-ai-enhance-btn"
                  onClick={generateReplyWithAI}
                  disabled={aiGeneratingReply}
                >
                  {aiGeneratingReply ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      יוצר...
                    </>
                  ) : (
                    <>
                      ✨ צור עם AI
                    </>
                  )}
                </button>
                <DebouncedTextarea
                  placeholder={`לדוגמה: היי בבקשה, לפרטים נוספים השאירו הודעה בווצאפ דרך הלינק הבא 👈 https://wa.me/124124
או במספר 0534550302
דניאל נכסים`}
                  value={vnPinnedReplyBlock ? vnReplyBodyText : (editingPost.reply_text || '')}
                  style={vnPinnedReplyBlock
                    ? {borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 'none', marginBottom: 0}
                    : undefined}
                  onCommit={(next) => {
                    editingPost.reply_text = joinVnBody(scrubPhones(next), vnPinnedReplyBlock);
                    editingPost.updated = true;
                    setEditingPost({...editingPost});
                  }}
                />
                {vnPinnedReplyBlock && (
                  <div
                    title="פרטי הקשר מתווספים אוטומטית לסוף התגובה"
                    style={{
                      border: '1px solid #dfe1e6', borderTop: '1px dashed #dfe1e6',
                      borderBottomLeftRadius: 8, borderBottomRightRadius: 8,
                      background: '#fafbfc', padding: '10px 12px 12px',
                      font: 'inherit', fontSize: 14, lineHeight: 1.5, color: '#1c1e21',
                      whiteSpace: 'pre-wrap', wordBreak: 'break-word', cursor: 'not-allowed', userSelect: 'none',
                    }}
                  >
                    {vnPinnedReplyBlock}
                    <div style={{marginTop: 8, fontSize: 11.5, color: '#8a8d91', display: 'flex', alignItems: 'center', gap: 5}}>
                      <span>🔒</span>
                      <span>פרטי הקשר נשמרים כחלק מהתגובה ואי אפשר לערוך אותם</span>
                    </div>
                  </div>
                )}
                {replyPhoneError && phoneErrorBox(replyPhoneError, 'בתגובה האוטומטית')}
                {waLinkControls('reply')}
                {editVnActive && (
                  <span className="fb-field-hint" style={{display: 'block', marginTop: 8}}>{VN_EXPLAINER}</span>
                )}
              </div>
            </div>

            {/* Marketplace Section - Show for new posts (if enabled), during tutorial (as wizard step), or posts with existing marketplace data */}
            {(((isTutorialMode || marketplaceEnabled) && editingPost.is_new && marketplaceCheckboxShown) || editingPost.converted_to_marketplace_listing_id || editingPost.marketplace_listing_id || editingPost.facebook_marketplace_listing_id || editingPost.marketplace?.enabled) && (
              <div className={`fb-marketplace-section ${marketplaceWizardClass()}`} data-field="marketplace">
                {/* If post already has a marketplace listing, show status instead of checkbox */}
                {(editingPost.facebook_marketplace_listing_id || editingPost.converted_to_marketplace_listing_id || editingPost.marketplace_listing_id) && !editingPost.is_new ? (
                  <div className="fb-marketplace-status">
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#4caf50', fontWeight: 600 }}>
                      <span style={{ fontSize: '18px' }}>✓</span>
                      🛒 מפורסם במרקטפלייס
                    </span>
                    {editingPost.facebook_marketplace_url && (
                      <a
                        href={editingPost.facebook_marketplace_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '12px', color: '#1877f2', marginTop: '4px', display: 'block' }}
                      >
                        צפה במודעה בפייסבוק →
                      </a>
                    )}
                  </div>
                ) : (
                <>
                <label className="fb-marketplace-toggle">
                  <input
                    type="checkbox"
                    checked={editingPost.marketplace?.enabled || false}
                    onChange={async (e) => {
                      const isEnabled = e.target.checked;
                      editingPost.marketplace = {
                        ...editingPost.marketplace,
                        enabled: isEnabled,
                        listing_type: editingPost.marketplace?.listing_type || MP_DEFAULT_LISTING_TYPE,
                        condition: editingPost.marketplace?.condition || 'used_good',
                        // Default the marketplace auto-reply to the post's own auto-reply.
                        auto_reply_message: editingPost.marketplace?.auto_reply_message || editingPost.reply_text || ''
                      };
                      editingPost.updated = true;
                      setEditingPost({...editingPost});

                      // If enabling marketplace and there's content, call AI to fill fields
                      if (isEnabled && editingPost.post_content) {
                        const result = await syncMarketplaceWithAI(editingPost.post_content, editingPost.marketplace);
                        if (result) {
                          editingPost.marketplace = result;
                          // Keep the post's auto-reply as the marketplace default if AI didn't set one.
                          if (!editingPost.marketplace.auto_reply_message) {
                            editingPost.marketplace.auto_reply_message = editingPost.reply_text || '';
                          }
                          editingPost.updated = true;
                          setEditingPost({...editingPost});
                          // Load category attributes if a category was suggested
                          if (result._suggestedCategory) {
                            handleCategoryChange(result._suggestedCategory);
                          }
                        }
                      }

                      // Scroll to marketplace options when enabled
                      if (isEnabled) {
                        setTimeout(() => {
                          document.getElementById('marketplace-options')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }, 100);
                      }
                    }}
                  />
                  <span>🛒 סמנו כאן כדי לפרסם גם במרקטפלייס</span>
                </label>
                {!editingPost.marketplace?.enabled && (
                  <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    ℹ️ יש לסמן את התיבה למעלה כדי שהפוסט יתפרסם גם במרקטפלייס
                  </div>
                )}
                </>
                )}

                {/* AI Loading Animation */}
                {aiFillingMarketplace && (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    borderRadius: '12px',
                    marginTop: '16px'
                  }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      border: '4px solid #3b82f6',
                      borderTopColor: 'transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginBottom: '16px'
                    }}></div>
                    <span style={{ fontSize: '16px', fontWeight: 600, color: '#1e40af' }}>
                      🤖 ממלא פרטי מרקטפלייס אוטומטית...
                    </span>
                    <span style={{ fontSize: '13px', color: '#3b82f6', marginTop: '8px' }}>
                      מנתח את תוכן הפוסט ומזהה סוג, מחיר וקטגוריה
                    </span>
                  </div>
                )}

                {(editingPost.marketplace?.enabled || editingPost.facebook_marketplace_listing_id || editingPost.converted_to_marketplace_listing_id || editingPost.marketplace_listing_id) && !aiFillingMarketplace && (
                  <div id="marketplace-options" className="fb-marketplace-options">
                    {/* AI Resync Button - hidden during tutorial */}
                    {!isTutorialMode && editingPost.marketplace?.enabled && editingPost.post_content && (
                      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                          type="button"
                          style={{
                            background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 12px',
                            fontSize: '12px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            opacity: aiFillingMarketplace ? 0.6 : 1
                          }}
                          disabled={aiFillingMarketplace}
                          onClick={async () => {
                            const result = await syncMarketplaceWithAI(editingPost.post_content, editingPost.marketplace);
                            if (result) {
                              editingPost.marketplace = result;
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                              // Load category attributes if a category was suggested
                              if (result._suggestedCategory) {
                                handleCategoryChange(result._suggestedCategory);
                              }
                            }
                          }}
                        >
                          {aiFillingMarketplace ? (
                            <>
                              <span style={{ display: 'inline-block', width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></span>
                              ממלא...
                            </>
                          ) : (
                            <>✨ עדכן עם AI</>
                          )}
                        </button>
                      </div>
                    )}
                    {!isTutorialMode && <div className="fb-modal-field" data-field="mp-profile">
                      {(() => {
                        // Inline circles instead of a dropdown: the old dropdown was
                        // position:fixed and placed once on open, so scrolling the modal
                        // left it floating over the wrong spot. Everything is visible and
                        // scrolls with the form, and every profile starts selected.
                        const mpOnlineCutoff = Date.now() - 5 * 60 * 1000;
                        const isOnline = (p: any) => !!(p.last_health_check && new Date(p.last_health_check).getTime() >= mpOnlineCutoff);
                        const selectedIds = mpSelectedIds(editingPost.marketplace);
                        const applyMpIds = (next: string[]) => {
                          editingPost.marketplace = {
                            ...editingPost.marketplace,
                            profile_ids: next,
                            profile_id: next[0] || '',
                          };
                          editingPost.updated = true;
                          setEditingPost({...editingPost});
                        };
                        const toggleMpProfile = (id: string) => {
                          const isSel = selectedIds.includes(id);
                          // Never leave the listing with nobody to publish it — the last
                          // selected circle can't be turned off.
                          if (isSel && selectedIds.length === 1) return;
                          applyMpIds(isSel ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);
                        };
                        const allSelected = mpDefaultProfileIds.length > 0 && selectedIds.length === mpDefaultProfileIds.length;
                        return (
                          <>
                            <label style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span>פרופילים לפרסום *</span>
                              <span style={{color: '#65676b', fontWeight: 400, fontSize: '12px'}}>
                                ({selectedIds.length}/{mpDefaultProfileIds.length})
                              </span>
                              {mpDefaultProfileIds.length > 1 && (
                                <button
                                  type="button"
                                  className="fb-profile-circles-all"
                                  onClick={() => applyMpIds(allSelected ? [selectedIds[0]] : mpDefaultProfileIds)}
                                >
                                  {allSelected ? 'בחר אחד' : 'בחר הכל'}
                                </button>
                              )}
                            </label>
                            {mpEligibleProfiles.length === 0 ? (
                              <p style={{color: '#999', fontSize: '13px', margin: 0}}>אין פרופילים מחוברים</p>
                            ) : (
                              <div className="fb-profile-circles">
                                {mpEligibleProfiles.map((profile: any) => {
                                  const id = String(profile._id);
                                  const isSel = selectedIds.includes(id);
                                  return (
                                    <button
                                      type="button"
                                      key={id}
                                      className={`fb-profile-circle ${isSel ? 'selected' : ''}`}
                                      onClick={() => toggleMpProfile(id)}
                                      title={`${profile.first_name || ''} ${profile.last_name || ''}`.trim() + (isOnline(profile) ? ' — מחובר' : ' — לא מחובר כרגע, הפרסום ימתין')}
                                    >
                                      <span className="fb-profile-circle-img">
                                        <img
                                          src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                          alt=""
                                        />
                                        <i className={`fb-profile-circle-dot ${isOnline(profile) ? 'online' : ''}`}></i>
                                        {isSel && <i className="bi bi-check-lg fb-profile-circle-check"></i>}
                                      </span>
                                      <span className="fb-profile-circle-name">
                                        {profile.first_name || profile.facebook_username || profile.facebook_id}
                                      </span>
                                    </button>
                                  );
                                })}
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>}

                    <div className="fb-modal-field">
                      <label>סוג מודעה</label>
                      <div className="fb-listing-types">
                        {[
                          { value: 'item', label: '📦 פריט למכירה' },
                          { value: 'vehicle', label: '🚗 רכב' },
                          { value: 'home_rent', label: '🏠 דירה להשכרה' },
                          { value: 'home_sale', label: '🏡 דירה למכירה' }
                        ].map(type => (
                          <button
                            key={type.value}
                            type="button"
                            className={`fb-listing-type-btn ${editingPost.marketplace?.listing_type === type.value ? 'active' : ''}`}
                            onClick={() => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                listing_type: type.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                          >
                            {type.label}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Item-specific fields */}
                    {editingPost.marketplace?.listing_type === 'item' && (
                      <>
                        <div className="fb-modal-field">
                          <label>קטגוריה *</label>
                          <select
                            value={editingPost.marketplace?.category || ''}
                            onChange={(e) => handleCategoryChange(e.target.value)}
                            disabled={loadingCategories}
                          >
                            <option value="">
                              {loadingCategories ? 'טוען קטגוריות...' : 'בחר קטגוריה...'}
                            </option>
                            {marketplaceCategories.map((cat) => {
                              // Skip special categories (Vehicles, Rentals, Home Sales)
                              if (['807311116002614', '1468271819871448', '821056594720130'].includes(cat.id)) {
                                return null;
                              }
                              // If category has subcategories, show as optgroup
                              if (cat.subcategories && cat.subcategories.length > 0) {
                                return (
                                  <optgroup key={cat.id} label={translateCategory(cat.name)}>
                                    {cat.subcategories.map((sub: any) => (
                                      <option key={sub.id} value={sub.id}>
                                        {translateCategory(sub.name)}
                                      </option>
                                    ))}
                                  </optgroup>
                                );
                              }
                              // If no subcategories, show as direct option
                              return (
                                <option key={cat.id} value={cat.id}>
                                  {translateCategory(cat.name)}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        {/* Dynamic Category Attributes */}
                        {loadingAttributes && (
                          <div className="fb-modal-field" style={{textAlign: 'center', padding: '12px'}}>
                            <span>טוען שדות נוספים...</span>
                          </div>
                        )}
                        {categoryAttributes.length > 0 && !loadingAttributes && (
                          <div className="fb-dynamic-attributes">
                            {categoryAttributes.map((attr: any, index: number) => {
                              const key = attr.attribute_name.toLowerCase().replace(/\s+/g, '_');
                              const value = editingPost.marketplace?.item_attributes?.[key] || '';

                              if (attr.input_type === 'LIST' && attr.value_label_inputs?.length > 0) {
                                return (
                                  <div className="fb-modal-field" key={index}>
                                    <label>{attr.attribute_name}{attr.is_required ? ' *' : <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px'}}> (לא חובה)</span>}</label>
                                    <select
                                      value={value}
                                      onChange={(e) => {
                                        editingPost.marketplace = {
                                          ...editingPost.marketplace,
                                          item_attributes: {
                                            ...editingPost.marketplace?.item_attributes,
                                            [key]: e.target.value
                                          }
                                        };
                                        editingPost.updated = true;
                                        setEditingPost({...editingPost});
                                      }}
                                    >
                                      <option value="">בחר {attr.attribute_name}</option>
                                      {attr.value_label_inputs.map((opt: any, optIdx: number) => (
                                        <option key={optIdx} value={opt.value}>
                                          {opt.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="fb-modal-field" key={index}>
                                    <label>{attr.attribute_name}{attr.is_required ? ' *' : <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px'}}> (לא חובה)</span>}</label>
                                    <input
                                      type="text"
                                      value={value}
                                      onChange={(e) => {
                                        editingPost.marketplace = {
                                          ...editingPost.marketplace,
                                          item_attributes: {
                                            ...editingPost.marketplace?.item_attributes,
                                            [key]: e.target.value
                                          }
                                        };
                                        editingPost.updated = true;
                                        setEditingPost({...editingPost});
                                      }}
                                      placeholder={`הזן ${attr.attribute_name}`}
                                    />
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}


                        <div className="fb-modal-field" data-field="mp-price">
                          <label>מחיר (₪) *</label>
                          <input
                            type="number"
                            value={editingPost.marketplace?.price || ''}
                            onChange={(e) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                price: e.target.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="0"
                          />
                        </div>

                        <div className="fb-modal-field" data-field="mp-description">
                          <label>תיאור <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px', marginRight: '4px'}}>(לא חובה)</span></label>
                          <DebouncedTextarea
                            value={editingPost.marketplace?.description || ''}
                            onCommit={(next) => {
                              const error = validateMarketplaceDescription(next);
                              setMarketplaceDescriptionError(error);
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                description: next
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="תאר את הפריט שלך..."
                            rows={3}
                            style={marketplaceDescriptionError ? { borderColor: '#f44336' } : undefined}
                          />
                          {marketplaceDescriptionError && (
                            <span style={{ color: '#f44336', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                              {marketplaceDescriptionError}
                            </span>
                          )}
                        </div>

                        <div className="fb-modal-field">
                          <label>מצב הפריט *</label>
                          <select
                            value={editingPost.marketplace?.condition || 'used_good'}
                            onChange={(e) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                condition: e.target.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                          >
                            <option value="new">חדש</option>
                            <option value="used_like_new">משומש - כמו חדש</option>
                            <option value="used_good">משומש - מצב טוב</option>
                            <option value="used_fair">משומש - מצב סביר</option>
                          </select>
                        </div>

                        <div className="fb-modal-field" data-field="mp-location">
                          <label>מיקום *</label>
                          <IsraelCitySelector
                            value={editingPost.marketplace?.latitude && editingPost.marketplace?.longitude ? {
                              lat: editingPost.marketplace.latitude,
                              lng: editingPost.marketplace.longitude,
                              city: editingPost.marketplace.location || ''
                            } : undefined}
                            onChange={(loc) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                location: loc.city,
                                latitude: loc.lat,
                                longitude: loc.lng
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="חפש עיר..."
                          />
                        </div>

                        <div className="fb-form-row">
                          <div className="fb-modal-field">
                            <label>מותג <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px', marginRight: '4px'}}>(לא חובה)</span></label>
                            <input
                              type="text"
                              value={editingPost.marketplace?.brand || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  brand: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="לדוגמה: Apple, Nike"
                            />
                          </div>
                          <div className="fb-modal-field">
                            <label>צבע <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px', marginRight: '4px'}}>(לא חובה)</span></label>
                            <input
                              type="text"
                              value={editingPost.marketplace?.color || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  color: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="לדוגמה: שחור, לבן"
                            />
                          </div>
                        </div>

                        <span className="fb-form-hint" style={{marginTop: '12px', display: 'block'}}>
                          💡 המודעה תפורסם ישירות בפייסבוק מרקטפלייס דרך הפרופיל שנבחר
                        </span>
                      </>
                    )}

                    {/* Vehicle-specific fields */}
                    {editingPost.marketplace?.listing_type === 'vehicle' && (
                      <>

                        <div className="fb-modal-field" data-field="mp-price">
                          <label>מחיר (₪) *</label>
                          <input
                            type="number"
                            value={editingPost.marketplace?.price || ''}
                            onChange={(e) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                price: e.target.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="0"
                          />
                        </div>

                        <div className="fb-modal-field">
                          <label>תיאור</label>
                          <DebouncedTextarea
                            value={editingPost.marketplace?.description || ''}
                            onCommit={(next) => {
                              const error = validateMarketplaceDescription(next);
                              setMarketplaceDescriptionError(error);
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                description: next
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="תאר את הרכב שלך..."
                            rows={3}
                            style={marketplaceDescriptionError ? { borderColor: '#f44336' } : undefined}
                          />
                          {marketplaceDescriptionError && (
                            <span style={{ color: '#f44336', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                              {marketplaceDescriptionError}
                            </span>
                          )}
                        </div>

                        <div className="fb-form-row">
                          <div className="fb-modal-field">
                            <label>יצרן *</label>
                            <input
                              type="text"
                              value={editingPost.marketplace?.vehicle_make || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  vehicle_make: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="טויוטה"
                            />
                          </div>
                          <div className="fb-modal-field">
                            <label>דגם *</label>
                            <input
                              type="text"
                              value={editingPost.marketplace?.vehicle_model || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  vehicle_model: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="קורולה"
                            />
                          </div>
                        </div>

                        <div className="fb-form-row">
                          <div className="fb-modal-field">
                            <label>שנה *</label>
                            <input
                              type="number"
                              value={editingPost.marketplace?.vehicle_year || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  vehicle_year: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="2020"
                            />
                          </div>
                          <div className="fb-modal-field">
                            <label>ק"מ</label>
                            <input
                              type="number"
                              value={editingPost.marketplace?.vehicle_mileage || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  vehicle_mileage: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="50000"
                            />
                          </div>
                        </div>

                        <div className="fb-modal-field" data-field="mp-location">
                          <label>מיקום *</label>
                          <IsraelCitySelector
                            value={editingPost.marketplace?.latitude && editingPost.marketplace?.longitude ? {
                              lat: editingPost.marketplace.latitude,
                              lng: editingPost.marketplace.longitude,
                              city: editingPost.marketplace.location || ''
                            } : undefined}
                            onChange={(loc) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                location: loc.city,
                                latitude: loc.lat,
                                longitude: loc.lng
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="חפש עיר..."
                          />
                        </div>

                        <span className="fb-form-hint" style={{marginTop: '12px', display: 'block'}}>
                          💡 המודעה תפורסם ישירות בפייסבוק מרקטפלייס דרך הפרופיל שנבחר
                        </span>
                      </>
                    )}

                    {/* Home-specific fields */}
                    {(editingPost.marketplace?.listing_type === 'home_rent' || editingPost.marketplace?.listing_type === 'home_sale') && (
                      <>

                        <div className="fb-modal-field" data-field="mp-price">
                          <label>{editingPost.marketplace?.listing_type === 'home_rent' ? 'שכר דירה (₪/חודש) *' : 'מחיר (₪) *'}</label>
                          <input
                            type="number"
                            value={editingPost.marketplace?.price || ''}
                            onChange={(e) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                price: e.target.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="0"
                          />
                        </div>

                        <div className="fb-modal-field">
                          <label>תיאור</label>
                          <DebouncedTextarea
                            value={editingPost.marketplace?.description || ''}
                            onCommit={(next) => {
                              const error = validateMarketplaceDescription(next);
                              setMarketplaceDescriptionError(error);
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                description: next
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="תאר את הנכס שלך..."
                            rows={3}
                            style={marketplaceDescriptionError ? { borderColor: '#f44336' } : undefined}
                          />
                          {marketplaceDescriptionError && (
                            <span style={{ color: '#f44336', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                              {marketplaceDescriptionError}
                            </span>
                          )}
                        </div>

                        <div className="fb-modal-field">
                          <label>סוג נכס *</label>
                          <select
                            value={editingPost.marketplace?.property_type || ''}
                            onChange={(e) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                property_type: e.target.value
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                          >
                            <option value="" disabled>בחר סוג נכס</option>
                            <option value="apartment">דירה</option>
                            <option value="house">בית פרטי / קוטג׳</option>
                            <option value="penthouse">פנטהאוז</option>
                            <option value="garden_apartment">דירת גן</option>
                            <option value="duplex">דופלקס</option>
                            <option value="condo">קונדו</option>
                            <option value="townhouse">טאון האוס</option>
                            <option value="studio">סטודיו</option>
                            {(editingPost.marketplace?.listing_type === 'home_rent' || editingPost.marketplace?.listing_type === 'rental') && (
                              <option value="private_room-shared_room">חדר</option>
                            )}
                            {editingPost.marketplace?.listing_type === 'home_sale' && (
                              <>
                                <option value="land">מגרש</option>
                                <option value="agricultural_lot">מגרש חקלאי</option>
                                <option value="multi-family">מרובה משפחות</option>
                              </>
                            )}
                            <option value="office">משרד</option>
                            <option value="retail">חנות</option>
                            <option value="warehouse">מחסן</option>
                            <option value="commercial">מסחרי (כללי)</option>
                          </select>
                        </div>

                        <div className="fb-form-row">
                          <div className="fb-modal-field">
                            <label>חדרים *</label>
                            <input
                              type="number"
                              value={editingPost.marketplace?.rooms ?? editingPost.marketplace?.bedrooms ?? ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  rooms: e.target.value,
                                  bedrooms: ''
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="3"
                            />
                          </div>
                          <div className="fb-modal-field">
                            <label>חדרי רחצה</label>
                            <input
                              type="number"
                              value={editingPost.marketplace?.bathrooms || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  bathrooms: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="1"
                            />
                          </div>
                          <div className="fb-modal-field">
                            <label>מ"ר</label>
                            <input
                              type="number"
                              value={editingPost.marketplace?.square_meters || ''}
                              onChange={(e) => {
                                editingPost.marketplace = {
                                  ...editingPost.marketplace,
                                  square_meters: e.target.value
                                };
                                editingPost.updated = true;
                                setEditingPost({...editingPost});
                              }}
                              placeholder="80"
                            />
                          </div>
                        </div>

                        <div className="fb-modal-field" data-field="mp-location">
                          <label>מיקום *</label>
                          <IsraelCitySelector
                            value={editingPost.marketplace?.latitude && editingPost.marketplace?.longitude ? {
                              lat: editingPost.marketplace.latitude,
                              lng: editingPost.marketplace.longitude,
                              city: editingPost.marketplace.location || ''
                            } : undefined}
                            onChange={(loc) => {
                              editingPost.marketplace = {
                                ...editingPost.marketplace,
                                location: loc.city,
                                latitude: loc.lat,
                                longitude: loc.lng
                              };
                              editingPost.updated = true;
                              setEditingPost({...editingPost});
                            }}
                            placeholder="חפש עיר..."
                          />
                        </div>

                        <span className="fb-form-hint" style={{marginTop: '12px', display: 'block'}}>
                          💡 המודעה תפורסם ישירות בפייסבוק מרקטפלייס דרך הפרופיל שנבחר
                        </span>
                      </>
                    )}

                    {/* Auto Reply Message - shared across all listing types */}
                    <div className="fb-modal-field" style={{marginTop: '12px'}}>
                      <label>הודעת תגובה אוטומטית <span style={{color: '#999', fontWeight: 'normal', fontSize: '12px', marginRight: '4px'}}>(לא חובה)</span></label>
                      <DebouncedTextarea
                        value={vnPinnedMpBlock ? vnMpBodyText : (editingPost.marketplace?.auto_reply_message ?? (editingPost.reply_text || ''))}
                        style={vnPinnedMpBlock
                          ? {borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 'none', marginBottom: 0}
                          : undefined}
                        onCommit={(next) => {
                          editingPost.marketplace = {
                            ...editingPost.marketplace,
                            auto_reply_message: joinVnBody(scrubPhones(next), vnPinnedMpBlock)
                          };
                          editingPost.updated = true;
                          setEditingPost({...editingPost});
                        }}
                        placeholder="הודעה שתישלח אוטומטית למתעניינים..."
                        rows={2}
                      />
                      {waLinkControls('mpReply')}
                      {vnPinnedMpBlock && (
                        <div
                          title="פרטי הקשר מתווספים אוטומטית לסוף ההודעה"
                          style={{
                            border: '1px solid #dfe1e6', borderTop: '1px dashed #dfe1e6',
                            borderBottomLeftRadius: 8, borderBottomRightRadius: 8,
                            background: '#fafbfc', padding: '10px 12px 12px',
                            font: 'inherit', fontSize: 14, lineHeight: 1.5, color: '#1c1e21',
                            whiteSpace: 'pre-wrap', wordBreak: 'break-word', cursor: 'not-allowed', userSelect: 'none',
                          }}
                        >
                          {vnPinnedMpBlock}
                          <div style={{marginTop: 8, fontSize: 11.5, color: '#8a8d91', display: 'flex', alignItems: 'center', gap: 5}}>
                            <span>🔒</span>
                            <span>פרטי הקשר נשמרים כחלק מההודעה ואי אפשר לערוך אותם</span>
                          </div>
                        </div>
                      )}
                      {mpReplyPhoneError && phoneErrorBox(mpReplyPhoneError, 'בהודעת התגובה האוטומטית')}
                      <small style={{ color: '#999', fontSize: '11px' }}>כברירת מחדל זהה לתגובה האוטומטית של הפוסט — ניתן לערוך</small>
                      {editVnActive && (
                        <span className="fb-field-hint" style={{display: 'block', marginTop: 6}}>{VN_EXPLAINER}</span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="fb-modal-footer">
            <button
              className="fb-btn fb-btn-secondary"
              onClick={closeCreatePostModal}
            >
              ביטול
            </button>
            <button
              className="fb-btn fb-btn-primary"
              disabled={editVnRequired || editingPost.loading || (isTutorialMode && editingPost.is_new && !isWizardDone && wizardStep < WIZARD_FIELDS.length - 1)}
              title={editVnRequired ? 'הוסף את המספר הווירטואלי לתוכן כדי לשמור' : undefined}
              onClick={() => {
                // Content/media basic validation - scroll to field instead of just disabling
                if (!editingPost.post_content && !(editingPost.media?.length > 0)) {
                  scrollToPostField('[data-field="content"]', 'נא להוסיף תוכן או תמונה');
                  return;
                }
                triggerPublish();
              }}
            >
              {editingPost.loading ? 'שומר...' : (editingPost.is_new ? 'פרסם' : 'שמור')}
            </button>
          </div>
        </div>
        {/* Wizard tutorial tooltip — floats next to modal */}
        {isTutorialMode && editingPost.is_new && (
          <div className="wizard-tooltip" ref={(el) => {
            // Drop any previous observer before re-attaching (inline refs re-run per render).
            if (wizardBannerRoRef.current) { wizardBannerRoRef.current.disconnect(); wizardBannerRoRef.current = null; }
            wizardBannerElRef.current = el;
            if (!el) return;
            const isMobileWizard = window.innerWidth <= 768 && document.body.classList.contains('spotlight-banner-active');
            if (isMobileWizard) {
              // On mobile with spotlight active: act as top banner, set CSS var for modal push-down
              el.style.top = '0px';
              // Measured continuously, not once. The banner's height changes after mount —
              // the validation error appearing, the keyboard collapsing it, longer copy on
              // the next step — and a stale value means the modal is pushed down by the
              // wrong amount and the banner sits on top of the field being asked about.
              const syncBannerHeight = () => {
                document.documentElement.style.setProperty('--spotlight-banner-h', `${el.offsetHeight}px`);
              };
              syncBannerHeight();
              syncWizardBannerToViewport();
              requestAnimationFrame(() => { syncBannerHeight(); syncWizardBannerToViewport(); });
              if (typeof ResizeObserver !== 'undefined') {
                const ro = new ResizeObserver(syncBannerHeight);
                ro.observe(el);
                wizardBannerRoRef.current = ro;
              }
              return;
            }
            setTimeout(() => {
              if (isWizardDone) {
                // Position near the publish button
                const footer = document.querySelector('.fb-modal-footer');
                if (footer) {
                  const footerRect = footer.getBoundingClientRect();
                  const tooltipHeight = el.offsetHeight;
                  let top = footerRect.top + footerRect.height / 2 - tooltipHeight / 2;
                  top = Math.max(20, Math.min(top, window.innerHeight - tooltipHeight - 20));
                  el.style.top = top + 'px';
                }
              } else {
                const activeField = document.querySelector(`[data-field="${WIZARD_FIELDS[wizardStep]?.dataField}"]`);
                if (activeField) {
                  const fieldRect = activeField.getBoundingClientRect();
                  const tooltipHeight = el.offsetHeight;
                  let top = fieldRect.top + fieldRect.height / 2 - tooltipHeight / 2;
                  top = Math.max(20, Math.min(top, window.innerHeight - tooltipHeight - 20));
                  el.style.top = top + 'px';
                }
              }
            }, 120);
          }}>
            <div className="wizard-tooltip-arrow" />
            {isWizardDone ? (
              <>
                <h3 className="wizard-tooltip-title">הכול מוכן!</h3>
                <p className="wizard-tooltip-description">לחצו על כפתור "פרסם" כדי לשמור את הפוסט ולהתחיל לפרסם.</p>
                <div className="wizard-tooltip-dots">
                  {WIZARD_FIELDS.map((_, i) => (
                    <div key={i} className="wizard-dot done" />
                  ))}
                </div>
                {wizardHelpButton}
              </>
            ) : (
              <>
                <div className="wizard-tooltip-step" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>שלב {wizardStep + 1} מתוך {WIZARD_FIELDS.length}</span>
                  {/* Admin-only exit — see the note on the tutorial banner's close button.
                      A customer who quits here is left with a half-created post. */}
                  {isAdminMode && (
                    <button
                      onClick={() => {
                        if (window.confirm('האם אתה בטוח שברצונך לצאת מהמדריך?')) {
                          const url = new URL(window.location.href);
                          url.searchParams.delete('tut');
                          window.location.href = url.toString();
                        }
                      }}
                      style={{ background: 'none', border: 'none', color: '#999', fontSize: '12px', cursor: 'pointer', padding: '0 4px' }}
                    >✕ יציאה (אדמין)</button>
                  )}
                </div>
                <h3 className="wizard-tooltip-title">{WIZARD_FIELDS[wizardStep]?.title}</h3>
                <p className="wizard-tooltip-description" style={{whiteSpace: 'pre-line'}}>{WIZARD_FIELDS[wizardStep]?.description}</p>
                {WIZARD_FIELDS[wizardStep]?.exampleImage && (
                  <span
                    className="wizard-tooltip-example-link"
                    onMouseEnter={() => {
                      const field = document.querySelector(`[data-field="${WIZARD_FIELDS[wizardStep].dataField}"] .fb-example-tooltip-wrapper`);
                      field?.classList.add('force-show');
                    }}
                    onMouseLeave={() => {
                      const field = document.querySelector(`[data-field="${WIZARD_FIELDS[wizardStep].dataField}"] .fb-example-tooltip-wrapper`);
                      field?.classList.remove('force-show');
                    }}
                  >📷 ראה דוגמה</span>
                )}
                {WIZARD_FIELDS[wizardStep]?.descriptionAfterExample && (
                  <p className="wizard-tooltip-description" style={{whiteSpace: 'pre-line', marginTop: '4px'}}>{WIZARD_FIELDS[wizardStep].descriptionAfterExample}</p>
                )}
                {wizardValidationError && (
                  <div className="wizard-tooltip-error">{wizardValidationError}</div>
                )}
                {/* Say why "next" is dead, in the tooltip the user is reading — the inline
                    error sits down by the field and can be off-screen from here. */}
                {phoneBlocksStep && (
                  <div className="wizard-tooltip-error">
                    ⛔ יש להסיר את מספר הטלפון (<span style={{fontFamily: 'monospace', direction: 'ltr', unicodeBidi: 'embed'}}>{postPhoneError || replyPhoneError || mpReplyPhoneError}</span>) — הפניות חייבות לעבור דרך המספר הווירטואלי.
                  </div>
                )}
                <div className="wizard-tooltip-dots">
                  {WIZARD_FIELDS.map((_, i) => (
                    <div key={i} className={`wizard-dot${i === wizardStep ? ' active' : ''}${i < wizardStep ? ' done' : ''}`} />
                  ))}
                </div>
                <div className="wizard-tooltip-buttons">
                  {wizardStep > 0 && (
                    <button
                      className="wizard-tooltip-btn secondary"
                      onClick={() => {
                        setWizardValidationError(null);
                        setWizardStep(wizardStep - 1);
                      }}
                    >
                      → הקודם
                    </button>
                  )}
                  {wizardStep < WIZARD_FIELDS.length - 1 ? (
                    <>
                      {/* "Skip" is offered when an optional step isn't filled in — but a
                          step held back by a phone number isn't unfilled, it's wrong, and
                          skipping would carry the number forward. */}
                      {!WIZARD_FIELDS[wizardStep]?.isRequired(editingPost) && !WIZARD_FIELDS[wizardStep]?.validate(editingPost) && !phoneBlocksStep && (
                        <button
                          className="wizard-tooltip-btn skip"
                          onClick={() => {
                            setWizardValidationError(null);
                            setWizardStep(wizardStep + 1);
                          }}
                        >
                          דלג
                        </button>
                      )}
                      <button
                        className="wizard-tooltip-btn primary"
                        disabled={editingPost.loading || !WIZARD_FIELDS[wizardStep]?.validate(editingPost)}
                        onClick={async () => {
                          setWizardValidationError(null);
                          setWizardStep(wizardStep + 1);
                        }}
                      >
                        הבא ←
                      </button>
                    </>
                  ) : (
                    <button
                      className="wizard-tooltip-btn primary"
                      disabled={editVnRequired}
                      title={editVnRequired ? 'הוסף את המספר הווירטואלי לתוכן כדי לשמור' : undefined}
                      onClick={() => triggerPublish()}
                    >
                      פרסם ←
                    </button>
                  )}
                </div>
                {wizardHelpButton}
              </>
            )}
          </div>
        )}
      </div>
    )}

    {/* AI Suggestion Modal */}
    {showAiSuggestionModal && aiSuggestion && (
      <div className="fb-ai-suggestion-modal-backdrop">
        <div className="fb-ai-suggestion-modal" style={{direction: 'rtl'}}>
          <div className="fb-modal-header">
            <button className="fb-modal-close" onClick={() => rejectAiSuggestion()}>×</button>
            <h3>✨ הצעת שיפור AI</h3>
          </div>
          <div className="fb-ai-suggestion-body">
            <p className="fb-ai-suggestion-intro">
              הנה הגרסה המשופרת של הפוסט שלך. השיפורים מותאמים לפוסטים בפייסבוק לקבלת מעורבות גבוהה יותר.
            </p>

            <div className="fb-ai-comparison">
              <div className="fb-ai-comparison-side">
                <div className="fb-ai-comparison-header original">
                  <span>📝 מקור</span>
                </div>
                <div className="fb-ai-comparison-content">
                  {aiSuggestion.original}
                </div>
              </div>

              <div className="fb-ai-comparison-arrow">←</div>

              <div className="fb-ai-comparison-side">
                <div className="fb-ai-comparison-header enhanced">
                  <span>✨ משופר (ניתן לעריכה)</span>
                </div>
                <DebouncedTextarea
                  className="fb-ai-comparison-content fb-ai-editable"
                  value={aiSuggestion.enhanced}
                  onCommit={(next) => setAiSuggestion({...aiSuggestion, enhanced: next})}
                  style={{
                    width: '100%',
                    minHeight: '200px',
                    resize: 'vertical',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '12px',
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit'
                  }}
                />
              </div>
            </div>
          </div>
          <div className="fb-modal-footer">
            <button className="fb-btn fb-btn-secondary" onClick={() => rejectAiSuggestion()}>
              לא תודה, השאר מקורי
            </button>
            <button className="fb-btn fb-btn-primary fb-btn-ai" onClick={() => acceptAiSuggestion()}>
              ✨ אשר שינויים
            </button>
          </div>
        </div>
      </div>
    )}

    {/* AI Reply Suggestion Modal */}
    {showAiReplyModal && aiReplySuggestion && (
      <div className="fb-ai-suggestion-modal-backdrop">
        <div className="fb-ai-suggestion-modal" style={{direction: 'rtl', maxWidth: '500px'}}>
          <div className="fb-modal-header">
            <button className="fb-modal-close" onClick={() => rejectAiReplySuggestion()}>×</button>
            <h3>✨ תגובה אוטומטית מוצעת</h3>
          </div>
          <div className="fb-ai-suggestion-body">
            <p className="fb-ai-suggestion-intro">
              הנה תגובה אוטומטית מוצעת שתישלח לכל מי שיגיב על הפוסט שלך. ניתן לערוך לפני השימוש.
            </p>

            <DebouncedTextarea
              value={aiReplySuggestion}
              onCommit={(next) => setAiReplySuggestion(next)}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                fontSize: '14px',
                minHeight: '140px',
                resize: 'vertical',
                lineHeight: '1.6'
              }}
              placeholder="ניתן לערוך את התגובה כאן..."
            />
          </div>
          <div className="fb-modal-footer">
            <button className="fb-btn fb-btn-secondary" onClick={() => rejectAiReplySuggestion()}>
              ביטול
            </button>
            <button className="fb-btn fb-btn-primary fb-btn-ai" onClick={() => acceptAiReplySuggestion()}>
              ✨ השתמש בתגובה
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Post to Marketplace Modal */}
    {postToMarketplace && (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1070,
          padding: '20px',
          backdropFilter: 'blur(4px)'
        }}
      >
        <div
          style={{
            direction: 'rtl',
            maxWidth: '600px',
            width: '100%',
            maxHeight: '90vh',
            overflow: 'auto',
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)'
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #e4e6eb'
          }}>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>🛒 פרסום במרקטפלייס</h3>
            <button
              onClick={() => setPostToMarketplace(null)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#65676b',
                padding: '4px 8px'
              }}
            >×</button>
          </div>
          <div style={{padding: '20px'}}>
            {aiFillingMarketplace ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
                background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                borderRadius: '12px'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  border: '4px solid #3b82f6',
                  borderTopColor: 'transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  marginBottom: '16px'
                }}></div>
                <span style={{ fontSize: '16px', fontWeight: 600, color: '#1e40af' }}>
                  🤖 ממלא פרטי מרקטפלייס אוטומטית...
                </span>
              </div>
            ) : (
              <>
                {/* Profile Selector — same circles as the edit modal: every profile
                    selected by default, each one publishes its own listing copy. */}
                <div style={{ marginBottom: '16px' }} id="gw-field-profile">
                  {(() => {
                    const mpCutoff = Date.now() - 5 * 60 * 1000;
                    const pIsOnline = (p: any) => !!(p.last_health_check && new Date(p.last_health_check).getTime() >= mpCutoff);
                    const chosen = mpSelectedIds(postToMarketplace.marketplace);
                    const applyIds = (next: string[]) => {
                      postToMarketplace.marketplace = {
                        ...postToMarketplace.marketplace,
                        profile_ids: next,
                        profile_id: next[0] || ''
                      };
                      setPostToMarketplace({...postToMarketplace});
                    };
                    const allSelected = mpDefaultProfileIds.length > 0 && chosen.length === mpDefaultProfileIds.length;
                    return (
                      <>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>
                          <span>פרופילים לפרסום *</span>
                          <span style={{ fontWeight: 400, fontSize: '12px' }}>({chosen.length}/{mpDefaultProfileIds.length})</span>
                          {mpDefaultProfileIds.length > 1 && (
                            <button
                              type="button"
                              className="fb-profile-circles-all"
                              onClick={() => applyIds(allSelected ? [chosen[0]] : mpDefaultProfileIds)}
                            >
                              {allSelected ? 'בחר אחד' : 'בחר הכל'}
                            </button>
                          )}
                        </label>
                        {mpEligibleProfiles.length === 0 ? (
                          <p style={{ color: '#999', fontSize: '13px', margin: 0 }}>אין פרופילים מחוברים</p>
                        ) : (
                          <div className="fb-profile-circles">
                            {mpEligibleProfiles.map((profile: any) => {
                              const id = String(profile._id);
                              const isSel = chosen.includes(id);
                              return (
                                <button
                                  type="button"
                                  key={id}
                                  className={`fb-profile-circle ${isSel ? 'selected' : ''}`}
                                  // The last selected profile can't be turned off — a
                                  // listing with nobody to publish it can't be saved.
                                  onClick={() => {
                                    if (isSel && chosen.length === 1) return;
                                    applyIds(isSel ? chosen.filter((x) => x !== id) : [...chosen, id]);
                                  }}
                                  title={`${profile.first_name || ''} ${profile.last_name || ''}`.trim() + (pIsOnline(profile) ? ' — מחובר' : ' — לא מחובר כרגע, הפרסום ימתין')}
                                >
                                  <span className="fb-profile-circle-img">
                                    <img
                                      src={`https://graph.facebook.com/${profile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                                      alt=""
                                    />
                                    <i className={`fb-profile-circle-dot ${pIsOnline(profile) ? 'online' : ''}`}></i>
                                    {isSel && <i className="bi bi-check-lg fb-profile-circle-check"></i>}
                                  </span>
                                  <span className="fb-profile-circle-name">
                                    {profile.first_name || profile.facebook_username || profile.facebook_id}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>

                {/* Listing Type */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>סוג מודעה</label>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {[
                      { value: 'item', label: '📦 פריט' },
                      { value: 'vehicle', label: '🚗 רכב' },
                      { value: 'home_rent', label: '🏠 השכרה' },
                      { value: 'home_sale', label: '🏡 מכירה' }
                    ].map(type => (
                      <button
                        key={type.value}
                        type="button"
                        style={{
                          padding: '6px 12px',
                          border: postToMarketplace.marketplace?.listing_type === type.value ? '2px solid #1877f2' : '1px solid #ddd',
                          borderRadius: '6px',
                          background: postToMarketplace.marketplace?.listing_type === type.value ? '#e7f3ff' : 'white',
                          cursor: 'pointer',
                          fontSize: '13px'
                        }}
                        onClick={() => {
                          postToMarketplace.marketplace = {
                            ...postToMarketplace.marketplace,
                            listing_type: type.value
                          };
                          setPostToMarketplace({...postToMarketplace});
                        }}
                      >
                        {type.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Title */}

                {/* Price */}
                <div style={{ marginBottom: '16px' }} id="gw-field-price">
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מחיר (₪) *</label>
                  <input
                    type="number"
                    value={postToMarketplace.marketplace?.price ?? ''}
                    onChange={(e) => {
                      postToMarketplace.marketplace = {
                        ...postToMarketplace.marketplace,
                        price: e.target.value
                      };
                      setPostToMarketplace({...postToMarketplace});
                    }}
                    placeholder="0"
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                  />
                </div>

                {/* Description */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>תיאור</label>
                  <DebouncedTextarea
                    value={postToMarketplace.marketplace?.description || ''}
                    onCommit={(next) => {
                      const error = validateMarketplaceDescription(next);
                      setMarketplaceDescriptionError(error);
                      postToMarketplace.marketplace = {
                        ...postToMarketplace.marketplace,
                        description: next
                      };
                      setPostToMarketplace({...postToMarketplace});
                    }}
                    placeholder="תיאור המודעה..."
                    rows={3}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: marketplaceDescriptionError ? '1px solid #f44336' : '1px solid #ddd', fontSize: '14px', resize: 'vertical' }}
                  />
                  {marketplaceDescriptionError && (
                    <span style={{ color: '#f44336', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                      {marketplaceDescriptionError}
                    </span>
                  )}
                </div>

                {/* Auto Reply Message */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>הודעת תגובה אוטומטית</label>
                  {selectedCampaign?.default_marketplace_auto_reply && !postToMarketplace.marketplace?.auto_reply_message && (
                    <div style={{
                      padding: '8px 12px', marginBottom: '8px', borderRadius: '6px',
                      background: 'rgba(54, 153, 255, 0.08)', border: '1px solid rgba(54, 153, 255, 0.2)',
                      fontSize: '12px', color: '#3699ff', display: 'flex', alignItems: 'center', gap: '6px'
                    }}>
                      <span>🛒</span>
                      <span>משתמש בהודעה גלובלית מהגדרות הקמפיין: "<strong>{selectedCampaign.default_marketplace_auto_reply.substring(0, 60)}{selectedCampaign.default_marketplace_auto_reply.length > 60 ? '...' : ''}</strong>"</span>
                    </div>
                  )}
                  <DebouncedTextarea
                    value={postToMarketplace.marketplace?.auto_reply_message || ''}
                    onCommit={(next) => {
                      postToMarketplace.marketplace = {
                        ...postToMarketplace.marketplace,
                        auto_reply_message: next
                      };
                      setPostToMarketplace({...postToMarketplace});
                    }}
                    placeholder="הודעה שתישלח אוטומטית למתעניינים..."
                    rows={2}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', resize: 'vertical' }}
                  />
                  <small style={{ color: '#999', fontSize: '12px' }}>אופציונלי - תישלח אוטומטית לכל מי שכותב על המודעה</small>
                </div>

                {/* Location */}
                <div style={{ marginBottom: '16px' }} id="gw-field-location">
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מיקום *</label>
                  <IsraelCitySelector
                    value={postToMarketplace.marketplace?.latitude && postToMarketplace.marketplace?.longitude ? {
                      lat: postToMarketplace.marketplace.latitude,
                      lng: postToMarketplace.marketplace.longitude,
                      city: postToMarketplace.marketplace.location || ''
                    } : undefined}
                    onChange={(loc) => {
                      postToMarketplace.marketplace = {
                        ...postToMarketplace.marketplace,
                        location: loc.city,
                        latitude: loc.lat,
                        longitude: loc.lng
                      };
                      setPostToMarketplace({...postToMarketplace});
                    }}
                    placeholder="חפש עיר..."
                  />
                </div>

                {/* Condition & Item fields */}
                {postToMarketplace.marketplace?.listing_type === 'item' && (
                  <>
                    <div style={{ marginBottom: '16px' }} id="gw-field-condition">
                      <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מצב הפריט</label>
                      <select
                        value={postToMarketplace.marketplace?.condition || 'used_good'}
                        onChange={(e) => {
                          postToMarketplace.marketplace = {
                            ...postToMarketplace.marketplace,
                            condition: e.target.value
                          };
                          setPostToMarketplace({...postToMarketplace});
                        }}
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                      >
                        <option value="new">חדש</option>
                        <option value="used_like_new">משומש - כמו חדש</option>
                        <option value="used_good">משומש - מצב טוב</option>
                        <option value="used_fair">משומש - מצב סביר</option>
                      </select>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מותג</label>
                        <input
                          type="text"
                          value={postToMarketplace.marketplace?.brand || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, brand: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="לדוגמה: Apple, Nike"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>צבע</label>
                        <input
                          type="text"
                          value={postToMarketplace.marketplace?.color || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, color: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="לדוגמה: שחור, לבן"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מידה</label>
                      <input
                        type="text"
                        value={postToMarketplace.marketplace?.size || ''}
                        onChange={(e) => {
                          postToMarketplace.marketplace = { ...postToMarketplace.marketplace, size: e.target.value };
                          setPostToMarketplace({...postToMarketplace});
                        }}
                        placeholder="לדוגמה: M, 42"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                      />
                    </div>
                  </>
                )}

                {/* Real-estate fields */}
                {(postToMarketplace.marketplace?.listing_type === 'home_rent' || postToMarketplace.marketplace?.listing_type === 'home_sale') && (
                  <>
                    <div style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>סוג נכס *</label>
                      <select
                        value={postToMarketplace.marketplace?.property_type || ''}
                        onChange={(e) => {
                          postToMarketplace.marketplace = { ...postToMarketplace.marketplace, property_type: e.target.value };
                          setPostToMarketplace({...postToMarketplace});
                        }}
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                      >
                        <option value="" disabled>בחר סוג נכס</option>
                        <option value="apartment">דירה</option>
                        <option value="house">בית פרטי / קוטג׳</option>
                        <option value="penthouse">פנטהאוז</option>
                        <option value="garden_apartment">דירת גן</option>
                        <option value="duplex">דופלקס</option>
                        <option value="condo">קונדו</option>
                        <option value="townhouse">טאון האוס</option>
                        <option value="studio">סטודיו</option>
                        {postToMarketplace.marketplace?.listing_type === 'home_rent' && (
                          <option value="private_room-shared_room">חדר</option>
                        )}
                        {postToMarketplace.marketplace?.listing_type === 'home_sale' && (
                          <>
                            <option value="land">מגרש</option>
                            <option value="agricultural_lot">מגרש חקלאי</option>
                            <option value="multi-family">מרובה משפחות</option>
                          </>
                        )}
                        <option value="office">משרד</option>
                        <option value="retail">חנות</option>
                        <option value="warehouse">מחסן</option>
                        <option value="commercial">מסחרי (כללי)</option>
                      </select>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>חדרים *</label>
                        <input
                          type="number"
                          value={postToMarketplace.marketplace?.rooms ?? postToMarketplace.marketplace?.bedrooms ?? ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, rooms: e.target.value, bedrooms: '' };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="3"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>חדרי רחצה</label>
                        <input
                          type="number"
                          value={postToMarketplace.marketplace?.bathrooms || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, bathrooms: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="1"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>מ"ר</label>
                        <input
                          type="number"
                          value={postToMarketplace.marketplace?.square_meters || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, square_meters: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="80"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Vehicle fields */}
                {postToMarketplace.marketplace?.listing_type === 'vehicle' && (
                  <>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>יצרן *</label>
                        <input
                          type="text"
                          value={postToMarketplace.marketplace?.vehicle_make || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, vehicle_make: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="טויוטה"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>דגם *</label>
                        <input
                          type="text"
                          value={postToMarketplace.marketplace?.vehicle_model || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, vehicle_model: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="קורולה"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>שנה *</label>
                        <input
                          type="number"
                          value={postToMarketplace.marketplace?.vehicle_year || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, vehicle_year: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="2020"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 600, color: '#65676b' }}>ק"מ</label>
                        <input
                          type="number"
                          value={postToMarketplace.marketplace?.vehicle_mileage || ''}
                          onChange={(e) => {
                            postToMarketplace.marketplace = { ...postToMarketplace.marketplace, vehicle_mileage: e.target.value };
                            setPostToMarketplace({...postToMarketplace});
                          }}
                          placeholder="50000"
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            padding: '16px 20px',
            borderTop: '1px solid #e4e6eb'
          }}>
            <button
              onClick={() => {
                setPostToMarketplace(null);
                setMarketplaceDescriptionError(null);
              }}
              style={{
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                background: '#fff',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              ביטול
            </button>
            <button
              disabled={aiFillingMarketplace}
              onClick={async () => {
                // Scroll-to-error validation
                const scrollToField = (fieldId: string) => {
                  const el = document.getElementById(fieldId)
                  if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    el.style.transition = 'box-shadow 0.3s'
                    el.style.boxShadow = '0 0 0 2px #dc3545'
                    setTimeout(() => { el.style.boxShadow = '' }, 3000)
                  }
                }

                // Untouched = every circle selected, so resolve the selection the same
                // way the UI draws it instead of rejecting the save. Only a real absence
                // of connected profiles blocks here.
                const mpIds = mpSelectedIds(postToMarketplace.marketplace)
                if (!mpIds.length) {
                  setToast({ message: 'אין פרופיל מחובר לפרסום במרקטפלייס', type: 'error' })
                  scrollToField('gw-field-profile')
                  return
                }
                postToMarketplace.marketplace = {
                  ...postToMarketplace.marketplace,
                  profile_ids: mpIds,
                  profile_id: mpIds[0],
                }
                const priceVal = postToMarketplace.marketplace?.price
                if (priceVal === undefined || priceVal === null || priceVal === '') {
                  setToast({ message: 'יש להזין מחיר', type: 'error' })
                  scrollToField('gw-field-price')
                  return
                }
                if (!postToMarketplace.marketplace?.location) {
                  setToast({ message: 'יש לבחור מיקום', type: 'error' })
                  scrollToField('gw-field-location')
                  return
                }
                if ((postToMarketplace.marketplace?.listing_type === 'home_sale' || postToMarketplace.marketplace?.listing_type === 'home_rent') && !postToMarketplace.marketplace?.property_type) {
                  setToast({ message: 'יש לבחור סוג נכס', type: 'error' })
                  return
                }
                if (marketplaceDescriptionError) {
                  setToast({ message: marketplaceDescriptionError, type: 'error' })
                  return
                }

                try {
                  // Save the post with marketplace data
                  const response = await axios.post(`${API_URL}/save-post`, {
                    api_token: auth?.api_token || '',
                    post: {
                      ...postToMarketplace,
                      marketplace: {
                        ...postToMarketplace.marketplace,
                        enabled: true,
                        // Derived, not typed — the title field was removed from this form.
                        title: String(postToMarketplace.marketplace?.title || '').trim()
                          || buildMarketplaceTitle(postToMarketplace.marketplace, postToMarketplace),
                      }
                    },
                    campaign: selectedCampaign,
                  });

                  if (response.data) {
                    // Update the post in the posts array
                    const idx = posts.findIndex((p: any) => p._id === postToMarketplace._id);
                    if (idx > -1) {
                      posts[idx] = {
                        ...posts[idx],
                        marketplace_listing_id: response.data.marketplace_listing_id,
                        converted_to_marketplace_listing_id: response.data.converted_to_marketplace_listing_id
                      };
                      setPosts([...posts]);
                    }

                    setToast({
                      message: 'המודעה נשלחה למרקטפלייס בהצלחה!',
                      type: 'success'
                    });
                  }

                  setPostToMarketplace(null);
                  setMarketplaceDescriptionError(null);
                } catch (error) {
                  console.error('Error posting to marketplace:', error);
                  setToast({
                    message: 'שגיאה בשליחה למרקטפלייס',
                    type: 'error'
                  });
                }
              }}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '6px',
                background: '#1877f2',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                opacity: aiFillingMarketplace ? 0.5 : 1
              }}
            >
              🛒 פרסם במרקטפלייס
            </button>
          </div>
        </div>
      </div>
    )}
</>}

    <CreateCampaignModal show={showCreateCampaignModal} handleClose={() => setShowCreateCampaignModal(false)} />

    {/* Custom Gallery Viewer with Video Support */}
    {galleryItems.length > 0 && (
      <div
        className="custom-gallery-overlay"
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Close button */}
        <button
          onClick={() => setGalleryItems([])}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            fontSize: '32px',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            cursor: 'pointer',
            zIndex: 10001
          }}
        >
          ×
        </button>

        {/* Previous button */}
        {currImg > 0 && (
          <button
            onClick={() => setCurrImg(currImg - 1)}
            style={{
              position: 'absolute',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              fontSize: '32px',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              cursor: 'pointer',
              zIndex: 10001
            }}
          >
            ‹
          </button>
        )}

        {/* Next button */}
        {currImg < galleryItems.length - 1 && (
          <button
            onClick={() => setCurrImg(currImg + 1)}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              fontSize: '32px',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              cursor: 'pointer',
              zIndex: 10001
            }}
          >
            ›
          </button>
        )}

        {/* Media content */}
        <div style={{ maxWidth: '90vw', maxHeight: '90vh', position: 'relative' }}>
          {/\.(mp4|mov|webm|avi|mkv)$/i.test(galleryItems[currImg]) ? (
            <video
              key={galleryItems[currImg]}
              src={galleryItems[currImg]}
              controls
              autoPlay
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
          ) : (
            <img
              src={watermarkPreviewSrc(galleryItems[currImg])}
              alt=""
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
          )}
        </div>

        {/* Counter */}
        <div style={{
          position: 'absolute',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          fontSize: '14px',
          background: 'rgba(0,0,0,0.5)',
          padding: '8px 16px',
          borderRadius: '20px'
        }}>
          {currImg + 1} / {galleryItems.length}
        </div>
      </div>
    )}

    {/* Profile Settings Modal */}
    {settingsModalProfile && (
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '500px', direction: 'rtl' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                הגדרות פרופיל - {settingsModalProfile.first_name} {settingsModalProfile.last_name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setSettingsModalProfile(null)}
              ></button>
            </div>
            <div className="modal-body">
              {/* Connection Status */}
              <div style={{
                padding: '16px',
                marginBottom: '20px',
                borderRadius: '12px',
                background: (() => {
                  const isConnected = settingsModalProfile.last_health_check &&
                    new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                  return isConnected ? '#e8f5e9' : '#ffebee';
                })(),
                border: (() => {
                  const isConnected = settingsModalProfile.last_health_check &&
                    new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                  return isConnected ? '1px solid #4caf50' : '1px solid #f44336';
                })()
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    background: (() => {
                      const isConnected = settingsModalProfile.last_health_check &&
                        new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                      return isConnected ? '#4caf50' : '#f44336';
                    })()
                  }}></span>
                  <div>
                    <div style={{ fontWeight: '600', color: '#333' }}>
                      {(() => {
                        const isConnected = settingsModalProfile.last_health_check &&
                          new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                        return isConnected ? 'פרופיל מחובר ופעיל' : 'פרופיל לא מחובר';
                      })()}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {(() => {
                        const isConnected = settingsModalProfile.last_health_check &&
                          new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000;
                        return isConnected
                          ? 'הפעולות למטה יעבדו כרגיל'
                          : 'התחבר לפרופיל כדי להשתמש בפעולות';
                      })()}
                    </div>
                  </div>
                </div>
              </div>

              {/* Automation Status (New Listeners) */}
              <div style={{
                padding: '12px 16px',
                marginBottom: '20px',
                borderRadius: '12px',
                background: (() => {
                  const status = automationStatus[settingsModalProfile._id];
                  if (!status || status.checking) return '#fff3e0';
                  return status.hasNewListeners ? '#e3f2fd' : '#fce4ec';
                })(),
                border: (() => {
                  const status = automationStatus[settingsModalProfile._id];
                  if (!status || status.checking) return '1px solid #ffb74d';
                  return status.hasNewListeners ? '1px solid #2196f3' : '1px solid #f48fb1';
                })()
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {(() => {
                    const status = automationStatus[settingsModalProfile._id];
                    if (!status || status.checking) {
                      return <span className="spinner-border spinner-border-sm" style={{ color: '#ff9800' }}></span>;
                    }
                    return (
                      <span style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        background: status.hasNewListeners ? '#2196f3' : '#e91e63'
                      }}></span>
                    );
                  })()}
                  <div>
                    <div style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>
                      {(() => {
                        const status = automationStatus[settingsModalProfile._id];
                        if (!status || status.checking) return 'בודק גרסת אוטומציה...';
                        return status.hasNewListeners ? 'גרסה חדשה פעילה' : 'גרסה ישנה (ללא מאזינים חדשים)';
                      })()}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666' }}>
                      {(() => {
                        const status = automationStatus[settingsModalProfile._id];
                        if (!status || status.checking) return 'מתחבר לשרת האוטומציה...';
                        return status.hasNewListeners
                          ? 'כפתורי הטעינה יעבדו'
                          : 'יש לפרוס את הקוד החדש בשרת';
                      })()}
                    </div>
                  </div>
                  {/* Refresh button */}
                  <button
                    onClick={() => checkAutomationStatus(settingsModalProfile._id)}
                    disabled={automationStatus[settingsModalProfile._id]?.checking}
                    style={{
                      marginRight: 'auto',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '16px',
                      opacity: 0.6
                    }}
                    title="בדוק שוב"
                  >
                    ↻
                  </button>
                </div>
              </div>

              {/* Profile Stats */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px',
                marginBottom: '20px'
              }}>
                {/* Groups Stats */}
                <div style={{
                  padding: '14px',
                  borderRadius: '8px',
                  background: '#f5f5f5',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '24px', fontWeight: '600', color: '#1976d2' }}>
                    {settingsModalProfile.group_count || 0}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>קבוצות</div>
                  {settingsModalProfile.last_get_following && (
                    <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                      עודכן: {new Date(settingsModalProfile.last_get_following).toLocaleDateString('he-IL')}
                    </div>
                  )}
                </div>
                {/* Sub-profiles Stats */}
                <div style={{
                  padding: '14px',
                  borderRadius: '8px',
                  background: '#f5f5f5',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '24px', fontWeight: '600', color: '#4caf50' }}>
                    {allProfiles.filter(p => p.parent_profile === settingsModalProfile._id).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>פרופילים משניים</div>
                  {settingsModalProfile.sub_profiles_fetched_at && (
                    <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                      עודכן: {new Date(settingsModalProfile.sub_profiles_fetched_at).toLocaleDateString('he-IL')}
                    </div>
                  )}
                </div>
              </div>

              {/* Max Posts Per Day */}
              <div style={{
                padding: '14px 16px',
                marginBottom: '20px',
                borderRadius: '12px',
                background: '#f5f5f5',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: '#333' }}>מקסימום פוסטים ביום</div>
                    <div style={{ fontSize: '11px', color: '#999' }}>ברירת מחדל: 90</div>
                  </div>
                  <input
                    type="number"
                    min="1"
                    max="1000"
                    defaultValue={settingsModalProfile.posts_per_day || 90}
                    onBlur={async (e) => {
                      const val = parseInt(e.target.value) || 90;
                      try {
                        await axios.post(`${API_URL}/api/update-profile-settings`, {
                          profile_id: settingsModalProfile._id,
                          posts_per_day: val
                        });
                        setAllProfiles(prev => prev.map(p =>
                          p._id === settingsModalProfile._id ? { ...p, posts_per_day: val } : p
                        ));
                        setSettingsModalProfile(prev => ({ ...prev, posts_per_day: val }));
                      } catch (e) {
                        console.error('Error updating posts_per_day:', e);
                      }
                    }}
                    style={{
                      width: '80px',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: '1px solid #ccc',
                      fontSize: '16px',
                      fontWeight: '600',
                      textAlign: 'center',
                      color: '#1976d2'
                    }}
                  />
                </div>
              </div>

              {/* Active Sub-Profiles Posts Per Day */}
              {(() => {
                const activeSubProfiles = allProfiles.filter(
                  (p: any) => p.parent_profile === settingsModalProfile._id && p.parent_profile_on
                );
                if (activeSubProfiles.length === 0) return null;
                return (
                  <div style={{
                    padding: '14px 16px',
                    marginBottom: '20px',
                    borderRadius: '12px',
                    background: '#f5f5f5',
                    border: '1px solid #e0e0e0'
                  }}>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: '#333', marginBottom: '12px' }}>
                      מקסימום פוסטים ביום - פרופילים משניים
                    </div>
                    {activeSubProfiles.map((sub: any) => (
                      <div key={sub._id} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '8px 0', borderBottom: '1px solid #e8e8e8',
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{
                            width: '8px', height: '8px', borderRadius: '50%', background: '#4caf50',
                          }}></div>
                          <span style={{ fontSize: '13px', color: '#333' }}>
                            {sub.first_name || sub.facebook_username || sub.facebook_id}
                          </span>
                        </div>
                        <input
                          type="number"
                          min="1"
                          max="500"
                          defaultValue={sub.posts_per_day || 90}
                          onBlur={async (e) => {
                            const val = parseInt(e.target.value) || 90;
                            try {
                              await axios.post(`${API_URL}/api/update-profile-settings`, {
                                profile_id: sub._id,
                                posts_per_day: val
                              });
                              setAllProfiles(prev => prev.map((p: any) =>
                                p._id === sub._id ? { ...p, posts_per_day: val } : p
                              ));
                            } catch (err) {
                              console.error('Error updating sub-profile posts_per_day:', err);
                            }
                          }}
                          style={{
                            width: '70px', padding: '6px 10px', borderRadius: '6px',
                            border: '1px solid #ccc', fontSize: '14px', fontWeight: '600',
                            textAlign: 'center', color: '#1976d2',
                          }}
                        />
                      </div>
                    ))}
                    <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>
                      ברירת מחדל: 90 | שינוי ישמר אוטומטית
                    </div>
                  </div>
                );
              })()}

              {/* Action Buttons */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {/* Fetch Sub-Profiles Button */}
                <button
                  className="btn btn-light-success d-flex align-items-center justify-content-between"
                  style={{ padding: '14px 20px' }}
                  onClick={() => fetchSubProfiles(settingsModalProfile._id)}
                  disabled={
                    fetchingProfiles.has(settingsModalProfile._id) ||
                    !(settingsModalProfile.last_health_check &&
                      new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000)
                  }
                >
                  <div>
                    <div style={{ fontWeight: '500' }}>טען פרופילים משניים</div>
                    <div style={{ fontSize: '12px', opacity: 0.7 }}>
                      סנכרן פרופילים משניים מפייסבוק
                    </div>
                  </div>
                  {fetchingProfiles.has(settingsModalProfile._id) ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <span style={{ fontSize: '20px' }}>↻</span>
                  )}
                </button>

                {/* Fetch Groups Button */}
                <button
                  className="btn btn-light-primary d-flex align-items-center justify-content-between"
                  style={{ padding: '14px 20px' }}
                  onClick={() => fetchGroups(settingsModalProfile._id)}
                  disabled={
                    fetchingGroups.has(settingsModalProfile._id) ||
                    !(settingsModalProfile.last_health_check &&
                      new Date(settingsModalProfile.last_health_check).getTime() > Date.now() - 5 * 60 * 1000)
                  }
                >
                  <div>
                    <div style={{ fontWeight: '500' }}>טען קבוצות</div>
                    <div style={{ fontSize: '12px', opacity: 0.7 }}>
                      סנכרן קבוצות שהפרופיל חבר בהן
                    </div>
                  </div>
                  {fetchingGroups.has(settingsModalProfile._id) ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <span style={{ fontSize: '20px' }}>👥</span>
                  )}
                </button>

                {/* Restart Worker Button */}
                <button
                  className="btn btn-light-danger d-flex align-items-center justify-content-between"
                  style={{ padding: '14px 20px' }}
                  onClick={async () => {
                    try {
                      setFetchMessage('שולח פקודת הפעלה מחדש...');
                      const response = await axios.post(`${API_URL}/api/restart-worker`, {
                        api_token: auth?.api_token || '',
                        profile_id: settingsModalProfile._id
                      });
                      if (response.data.success) {
                        setFetchMessage(response.data.message);
                      } else {
                        setFetchMessage(response.data.error || 'שגיאה בהפעלה מחדש');
                      }
                    } catch (error) {
                      console.error('Error restarting worker:', error);
                      setFetchMessage('שגיאה בהפעלה מחדש של העובד');
                    }
                  }}
                >
                  <div>
                    <div style={{ fontWeight: '500' }}>הפעל מחדש את העובד</div>
                    <div style={{ fontSize: '12px', opacity: 0.7 }}>
                      מפעיל מחדש את תהליך האוטומציה
                    </div>
                  </div>
                  <span style={{ fontSize: '20px' }}>🔄</span>
                </button>

                {/* First-login link — share a per-profile mobile login page.
                    The customer completes the FB login (incl. 2FA) in a live
                    browser view scoped to this profile only. */}
                <button
                  className="btn btn-light-info d-flex align-items-center justify-content-between"
                  style={{ padding: '14px 20px' }}
                  onClick={async () => {
                    try {
                      setFetchMessage('יוצר קישור התחברות...');
                      const r = await axios.post(`${API_URL}/api/profiles/${settingsModalProfile._id}/connect-link`, {
                        api_token: auth?.api_token || ''
                      });
                      const url = r.data?.url;
                      if (!url) { setFetchMessage('שגיאה ביצירת קישור'); return; }
                      try { await navigator.clipboard.writeText(url); } catch (e) {}
                      setFetchMessage('קישור התחברות נוצר והועתק ללוח: ' + url);
                    } catch (err) {
                      console.error('Error creating connect link:', err);
                      setFetchMessage('שגיאה ביצירת קישור התחברות');
                    }
                  }}
                >
                  <div>
                    <div style={{ fontWeight: '500' }}>קישור התחברות ראשונית (נייד)</div>
                    <div style={{ fontSize: '12px', opacity: 0.7 }}>
                      שלח ללקוח קישור להתחברות לפייסבוק לפרופיל זה בלבד
                    </div>
                  </div>
                  <span style={{ fontSize: '20px' }}>🔗</span>
                </button>
              </div>

              {/* Fetch message in modal */}
              {fetchMessage && (
                <div style={{
                  marginTop: '16px',
                  padding: '12px',
                  borderRadius: '8px',
                  background: fetchMessage.includes('שגיאה') || fetchMessage.includes('לא') ? '#ffebee' : '#e8f5e9',
                  color: fetchMessage.includes('שגיאה') || fetchMessage.includes('לא') ? '#c62828' : '#2e7d32',
                  fontSize: '14px'
                }}>
                  {fetchMessage}
                </div>
              )}

              {/* Sub-profiles list */}
              {(() => {
                const subProfiles = allProfiles.filter(p => p.parent_profile === settingsModalProfile._id);
                const enabledCount = subProfiles.filter(p => p.parent_profile_on).length;
                return subProfiles.length > 0 && (
                  <div style={{ marginTop: '20px' }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '12px'
                    }}>
                      <h6 style={{ margin: 0, color: '#333' }}>פרופילים משניים</h6>
                      <span style={{ fontSize: '13px', color: '#666' }}>
                        {enabledCount}/{subProfiles.length} מופעלים
                      </span>
                    </div>
                    <div style={{
                      maxHeight: '300px',
                      overflowY: 'auto',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px'
                    }}>
                      {subProfiles.map((subProfile, idx) => (
                        <div
                          key={subProfile._id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            borderBottom: idx < subProfiles.length - 1 ? '1px solid #f0f0f0' : 'none',
                            background: subProfile.parent_profile_on ? 'rgba(76, 175, 80, 0.05)' : 'transparent'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <img
                              src={`https://graph.facebook.com/${subProfile.facebook_id}/picture?type=square&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                              alt=""
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                border: subProfile.parent_profile_on ? '2px solid #4caf50' : '2px solid #ccc'
                              }}
                            />
                            <div>
                              <div style={{
                                fontWeight: '500',
                                color: subProfile.parent_profile_on ? '#333' : '#999'
                              }}>
                                {subProfile.first_name} {subProfile.last_name}
                              </div>
                              <div style={{ fontSize: '12px', color: '#999' }}>
                                {subProfile.facebook_id}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              width: '44px',
                              height: '24px',
                              borderRadius: '12px',
                              background: subProfile.parent_profile_on ? '#4caf50' : '#ccc',
                              cursor: togglingProfiles.has(subProfile._id) ? 'not-allowed' : 'pointer',
                              position: 'relative',
                              transition: 'background 0.2s',
                              opacity: togglingProfiles.has(subProfile._id) ? 0.6 : 1,
                              flexShrink: 0,
                            }}
                            onClick={async () => {
                              if (togglingProfiles.has(subProfile._id)) return;
                                const newValue = !subProfile.parent_profile_on;
                                setTogglingProfiles(prev => new Set(prev).add(subProfile._id));
                                try {
                                  const response = await axios.post(`${API_URL}/api/toggle-sub-profile`, {
                                    api_token: auth?.api_token || '',
                                    sub_profile_id: subProfile._id,
                                    enabled: newValue
                                  });
                                  if (response.data.success) {
                                    setAllProfiles(prev => prev.map(p =>
                                      p._id === subProfile._id ? { ...p, parent_profile_on: newValue } : p
                                    ));
                                  }
                                } catch (error) {
                                  console.error('Error toggling sub-profile:', error);
                                } finally {
                                  setTogglingProfiles(prev => {
                                    const next = new Set(prev);
                                    next.delete(subProfile._id);
                                    return next;
                                  });
                                }
                            }}
                          >
                            <div style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              background: '#fff',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                              position: 'absolute',
                              top: '2px',
                              left: subProfile.parent_profile_on ? '22px' : '2px',
                              transition: 'left 0.2s',
                            }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setSettingsModalProfile(null)}
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Move Post to Campaign Modal */}
    {movingPost && (
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        onClick={(e) => {
          if (e.target === e.currentTarget) setMovingPost(null);
        }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px', direction: 'rtl' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">העבר פוסט לקמפיין אחר</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setMovingPost(null)}
              ></button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
                בחר את הקמפיין שאליו תרצה להעביר את הפוסט:
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {campaigns.filter((c: any) => c._id !== selectedCampaign?._id).map((camp: any) => (
                  <button
                    key={camp._id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '12px 16px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      background: '#fff',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#333',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = '#1877f2';
                      e.currentTarget.style.background = '#f0f7ff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                      e.currentTarget.style.background = '#fff';
                    }}
                    onClick={async () => {
                      try {
                        const response = await axios.post(`${API_URL}/move-post`, {
                          api_token: auth?.api_token || '',
                          post_id: movingPost._id,
                          target_campaign_id: camp._id,
                        });
                        if (response.data.success) {
                          setPosts(prev => prev.filter(p => p._id !== movingPost._id));
                          setToast({ message: `הפוסט הועבר לקמפיין ${camp.name}`, type: 'success' });
                          // Update post counts
                          if (currentUser?.campaigns) {
                            const updatedCampaigns = currentUser.campaigns.map((c: any) => {
                              if (c._id === selectedCampaign?._id) return { ...c, post_count: Math.max(0, (c.post_count || 0) - 1) };
                              if (c._id === camp._id) return { ...c, post_count: (c.post_count || 0) + 1 };
                              return c;
                            });
                            setCurrentUser({ ...currentUser, campaigns: updatedCampaigns });
                          }
                        }
                      } catch (error) {
                        console.error('Error moving post:', error);
                        setToast({ message: 'שגיאה בהעברת הפוסט', type: 'error' });
                      } finally {
                        setMovingPost(null);
                      }
                    }}
                  >
                    {camp.color && (
                      <span style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        background: camp.color,
                        flexShrink: 0,
                      }}></span>
                    )}
                    {camp.name}
                  </button>
                ))}
                {campaigns.filter((c: any) => c._id !== selectedCampaign?._id).length === 0 && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#999', fontSize: '14px' }}>
                    אין קמפיינים אחרים להעברה
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setMovingPost(null)}
              >
                ביטול
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Mobile Campaign Switcher */}
    <MobileCampaignSwitcher
      campaigns={currentUser?.campaigns || []}
      selectedCampaign={selectedCampaign}
      onCampaignSelect={(camp) => navigate(`/campaigns/${camp._id}?${params.toString()}`)}
      onEnableCampaign={enableCampaign}
      onDeleteCampaign={(camp) => {
        setCampaignToDelete(camp);
        const modalBtn = document.getElementById('delete-campaign-modal-trigger') as HTMLElement;
        modalBtn?.click();
      }}
      onCreateCampaign={() => {
        // Initialize with all active profiles selected
        const activeProfiles = allProfiles.filter((p: any) => p.facebook_id && (!p.parent_profile || p.parent_profile_on));
        setNewCampaignProfiles(activeProfiles.map((p: any) => p._id));
        // Use Bootstrap modal API directly for mobile compatibility
        const modalEl = document.getElementById('kt_modal_1');
        if (modalEl) {
          BsModal.getOrCreateInstance(modalEl).show();
        } else {
          // Fallback to clicking the button
          const modalBtn = document.querySelector('[data-bs-target="#kt_modal_1"]') as HTMLElement;
          modalBtn?.click();
        }
      }}
      onSelectGroups={() => {
        document.getElementById('groups-modal-trigger')?.click();
      }}
      onScrollToPosts={() => {
        document.getElementById('posts-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }}
      campaignStats={allCampaignStats}
      onEditCampaignName={(campaignId, currentName, maxPosts, fakePublished) => {
        setEditingCampaignId(campaignId);
        setEditingCampaignName(currentName);
        setEditingMaxPosts(maxPosts || 300);
        setEditingFakePublished(fakePublished || 0);
        const camp = campaigns.find((c: any) => c._id === campaignId);
        setEditingDefaultAutoReply(camp?.default_auto_reply || '');
        setEditingDefaultMarketplaceAutoReply(camp?.default_marketplace_auto_reply || '');
        setEditingDefaultSignature(camp?.default_signature || '');
        setEditingDefaultSignatureLocked(!!camp?.default_signature_locked);
      }}
    />

    {/* Edit Campaign Name Modal */}
    {editingCampaignId && (
      <div
        className="edit-campaign-modal-backdrop"
        style={{
          display: 'flex',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 10001,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '24px',
            width: '90%',
            maxWidth: '400px',
            direction: 'rtl',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}
        >
          <h4 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600 }}>הגדרות קמפיין</h4>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>שם הקמפיין</label>
          <input
            type="text"
            value={editingCampaignName}
            onChange={(e) => setEditingCampaignName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && editingCampaignName.trim()) {
                updateCampaignName(editingCampaignId, editingCampaignName);
              } else if (e.key === 'Escape') {
                setEditingCampaignId(null);
                setEditingCampaignName('');
              }
            }}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              border: '2px solid #1877f2',
              borderRadius: '8px',
              outline: 'none',
              marginBottom: '16px'
            }}
            autoFocus
          />
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>
            מקסימום פרסומים ביום <span style={{ color: '#a1a5b7', fontWeight: 400 }}>(לא חובה — ריק = ללא הגבלה)</span>
          </label>
          <input
            type="number"
            value={editingMaxPosts > 0 ? editingMaxPosts : ''}
            placeholder="ללא הגבלה"
            onChange={(e) => {
              // Empty clears the cap. Coercing blank to a number here is what used to
              // force every campaign back to a limit it never asked for.
              const n = parseInt(e.target.value, 10);
              setEditingMaxPosts(Number.isFinite(n) && n > 0 ? n : 0);
            }}
            min={1}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              border: '1px solid #e4e6ef',
              borderRadius: '8px',
              outline: 'none',
              marginBottom: '16px'
            }}
          />
          {/* Global Auto Reply for posts */}
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>
            💬 תגובה אוטומטית גלובלית
          </label>
          <DebouncedTextarea
            value={editingDefaultAutoReply}
            onCommit={(next) => setEditingDefaultAutoReply(next)}
            placeholder="תגובה שתישלח אוטומטית לכל פוסט בקמפיין (ניתן לדרוס בפוסט בודד)"
            rows={2}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '13px',
              border: '1px solid #e4e6ef',
              borderRadius: '8px',
              outline: 'none',
              marginBottom: '4px',
              resize: 'vertical'
            }}
          />
          <small style={{ display: 'block', color: '#a1a5b7', fontSize: '11px', marginBottom: '16px' }}>
            הגדרת תגובה בפוסט בודד תדרוס את ההגדרה הגלובלית
          </small>

          {/* Global Marketplace Auto Reply */}
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>
            🛒 הודעת תגובה אוטומטית במרקטפלייס
          </label>
          <DebouncedTextarea
            value={editingDefaultMarketplaceAutoReply}
            onCommit={(next) => setEditingDefaultMarketplaceAutoReply(next)}
            placeholder="הודעה שתישלח אוטומטית למתעניינים במודעות מרקטפלייס (ניתן לדרוס במודעה בודדת)"
            rows={2}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '13px',
              border: '1px solid #e4e6ef',
              borderRadius: '8px',
              outline: 'none',
              marginBottom: '4px',
              resize: 'vertical'
            }}
          />
          <small style={{ display: 'block', color: '#a1a5b7', fontSize: '11px', marginBottom: '16px' }}>
            הגדרת הודעה במודעת מרקטפלייס בודדת תדרוס את ההגדרה הגלובלית
          </small>

          {/* Campaign default signature — editable and clearable, unless an admin locked it */}
          {(() => {
            const sigLocked = editingDefaultSignatureLocked && !isAdmin;
            return (
              <>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>
                  {sigLocked ? '🔒' : '✍️'} חתימת ברירת מחדל
                </label>
                <DebouncedTextarea
                  value={editingDefaultSignature}
                  onCommit={(next) => setEditingDefaultSignature(next)}
                  readOnly={sigLocked}
                  placeholder="חתימה שתתווסף לסוף כל פוסט בקמפיין (השאירו ריק כדי לבטל)"
                  rows={2}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '13px',
                    border: '1px solid #e4e6ef',
                    borderRadius: '8px',
                    outline: 'none',
                    marginBottom: '4px',
                    resize: 'vertical',
                    ...(sigLocked ? { background: '#f5f6f8', color: '#5e6278', cursor: 'not-allowed' } : {}),
                  }}
                />
                <small style={{ display: 'block', color: '#a1a5b7', fontSize: '11px', marginBottom: '16px' }}>
                  {sigLocked
                    ? 'החתימה ננעלה על ידי מנהל המערכת ואינה ניתנת לעריכה'
                    : 'ניתן לערוך או למחוק. שדות זמינים: {number} למספר, {wa_link} לקישור וואטסאפ'}
                </small>
              </>
            );
          })()}

          {isAdmin && (
            <>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#5e6278', marginBottom: '6px' }}>כמות "פורסמו" מדומה (אדמין)</label>
              <input
                type="number"
                value={editingFakePublished}
                onChange={(e) => setEditingFakePublished(Math.max(0, parseInt(e.target.value) || 0))}
                min={0}
                placeholder="0 = ללא"
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  border: '1px solid #e4e6ef',
                  borderRadius: '8px',
                  outline: 'none',
                  marginBottom: '16px'
                }}
              />
            </>
          )}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => updateCampaignName(editingCampaignId, editingCampaignName)}
              disabled={savingCampaignName}
              style={{
                flex: 1,
                padding: '12px',
                background: '#1877f2',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              {savingCampaignName ? 'שומר...' : 'שמור'}
            </button>
            <button
              onClick={() => {
                setEditingCampaignId(null);
                setEditingCampaignName('');
              }}
              style={{
                flex: 1,
                padding: '12px',
                background: '#e4e6eb',
                color: '#333',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              ביטול
            </button>
          </div>
        </div>
      </div>
    )}

    {/* WhatsApp click-to-chat link builder (post body / auto-reply / MP reply) */}
    <WhatsappLinkModal
      open={!!waLinkModal}
      initial={waLinkModal?.initial}
      onClose={() => setWaLinkModal(null)}
      onInsert={applyWaLink}
    />

    {/* Toast notification */}
    {toast && (
      <div className={`custom-toast ${toast.type}`}>
        <span className="toast-icon">
          {toast.type === 'success' ? '✓' : toast.type === 'warning' ? '⏸' : '✕'}
        </span>
        <span className="toast-message">{toast.message}</span>
      </div>
    )}

    {/* Marketplace Delete Confirmation Dialog */}
    {showMarketplaceDeleteDialog && (
      <div style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 10002, backdropFilter: 'blur(4px)',
      }}>
        <div style={{
          background: '#fff', borderRadius: '16px', padding: '0', width: '90%', maxWidth: '420px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden', direction: 'rtl',
        }}>
          {/* Header */}
          <div style={{
            padding: '20px 24px', background: 'linear-gradient(135deg, #f64e60 0%, #d63384 100%)',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{
              width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px',
            }}>🛒</div>
            <div>
              <h4 style={{margin: 0, color: '#fff', fontSize: '16px', fontWeight: 700}}>מחיקת מודעת מרקטפלייס</h4>
              <p style={{margin: 0, color: 'rgba(255,255,255,0.8)', fontSize: '13px'}}>
                הפוסט מפורסם גם במרקטפלייס
              </p>
            </div>
          </div>

          {/* Body */}
          <div style={{padding: '24px'}}>
            <p style={{fontSize: '14px', color: '#5e6278', marginBottom: '20px', lineHeight: '1.6'}}>
              הפוסט "<strong>{showMarketplaceDeleteDialog.post.name}</strong>" מקושר למודעת מרקטפלייס.
              <br />האם ברצונך למחוק גם את המודעה מפייסבוק מרקטפלייס?
            </p>

            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {/* Delete both */}
              <button
                onClick={() => deletePost(showMarketplaceDeleteDialog.post, showMarketplaceDeleteDialog.campaign, true)}
                disabled={deletingMarketplace}
                style={{
                  padding: '12px 16px', border: 'none', borderRadius: '10px',
                  background: 'linear-gradient(135deg, #f64e60 0%, #d63384 100%)',
                  color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  opacity: deletingMarketplace ? 0.7 : 1,
                }}
              >
                {deletingMarketplace ? (
                  <><span className="spinner-border spinner-border-sm" /> מוחק...</>
                ) : (
                  <>🗑 מחק את הפוסט + המודעה מהמרקטפלייס</>
                )}
              </button>

              {/* Delete post only */}
              <button
                onClick={() => {
                  const {post, campaign} = showMarketplaceDeleteDialog;
                  setShowMarketplaceDeleteDialog(null);
                  // Call delete directly without marketplace check
                  axios.post(`${API_URL}/delete-post`, {
                    api_token: auth?.api_token || '',
                    post, campaign,
                  }).then(() => {
                    posts.splice(posts.indexOf(post), 1);
                    setPosts([...posts]);
                  }).catch(console.error);
                }}
                disabled={deletingMarketplace}
                style={{
                  padding: '12px 16px', border: '1px solid #e4e6ef', borderRadius: '10px',
                  background: '#fff', color: '#5e6278', fontSize: '14px', fontWeight: 500,
                  cursor: 'pointer',
                }}
              >
                מחק רק את הפוסט (השאר את המודעה במרקטפלייס)
              </button>

              {/* Cancel */}
              <button
                onClick={() => setShowMarketplaceDeleteDialog(null)}
                disabled={deletingMarketplace}
                style={{
                  padding: '10px 16px', border: 'none', borderRadius: '10px',
                  background: 'transparent', color: '#a1a5b7', fontSize: '13px',
                  cursor: 'pointer', textAlign: 'center',
                }}
              >
                ביטול
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Bulk Marketplace Modal */}
    <BulkMarketplaceModal
      show={showBulkMarketplace}
      onClose={() => setShowBulkMarketplace(false)}
      onSuccess={(updatedPostIds) => {
        setPosts((prev: any[]) => prev.map((p: any) =>
          updatedPostIds.includes(p._id)
            ? {...p, converted_to_marketplace_listing_id: 'pending'}
            : p
        ))
        setShowBulkMarketplace(false)
      }}
      posts={posts.filter((p: any) =>
        !p.is_new &&
        !p.converted_to_marketplace_listing_id &&
        !p.marketplace_listing_id &&
        !p.facebook_marketplace_listing_id &&
        (p.media_url || (p.media && p.media.length > 0))
      )}
      campaignId={selectedCampaign?._id || ''}
      campaignName={selectedCampaign?.name || ''}
    />

    </>
  )
}

export {GroupsWrapper}
